import React from "react"

export const AddColumnLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M10,14 L2,14 L2,2 L10,2 L10,14 Z M14,14 L11,14 L11,2 L14,2 L14,14 Z M4,9 L5,9 L5,10 C5,10.55 5.45,11 6,11 C6.55,11 7,10.55 7,10 L7,9 L8,9 C8.55,9 9,8.55 9,8 C9,7.45 8.55,7 8,7 L7,7 L7,6 C7,5.45 6.55,5 6,5 C5.45,5 5,5.45 5,6 L5,7 L4,7 C3.45,7 3,7.45 3,8 C3,8.55 3.45,9 4,9 Z" />
  </svg>
)
AddColumnLeft.iconName = "AddColumnLeft"
export const AddColumnRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,9 L9,9 L9,10 C9,10.55 9.45,11 10,11 C10.55,11 11,10.55 11,10 L11,9 L12,9 C12.55,9 13,8.55 13,8 C13,7.45 12.55,7 12,7 L11,7 L11,6 C11,5.45 10.55,5 10,5 C9.45,5 9,5.45 9,6 L9,7 L8,7 C7.45,7 7,7.45 7,8 C7,8.55 7.45,9 8,9 Z M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M5,14 L2,14 L2,2 L5,2 L5,14 Z M14,14 L6,14 L6,2 L14,2 L14,14 Z" />
  </svg>
)
AddColumnRight.iconName = "AddColumnRight"
export const AddRowBottom = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,11 L7,11 L7,12 C7,12.55 7.45,13 8,13 C8.55,13 9,12.55 9,12 L9,11 L10,11 C10.55,11 11,10.55 11,10 C11,9.45 10.55,9 10,9 L9,9 L9,8 C9,7.45 8.55,7 8,7 C7.45,7 7,7.45 7,8 L7,9 L6,9 C5.45,9 5,9.45 5,10 C5,10.55 5.45,11 6,11 Z M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M14,14 L2,14 L2,6 L14,6 L14,14 Z M14,5 L2,5 L2,2 L14,2 L14,5 Z" />
  </svg>
)
AddRowBottom.iconName = "AddRowBottom"
export const AddRowTop = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M14,14 L2,14 L2,11 L14,11 L14,14 Z M14,10 L2,10 L2,2 L14,2 L14,10 Z M6,7 L7,7 L7,8 C7,8.55 7.45,9 8,9 C8.55,9 9,8.55 9,8 L9,7 L10,7 C10.55,7 11,6.55 11,6 C11,5.45 10.55,5 10,5 L9,5 L9,4 C9,3.45 8.55,3 8,3 C7.45,3 7,3.45 7,4 L7,5 L6,5 C5.45,5 5,5.45 5,6 C5,6.55 5.45,7 6,7 Z" />
  </svg>
)
AddRowTop.iconName = "AddRowTop"
export const AddToArtifact = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,4 L13.5,4 L13.5,3 C13.5,2.45 13.05,2 12.5,2 C11.95,2 11.5,2.45 11.5,3 L11.5,4 L10.5,4 C9.95,4 9.5,4.45 9.5,5 C9.5,5.55 9.95,6 10.5,6 L11.5,6 L11.5,7 C11.5,7.55 11.95,8 12.5,8 C13.05,8 13.5,7.55 13.5,7 L13.5,6 L14.5,6 C15.05,6 15.5,5.55 15.5,5 C15.5,4.44 15.05,4 14.5,4 Z M1.5,6 L7.5,6 C8.05,6 8.5,5.55 8.5,5 C8.5,4.45 8.05,4 7.5,4 L1.5,4 C0.95,4 0.5,4.45 0.5,5 C0.5,5.55 0.95,6 1.5,6 Z M9.5,12 L1.5,12 C0.95,12 0.5,12.45 0.5,13 C0.5,13.55 0.95,14 1.5,14 L9.5,14 C10.05,14 10.5,13.55 10.5,13 C10.5,12.44 10.05,12 9.5,12 Z M9.5,8 L1.5,8 C0.95,8 0.5,8.45 0.5,9 C0.5,9.55 0.95,10 1.5,10 L9.5,10 C10.05,10 10.5,9.55 10.5,9 C10.5,8.44 10.05,8 9.5,8 Z" />
  </svg>
)
AddToArtifact.iconName = "AddToArtifact"
export const AddToFolder = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,9.5 L14,9.5 C14.55,9.5 15,9.05 15,8.5 C15,7.95 14.55,7.5 14,7.5 L12.41,7.5 L15.7,4.21 C15.89,4.03 16,3.78 16,3.5 C16,2.95 15.55,2.5 15,2.5 C14.72,2.5 14.47,2.61 14.29,2.79 L11,6.09 L11,4.5 C11,3.95 10.55,3.5 10,3.5 C9.45,3.5 9,3.95 9,4.5 L9,8.5 C9,9.05 9.45,9.5 10,9.5 Z M7,3.09 L5.71,1.79 C5.53,1.61 5.28,1.5 5,1.5 L1,1.5 C0.45,1.5 0,1.95 0,2.5 L0,5.5 L7,5.5 L7,3.09 Z M7,9.5 L7,6.5 L0,6.5 L0,13.5 C0,14.05 0.45,14.5 1,14.5 L15,14.5 C15.55,14.5 16,14.05 16,13.5 L16,11.5 L9,11.5 C7.9,11.5 7,10.6 7,9.5 Z" />
  </svg>
)
AddToFolder.iconName = "AddToFolder"
export const Add = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.9931293,6.99562773 L8.99437851,6.99562773 L8.99437851,4.99687695 C8.99437851,4.44722049 8.54465959,3.99750156 7.99500312,3.99750156 C7.44534666,3.99750156 6.99562773,4.44722049 6.99562773,4.99687695 L6.99562773,6.99562773 L4.99687695,6.99562773 C4.44722049,6.99562773 3.99750156,7.44534666 3.99750156,7.99500312 C3.99750156,8.54465959 4.44722049,8.99437851 4.99687695,8.99437851 L6.99562773,8.99437851 L6.99562773,10.9931293 C6.99562773,11.5427858 7.44534666,11.9925047 7.99500312,11.9925047 C8.54465959,11.9925047 8.99437851,11.5427858 8.99437851,10.9931293 L8.99437851,8.99437851 L10.9931293,8.99437851 C11.5427858,8.99437851 11.9925047,8.54465959 11.9925047,7.99500312 C11.9925047,7.44534666 11.5427858,6.99562773 10.9931293,6.99562773 Z M7.99500312,0 C3.5777639,0 0,3.5777639 0,7.99500312 C0,12.4122423 3.5777639,15.9900062 7.99500312,15.9900062 C12.4122423,15.9900062 15.9900062,12.4122423 15.9900062,7.99500312 C15.9900062,3.5777639 12.4122423,0 7.99500312,0 Z M7.99500312,13.9912555 C4.68707058,13.9912555 1.99875078,11.3029357 1.99875078,7.99500312 C1.99875078,4.68707058 4.68707058,1.99875078 7.99500312,1.99875078 C11.3029357,1.99875078 13.9912555,4.68707058 13.9912555,7.99500312 C13.9912555,11.3029357 11.3129294,13.9912555 7.99500312,13.9912555 Z" />
  </svg>
)
Add.iconName = "Add"
export const Airplane = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16,1.5 C16,0.67 15.33,0 14.5,0 C14.09,0 13.71,0.17 13.44,0.44 L9.91,3.97 L2,1 L1,3 L6.93,6.95 L3.88,10 L1,10 L0,11 L3,13 L5,16 L6,15 L6,12.12 L9.05,9.07 L13,15 L15,14 L12.03,6.09 L15.56,2.56 C15.83,2.29 16,1.91 16,1.5 Z" />
  </svg>
)
Airplane.iconName = "Airplane"
export const AlignCenter = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,4 C3.45,4 3,4.45 3,5 C3,5.55 3.45,6 4,6 L12,6 C12.55,6 13,5.55 13,5 C13,4.45 12.55,4 12,4 L4,4 Z M1,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 Z M14,13 L2,13 C1.45,13 1,13.45 1,14 C1,14.55 1.45,15 2,15 L14,15 C14.55,15 15,14.55 15,14 C15,13.45 14.55,13 14,13 Z M15,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z M10,12 C10.55,12 11,11.55 11,11 C11,10.45 10.55,10 10,10 L6,10 C5.45,10 5,10.45 5,11 C5,11.55 5.45,12 6,12 L10,12 Z" />
  </svg>
)
AlignCenter.iconName = "AlignCenter"
export const AlignJustify = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M1,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.56 0.45,3 1,3 Z M15,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z M15,4 L1,4 C0.45,4 0,4.45 0,5 C0,5.55 0.45,6 1,6 L15,6 C15.55,6 16,5.55 16,5 C16,4.45 15.55,4 15,4 Z M15,10 L1,10 C0.45,10 0,10.45 0,11 C0,11.55 0.45,12 1,12 L15,12 C15.55,12 16,11.55 16,11 C16,10.45 15.55,10 15,10 Z" />
  </svg>
)
AlignJustify.iconName = "AlignJustify"
export const AlignLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 C14,13.45 13.55,13 13,13 Z M1,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 Z M1,6 L9,6 C9.55,6 10,5.55 10,5 C10,4.45 9.55,4 9,4 L1,4 C0.45,4 0,4.45 0,5 C0,5.55 0.45,6 1,6 Z M15,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z M1,12 L5,12 C5.55,12 6,11.55 6,11 C6,10.45 5.55,10 5,10 L1,10 C0.45,10 0,10.45 0,11 C0,11.55 0.45,12 1,12 Z" />
  </svg>
)
AlignLeft.iconName = "AlignLeft"
export const AlignRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,13 L3,13 C2.45,13 2,13.45 2,14 C2,14.55 2.45,15 3,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M1,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.56 0.45,3 1,3 Z M15,4 L7,4 C6.45,4 6,4.45 6,5 C6,5.55 6.45,6 7,6 L15,6 C15.55,6 16,5.55 16,5 C16,4.45 15.55,4 15,4 Z M15,10 L11,10 C10.45,10 10,10.45 10,11 C10,11.55 10.45,12 11,12 L15,12 C15.55,12 16,11.55 16,11 C16,10.45 15.55,10 15,10 Z M15,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z" />
  </svg>
)
AlignRight.iconName = "AlignRight"
export const AlignmentBottom = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,11.5 L13,11.5 C13.55,11.5 14,11.05 14,10.5 L14,6.5 C14,5.95 13.55,5.5 13,5.5 L10,5.5 C9.45,5.5 9,5.95 9,6.5 L9,10.5 C9,11.05 9.45,11.5 10,11.5 Z M15,13.5 L1,13.5 C0.45,13.5 0,13.95 0,14.5 C0,15.05 0.45,15.5 1,15.5 L15,15.5 C15.55,15.5 16,15.05 16,14.5 C16,13.95 15.55,13.5 15,13.5 Z M3,11.5 L6,11.5 C6.55,11.5 7,11.05 7,10.5 L7,1.5 C7,0.95 6.55,0.5 6,0.5 L3,0.5 C2.45,0.5 2,0.95 2,1.5 L2,10.5 C2,11.05 2.45,11.5 3,11.5 Z" />
  </svg>
)
AlignmentBottom.iconName = "AlignmentBottom"
export const AlignmentHorizontalCenter = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,7 L14,7 L14,6 C14,5.45 13.55,5 13,5 L10,5 C9.45,5 9,5.45 9,6 L9,7 L7,7 L7,3 C7,2.45 6.55,2 6,2 L3,2 C2.45,2 2,2.45 2,3 L2,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L2,9 L2,13 C2,13.55 2.45,14 3,14 L6,14 C6.55,14 7,13.55 7,13 L7,9 L9,9 L9,10 C9,10.55 9.45,11 10,11 L13,11 C13.55,11 14,10.55 14,10 L14,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z" />
  </svg>
)
AlignmentHorizontalCenter.iconName = "AlignmentHorizontalCenter"
export const AlignmentLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.5,9 L5.5,9 C4.95,9 4.5,9.45 4.5,10 L4.5,13 C4.5,13.55 4.95,14 5.5,14 L9.5,14 C10.05,14 10.5,13.55 10.5,13 L10.5,10 C10.5,9.45 10.05,9 9.5,9 Z M1.5,0 C0.95,0 0.5,0.45 0.5,1 L0.5,15 C0.5,15.55 0.95,16 1.5,16 C2.05,16 2.5,15.55 2.5,15 L2.5,1 C2.5,0.45 2.05,0 1.5,0 Z M14.5,2 L5.5,2 C4.95,2 4.5,2.45 4.5,3 L4.5,6 C4.5,6.55 4.95,7 5.5,7 L14.5,7 C15.05,7 15.5,6.55 15.5,6 L15.5,3 C15.5,2.45 15.05,2 14.5,2 Z" />
  </svg>
)
AlignmentLeft.iconName = "AlignmentLeft"
export const AlignmentRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5,9 L6.5,9 C5.95,9 5.5,9.45 5.5,10 L5.5,13 C5.5,13.55 5.95,14 6.5,14 L10.5,14 C11.05,14 11.5,13.55 11.5,13 L11.5,10 C11.5,9.45 11.05,9 10.5,9 Z M14.5,0 C13.95,0 13.5,0.45 13.5,1 L13.5,15 C13.5,15.55 13.95,16 14.5,16 C15.05,16 15.5,15.55 15.5,15 L15.5,1 C15.5,0.45 15.05,0 14.5,0 Z M10.5,2 L1.5,2 C0.95,2 0.5,2.45 0.5,3 L0.5,6 C0.5,6.55 0.95,7 1.5,7 L10.5,7 C11.05,7 11.5,6.55 11.5,6 L11.5,3 C11.5,2.45 11.05,2 10.5,2 Z" />
  </svg>
)
AlignmentRight.iconName = "AlignmentRight"
export const AlignmentTop = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0.5 L1,0.5 C0.45,0.5 0,0.95 0,1.5 C0,2.05 0.45,2.5 1,2.5 L15,2.5 C15.55,2.5 16,2.05 16,1.5 C16,0.95 15.55,0.5 15,0.5 Z M6,4.5 L3,4.5 C2.45,4.5 2,4.95 2,5.5 L2,14.5 C2,15.05 2.45,15.5 3,15.5 L6,15.5 C6.55,15.5 7,15.05 7,14.5 L7,5.5 C7,4.95 6.55,4.5 6,4.5 Z M13,4.5 L10,4.5 C9.45,4.5 9,4.95 9,5.5 L9,9.5 C9,10.05 9.45,10.5 10,10.5 L13,10.5 C13.55,10.5 14,10.05 14,9.5 L14,5.5 C14,4.95 13.55,4.5 13,4.5 Z" />
  </svg>
)
AlignmentTop.iconName = "AlignmentTop"
export const AlignmentVerticalCenter = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,2 L9,2 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,2 L3,2 C2.45,2 2,2.45 2,3 L2,6 C2,6.55 2.45,7 3,7 L7,7 L7,9 L6,9 C5.45,9 5,9.45 5,10 L5,13 C5,13.55 5.45,14 6,14 L7,14 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,14 L10,14 C10.55,14 11,13.55 11,13 L11,10 C11,9.45 10.55,9 10,9 L9,9 L9,7 L13,7 C13.55,7 14,6.55 14,6 L14,3 C14,2.45 13.55,2 13,2 Z" />
  </svg>
)
AlignmentVerticalCenter.iconName = "AlignmentVerticalCenter"
export const Annotation = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.52,2.77 C15.82,2.48 16,2.07 16,1.62 C16,0.73 15.27,0 14.38,0 C13.93,0 13.53,0.18 13.23,0.48 L11.89,1.82 L14.19,4.12 L15.52,2.77 L15.52,2.77 Z M7.4,10.9 L13.61,4.69 L11.31,2.39 L5.1,8.6 L7.4,10.9 L7.4,10.9 Z M14,14 L2,14 L2,2 L8.34,2 L10.34,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,5.66 L14,7.66 L14,14 Z M3,13 L6.58,11.71 L4.29,9.44 L3,13 Z" />
  </svg>
)
Annotation.iconName = "Annotation"
export const Application = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.5,7 L10.5,7 C10.78,7 11,6.78 11,6.5 C11,6.22 10.78,6 10.5,6 L3.5,6 C3.22,6 3,6.22 3,6.5 C3,6.78 3.22,7 3.5,7 Z M15,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 L16,2 C16,1.45 15.55,1 15,1 Z M14,13 L2,13 L2,5 L14,5 L14,13 Z M3.5,9 L7.5,9 C7.78,9 8,8.78 8,8.5 C8,8.22 7.78,8 7.5,8 L3.5,8 C3.22,8 3,8.22 3,8.5 C3,8.78 3.22,9 3.5,9 Z M3.5,11 L8.5,11 C8.78,11 9,10.78 9,10.5 C9,10.22 8.78,10 8.5,10 L3.5,10 C3.22,10 3,10.22 3,10.5 C3,10.78 3.22,11 3.5,11 Z" />
  </svg>
)
Application.iconName = "Application"
export const Applications = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.5,11 L5.5,11 C5.78,11 6,10.78 6,10.5 C6,10.22 5.78,10 5.5,10 L3.5,10 C3.22,10 3,10.22 3,10.5 C3,10.78 3.22,11 3.5,11 Z M3.5,9 L8.5,9 C8.78,9 9,8.78 9,8.5 C9,8.22 8.78,8 8.5,8 L3.5,8 C3.22,8 3,8.22 3,8.5 C3,8.78 3.22,9 3.5,9 Z M11,4 L1,4 C0.45,4 0,4.45 0,5 L0,15 C0,15.55 0.45,16 1,16 L11,16 C11.55,16 12,15.55 12,15 L12,5 C12,4.45 11.55,4 11,4 Z M10,14 L2,14 L2,7 L10,7 L10,14 Z M15,0 L5,0 C4.45,0 4,0.45 4,1 L4,3 L6,3 L6,2 L14,2 L14,9 L13,9 L13,11 L15,11 C15.55,11 16,10.55 16,10 L16,1 C16,0.45 15.55,0 15,0 Z M3.5,13 L6.5,13 C6.78,13 7,12.78 7,12.5 C7,12.22 6.78,12 6.5,12 L3.5,12 C3.22,12 3,12.22 3,12.5 C3,12.78 3.22,13 3.5,13 Z" />
  </svg>
)
Applications.iconName = "Applications"
export const ArrowBottomLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,3 C14,2.45 13.55,2 13,2 C12.72,2 12.47,2.11 12.29,2.29 L4,10.59 L4,6 C4,5.45 3.55,5 3,5 C2.45,5 2,5.45 2,6 L2,13 C2,13.55 2.45,14 3,14 L10,14 C10.55,14 11,13.55 11,13 C11,12.45 10.55,12 10,12 L5.41,12 L13.7,3.71 C13.89,3.53 14,3.28 14,3 Z" />
  </svg>
)
ArrowBottomLeft.iconName = "ArrowBottomLeft"
export const ArrowBottomRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,5 C12.45,5 12,5.45 12,6 L12,10.59 L3.71,2.29 C3.53,2.11 3.28,2 3,2 C2.45,2 2,2.45 2,3 C2,3.28 2.11,3.53 2.29,3.71 L10.59,12 L6,12 C5.45,12 5,12.45 5,13 C5,13.55 5.45,14 6,14 L13,14 C13.55,14 14,13.55 14,13 L14,6 C14,5.45 13.55,5 13,5 Z" />
  </svg>
)
ArrowBottomRight.iconName = "ArrowBottomRight"
export const ArrowDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2.005V11.585L12.29 8.295C12.47 8.115 12.72 8.005 13 8.005C13.55 8.005 14 8.455 14 9.005C14 9.285 13.89 9.535 13.71 9.715L8.71 14.715C8.52 14.895 8.27 15.005 8 15.005C7.73 15.005 7.47 14.895 7.29 14.715L2.29 9.715C2.11 9.535 2 9.285 2 9.005C2 8.455 2.45 8.005 3 8.005C3.28 8.005 3.53 8.115 3.71 8.295L7 11.585L7 1.995C7 1.445 7.45 0.994995 8 0.994995C8.55 0.994995 9 1.455 9 2.005Z"
      fillRule="evenodd"
    />
  </svg>
)
ArrowDown.iconName = "ArrowDown"
export const ArrowLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.995,7 L4.415,7 L7.705,3.71 C7.885,3.53 7.995,3.28 7.995,3 C7.995,2.45 7.545,2 6.995,2 C6.715,2 6.465,2.11 6.285,2.29 L1.285,7.29 C1.105,7.48 0.995,7.73 0.995,8 C0.995,8.27 1.105,8.53 1.285,8.71 L6.285,13.71 C6.465,13.89 6.715,14 6.995,14 C7.545,14 7.995,13.55 7.995,13 C7.995,12.72 7.885,12.47 7.705,12.29 L4.415,9 L14.005,9 C14.555,9 15.005,8.55 15.005,8 C15.005,7.45 14.545,7 13.995,7 Z" />
  </svg>
)
ArrowLeft.iconName = "ArrowLeft"
export const ArrowRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.005,7 L11.585,7 L8.295,3.71 C8.115,3.53 8.005,3.28 8.005,3 C8.005,2.45 8.455,2 9.005,2 C9.285,2 9.535,2.11 9.715,2.29 L14.715,7.29 C14.895,7.48 15.005,7.73 15.005,8 C15.005,8.27 14.895,8.53 14.715,8.71 L9.715,13.71 C9.535,13.89 9.285,14 9.005,14 C8.455,14 8.005,13.55 8.005,13 C8.005,12.72 8.115,12.47 8.295,12.29 L11.585,9 L1.995,9 C1.445,9 0.995,8.55 0.995,8 C0.995,7.45 1.455,7 2.005,7 Z" />
  </svg>
)
ArrowRight.iconName = "ArrowRight"
export const ArrowTopLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.71,12.29 L5.41,4 L10,4 C10.55,4 11,3.55 11,3 C11,2.45 10.55,2 10,2 L3,2 C2.45,2 2,2.45 2,3 L2,10 C2,10.55 2.45,11 3,11 C3.55,11 4,10.55 4,10 L4,5.41 L12.29,13.7 C12.47,13.89 12.72,14 13,14 C13.55,14 14,13.55 14,13 C14,12.72 13.89,12.47 13.71,12.29 Z" />
  </svg>
)
ArrowTopLeft.iconName = "ArrowTopLeft"
export const ArrowTopRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,2 L6,2 C5.45,2 5,2.45 5,3 C5,3.55 5.45,4 6,4 L10.59,4 L2.3,12.29 C2.11,12.47 2,12.72 2,13 C2,13.55 2.45,14 3,14 C3.28,14 3.53,13.89 3.71,13.71 L12,5.41 L12,10 C12,10.55 12.45,11 13,11 C13.55,11 14,10.55 14,10 L14,3 C14,2.45 13.55,2 13,2 Z" />
  </svg>
)
ArrowTopRight.iconName = "ArrowTopRight"
export const ArrowUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9,13.995 C9,14.545 8.55,15.005 8,15.005 C7.45,15.005 7,14.555 7,14.005 L7,4.415 L3.71,7.705 C3.53,7.885 3.28,7.995 3,7.995 C2.45,7.995 2,7.545 2,6.995 C2,6.715 2.11,6.465 2.29,6.285 L7.29,1.285 C7.47,1.105 7.73,0.995 8,0.995 C8.27,0.995 8.52,1.105 8.71,1.285 L13.71,6.285 C13.89,6.465 14,6.715 14,6.995 C14,7.545 13.55,7.995 13,7.995 C12.72,7.995 12.47,7.885 12.29,7.705 L9,4.415 L9,13.995 Z" />
  </svg>
)
ArrowUp.iconName = "ArrowUp"
export const ArrowsHorizontal = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.7,7.3 L11.7,3.3 C11.5,3.1 11.3,3 11,3 C10.4,3 10,3.5 10,4 C10,4.3 10.1,4.5 10.3,4.7 L12.6,7 L3.4,7 L5.7,4.7 C5.9,4.5 6,4.3 6,4 C6,3.5 5.6,3 5,3 C4.7,3 4.5,3.1 4.3,3.3 L0.3,7.3 C0.1,7.5 0,7.7 0,8 C0,8.3 0.1,8.5 0.3,8.7 L4.3,12.7 C4.5,12.9 4.7,13 5,13 C5.6,13 6,12.6 6,12 C6,11.7 5.9,11.5 5.7,11.3 L3.4,9 L12.6,9 L10.3,11.3 C10.1,11.5 10,11.7 10,12 C10,12.6 10.4,13 11,13 C11.3,13 11.5,12.9 11.7,12.7 L15.7,8.7 C15.9,8.5 16,8.3 16,8 C16,7.7 15.9,7.5 15.7,7.3 Z" />
  </svg>
)
ArrowsHorizontal.iconName = "ArrowsHorizontal"
export const ArrowsVertical = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,10 C11.7,10 11.5,10.1 11.3,10.3 L9,12.6 L9,3.4 L11.3,5.7 C11.5,5.9 11.7,6 12,6 C12.6,6 13,5.6 13,5 C13,4.7 12.9,4.5 12.7,4.3 L8.7,0.3 C8.5,0.1 8.3,0 8,0 C7.7,0 7.5,0.1 7.3,0.3 L3.3,4.3 C3.1,4.5 3,4.7 3,5 C3,5.6 3.5,6 4,6 C4.3,6 4.5,5.9 4.7,5.7 L7,3.4 L7,12.6 L4.7,10.3 C4.5,10.1 4.3,10 4,10 C3.5,10 3,10.4 3,11 C3,11.3 3.1,11.5 3.3,11.7 L7.3,15.7 C7.5,15.9 7.7,16 8,16 C8.3,16 8.5,15.9 8.7,15.7 L12.7,11.7 C12.9,11.5 13,11.3 13,11 C13,10.4 12.6,10 12,10 Z" />
  </svg>
)
ArrowsVertical.iconName = "ArrowsVertical"
export const Asterisk = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.54,11.18 L14.55,11.16 L9.8,8 L14.55,4.83 L14.54,4.81 C14.81,4.64 15,4.35 15,4 C15,3.45 14.55,3 14,3 C13.79,3 13.61,3.08 13.46,3.18 L13.45,3.16 L9,6.13 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,6.13 L2.55,3.17 L2.54,3.18 C2.39,3.08 2.21,3 2,3 C1.45,3 1,3.45 1,4 C1,4.35 1.19,4.64 1.46,4.82 L1.45,4.83 L6.2,8 L1.45,11.17 L1.46,11.19 C1.19,11.36 1,11.65 1,12 C1,12.55 1.45,13 2,13 C2.21,13 2.39,12.92 2.54,12.82 L2.55,12.84 L7,9.87 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,9.87 L13.45,12.83 L13.46,12.81 C13.61,12.92 13.79,13 14,13 C14.55,13 15,12.55 15,12 C15,11.65 14.81,11.36 14.54,11.18 Z" />
  </svg>
)
Asterisk.iconName = "Asterisk"
export const AutomaticUpdates = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,14 C4.69,14 2,11.31 2,8 C2,6.23 2.78,4.64 4,3.54 L4,5 C4,5.55 4.45,6 5,6 C5.55,6 6,5.55 6,5 L6,1 C6,0.45 5.55,0 5,0 L1,0 C0.45,0 0,0.45 0,1 C0,1.55 0.45,2 1,2 L2.74,2 C1.07,3.46 0,5.6 0,8 C0,12.42 3.58,16 8,16 C8.55,16 9,15.55 9,15 C9,14.45 8.55,14 8,14 Z M8,2 C9.08,2 10.08,2.31 10.95,2.81 L12.42,1.34 C11.15,0.49 9.64,0 8,0 C7.45,0 7,0.45 7,1 C7,1.55 7.45,2 8,2 Z M10.71,8.71 L15.71,3.71 C15.89,3.53 16,3.28 16,3 C16,2.45 15.55,2 15,2 C14.72,2 14.47,2.11 14.29,2.29 L10,6.59 L8.71,5.29 C8.53,5.11 8.28,5 8,5 C7.45,5 7,5.45 7,6 C7,6.28 7.11,6.53 7.29,6.71 L9.29,8.71 C9.47,8.89 9.72,9 10,9 C10.28,9 10.53,8.89 10.71,8.71 Z M16,8 C16,7.45 15.94,6.92 15.84,6.4 L13.97,8.27 C13.89,9.93 13.16,11.41 12,12.45 L12,11 C12,10.45 11.55,10 11,10 C10.45,10 10,10.45 10,11 L10,15 C10,15.55 10.45,16 11,16 L15,16 C15.55,16 16,15.55 16,15 C16,14.45 15.55,14 15,14 L13.26,14 C14.93,12.54 16,10.4 16,8 Z" />
  </svg>
)
AutomaticUpdates.iconName = "AutomaticUpdates"
export const Badge = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.5624403,4.59 C13.4124403,3.46 14.0624403,2.58 14.6624403,1.72 L13.6324403,0.53 C11.9124403,1.41 9.51244032,1.18 8.00244032,9e-16 C6.49244032,1.18 4.09244032,1.41 2.37244032,0.52 L1.34244032,1.72 C1.95244032,2.58 2.59244032,3.46 2.44244032,4.59 C2.14244032,6.88 -0.00755968364,8.76 1.12244032,11.27 C1.57244032,12.41 2.56244032,13.17 3.84244032,13.47 C5.40244032,13.83 7.36244032,14.19 8.00244032,16 C8.64244032,14.19 10.6024403,13.84 12.1624403,13.46 C13.4424403,13.16 14.4324403,12.4 14.8824403,11.26 C16.0024403,8.76 13.8524403,6.88 13.5624403,4.59 Z" />
  </svg>
)
Badge.iconName = "Badge"
export const BanCircle = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M11,9 L5,9 C4.45,9 4,8.55 4,8 C4,7.45 4.45,7 5,7 L11,7 C11.55,7 12,7.45 12,8 C12,8.55 11.55,9 11,9 Z" />
  </svg>
)
BanCircle.iconName = "BanCircle"
export const BankAccount = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.7421697,6.32290492 C14.4321697,5.20290492 13.7621697,4.17290492 12.8721697,3.33290492 L13.2721697,1.56290492 C13.3621697,1.23290492 13.0921697,0.952904918 12.7821697,1.00290492 C11.9321697,1.09290492 11.1821697,1.42290492 10.6421697,1.98290492 C9.80216972,1.66290492 8.77216972,1.47290492 7.79216972,1.47290492 C5.30216972,1.47290492 3.16216972,2.64290492 1.87216972,4.36290492 C1.69216972,4.32290492 1.51216972,4.27290492 1.34216972,4.27290492 C0.582169723,4.27290492 0.00216972284,4.88290492 0.00216972284,5.67290492 C0.00216972284,6.23290492 0.312169723,6.70290492 0.762169723,6.93290492 C0.712169723,7.26290492 0.672169723,7.63290492 0.672169723,8.00290492 C0.672169723,9.68290492 1.38216972,11.1729049 2.50216972,12.3429049 L2.23216972,13.9329049 C2.14216972,14.4929049 2.58216972,15.0029049 3.12216972,15.0029049 L3.70216972,15.0029049 C4.15216972,15.0029049 4.50216972,14.6729049 4.59216972,14.2129049 L4.63216972,13.8429049 C5.57216972,14.2629049 6.63216972,14.5429049 7.79216972,14.5429049 C8.90216972,14.5429049 10.0221697,14.3129049 10.9521697,13.8429049 L11.0021697,14.2129049 C11.0921697,14.6829049 11.4521697,15.0029049 11.8921697,15.0029049 L12.4721697,15.0029049 C13.0021697,15.0029049 13.4521697,14.4929049 13.3621697,13.9329049 L13.0921697,12.3929049 C13.7121697,11.7829049 14.1621697,11.0429049 14.4721697,10.2429049 L15.2721697,10.0529049 C15.6721697,9.96290492 15.9821697,9.58290492 15.9821697,9.12290492 L15.9821697,7.40290492 C16.0721697,6.93290492 15.7621697,6.56290492 15.3621697,6.46290492 L14.7421697,6.32290492 Z M12.0021697,8.00290492 C11.4021697,8.00290492 11.0021697,7.30290492 11.0021697,6.50290492 C11.0021697,5.70290492 11.4021697,5.00290492 12.0021697,5.00290492 C12.6021697,5.00290492 13.0021697,5.70290492 13.0021697,6.50290492 C13.0021697,7.30290492 12.6021697,8.00290492 12.0021697,8.00290492 Z M6.21216972,4.92290492 C5.80216972,5.12290492 5.30216972,4.96290492 5.09216972,4.56290492 C4.88216972,4.16290492 5.05216972,3.68290492 5.46216972,3.49290492 C6.81216972,2.84290492 8.19216972,2.84290492 9.54216972,3.49290492 C9.95216972,3.69290492 10.1221697,4.17290492 9.91216972,4.56290492 C9.70216972,4.96290492 9.20216972,5.12290492 8.79216972,4.92290492 C7.92216972,4.49290492 7.08216972,4.49290492 6.21216972,4.92290492 Z" />
  </svg>
)
BankAccount.iconName = "BankAccount"
export const Barcode = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,14 L2,14 L2,2 L0,2 L0,14 Z M6,14 L7,14 L7,2 L6,2 L6,14 Z M8,14 L9,14 L9,2 L8,2 L8,14 Z M3,14 L5,14 L5,2 L3,2 L3,14 Z M15,2 L15,14 L16,14 L16,2 L15,2 Z M10,14 L11,14 L11,2 L10,2 L10,14 Z M12,14 L14,14 L14,2 L12,2 L12,14 Z" />
  </svg>
)
Barcode.iconName = "Barcode"
export const BlockedPerson = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.39003037,12.69 C8.19003588,12.16 8.35003515,11.84 8.31003533,11.4 C8.30003538,11.33 8.30003538,11.27 8.29003542,11.2 C8.70003354,10.83 9.04003198,10.33 9.26003097,9.76 C9.26003097,9.76 9.27003092,9.73 9.27003092,9.72 C9.32003069,9.59 9.36003051,9.46 9.40003032,9.33 C9.67002908,9.27 9.83002835,8.97 9.90002803,8.7 C9.91002798,8.67 9.93002789,8.62 9.9500278,8.58 C8.18003593,7.8 6.94004163,6.04 6.94004163,4 C6.94004163,3.68 6.98004144,3.38 7.03004121,3.08 C6.86004199,3.05 6.68004282,3 6.52004356,3 C5.87004654,3 5.15004985,3.2 4.64005219,3.59 C4.14005449,3.97 3.77005619,4.51 3.59005702,5.1 C3.5500572,5.24 3.52005734,5.37 3.50005743,5.51 C3.41005785,5.99 3.36005808,6.74 3.36005808,7.25 L3.36005808,7.31 C3.17005895,7.39 3.00005973,7.58 2.96005991,7.99 C2.93006005,8.3 3.06005945,8.58 3.12005918,8.69 C3.1800589,8.97 3.35005812,9.28 3.63005683,9.33 C3.67005665,9.47 3.71005647,9.6 3.76005624,9.72 C3.76005624,9.73 3.77005619,9.74 3.77005619,9.74 L3.77005619,9.75 C3.99005518,10.34 4.34005357,10.85 4.76005164,11.21 C4.76005164,11.27 4.75005169,11.33 4.75005169,11.38 C4.71005187,11.82 4.83005132,12.14 3.63005683,12.67 C2.43006235,13.2 0.620070664,13.77 0.250072364,14.62 C-0.119925936,15.5 0.0300733749,16 0.0300733749,16 L12.9900138,16 C12.9900138,16 13.1400131,15.5 12.7700148,14.64 C12.4000165,13.79 10.5900249,13.22 9.39003037,12.69 L9.39003037,12.69 Z M11.9700185,0 C9.75002872,0 7.94003703,1.79 7.94003703,4 C7.94003703,6.21 9.74002876,8 11.9700185,8 C14.2000083,8 16,6.21 16,4 C16,1.79 14.2000083,0 11.9700185,0 L11.9700185,0 Z M9.96002775,4 C9.96002775,2.9 10.8600236,2 11.9700185,2 C12.3400168,2 12.6900152,2.11 12.9900138,2.28 L10.2400265,5.01 C10.0700272,4.71 9.96002775,4.37 9.96002775,4 Z M11.9700185,6 C11.6000202,6 11.2500218,5.89 10.9500232,5.72 L13.7000106,2.99 C13.8800097,3.29 13.9800093,3.63 13.9800093,4 C13.9900092,5.1 13.0800134,6 11.9700185,6 Z" />
  </svg>
)
BlockedPerson.iconName = "BlockedPerson"
export const Bold = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.7,7 C11.9,6.6 12,6 12,5.5 L12,5.1 L12,5 C12,4.9 12,4.8 11.9,4.7 L11.9,4.6 C11.4,3.1 10.1,2 8.5,2 L4,2 C3.5,2 3,2.4 3,3 L3,13 C3,13.5 3.4,14 4,14 L9,14 C11.2,14 13,12.2 13,10 C13,8.8 12.5,7.7 11.7,7 Z M6,5 L8,5 C8.6,5 9,5.4 9,6 C9,6.6 8.6,7 8,7 L6,7 L6,5 Z M9,11 L6,11 L6,9 L9,9 C9.6,9 10,9.4 10,10 C10,10.6 9.6,11 9,11 Z" />
  </svg>
)
Bold.iconName = "Bold"
export const Book = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,1 L2,15 C2,15.55 2.45,16 3,16 L4,16 L4,0 L3,0 C2.45,0 2,0.45 2,1 Z M13,0 L12,0 L12,7 L10,5 L8,7 L8,0 L5,0 L5,16 L13,16 C13.55,16 14,15.55 14,15 L14,1 C14,0.45 13.55,0 13,0 Z" />
  </svg>
)
Book.iconName = "Book"
export const Bookmark = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.195,0.00999779094 L11.045,0.00999779094 C11.025,0.00999779094 11.015,0 10.995,0 L4.995,0 C4.975,0 4.965,0.00999779094 4.945,0.00999779094 L4.795,0.00999779094 C4.355,0.00999779094 3.995,0.379916056 3.995,0.829816648 L3.995,15.5765583 C3.995,16.0264589 4.245,16.1364346 4.565,15.8165053 L7.435,12.8771547 C7.745,12.5572254 8.255,12.5572254 8.565,12.8771547 L11.435,15.8165053 C11.745,16.1364346 12.005,16.0264589 12.005,15.5765583 L12.005,0.829816648 C11.995,0.379916056 11.635,0.00999779094 11.195,0.00999779094 Z" />
  </svg>
)
Bookmark.iconName = "Bookmark"
export const Box = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,10 L10,10 C10.55,10 11,9.55 11,9 C11,8.45 10.55,8 10,8 L6,8 C5.45,8 5,8.45 5,9 C5,9.55 5.45,10 6,10 Z M15.93,5.63 L15.93,5.61 L13.94,0.63 C13.78,0.26 13.42,0 13,0 L3,0 C2.58,0 2.22,0.26 2.07,0.63 L0.08,5.61 L0.07,5.63 C0.03,5.74 0,5.87 0,6 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,6 C16,5.87 15.97,5.74 15.93,5.63 Z M9,2 L12.32,2 L13.52,5 L9,5 L9,2 Z M3.68,2 L7,2 L7,5 L2.48,5 L3.68,2 Z M14,14 L2,14 L2,7 L14,7 L14,14 Z" />
  </svg>
)
Box.iconName = "Box"
export const Briefcase = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,4 L12,4 L12,2 C12,1.45 11.55,1 11,1 L5,1 C4.45,1 4,1.45 4,2 L4,4 L1,4 C0.45,4 0,4.45 0,5 L0,9 L3,9 L3,8 L5,8 L5,9 L11,9 L11,8 L13,8 L13,9 L16,9 L16,5 C16,4.45 15.55,4 15,4 Z M10,4 L6,4 L6,3 L10,3 L10,4 Z M13,11 L11,11 L11,10 L5,10 L5,11 L3,11 L3,10 L0,10 L0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 L16,10 L13,10 L13,11 Z" />
  </svg>
)
Briefcase.iconName = "Briefcase"
export const Build = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.3875,12.4229231 L7.6975,6.02262651 L8.7675,4.92429167 C9.1075,4.58480636 8.6475,4.29524536 8.8875,3.66619905 C9.7675,1.49948396 12.2975,1.31975644 12.2975,1.31975644 C12.2975,1.31975644 12.6575,0.950316544 13.0075,0.600846369 C9.7375,-0.777064606 7.5275,0.56090692 6.5375,1.42958993 L3.1175,4.92429167 L2.4075,5.64320175 C2.0175,6.04259623 2.0175,6.69161227 2.4075,7.09100676 L1.7075,7.80991683 C1.3175,7.41052235 0.6875,7.41052235 0.2975,7.80991683 C-0.0925,8.20931132 -0.0925,8.85832736 0.2975,9.25772184 L1.7075,10.7055269 C2.0975,11.1049213 2.7275,11.1049213 3.1175,10.7055269 C3.5075,10.3061324 3.5075,9.65711633 3.1175,9.25772184 L3.8275,8.53881177 C4.2175,8.93820625 4.8475,8.93820625 5.2375,8.53881177 L6.0375,7.72005307 L12.4275,15.3784423 C13.2475,16.197201 14.5675,16.197201 15.3875,15.3784423 C16.1975,14.5596836 16.1975,13.231697 15.3875,12.4229231 Z" />
  </svg>
)
Build.iconName = "Build"
export const Calculator = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,0 L3,0 C2.45,0 2,0.45 2,1 L2,15 C2,15.55 2.45,16 3,16 L13,16 C13.55,16 14,15.55 14,15 L14,1 C14,0.45 13.55,0 13,0 Z M6,14 L4,14 L4,12 L6,12 L6,14 Z M6,11 L4,11 L4,9 L6,9 L6,11 Z M6,8 L4,8 L4,6 L6,6 L6,8 Z M9,14 L7,14 L7,12 L9,12 L9,14 Z M9,11 L7,11 L7,9 L9,9 L9,11 Z M9,8 L7,8 L7,6 L9,6 L9,8 Z M12,14 L10,14 L10,9 L12,9 L12,14 Z M12,8 L10,8 L10,6 L12,6 L12,8 Z M12,5 L4,5 L4,2 L12,2 L12,5 Z" />
  </svg>
)
Calculator.iconName = "Calculator"
export const Calendar = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5,3.5 C12.1,3.5 12.5,3 12.5,2.5 L12.5,1.5 C12.5,0.9 12.1,0.5 11.5,0.5 C10.9,0.5 10.5,0.9 10.5,1.5 L10.5,2.5 C10.5,3 10.9,3.5 11.5,3.5 Z M14.5,1.5 L13.5,1.5 L13.5,2.5 C13.5,3.6 12.6,4.5 11.5,4.5 C10.4,4.5 9.5,3.6 9.5,2.5 L9.5,1.5 L6.5,1.5 L6.5,2.5 C6.5,3.6 5.6,4.5 4.5,4.5 C3.4,4.5 2.5,3.6 2.5,2.5 L2.5,1.5 L1.5,1.5 C0.9,1.5 0.5,2 0.5,2.5 L0.5,14.5 C0.5,15.1 0.9,15.5 1.5,15.5 L14.5,15.5 C15.1,15.5 15.5,15.1 15.5,14.5 L15.5,2.5 C15.5,1.9 15,1.5 14.5,1.5 Z M5.5,13.5 L2.5,13.5 L2.5,10.5 L5.5,10.5 L5.5,13.5 Z M5.5,9.5 L2.5,9.5 L2.5,6.5 L5.5,6.5 L5.5,9.5 Z M9.5,13.5 L6.5,13.5 L6.5,10.5 L9.5,10.5 L9.5,13.5 Z M9.5,9.5 L6.5,9.5 L6.5,6.5 L9.5,6.5 L9.5,9.5 Z M13.5,13.5 L10.5,13.5 L10.5,10.5 L13.5,10.5 L13.5,13.5 Z M13.5,9.5 L10.5,9.5 L10.5,6.5 L13.5,6.5 L13.5,9.5 Z M4.5,3.5 C5.1,3.5 5.5,3 5.5,2.5 L5.5,1.5 C5.5,0.9 5.1,0.5 4.5,0.5 C3.9,0.5 3.5,0.9 3.5,1.5 L3.5,2.5 C3.5,3 3.9,3.5 4.5,3.5 Z" />
  </svg>
)
Calendar.iconName = "Calendar"
export const Camera = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,3.5 L12.41,3.5 L10.7,1.79 C10.53,1.61 10.28,1.5 10,1.5 L6,1.5 C5.72,1.5 5.47,1.61 5.29,1.79 L3.59,3.5 L1,3.5 C0.45,3.5 0,3.95 0,4.5 L0,11.5 C0,12.05 0.45,12.5 1,12.5 L3.56,12.5 C4.66,13.72 6.23,14.5 8,14.5 C9.77,14.5 11.34,13.72 12.44,12.5 L15,12.5 C15.55,12.5 16,12.05 16,11.5 L16,4.5 C16,3.95 15.55,3.5 15,3.5 Z M3,6.5 L1,6.5 L1,5.5 L3,5.5 L3,6.5 Z M8,12.5 C5.79,12.5 4,10.71 4,8.5 C4,6.29 5.79,4.5 8,4.5 C10.21,4.5 12,6.29 12,8.5 C12,10.71 10.21,12.5 8,12.5 Z M8,6.5 C6.9,6.5 6,7.4 6,8.5 C6,9.6 6.9,10.5 8,10.5 C9.1,10.5 10,9.6 10,8.5 C10,7.4 9.1,6.5 8,6.5 Z" />
  </svg>
)
Camera.iconName = "Camera"
export const CaretDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5,6 C11.5,5.72 11.3075,5.5 11.0625,5.5 L4.9375,5.5 C4.6925,5.5 4.5,5.72 4.5,6 C4.5,6.13 4.54375,6.24 4.61375,6.33 L7.67625,10.33 C7.755,10.43 7.86875,10.5 8,10.5 C8.13125,10.5 8.245,10.43 8.32375,10.33 L11.38625,6.33 C11.45625,6.24 11.5,6.13 11.5,6 Z" />
  </svg>
)
CaretDown.iconName = "CaretDown"
export const CaretLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,12 C9.87,12 9.76,11.95 9.67,11.87 L5.67,8.37 C5.57,8.28 5.5,8.15 5.5,8 C5.5,7.85 5.57,7.72 5.67,7.63 L9.67,4.13 C9.76,4.05 9.87,4 10,4 C10.28,4 10.5,4.22 10.5,4.5 L10.5,11.5 C10.5,11.78 10.28,12 10,12 Z" />
  </svg>
)
CaretLeft.iconName = "CaretLeft"
export const CaretUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5,10 C11.5,10.28 11.3075,10.5 11.0625,10.5 L4.9375,10.5 C4.6925,10.5 4.5,10.28 4.5,10 C4.5,9.87 4.54375,9.76 4.61375,9.67 L7.67625,5.67 C7.755,5.57 7.86875,5.5 8,5.5 C8.13125,5.5 8.245,5.57 8.32375,5.67 L11.38625,9.67 C11.45625,9.76 11.5,9.87 11.5,10 Z" />
  </svg>
)
CaretUp.iconName = "CaretUp"
export const CellTower = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.97391771,6.76210375 C8.96392239,6.71211216 8.93393645,6.68211721 8.91394582,6.63212562 C8.89395519,6.58213403 8.88395987,6.53214245 8.86396924,6.48215086 C8.94393176,6.34217441 9.00390365,6.18220133 9.00390365,6.00223161 C9.00390365,5.45232414 8.55411449,5.00239985 8.00437218,5.00239985 C7.45462987,5.00239985 7.00484071,5.45232414 7.00484071,6.00223161 C7.00484071,6.18220133 7.0648126,6.34217441 7.14477512,6.48215086 C7.11478917,6.53214245 7.11478917,6.58213403 7.09479854,6.63212562 C7.07480791,6.68211721 7.04482197,6.71211216 7.03482666,6.76210375 L5.03576372,14.7607579 C4.90582463,15.300667 5.2256747,15.8405762 5.76542169,15.9705543 C6.30516868,16.1005324 6.84491568,15.7805863 6.97485477,15.2406771 L7.53459239,13.001054 L8.47415197,13.001054 L9.03388959,15.2406771 C9.16382869,15.7805863 9.71357099,16.1005324 10.2433227,15.9705543 C10.7830697,15.8405762 11.1029197,15.2906687 10.9729806,14.7607579 L8.97391771,6.76210375 L8.97391771,6.76210375 Z M3.72637749,1.70295502 C4.10619945,1.30302232 4.09620413,0.673128308 3.70638686,0.28319392 C3.31656959,-0.106740469 2.67686945,-0.0867438333 2.28705217,0.303190555 C-0.761518808,3.42266566 -0.761518808,8.58179756 2.28705217,11.7012727 C2.67686945,12.1012054 3.30657427,12.1012054 3.69639155,11.7212693 C4.08620882,11.3413332 4.09620413,10.7014409 3.71638218,10.3115065 C1.43745043,7.96190187 1.43745043,4.04256135 3.72637749,1.70295502 L3.72637749,1.70295502 Z M11.6026855,3.20270267 C11.1628916,2.87275819 10.5331868,2.96274305 10.2033414,3.40266902 C9.87349603,3.842595 9.96345386,4.47248901 10.4032477,4.80243349 C10.8330462,5.12237966 10.9329994,6.76210375 10.3632664,7.23202468 C9.94346323,7.5819658 9.88349134,8.21185981 10.2333274,8.64178747 C10.5831634,9.06171681 11.2128682,9.12170672 11.6426667,8.7717656 C13.2319218,7.44198935 13.0320155,4.27252266 11.6026855,3.20270267 Z M13.7216922,0.303190555 C13.3318749,-0.0967421509 12.7021701,-0.0967421509 12.3123528,0.28319392 C11.9225355,0.66312999 11.9025449,1.30302232 12.2823669,1.70295502 C14.5712939,4.04256135 14.5712939,7.96190187 12.2823669,10.3015082 C11.8925496,10.6914426 11.9025449,11.3313349 12.3023575,11.711271 C12.7021701,12.0912071 13.3318749,12.0912071 13.7116969,11.6912744 C16.7602679,8.58179756 16.7602679,3.42266566 13.7216922,0.303190555 Z M5.40559036,7.23202468 C4.83585742,6.76210375 4.93581057,5.12237966 5.3656091,4.80243349 C5.80540295,4.47248901 5.89536078,3.842595 5.56551539,3.40266902 C5.23567001,2.96274305 4.60596518,2.87275819 4.16617134,3.20270267 C2.72684602,4.27252266 2.53693504,7.44198935 4.12619008,8.7717656 C4.5459933,9.12170672 5.17569812,9.07171513 5.53552945,8.64178747 C5.88536547,8.22185813 5.82539358,7.5819658 5.40559036,7.23202468 Z" />
  </svg>
)
CellTower.iconName = "CellTower"
export const Changes = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.29,7.71 L11.29,10.71 C11.47,10.89 11.72,11 12,11 C12.28,11 12.53,10.89 12.71,10.71 L15.71,7.71 C15.89,7.53 16,7.28 16,7 C16,6.45 15.55,6 15,6 C14.72,6 14.47,6.11 14.29,6.29 L13,7.59 L13,1 C13,0.45 12.55,0 12,0 C11.45,0 11,0.45 11,1 L11,7.59 L9.71,6.29 C9.53,6.11 9.28,6 9,6 C8.45,6 8,6.45 8,7 C8,7.28 8.11,7.53 8.29,7.71 Z M14.5,13 L1.5,13 C0.67,13 0,13.67 0,14.5 C0,15.33 0.67,16 1.5,16 L14.5,16 C15.33,16 16,15.33 16,14.5 C16,13.67 15.33,13 14.5,13 Z M1,5 C1.28,5 1.53,4.89 1.71,4.71 L3,3.41 L3,10 C3,10.55 3.45,11 4,11 C4.55,11 5,10.55 5,10 L5,3.41 L6.29,4.7 C6.47,4.89 6.72,5 7,5 C7.55,5 8,4.55 8,4 C8,3.72 7.89,3.47 7.71,3.29 L4.71,0.29 C4.53,0.11 4.28,0 4,0 C3.72,0 3.47,0.11 3.29,0.29 L0.29,3.29 C0.11,3.47 0,3.72 0,4 C0,4.55 0.45,5 1,5 Z" />
  </svg>
)
Changes.iconName = "Changes"
export const Chart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,14.5 C0,15.05 0.45,15.5 1,15.5 L3,15.5 C3.55,15.5 4,15.05 4,14.5 L4,8.9 L0,10.5 L0,14.5 Z M6,9 L6,14.5 C6,15.05 6.45,15.5 7,15.5 L9,15.5 C9.55,15.5 10,15.05 10,14.5 L10,9.5 L9,10.5 L6,9 Z M13,6.5 L12,7.5 L12,14.5 C12,15.05 12.45,15.5 13,15.5 L15,15.5 C15.55,15.5 16,15.05 16,14.5 L16,7.38 C15.74,7.45 15.42,7.5 15,7.5 C13.04,7.5 13,6.5 13,6.5 Z M15,0.5 L12,0.5 C11.45,0.5 11,0.95 11,1.5 C11,2.05 11.45,2.5 12,2.5 L12.59,2.5 L8.8,6.28 L5.45,4.61 L5.45,4.62 C5.31,4.55 5.16,4.5 5,4.5 C4.84,4.5 4.69,4.55 4.56,4.61 L4.56,4.6 L0.56,6.6 L0.56,6.61 C0.23,6.78 0,7.11 0,7.5 C0,8.05 0.45,8.5 1,8.5 C1.16,8.5 1.31,8.45 1.44,8.39 L1.44,8.4 L5,6.62 L8.55,8.4 L8.55,8.39 C8.69,8.45 8.84,8.5 9,8.5 C9.28,8.5 9.53,8.39 9.71,8.21 L14,3.91 L14,4.5 C14,5.05 14.45,5.5 15,5.5 C15.55,5.5 16,5.05 16,4.5 L16,1.5 C16,0.95 15.55,0.5 15,0.5 Z" />
  </svg>
)
Chart.iconName = "Chart"
export const ChevronBackward = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.91,8 L11.2,4.71 C11.39,4.53 11.5,4.28 11.5,4 C11.5,3.45 11.05,3 10.5,3 C10.22,3 9.97,3.11 9.79,3.29 L6.5,6.59 L6.5,4 C6.5,3.45 6.05,3 5.5,3 C4.95,3 4.5,3.45 4.5,4 L4.5,12 C4.5,12.55 4.95,13 5.5,13 C6.05,13 6.5,12.55 6.5,12 L6.5,9.41 L9.79,12.7 C9.97,12.89 10.22,13 10.5,13 C11.05,13 11.5,12.55 11.5,12 C11.5,11.72 11.39,11.47 11.21,11.29 L7.91,8 Z" />
  </svg>
)
ChevronBackward.iconName = "ChevronBackward"
export const ChevronDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,5 C11.72,5 11.47,5.11 11.29,5.29 L8,8.59 L4.71,5.29 C4.53,5.11 4.28,5 4,5 C3.45,5 3,5.45 3,6 C3,6.28 3.11,6.53 3.29,6.71 L7.29,10.71 C7.47,10.89 7.72,11 8,11 C8.28,11 8.53,10.89 8.71,10.71 L12.71,6.71 C12.89,6.53 13,6.28 13,6 C13,5.45 12.55,5 12,5 Z" />
  </svg>
)
ChevronDown.iconName = "ChevronDown"
export const ChevronForward = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5,3 C9.95,3 9.5,3.45 9.5,4 L9.5,6.59 L6.21,3.29 C6.03,3.11 5.78,3 5.5,3 C4.95,3 4.5,3.45 4.5,4 C4.5,4.28 4.61,4.53 4.79,4.71 L8.09,8 L4.8,11.29 C4.61,11.47 4.5,11.72 4.5,12 C4.5,12.55 4.95,13 5.5,13 C5.78,13 6.03,12.89 6.21,12.71 L9.5,9.41 L9.5,12 C9.5,12.55 9.95,13 10.5,13 C11.05,13 11.5,12.55 11.5,12 L11.5,4 C11.5,3.45 11.05,3 10.5,3 Z" />
  </svg>
)
ChevronForward.iconName = "ChevronForward"
export const ChevronLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.71,7.29 L6.71,3.29 C6.53,3.11 6.28,3 6,3 C5.45,3 5,3.45 5,4 C5,4.28 5.11,4.53 5.29,4.71 L8.59,8 L5.3,11.29 C5.11,11.47 5,11.72 5,12 C5,12.55 5.45,13 6,13 C6.28,13 6.53,12.89 6.71,12.71 L10.71,8.71 C10.89,8.53 11,8.28 11,8 C11,7.72 10.89,7.47 10.71,7.29 Z"
      transform="matrix(-1 0 0 1 16 0)"
    />
  </svg>
)
ChevronLeft.iconName = "ChevronLeft"
export const ChevronRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.71,7.29 L6.71,3.29 C6.53,3.11 6.28,3 6,3 C5.45,3 5,3.45 5,4 C5,4.28 5.11,4.53 5.29,4.71 L8.59,8 L5.3,11.29 C5.11,11.47 5,11.72 5,12 C5,12.55 5.45,13 6,13 C6.28,13 6.53,12.89 6.71,12.71 L10.71,8.71 C10.89,8.53 11,8.28 11,8 C11,7.72 10.89,7.47 10.71,7.29 Z" />
  </svg>
)
ChevronRight.iconName = "ChevronRight"
export const ChevronUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.71,9.29 L8.71,5.29 C8.53,5.11 8.28,5 8,5 C7.72,5 7.47,5.11 7.29,5.29 L3.29,9.29 C3.11,9.47 3,9.72 3,10 C3,10.55 3.45,11 4,11 C4.28,11 4.53,10.89 4.71,10.71 L8,7.41 L11.29,10.7 C11.47,10.89 11.72,11 12,11 C12.55,11 13,10.55 13,10 C13,9.72 12.89,9.47 12.71,9.29 Z" />
  </svg>
)
ChevronUp.iconName = "ChevronUp"
export const CircleArrowDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,7 C10.72,7 10.47,7.11 10.29,7.29 L9,8.59 L9,5 C9,4.45 8.55,4 8,4 C7.45,4 7,4.45 7,5 L7,8.59 L5.71,7.29 C5.53,7.11 5.28,7 5,7 C4.45,7 4,7.45 4,8 C4,8.28 4.11,8.53 4.29,8.71 L7.29,11.71 C7.47,11.89 7.72,12 8,12 C8.28,12 8.53,11.89 8.71,11.71 L11.71,8.71 C11.89,8.53 12,8.28 12,8 C12,7.45 11.55,7 11,7 Z M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,4.69 4.69,2 8,2 C11.31,2 14,4.69 14,8 C14,11.31 11.31,14 8,14 Z" />
  </svg>
)
CircleArrowDown.iconName = "CircleArrowDown"
export const CircleArrowLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,7 L7.41,7 L8.7,5.71 C8.89,5.53 9,5.28 9,5 C9,4.45 8.55,4 8,4 C7.72,4 7.47,4.11 7.29,4.29 L4.29,7.29 C4.11,7.47 4,7.72 4,8 C4,8.28 4.11,8.53 4.29,8.71 L7.29,11.71 C7.47,11.89 7.72,12 8,12 C8.55,12 9,11.55 9,11 C9,10.72 8.89,10.47 8.71,10.29 L7.41,9 L11,9 C11.55,9 12,8.55 12,8 C12,7.45 11.55,7 11,7 Z M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,4.69 4.69,2 8,2 C11.31,2 14,4.69 14,8 C14,11.31 11.31,14 8,14 Z" />
  </svg>
)
CircleArrowLeft.iconName = "CircleArrowLeft"
export const CircleArrowRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.71,4.29 C8.53,4.11 8.28,4 8,4 C7.45,4 7,4.45 7,5 C7,5.28 7.11,5.53 7.29,5.71 L8.59,7 L5,7 C4.45,7 4,7.45 4,8 C4,8.55 4.45,9 5,9 L8.59,9 L7.3,10.29 C7.11,10.47 7,10.72 7,11 C7,11.55 7.45,12 8,12 C8.28,12 8.53,11.89 8.71,11.71 L11.71,8.71 C11.89,8.53 12,8.28 12,8 C12,7.72 11.89,7.47 11.71,7.29 L8.71,4.29 Z M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,4.69 4.69,2 8,2 C11.31,2 14,4.69 14,8 C14,11.31 11.31,14 8,14 Z" />
  </svg>
)
CircleArrowRight.iconName = "CircleArrowRight"
export const CircleArrowUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.71,4.29 C8.53,4.11 8.28,4 8,4 C7.72,4 7.47,4.11 7.29,4.29 L4.29,7.29 C4.11,7.47 4,7.72 4,8 C4,8.55 4.45,9 5,9 C5.28,9 5.53,8.89 5.71,8.71 L7,7.41 L7,11 C7,11.55 7.45,12 8,12 C8.55,12 9,11.55 9,11 L9,7.41 L10.29,8.7 C10.47,8.89 10.72,9 11,9 C11.55,9 12,8.55 12,8 C12,7.72 11.89,7.47 11.71,7.29 L8.71,4.29 Z M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,4.69 4.69,2 8,2 C11.31,2 14,4.69 14,8 C14,11.31 11.31,14 8,14 Z" />
  </svg>
)
CircleArrowUp.iconName = "CircleArrowUp"
export const Circle = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 Z M8,14 C4.7,14 2,11.3 2,8 C2,4.7 4.7,2 8,2 C11.3,2 14,4.7 14,8 C14,11.3 11.3,14 8,14 Z" />
  </svg>
)
Circle.iconName = "Circle"
export const Citation = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,5.5 C15,3.84 13.66,2.5 12,2.5 C10.34,2.5 9,3.84 9,5.5 C9,7.16 10.34,8.5 12,8.5 C12.21,8.5 12.41,8.48 12.6,8.44 C12.08,10.26 11.12,11.5 10,11.5 C9.45,11.5 9,11.95 9,12.5 C9,13.05 9.45,13.5 10,13.5 C12.76,13.5 15,10.37 15,6.5 C15,6.3 14.98,6.11 14.96,5.92 C14.97,5.78 15,5.64 15,5.5 Z M4,2.5 C2.34,2.5 1,3.84 1,5.5 C1,7.16 2.34,8.5 4,8.5 C4.21,8.5 4.41,8.48 4.6,8.44 C4.08,10.26 3.12,11.5 2,11.5 C1.45,11.5 1,11.95 1,12.5 C1,13.05 1.45,13.5 2,13.5 C4.76,13.5 7,10.37 7,6.5 C7,6.3 6.98,6.11 6.96,5.92 C6.97,5.78 7,5.64 7,5.5 C7,3.84 5.65,2.5 4,2.5 Z" />
  </svg>
)
Citation.iconName = "Citation"
export const Clipboard = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5,2 C10.5,1.45 10.05,1 9.5,1 L9.72,1 C9.38,0.4 8.74,0 8,0 C7.26,0 6.62,0.4 6.28,1 L6.5,1 C5.95,1 5.5,1.45 5.5,2 L5.5,3 L10.5,3 L10.5,2 Z M12.5,2 L11.5,2 L11.5,4 L4.5,4 L4.5,2 L3.5,2 C2.95,2 2.5,2.45 2.5,3 L2.5,15 C2.5,15.55 2.95,16 3.5,16 L12.5,16 C13.05,16 13.5,15.55 13.5,15 L13.5,3 C13.5,2.45 13.05,2 12.5,2 Z" />
  </svg>
)
Clipboard.iconName = "Clipboard"
export const CloudDownload = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,11 C10.72,11 10.47,11.11 10.29,11.29 L9,12.59 L9,8 C9,7.45 8.55,7 8,7 C7.45,7 7,7.45 7,8 L7,12.59 L5.71,11.3 C5.53,11.11 5.28,11 5,11 C4.45,11 4,11.45 4,12 C4,12.28 4.11,12.53 4.29,12.71 L7.29,15.71 C7.47,15.89 7.72,16 8,16 C8.28,16 8.53,15.89 8.71,15.71 L11.71,12.71 C11.89,12.53 12,12.28 12,12 C12,11.45 11.55,11 11,11 Z M12,4 C11.97,4 11.93,4 11.9,4.01 C11.44,1.72 9.42,0 7,0 C4.24,0 2,2.24 2,5 C2,5.11 2.01,5.22 2.02,5.33 C0.83,5.89 0,7.1 0,8.5 C0,9.91 0.84,11.11 2.03,11.67 C2.2,10.17 3.46,9 5,9 C5.06,9 5.13,9.02 5.19,9.02 C5.07,8.7 5,8.36 5,8 C5,6.34 6.34,5 8,5 C9.66,5 11,6.34 11,8 C11,8.36 10.93,8.7 10.81,9.02 C10.87,9.02 10.94,9 11,9 C12.48,9 13.7,10.07 13.95,11.47 C15.17,10.79 16,9.5 16,8 C16,5.79 14.21,4 12,4 Z" />
  </svg>
)
CloudDownload.iconName = "CloudDownload"
export const CloudUpload = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.71,7.29 C8.53,7.11 8.28,7 8,7 C7.72,7 7.47,7.11 7.29,7.29 L4.29,10.29 C4.11,10.47 4,10.72 4,11 C4,11.55 4.45,12 5,12 C5.28,12 5.53,11.89 5.71,11.71 L7,10.41 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,10.41 L10.29,11.7 C10.47,11.89 10.72,12 11,12 C11.55,12 12,11.55 12,11 C12,10.72 11.89,10.47 11.71,10.29 L8.71,7.29 Z M12,4 C11.97,4 11.93,4 11.9,4.01 C11.44,1.72 9.42,0 7,0 C4.24,0 2,2.24 2,5 C2,5.11 2.01,5.22 2.02,5.33 C0.83,5.89 0,7.1 0,8.5 C0,9.93 0.86,11.16 2.09,11.7 C2.04,11.47 2,11.24 2,11 C2,10.17 2.34,9.42 2.88,8.88 L5.88,5.88 C6.42,5.34 7.17,5 8,5 C8.83,5 9.58,5.34 10.12,5.88 L13.12,8.88 C13.66,9.42 14,10.17 14,11 C14,11.16 13.98,11.32 13.95,11.47 C15.17,10.78 16,9.5 16,8 C16,5.79 14.21,4 12,4 Z" />
  </svg>
)
CloudUpload.iconName = "CloudUpload"
export const Cloud = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,6 C11.97,6 11.93,6 11.9,6.01 C11.44,3.72 9.42,2 7,2 C4.24,2 2,4.24 2,7 C2,7.11 2.01,7.22 2.02,7.33 C0.83,7.89 0,9.1 0,10.5 C0,12.43 1.57,14 3.5,14 L12,14 C14.21,14 16,12.21 16,10 C16,7.79 14.21,6 12,6 Z" />
  </svg>
)
Cloud.iconName = "Cloud"
export const CodeBlock = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,3 L13,3 L13,2 C13,1.45 12.55,1 12,1 L10,1 C9.45,1 9,1.45 9,2 L9,3 L7,3 L7,2 C7,1.45 6.55,1 6,1 L4,1 C3.45,1 3,1.45 3,2 L3,3 L1,3 C0.45,3 0,3.45 0,4 L0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 L16,4 C16,3.45 15.55,3 15,3 Z M6.71,11.29 C6.89,11.47 7,11.72 7,12 C7,12.55 6.55,13 6,13 C5.72,13 5.47,12.89 5.29,12.71 L2.29,9.71 C2.11,9.53 2,9.28 2,9 C2,8.72 2.11,8.47 2.29,8.29 L5.29,5.29 C5.47,5.11 5.72,5 6,5 C6.55,5 7,5.45 7,6 C7,6.28 6.89,6.53 6.71,6.71 L4.41,9 L6.71,11.29 Z M13.71,9.71 L10.71,12.71 C10.53,12.89 10.28,13 10,13 C9.45,13 9,12.55 9,12 C9,11.72 9.11,11.47 9.29,11.29 L11.59,9 L9.29,6.71 C9.11,6.53 9,6.28 9,6 C9,5.45 9.45,5 10,5 C10.28,5 10.53,5.11 10.71,5.29 L13.71,8.29 C13.89,8.47 14,8.72 14,9 C14,9.28 13.89,9.53 13.71,9.71 L13.71,9.71 Z" />
  </svg>
)
CodeBlock.iconName = "CodeBlock"
export const Code = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.71,7.29 L12.71,4.29 C12.53,4.11 12.28,4 12,4 C11.45,4 11,4.45 11,5 C11,5.28 11.11,5.53 11.29,5.71 L13.59,8 L11.3,10.29 C11.11,10.47 11,10.72 11,11 C11,11.55 11.45,12 12,12 C12.28,12 12.53,11.89 12.71,11.71 L15.71,8.71 C15.89,8.53 16,8.28 16,8 C16,7.72 15.89,7.47 15.71,7.29 Z M5,5 C5,4.45 4.55,4 4,4 C3.72,4 3.47,4.11 3.29,4.29 L0.29,7.29 C0.11,7.47 0,7.72 0,8 C0,8.28 0.11,8.53 0.29,8.71 L3.29,11.71 C3.47,11.89 3.72,12 4,12 C4.55,12 5,11.55 5,11 C5,10.72 4.89,10.47 4.71,10.29 L2.41,8 L4.7,5.71 C4.89,5.53 5,5.28 5,5 Z M9,2 C8.52,2 8.13,2.35 8.04,2.81 L6.04,12.81 C6.03,12.87 6,12.93 6,13 C6,13.55 6.45,14 7,14 C7.48,14 7.87,13.65 7.96,13.19 L9.96,3.19 C9.97,3.13 10,3.07 10,3 C10,2.45 9.55,2 9,2 L9,2 Z" />
  </svg>
)
Code.iconName = "Code"
export const CollapseAll = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.29,6.71 C7.47,6.89 7.72,7 8,7 C8.28,7 8.53,6.89 8.71,6.71 L12.71,2.71 C12.89,2.53 13,2.28 13,2 C13,1.45 12.55,1 12,1 C11.72,1 11.47,1.11 11.29,1.29 L8,4.59 L4.71,1.29 C4.53,1.11 4.28,1 4,1 C3.45,1 3,1.45 3,2 C3,2.28 3.11,2.53 3.29,2.71 L7.29,6.71 Z M8.71,9.29 C8.53,9.11 8.28,9 8,9 C7.72,9 7.47,9.11 7.29,9.29 L3.29,13.29 C3.11,13.47 3,13.72 3,14 C3,14.55 3.45,15 4,15 C4.28,15 4.53,14.89 4.71,14.71 L8,11.41 L11.29,14.7 C11.47,14.89 11.72,15 12,15 C12.55,15 13,14.55 13,14 C13,13.72 12.89,13.47 12.71,13.29 L8.71,9.29 Z" />
  </svg>
)
CollapseAll.iconName = "CollapseAll"
export const ColumnLayout = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 L16,2 C16,1.45 15.55,1 15,1 Z M4,13 L2,13 L2,3 L4,3 L4,13 Z M7,13 L5,13 L5,3 L7,3 L7,13 Z M14,13 L8,13 L8,3 L14,3 L14,13 Z" />
  </svg>
)
ColumnLayout.iconName = "ColumnLayout"
export const Comment = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,0.5 L1.5,0.5 C0.95,0.5 0.5,0.95 0.5,1.5 L0.5,10.5 C0.5,11.05 0.95,11.5 1.5,11.5 L3.5,11.5 L3.5,14.5 C3.5,15.05 3.95,15.5 4.5,15.5 C4.78,15.5 5.03,15.39 5.21,15.21 L8.91,11.5 L14.5,11.5 C15.05,11.5 15.5,11.05 15.5,10.5 L15.5,1.5 C15.5,0.95 15.05,0.5 14.5,0.5 Z M4,7.5 C3.17,7.5 2.5,6.83 2.5,6 C2.5,5.17 3.17,4.5 4,4.5 C4.83,4.5 5.5,5.17 5.5,6 C5.5,6.83 4.83,7.5 4,7.5 Z M8,7.5 C7.17,7.5 6.5,6.83 6.5,6 C6.5,5.17 7.17,4.5 8,4.5 C8.83,4.5 9.5,5.17 9.5,6 C9.5,6.83 8.83,7.5 8,7.5 Z M12,7.5 C11.17,7.5 10.5,6.83 10.5,6 C10.5,5.17 11.17,4.5 12,4.5 C12.83,4.5 13.5,5.17 13.5,6 C13.5,6.83 12.83,7.5 12,7.5 Z" />
  </svg>
)
Comment.iconName = "Comment"
export const Comparison = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0.00499687695 C7.45034354,0.00499687695 7.00062461,0.454715803 7.00062461,1.00437227 L7.00062461,14.9956277 C7.00062461,15.5452842 7.45034354,15.9950031 8,15.9950031 C8.54965646,15.9950031 8.99937539,15.5452842 8.99937539,14.9956277 L8.99937539,1.00437227 C8.99937539,0.454715803 8.54965646,0.00499687695 8,0.00499687695 Z M5.00187383,3.00312305 L1.00437227,3.00312305 C0.454715803,3.00312305 0.00499687695,3.45284197 0.00499687695,4.00249844 L0.00499687695,6.00124922 C0.00499687695,6.55090568 0.454715803,7.00062461 1.00437227,7.00062461 L5.00187383,7.00062461 C5.55153029,7.00062461 6.00124922,6.55090568 6.00124922,6.00124922 L6.00124922,4.00249844 C6.00124922,3.45284197 5.55153029,3.00312305 5.00187383,3.00312305 Z M14.9956277,3.00312305 L10.9981262,3.00312305 C10.4484697,3.00312305 9.99875078,3.45284197 9.99875078,4.00249844 L9.99875078,6.00124922 C9.99875078,6.55090568 10.4484697,7.00062461 10.9981262,7.00062461 L14.9956277,7.00062461 C15.5452842,7.00062461 15.9950031,6.55090568 15.9950031,6.00124922 L15.9950031,4.00249844 C15.9950031,3.45284197 15.5452842,3.00312305 14.9956277,3.00312305 Z M14.9956277,6.00124922 L10.9981262,6.00124922 L10.9981262,4.00249844 L14.9956277,4.00249844 L14.9956277,6.00124922 Z M14.9956277,8.99937539 L10.9981262,8.99937539 C10.4484697,8.99937539 9.99875078,9.44909432 9.99875078,9.99875078 L9.99875078,11.9975016 C9.99875078,12.547158 10.4484697,12.996877 10.9981262,12.996877 L14.9956277,12.996877 C15.5452842,12.996877 15.9950031,12.547158 15.9950031,11.9975016 L15.9950031,9.99875078 C15.9950031,9.44909432 15.5452842,8.99937539 14.9956277,8.99937539 Z M14.9956277,11.9975016 L10.9981262,11.9975016 L10.9981262,9.99875078 L14.9956277,9.99875078 L14.9956277,11.9975016 Z M5.00187383,8.99937539 L1.00437227,8.99937539 C0.454715803,8.99937539 0.00499687695,9.44909432 0.00499687695,9.99875078 L0.00499687695,11.9975016 C0.00499687695,12.547158 0.454715803,12.996877 1.00437227,12.996877 L5.00187383,12.996877 C5.55153029,12.996877 6.00124922,12.547158 6.00124922,11.9975016 L6.00124922,9.99875078 C6.00124922,9.44909432 5.55153029,8.99937539 5.00187383,8.99937539 Z" />
  </svg>
)
Comparison.iconName = "Comparison"
export const Compass = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,8 C12,8.14 11.97,8.27 11.92,8.39 L8.92,15.38 C8.77,15.75 8.41,16 8,16 C7.59,16 7.23,15.75 7.08,15.39 L4.08,8.4 C4.03,8.27 4,8.14 4,8 C4,7.86 4.03,7.73 4.08,7.61 L7.08,0.62 C7.23,0.25 7.59,0 8,0 C8.41,0 8.77,0.25 8.92,0.61 L11.92,7.6 C11.97,7.73 12,7.86 12,8 Z M8,3.54 L6.09,8 L9.91,8 L8,3.54 Z" />
  </svg>
)
Compass.iconName = "Compass"
export const Compressed = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.93,5.63 L15.93,5.61 L13.94,0.63 C13.78,0.26 13.42,0 13,0 L3,0 C2.58,0 2.22,0.26 2.07,0.63 L0.08,5.61 L0.07,5.63 C0.03,5.74 0,5.87 0,6 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,6 C16,5.87 15.97,5.74 15.93,5.63 Z M9,2 L12.32,2 L13.52,5 L9,5 L9,2 Z M3.68,2 L7,2 L7,5 L2.48,5 L3.68,2 Z M14,14 L2,14 L2,7 L7,7 L7,9.59 L5.71,8.29 C5.53,8.11 5.28,8 5,8 C4.45,8 4,8.45 4,9 C4,9.28 4.11,9.53 4.29,9.71 L7.29,12.71 C7.47,12.89 7.72,13 8,13 C8.28,13 8.53,12.89 8.71,12.71 L11.71,9.71 C11.89,9.53 12,9.28 12,9 C12,8.45 11.55,8 11,8 C10.72,8 10.47,8.11 10.29,8.29 L9,9.59 L9,7 L14,7 L14,14 Z" />
  </svg>
)
Compressed.iconName = "Compressed"
export const Confirm = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.70955653,4.30231106 C8.52966896,4.11242973 8.27982511,4.00249844 8,4.00249844 C7.45034354,4.00249844 7.00062461,4.45221736 7.00062461,5.00187383 C7.00062461,5.28169894 7.1105559,5.53154279 7.29044347,5.71143036 L9.28919425,7.71018114 C9.46908182,7.89006871 9.71892567,8 9.99875078,8 C10.2785759,8 10.5284197,7.89006871 10.7083073,7.71018114 L15.7051843,2.71330418 C15.8850718,2.53341661 15.9950031,2.28357277 15.9950031,2.00374766 C15.9950031,1.45409119 15.5452842,1.00437227 14.9956277,1.00437227 C14.7158026,1.00437227 14.4659588,1.11430356 14.2860712,1.29419113 L9.99875078,5.59150531 L8.70955653,4.30231106 Z M13.9262961,7.31043098 C13.9562773,7.54028732 13.9962523,7.76014991 13.9962523,8 C13.9962523,11.3079325 11.3079325,13.9962523 8,13.9962523 C4.69206746,13.9962523 2.00374766,11.3079325 2.00374766,8 C2.00374766,4.69206746 4.69206746,2.00374766 8,2.00374766 C8.80949407,2.00374766 9.58900687,2.17364147 10.2985634,2.46346034 L11.7976265,0.964397252 C10.6683323,0.354778264 9.37913804,0.00499687695 8,0.00499687695 C3.58276077,0.00499687695 0.00499687695,3.58276077 0.00499687695,8 C0.00499687695,12.4172392 3.58276077,15.9950031 8,15.9950031 C12.4172392,15.9950031 15.9950031,12.4172392 15.9950031,8 C15.9950031,7.17051843 15.8650843,6.36102436 15.635228,5.61149282 L13.9262961,7.31043098 Z" />
  </svg>
)
Confirm.iconName = "Confirm"
export const Console = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L15,1 C15.55,1 16,1.45 16,2 L16,14 C16,14.55 15.55,15 15,15 Z M14,5 L2,5 L2,13 L14,13 L14,5 Z M4,6 C4.28,6 4.53,6.11 4.71,6.29 L6.71,8.29 C6.89,8.47 7,8.72 7,9 C7,9.28 6.89,9.53 6.71,9.71 L4.71,11.71 C4.53,11.89 4.28,12 4,12 C3.45,12 3,11.55 3,11 C3,10.72 3.11,10.47 3.29,10.29 L4.59,9 L3.29,7.71 C3.11,7.53 3,7.28 3,7 C3,6.45 3.45,6 4,6 Z M9,10 L12,10 C12.55,10 13,10.45 13,11 C13,11.55 12.55,12 12,12 L9,12 C8.45,12 8,11.55 8,11 C8,10.45 8.45,10 9,10 Z" />
  </svg>
)
Console.iconName = "Console"
export const Contrast = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.1905059,6.4 L13.7514054,6.4 C13.6214866,5.93 13.4316052,5.48 13.1917552,5.06 L14.2510931,4 C14.5608994,3.69 14.5608994,3.18 14.2510931,2.87 L13.1217989,1.74 C12.8119925,1.43 12.3023111,1.43 11.9925047,1.74 L10.9331668,2.8 C10.5134291,2.56 10.0737039,2.38 9.59400375,2.24 L9.59400375,0.8 C9.59400375,0.36 9.23422861,0 8.79450344,0 L7.19550281,0 C6.75577764,0 6.3960025,0.36 6.3960025,0.8 L6.3960025,2.24 C5.8963148,2.38 5.43660212,2.58 4.99687695,2.83 L3.99750156,1.83 C3.69768894,1.53 3.207995,1.53 2.90818239,1.83 L1.82885696,2.91 C1.52904435,3.21 1.52904435,3.7 1.82885696,4 L2.82823235,5 C2.57838851,5.44 2.37851343,5.9 2.23860087,6.4 L0.799500312,6.4 C0.359775141,6.4 0,6.76 0,7.2 L0,8.8 C0,9.24 0.359775141,9.6 0.799500312,9.6 L2.23860087,9.6 C2.36851968,10.07 2.558401,10.52 2.79825109,10.94 L1.73891318,12 C1.42910681,12.31 1.42910681,12.82 1.73891318,13.13 L2.86820737,14.26 C3.17801374,14.57 3.68769519,14.57 3.99750156,14.26 L5.05683948,13.2 C5.47657714,13.44 5.91630231,13.62 6.3960025,13.76 L6.3960025,15.2 C6.3960025,15.64 6.75577764,16 7.19550281,16 L8.79450344,16 C9.23422861,16 9.59400375,15.64 9.59400375,15.2 L9.59400375,13.76 C10.0936914,13.62 10.5534041,13.43 10.9931293,13.17 L11.9925047,14.17 C12.2923173,14.47 12.7820112,14.47 13.0818239,14.17 L14.171143,13.08 C14.4709557,12.78 14.4709557,12.29 14.171143,11.99 L13.1717676,10.99 C13.4216115,10.56 13.6214866,10.09 13.7613991,9.59 L15.2004997,9.59 C15.6402249,9.59 16,9.23 16,8.79 L16,7.2 C15.9900062,6.76 15.6302311,6.4 15.1905059,6.4 Z M7.99500312,12 C5.78638351,12 3.99750156,10.21 3.99750156,8 C3.99750156,5.79 5.78638351,4 7.99500312,4 L7.99500312,12 Z" />
  </svg>
)
Contrast.iconName = "Contrast"
export const Control = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,8 L8,8 L8,13 L13,13 L13,8 Z M13,3 L8,3 L8,7 L13,7 L13,3 Z M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M14,14 L2,14 L2,2 L14,2 L14,14 Z M7,3 L3,3 L3,13 L7,13 L7,3 Z" />
  </svg>
)
Control.iconName = "Control"
export const CreditCard = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.9956277,2.5 L1.00437227,2.5 C0.454715803,2.5 0.00499687695,2.95 0.00499687695,3.5 L0.00499687695,4.5 L15.9950031,4.5 L15.9950031,3.5 C15.9950031,2.95 15.5452842,2.5 14.9956277,2.5 Z M0.00499687695,12.5 C0.00499687695,13.05 0.454715803,13.5 1.00437227,13.5 L14.9956277,13.5 C15.5452842,13.5 15.9950031,13.05 15.9950031,12.5 L15.9950031,6.5 L0.00499687695,6.5 L0.00499687695,12.5 Z M5.50156152,10.5 L10.4984385,10.5 C10.7782636,10.5 10.9981262,10.72 10.9981262,11 C10.9981262,11.28 10.7782636,11.5 10.4984385,11.5 L5.50156152,11.5 C5.22173641,11.5 5.00187383,11.28 5.00187383,11 C5.00187383,10.72 5.23173017,10.5 5.50156152,10.5 Z M2.50343535,10.5 L3.50281074,10.5 C3.78263585,10.5 4.00249844,10.72 4.00249844,11 C4.00249844,11.28 3.78263585,11.5 3.50281074,11.5 L2.50343535,11.5 C2.22361024,11.5 2.00374766,11.28 2.00374766,11 C2.00374766,10.72 2.233604,10.5 2.50343535,10.5 Z" />
  </svg>
)
CreditCard.iconName = "CreditCard"
export const Cross = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.41,8 L12.7,4.71 C12.89,4.53 13,4.28 13,4 C13,3.45 12.55,3 12,3 C11.72,3 11.47,3.11 11.29,3.29 L8,6.59 L4.71,3.29 C4.53,3.11 4.28,3 4,3 C3.45,3 3,3.45 3,4 C3,4.28 3.11,4.53 3.29,4.71 L6.59,8 L3.3,11.29 C3.11,11.47 3,11.72 3,12 C3,12.55 3.45,13 4,13 C4.28,13 4.53,12.89 4.71,12.71 L8,9.41 L11.29,12.7 C11.47,12.89 11.72,13 12,13 C12.55,13 13,12.55 13,12 C13,11.72 12.89,11.47 12.71,11.29 L9.41,8 Z" />
  </svg>
)
Cross.iconName = "Cross"
export const CurvedRangeChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,12 L3.12,12 L4.93,10.61 C6.66,11.62 10.46,10.58 14.01,8 L12.79,6.5 C10.3,8.3 7.86,9.37 6.65,9.29 L14.3,3.4 L13.7,2.6 L5.87,8.63 C5.86,7.56 7.67,5.44 10.34,3.5 L9.12,2 C5.38,4.7 3.34,8.1 4.25,9.87 L2,11.6 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z" />
  </svg>
)
CurvedRangeChart.iconName = "CurvedRangeChart"
export const Cut = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,2 C13,2 13.71,0.71 13,0 L8.66,5.07 L9.71,6.39 L13,2 Z M13.07,10 C12.65,10 12.25,10.09 11.89,10.26 L3.31,0 C2.62,0.71 3.31,2 3.31,2 L6.99,7.02 L4.22,10.26 C3.84,10.09 3.43,10 3,10 C1.34,10 0,11.34 0,13 C0,14.66 1.34,16 3,16 C4.66,16 6,14.66 6,13 C6,12.54 5.89,12.11 5.71,11.73 L8.1,8.54 L10.43,11.73 C10.25,12.12 10.14,12.55 10.14,13 C10.14,14.66 11.45,16 13.07,16 C14.69,16 16,14.66 16,13 C16,11.34 14.69,10 13.07,10 Z M3,14 C2.45,14 2,13.55 2,13 C2,12.45 2.45,12 3,12 C3.55,12 4,12.45 4,13 C4,13.55 3.55,14 3,14 Z M13.07,14 C12.53,14 12.09,13.55 12.09,13 C12.09,12.45 12.53,12 13.07,12 C13.61,12 14.05,12.45 14.05,13 C14.05,13.55 13.61,14 13.07,14 Z" />
  </svg>
)
Cut.iconName = "Cut"
export const Dashboard = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,4 C4.45,4 4,4.45 4,5 C4,5.55 4.45,6 5,6 C5.55,6 6,5.55 6,5 C6,4.45 5.55,4 5,4 Z M4,7 C3.45,7 3,7.45 3,8 C3,8.55 3.45,9 4,9 C4.55,9 5,8.55 5,8 C5,7.45 4.55,7 4,7 Z M8,5 C8.55,5 9,4.55 9,4 C9,3.45 8.55,3 8,3 C7.45,3 7,3.45 7,4 C7,4.55 7.45,5 8,5 Z M6,11 C6,12.1 6.9,13 8,13 C9.1,13 10,12.1 10,11 C10,10.47 8,6 8,6 C8,6 6,10.47 6,11 Z M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,4.69 4.69,2 8,2 C11.31,2 14,4.69 14,8 C14,11.31 11.31,14 8,14 Z M12,5 C12,4.45 11.55,4 11,4 C10.45,4 10,4.45 10,5 C10,5.55 10.45,6 11,6 C11.55,6 12,5.55 12,5 Z M12,7 C11.45,7 11,7.45 11,8 C11,8.55 11.45,9 12,9 C12.55,9 13,8.55 13,8 C13,7.45 12.55,7 12,7 Z" />
  </svg>
)
Dashboard.iconName = "Dashboard"
export const Database = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,4 C11.31,4 14,3.1 14,2 C14,0.9 11.31,0 8,0 C4.68,0 2,0.9 2,2 C2,3.1 4.68,4 8,4 Z M2,3.52 L2,8 C2,9.1 4.69,10 8,10 C11.31,10 14,9.1 14,8 L14,3.52 C12.78,4.4 10.56,5 8,5 C5.44,5 3.22,4.4 2,3.52 Z M2,9.52 L2,14 C2,15.1 4.69,16 8,16 C11.31,16 14,15.1 14,14 L14,9.52 C12.78,10.4 10.56,11 8,11 C5.44,11 3.22,10.4 2,9.52 Z" />
  </svg>
)
Database.iconName = "Database"
export const Delete = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.9975016,5.00187383 C11.9975016,4.45221736 11.5477826,4.00249844 10.9981262,4.00249844 C10.7183011,4.00249844 10.4684572,4.11242973 10.2885696,4.2923173 L8,6.5908807 L5.71143036,4.30231106 C5.53154279,4.11242973 5.28169894,4.00249844 5.00187383,4.00249844 C4.45221736,4.00249844 4.00249844,4.45221736 4.00249844,5.00187383 C4.00249844,5.28169894 4.11242973,5.53154279 4.2923173,5.71143036 L6.58088695,8 L4.2923173,10.2885696 C4.11242973,10.4684572 4.00249844,10.7183011 4.00249844,10.9981262 C4.00249844,11.5477826 4.45221736,11.9975016 5.00187383,11.9975016 C5.28169894,11.9975016 5.53154279,11.8875703 5.71143036,11.7076827 L8,9.41911305 L10.2885696,11.7076827 C10.4684572,11.8875703 10.7183011,11.9975016 10.9981262,11.9975016 C11.5477826,11.9975016 11.9975016,11.5477826 11.9975016,10.9981262 C11.9975016,10.7183011 11.8875703,10.4684572 11.7076827,10.2885696 L9.41911305,8 L11.7076827,5.71143036 C11.8875703,5.53154279 11.9975016,5.28169894 11.9975016,5.00187383 L11.9975016,5.00187383 Z M8,0.00499687695 C3.58276077,0.00499687695 0.00499687695,3.58276077 0.00499687695,8 C0.00499687695,12.4172392 3.58276077,15.9950031 8,15.9950031 C12.4172392,15.9950031 15.9950031,12.4172392 15.9950031,8 C15.9950031,3.58276077 12.4172392,0.00499687695 8,0.00499687695 Z M8,13.9962523 C4.69206746,13.9962523 2.00374766,11.3079325 2.00374766,8 C2.00374766,4.69206746 4.69206746,2.00374766 8,2.00374766 C11.3079325,2.00374766 13.9962523,4.69206746 13.9962523,8 C13.9962523,11.3079325 11.3179263,13.9962523 8,13.9962523 Z" />
  </svg>
)
Delete.iconName = "Delete"
export const Delta = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 L0,16 L16,16 L8,0 Z M7,5 L12,15 L2,15 L7,5 Z" />
  </svg>
)
Delta.iconName = "Delta"
export const DeriveColumn = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.08,6.67 L5.24,6.67 C5.48,5.75 5.8,5.07 6.2,4.64 C6.44,4.37 6.68,4.24 6.91,4.24 C6.96,4.24 6.99,4.25 7.02,4.28 C7.05,4.31 7.06,4.34 7.06,4.38 C7.06,4.42 7.03,4.49 6.96,4.59 C6.9,4.69 6.86,4.79 6.86,4.88 C6.86,5.01 6.91,5.12 7.01,5.21 C7.11,5.3 7.24,5.35 7.4,5.35 C7.57,5.35 7.71,5.29 7.82,5.18 C7.94,5.07 8,4.92 8,4.73 C8,4.51 7.91,4.34 7.74,4.2 C7.57,4.07 7.3,4 6.93,4 C6.34,4 5.81,4.16 5.34,4.48 C4.86,4.8 4.41,5.33 3.98,6.07 C3.83,6.33 3.69,6.49 3.56,6.56 C3.43,6.63 3.21,6.67 2.92,6.66 L2.73,7.31 L3.54,7.31 L2.35,11.68 C2.15,12.4 2.02,12.84 1.95,13.01 C1.85,13.25 1.69,13.46 1.49,13.63 C1.41,13.7 1.31,13.73 1.19,13.73 C1.16,13.73 1.13,13.72 1.11,13.7 L1.08,13.66 C1.08,13.64 1.11,13.6 1.17,13.55 C1.23,13.49 1.26,13.41 1.26,13.29 C1.26,13.16 1.21,13.06 1.12,12.97 C1.03,12.89 0.89,12.84 0.72,12.84 C0.51,12.84 0.34,12.89 0.21,13 C0.08,13.11 9e-16,13.25 9e-16,13.4 C9e-16,13.56 0.08,13.7 0.23,13.82 C0.39,13.94 0.63,14 0.97,14 C1.5,14 1.96,13.87 2.37,13.61 C2.78,13.35 3.13,12.96 3.44,12.42 C3.74,11.88 4.06,11.02 4.38,9.83 L5.06,7.3 L5.88,7.3 L6.08,6.67 Z M15,0 L8,0 C7.45,0 7,0.45 7,1 L7,3 L9,3 L9,2 L14,2 L14,14 L9,14 L9,13 L7,13 L7,15 C7,15.55 7.45,16 8,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M8.3,9.94 C8.48,10.46 8.63,10.83 8.76,11.07 C8.89,11.31 9.04,11.47 9.2,11.58 C9.37,11.68 9.57,11.74 9.82,11.74 C10.06,11.74 10.31,11.66 10.56,11.49 C10.89,11.28 11.22,10.91 11.57,10.4 L11.36,10.29 C11.13,10.6 10.95,10.79 10.84,10.86 C10.77,10.91 10.68,10.93 10.58,10.93 C10.46,10.93 10.34,10.86 10.22,10.72 C10.02,10.48 9.76,9.81 9.42,8.72 C9.72,8.23 9.97,7.91 10.17,7.76 C10.32,7.65 10.47,7.6 10.64,7.6 C10.7,7.6 10.81,7.62 10.98,7.66 C11.14,7.7 11.29,7.72 11.41,7.72 C11.58,7.72 11.72,7.66 11.84,7.55 C11.94,7.44 12,7.3 12,7.12 C12,6.93 11.94,6.79 11.83,6.68 C11.71,6.57 11.55,6.52 11.34,6.52 C11.15,6.52 10.97,6.56 10.8,6.65 C10.63,6.74 10.41,6.92 10.15,7.21 C9.95,7.42 9.67,7.79 9.28,8.32 C9.13,7.66 8.87,7.06 8.5,6.51 L6.45,6.84 L6.41,7.05 C6.56,7.02 6.69,7.01 6.8,7.01 C7,7.01 7.17,7.09 7.3,7.26 C7.51,7.52 7.8,8.29 8.18,9.59 C7.89,9.96 7.69,10.2 7.58,10.31 C7.4,10.49 7.25,10.61 7.14,10.67 C7.05,10.71 6.95,10.74 6.84,10.74 C6.75,10.74 6.61,10.7 6.42,10.61 C6.29,10.55 6.17,10.52 6.06,10.52 C5.86,10.52 5.7,10.58 5.57,10.7 C5.44,10.82 5.38,10.97 5.38,11.16 C5.38,11.33 5.44,11.48 5.56,11.59 C5.68,11.7 5.84,11.75 6.04,11.75 C6.24,11.75 6.42,11.71 6.59,11.64 C6.76,11.56 6.98,11.4 7.24,11.15 C7.48,10.88 7.84,10.49 8.3,9.94 L8.3,9.94 Z" />
  </svg>
)
DeriveColumn.iconName = "DeriveColumn"
export const Desktop = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,11 C0,11.55 0.45,12 1,12 L5.75,12 L5.25,14 L4,14 C3.45,14 3,14.45 3,15 C3,15.55 3.45,16 4,16 L12,16 C12.55,16 13,15.55 13,15 C13,14.45 12.55,14 12,14 L10.75,14 L10.25,12 L15,12 C15.55,12 16,11.55 16,11 L16,1 C16,0.45 15.55,0 15,0 Z M14,10 L2,10 L2,2 L14,2 L14,10 Z" />
  </svg>
)
Desktop.iconName = "Desktop"
export const DirectionLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon fillRule="evenodd" points="16 2 0 8 16 14 12 8" />
  </svg>
)
DirectionLeft.iconName = "DirectionLeft"
export const DirectionRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon fillRule="evenodd" points="16 8 0 2 4 8 0 14" />
  </svg>
)
DirectionRight.iconName = "DirectionRight"
export const Disable = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0.00499687695 C3.58276077,0.00499687695 0.00499687695,3.58276077 0.00499687695,8 C0.00499687695,12.4172392 3.58276077,15.9950031 8,15.9950031 C12.4172392,15.9950031 15.9950031,12.4172392 15.9950031,8 C15.9950031,3.58276077 12.4172392,0.00499687695 8,0.00499687695 Z M2.00374766,8 C2.00374766,4.69206746 4.69206746,2.00374766 8,2.00374766 C9.29918801,2.00374766 10.4884447,2.42348532 11.4678326,3.12304809 L3.12304809,11.4678326 C2.42348532,10.4884447 2.00374766,9.29918801 2.00374766,8 Z M8,13.9962523 C6.70081199,13.9962523 5.51155528,13.5765147 4.5321674,12.8769519 L12.8769519,4.5321674 C13.5765147,5.51155528 13.9962523,6.70081199 13.9962523,8 C13.9962523,11.3179263 11.3179263,13.9962523 8,13.9962523 L8,13.9962523 Z" />
  </svg>
)
Disable.iconName = "Disable"
export const DocumentOpen = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,12 C6,12.55 6.45,13 7,13 C7.55,13 8,12.55 8,12 L8,8 C8,7.45 7.55,7 7,7 L3,7 C2.45,7 2,7.45 2,8 C2,8.55 2.45,9 3,9 L4.59,9 L1.3,12.29 C1.11,12.47 1,12.72 1,13 C1,13.55 1.45,14 2,14 C2.28,14 2.53,13.89 2.71,13.71 L6,10.41 L6,12 Z M10,0 L4,0 C3.45,0 3,0.45 3,1 L3,5 L5,5 L5,2 L9,2 L9,6 L13,6 L13,14 L5.24,14 L3.44,15.8 C3.6,15.92 3.79,16 4,16 L14,16 C14.55,16 15,15.55 15,15 L15,5 L10,0 Z" />
  </svg>
)
DocumentOpen.iconName = "DocumentOpen"
export const DocumentShare = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,14 L2,14 L2,2 L6,2 L6,6 L7,6 C7,5.17 7.36,4.45 7.91,3.91 L7.88,3.88 L8.78,2.98 C8.3,2.45 8,1.77 8,1 L7,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L11,16 C11.55,16 12,15.55 12,15 L12,8.22 C11.47,8.7 10.77,9 10,9 L10,14 Z M15,0 L11,0 C10.45,0 10,0.45 10,1 C10,1.55 10.45,2 11,2 L12.59,2 L9.29,5.29 C9.11,5.47 9,5.72 9,6 C9,6.55 9.45,7 10,7 C10.28,7 10.53,6.89 10.71,6.71 L14,3.41 L14,5 C14,5.55 14.45,6 15,6 C15.55,6 16,5.55 16,5 L16,1 C16,0.45 15.55,0 15,0 Z" />
  </svg>
)
DocumentShare.iconName = "DocumentShare"
export const Document = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9,0 L3,0 C2.45,0 2,0.45 2,1 L2,15 C2,15.55 2.45,16 3,16 L13,16 C13.55,16 14,15.55 14,15 L14,5 L9,0 Z M12,14 L4,14 L4,2 L8,2 L8,6 L12,6 L12,14 Z" />
  </svg>
)
Document.iconName = "Document"
export const Dollar = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.84,9.51 C12.74,9.21 12.59,8.93 12.39,8.67 C12.19,8.41 11.94,8.18 11.64,7.97 C11.34,7.77 10.99,7.61 10.59,7.49 C10.43,7.45 10.16,7.38 9.79,7.29 C9.44,7.2 9.06,7.11 8.67,7.01 C8.28,6.91 7.93,6.82 7.61,6.74 C7.3,6.66 7.12,6.62 7.07,6.61 C6.64,6.49 6.29,6.32 6.02,6.09 C5.75,5.86 5.62,5.54 5.62,5.14 C5.62,4.85 5.69,4.61 5.83,4.42 C5.97,4.23 6.15,4.08 6.37,3.96 C6.59,3.85 6.83,3.77 7.09,3.72 C7.35,3.67 7.61,3.64 7.86,3.64 C8.6,3.64 9.21,3.79 9.69,4.1 C10.17,4.4 10.44,4.93 10.5,5.66 L12.64,5.66 C12.64,5.06 12.51,4.53 12.26,4.08 C12.01,3.63 11.67,3.24 11.24,2.93 C10.81,2.62 10.31,2.39 9.75,2.23 C9.51,2.17 9.26,2.13 9,2.09 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,2.08 C6.77,2.11 6.54,2.15 6.32,2.21 C5.78,2.34 5.3,2.55 4.88,2.82 C4.46,3.1 4.12,3.45 3.86,3.87 C3.6,4.3 3.47,4.8 3.47,5.37 C3.47,5.67 3.51,5.96 3.6,6.25 C3.69,6.54 3.83,6.81 4.04,7.07 C4.25,7.33 4.52,7.56 4.87,7.77 C5.22,7.98 5.66,8.15 6.18,8.28 C7.03,8.49 7.74,8.66 8.32,8.8 C8.9,8.93 9.4,9.08 9.84,9.22 C10.09,9.31 10.32,9.45 10.53,9.66 C10.74,9.87 10.85,10.19 10.85,10.63 C10.85,10.84 10.8,11.05 10.71,11.26 C10.62,11.47 10.47,11.65 10.26,11.81 C10.05,11.97 9.79,12.1 9.45,12.2 C9.12,12.3 8.72,12.35 8.25,12.35 C7.82,12.35 7.41,12.3 7.04,12.21 C6.67,12.12 6.34,11.97 6.05,11.78 C5.76,11.58 5.54,11.33 5.38,11.02 C5.22,10.71 5.14,10.34 5.14,9.9 L3.01,9.9 C3.02,10.61 3.16,11.22 3.44,11.74 C3.71,12.26 4.08,12.68 4.54,13.01 C5,13.34 5.53,13.59 6.15,13.75 C6.42,13.82 6.71,13.87 7,13.91 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,13.95 C9.3,13.92 9.61,13.87 9.9,13.8 C10.48,13.67 11,13.46 11.46,13.17 C11.92,12.88 12.29,12.51 12.57,12.06 C12.85,11.61 12.99,11.06 12.99,10.42 C12.99,10.11 12.94,9.81 12.84,9.51 Z" />
  </svg>
)
Dollar.iconName = "Dollar"
export const Dot = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,5 C6.34314575,5 5,6.34314575 5,8 C5,9.65685425 6.34314575,11 8,11 C9.65685425,11 11,9.65685425 11,8 C11,6.34314575 9.65685425,5 8,5 Z" />
  </svg>
)
Dot.iconName = "Dot"
export const DoubleCaretHorizontal = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.71,7.29 L10.71,4.29 C10.53,4.11 10.28,4 10,4 C9.45,4 9,4.45 9,5 L9,11 C9,11.55 9.45,12 10,12 C10.28,12 10.53,11.89 10.71,11.71 L13.71,8.71 C13.89,8.53 14,8.28 14,8 C14,7.72 13.89,7.47 13.71,7.29 Z M6,4 C5.72,4 5.47,4.11 5.29,4.29 L2.29,7.29 C2.11,7.47 2,7.72 2,8 C2,8.28 2.11,8.53 2.29,8.71 L5.29,11.71 C5.47,11.89 5.72,12 6,12 C6.55,12 7,11.55 7,11 L7,5 C7,4.45 6.55,4 6,4 Z" />
  </svg>
)
DoubleCaretHorizontal.iconName = "DoubleCaretHorizontal"
export const DoubleCaretVertical = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,7 L11,7 C11.55,7 12,6.55 12,6 C12,5.72 11.89,5.47 11.71,5.29 L8.71,2.29 C8.53,2.11 8.28,2 8,2 C7.72,2 7.47,2.11 7.29,2.29 L4.29,5.29 C4.11,5.47 4,5.72 4,6 C4,6.55 4.45,7 5,7 Z M11,9 L5,9 C4.45,9 4,9.45 4,10 C4,10.28 4.11,10.53 4.29,10.71 L7.29,13.71 C7.47,13.89 7.72,14 8,14 C8.28,14 8.53,13.89 8.71,13.71 L11.71,10.71 C11.89,10.53 12,10.28 12,10 C12,9.45 11.55,9 11,9 Z" />
  </svg>
)
DoubleCaretVertical.iconName = "DoubleCaretVertical"
export const DoubleChevronDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.29,8.21 C7.47,8.39 7.72,8.5 8,8.5 C8.28,8.5 8.53,8.39 8.71,8.21 L12.71,4.21 C12.89,4.03 13,3.78 13,3.5 C13,2.95 12.55,2.5 12,2.5 C11.72,2.5 11.47,2.61 11.29,2.79 L8,6.09 L4.71,2.79 C4.53,2.61 4.28,2.5 4,2.5 C3.45,2.5 3,2.95 3,3.5 C3,3.78 3.11,4.03 3.29,4.21 L7.29,8.21 Z M12,7.5 C11.72,7.5 11.47,7.61 11.29,7.79 L8,11.09 L4.71,7.79 C4.53,7.61 4.28,7.5 4,7.5 C3.45,7.5 3,7.95 3,8.5 C3,8.78 3.11,9.03 3.29,9.21 L7.29,13.21 C7.47,13.39 7.72,13.5 8,13.5 C8.28,13.5 8.53,13.39 8.71,13.21 L12.71,9.21 C12.89,9.03 13,8.78 13,8.5 C13,7.95 12.55,7.5 12,7.5 Z" />
  </svg>
)
DoubleChevronDown.iconName = "DoubleChevronDown"
export const DoubleChevronLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.91,8 L8.2,4.71 C8.39,4.53 8.5,4.28 8.5,4 C8.5,3.45 8.05,3 7.5,3 C7.22,3 6.97,3.11 6.79,3.29 L2.79,7.29 C2.61,7.47 2.5,7.72 2.5,8 C2.5,8.28 2.61,8.53 2.79,8.71 L6.79,12.71 C6.97,12.89 7.22,13 7.5,13 C8.05,13 8.5,12.55 8.5,12 C8.5,11.72 8.39,11.47 8.21,11.29 L4.91,8 Z M9.91,8 L13.2,4.71 C13.39,4.53 13.5,4.28 13.5,4 C13.5,3.45 13.05,3 12.5,3 C12.22,3 11.97,3.11 11.79,3.29 L7.79,7.29 C7.61,7.47 7.5,7.72 7.5,8 C7.5,8.28 7.61,8.53 7.79,8.71 L11.79,12.71 C11.97,12.89 12.22,13 12.5,13 C13.05,13 13.5,12.55 13.5,12 C13.5,11.72 13.39,11.47 13.21,11.29 L9.91,8 Z" />
  </svg>
)
DoubleChevronLeft.iconName = "DoubleChevronLeft"
export const DoubleChevronRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.5,8 C8.5,7.72 8.39,7.47 8.21,7.29 L4.21,3.29 C4.03,3.11 3.78,3 3.5,3 C2.95,3 2.5,3.45 2.5,4 C2.5,4.28 2.61,4.53 2.79,4.71 L6.09,8 L2.8,11.29 C2.61,11.47 2.5,11.72 2.5,12 C2.5,12.55 2.95,13 3.5,13 C3.78,13 4.03,12.89 4.21,12.71 L8.21,8.71 C8.39,8.53 8.5,8.28 8.5,8 Z M13.21,7.29 L9.21,3.29 C9.03,3.11 8.78,3 8.5,3 C7.95,3 7.5,3.45 7.5,4 C7.5,4.28 7.61,4.53 7.79,4.71 L11.09,8 L7.8,11.29 C7.61,11.47 7.5,11.72 7.5,12 C7.5,12.55 7.95,13 8.5,13 C8.78,13 9.03,12.89 9.21,12.71 L13.21,8.71 C13.39,8.53 13.5,8.28 13.5,8 C13.5,7.72 13.39,7.47 13.21,7.29 Z" />
  </svg>
)
DoubleChevronRight.iconName = "DoubleChevronRight"
export const DoubleChevronUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,8.5 C4.28,8.5 4.53,8.39 4.71,8.21 L8,4.91 L11.29,8.2 C11.47,8.39 11.72,8.5 12,8.5 C12.55,8.5 13,8.05 13,7.5 C13,7.22 12.89,6.97 12.71,6.79 L8.71,2.79 C8.53,2.61 8.28,2.5 8,2.5 C7.72,2.5 7.47,2.61 7.29,2.79 L3.29,6.79 C3.11,6.97 3,7.22 3,7.5 C3,8.05 3.45,8.5 4,8.5 Z M8.71,7.79 C8.53,7.61 8.28,7.5 8,7.5 C7.72,7.5 7.47,7.61 7.29,7.79 L3.29,11.79 C3.11,11.97 3,12.22 3,12.5 C3,13.05 3.45,13.5 4,13.5 C4.28,13.5 4.53,13.39 4.71,13.21 L8,9.91 L11.29,13.2 C11.47,13.39 11.72,13.5 12,13.5 C12.55,13.5 13,13.05 13,12.5 C13,12.22 12.89,11.97 12.71,11.79 L8.71,7.79 Z" />
  </svg>
)
DoubleChevronUp.iconName = "DoubleChevronUp"
export const DoughnutChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.86,7 L15.91,7 C15.45,3.39 12.61,0.52 9,0.07 L9,4.14 C10.4,4.5 11.49,5.6 11.86,7 Z M12,8 C12,10.21 10.21,12 8,12 C5.79,12 4,10.21 4,8 C4,5.79 5.79,4 8,4 L8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 L12,8 Z" />
  </svg>
)
DoughnutChart.iconName = "DoughnutChart"
export const Download = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0.00499687695 C3.58276077,0.00499687695 0.00499687695,3.58276077 0.00499687695,8 C0.00499687695,12.4172392 3.58276077,15.9950031 8,15.9950031 C12.4172392,15.9950031 15.9950031,12.4172392 15.9950031,8 C15.9950031,3.58276077 12.4172392,0.00499687695 8,0.00499687695 Z M11.7076827,9.70893192 L8.70955653,12.7070581 C8.52966896,12.8869457 8.27982511,12.996877 8,12.996877 C7.72017489,12.996877 7.47033104,12.8869457 7.29044347,12.7070581 L4.2923173,9.70893192 C4.11242973,9.52904435 4.00249844,9.2792005 4.00249844,8.99937539 C4.00249844,8.44971893 4.45221736,8 5.00187383,8 C5.28169894,8 5.53154279,8.10993129 5.71143036,8.28981886 L7.00062461,9.57901312 L7.00062461,4.00249844 C7.00062461,3.45284197 7.45034354,3.00312305 8,3.00312305 C8.54965646,3.00312305 8.99937539,3.45284197 8.99937539,4.00249844 L8.99937539,9.58900687 L10.2885696,8.29981262 C10.4684572,8.11992505 10.7183011,8.00999375 10.9981262,8.00999375 C11.5477826,8.00999375 11.9975016,8.45971268 11.9975016,9.00936914 C11.9975016,9.2792005 11.8875703,9.52904435 11.7076827,9.70893192 Z" />
  </svg>
)
Download.iconName = "Download"
export const DragHandleHorizontal = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,9 C1.45,9 1,9.45 1,10 C1,10.55 1.45,11 2,11 C2.55,11 3,10.55 3,10 C3,9.45 2.55,9 2,9 Z M2,5 C1.45,5 1,5.45 1,6 C1,6.55 1.45,7 2,7 C2.55,7 3,6.55 3,6 C3,5.45 2.55,5 2,5 Z M6,9 C5.45,9 5,9.45 5,10 C5,10.55 5.45,11 6,11 C6.55,11 7,10.55 7,10 C7,9.45 6.55,9 6,9 Z M14,7 C14.55,7 15,6.55 15,6 C15,5.45 14.55,5 14,5 C13.45,5 13,5.45 13,6 C13,6.55 13.45,7 14,7 Z M14,9 C13.45,9 13,9.45 13,10 C13,10.55 13.45,11 14,11 C14.55,11 15,10.55 15,10 C15,9.45 14.55,9 14,9 Z M10,5 C9.45,5 9,5.45 9,6 C9,6.55 9.45,7 10,7 C10.55,7 11,6.55 11,6 C11,5.45 10.55,5 10,5 Z M10,9 C9.45,9 9,9.45 9,10 C9,10.55 9.45,11 10,11 C10.55,11 11,10.55 11,10 C11,9.45 10.55,9 10,9 Z M6,5 C5.45,5 5,5.45 5,6 C5,6.55 5.45,7 6,7 C6.55,7 7,6.55 7,6 C7,5.45 6.55,5 6,5 Z" />
  </svg>
)
DragHandleHorizontal.iconName = "DragHandleHorizontal"
export const DragHandleVertical = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,9 C5.45,9 5,9.45 5,10 C5,10.55 5.45,11 6,11 C6.55,11 7,10.55 7,10 C7,9.45 6.55,9 6,9 Z M10,3 C10.55,3 11,2.55 11,2 C11,1.45 10.55,1 10,1 C9.45,1 9,1.45 9,2 C9,2.55 9.45,3 10,3 Z M6,13 C5.45,13 5,13.45 5,14 C5,14.55 5.45,15 6,15 C6.55,15 7,14.55 7,14 C7,13.45 6.55,13 6,13 Z M6,5 C5.45,5 5,5.45 5,6 C5,6.55 5.45,7 6,7 C6.55,7 7,6.55 7,6 C7,5.45 6.55,5 6,5 Z M6,1 C5.45,1 5,1.45 5,2 C5,2.55 5.45,3 6,3 C6.55,3 7,2.55 7,2 C7,1.45 6.55,1 6,1 Z M10,9 C9.45,9 9,9.45 9,10 C9,10.55 9.45,11 10,11 C10.55,11 11,10.55 11,10 C11,9.45 10.55,9 10,9 Z M10,5 C9.45,5 9,5.45 9,6 C9,6.55 9.45,7 10,7 C10.55,7 11,6.55 11,6 C11,5.45 10.55,5 10,5 Z M10,13 C9.45,13 9,13.45 9,14 C9,14.55 9.45,15 10,15 C10.55,15 11,14.55 11,14 C11,13.45 10.55,13 10,13 Z" />
  </svg>
)
DragHandleVertical.iconName = "DragHandleVertical"
export const Draw = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.95,10.95 C14.65,10.95 14.45,11.05 14.25,11.25 L11.25,14.25 C11.05,14.45 10.95,14.65 10.95,14.95 C10.95,15.55 11.45,15.95 11.95,15.95 C12.25,15.95 12.45,15.85 12.65,15.65 L15.65,12.65 C15.85,12.45 15.95,12.25 15.95,11.95 C15.95,11.45 15.55,10.95 14.95,10.95 Z M13.95,9.95 L13.95,9.75 L12.95,4.75 C12.85,4.45 12.65,4.15 12.35,4.05 L1.35,0.05 L1.05,0.35 L6.85,6.15 C7.05,6.05 7.25,5.95 7.45,5.95 C8.25,5.95 8.95,6.65 8.95,7.45 C8.95,8.25 8.35,8.95 7.45,8.95 C6.55,8.95 5.95,8.25 5.95,7.45 C5.95,7.25 6.05,7.05 6.15,6.85 L0.35,1.05 L0.05,1.35 L4.05,12.35 C4.15,12.65 4.45,12.95 4.75,12.95 L9.75,13.95 L9.95,13.95 C10.25,13.95 10.45,13.85 10.65,13.65 L13.65,10.65 C13.85,10.45 13.95,10.25 13.95,9.95 Z" />
  </svg>
)
Draw.iconName = "Draw"
export const DriveTime = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.12,4.76 L14.07,4.76 L13.31,2.64 C13.12,2.11 12.55,1.56 12.04,1.4 C12.04,1.4 10.72,1 8,1 C5.28,1 3.96,1.4 3.96,1.4 C3.46,1.56 2.89,2.11 2.7,2.64 L1.93,4.76 L0.88,4.76 C0.4,4.76 0,5.18 0,5.7 C0,6.22 0.4,6.64 0.88,6.64 L1.26,6.64 L1,7 C0.97,7.69 1,8.44 1,9 L1,14 C1,14.66 1.38,15 2,15 C2.62,15 3,14.66 3,14 L3,13 L13,13 L13,14 C13,14.66 13.38,15 14,15 C14.62,15 15,14.66 15,14 L15,9 C15,8.44 14.99,7.63 15,7 L14.74,6.63 L15.12,6.63 C15.6,6.63 16,6.21 16,5.7 C16,5.18 15.6,4.76 15.12,4.76 Z M5,10 L3,10 L3,8 L5,8 L5,10 Z M13,10 L11,10 L11,8 L13,8 L13,10 Z M13,6 L3,6 C2.82,6 2.94,5.18 3,5 L3.73,3.37 C3.79,3.19 3.82,3 4,3 L12,3 C12.18,3 12.21,3.19 12.27,3.37 L13,5 C13.06,5.18 13.18,6 13,6 Z" />
  </svg>
)
DriveTime.iconName = "DriveTime"
export const Duplicate = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L5,0 C4.45,0 4,0.45 4,1 L4,3 L6,3 L6,2 L14,2 L14,9 L13,9 L13,11 L15,11 C15.55,11 16,10.55 16,10 L16,1 C16,0.45 15.55,0 15,0 Z M11,4 L1,4 C0.45,4 0,4.45 0,5 L0,15 C0,15.55 0.45,16 1,16 L11,16 C11.55,16 12,15.55 12,15 L12,5 C12,4.45 11.55,4 11,4 Z M10,14 L2,14 L2,6 L10,6 L10,14 Z" />
  </svg>
)
Duplicate.iconName = "Duplicate"
export const Edit = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.26495246,10.27 L5.73495246,12.74 L12.4249525,6.05 L9.96495246,3.57 L3.26495246,10.27 Z M1.00495246,15 L4.86495246,13.61 L2.40495246,11.17 L1.00495246,15 Z M13.2549525,1 C12.7749525,1 12.3349525,1.2 12.0149525,1.51 L10.5749525,2.95 L13.0449525,5.42 L14.4849525,3.98 C14.8049525,3.66 14.9949525,3.23 14.9949525,2.74 C15.0049525,1.79 14.2249525,1 13.2549525,1 Z" />
  </svg>
)
Edit.iconName = "Edit"
export const Eject = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,9 L12,9 C12.55,9 13,8.55 13,8 C13,7.72 12.89,7.47 12.71,7.29 L8.71,3.29 C8.53,3.11 8.28,3 8,3 C7.72,3 7.47,3.11 7.29,3.29 L3.29,7.29 C3.11,7.47 3,7.72 3,8 C3,8.55 3.45,9 4,9 Z M12,10 L4,10 C3.45,10 3,10.45 3,11 L3,12 C3,12.55 3.45,13 4,13 L12,13 C12.55,13 13,12.55 13,12 L13,11 C13,10.45 12.55,10 12,10 Z" />
  </svg>
)
Eject.iconName = "Eject"
export const Endorsed = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.8610712,7.50132792 L15.0510712,6.08154976 L15.0510712,4.50179659 C15.0510712,4.14185284 14.8610712,3.82190283 14.5610712,3.63193251 L13.1910712,2.83205749 L12.3810712,1.42227777 C12.1910712,1.1123262 11.8710712,0.93235432 11.5210712,0.93235432 L9.89107116,0.93235432 L8.50107116,0.142477738 C8.20107116,-0.0474925793 7.81107116,-0.0474925793 7.50107116,0.142477738 L6.11107116,0.942352757 L4.52107116,0.942352757 C4.16107116,0.942352757 3.84107116,1.13232307 3.66107116,1.43227621 L2.86107116,2.80206218 L1.42107116,3.63193251 C1.12107116,3.82190283 0.931071158,4.14185284 0.931071158,4.50179659 L0.931071158,6.15153882 L0.131071158,7.52132479 C0.0510711577,7.67130136 0.0010711577,7.8412748 0.0010711577,8.01124824 C0.0010711577,8.18122168 0.0510711577,8.35119513 0.141071158,8.50117169 L0.941071158,9.87095766 L0.941071158,11.5206999 C0.941071158,11.8806436 1.13107116,12.2005937 1.43107116,12.390564 L2.85107116,13.2004374 L3.65107116,14.5702234 C3.84107116,14.880175 4.16107116,15.0601469 4.51107116,15.0601469 L6.10107116,15.0601469 L7.49107116,15.8600219 C7.64107116,15.9500078 7.81107116,16 7.97107116,16 C8.13107116,16 8.31107116,15.9500078 8.46107116,15.8600219 L9.85107116,15.0601469 L11.4810712,15.0601469 C11.8410712,15.0601469 12.1610712,14.8701765 12.3410712,14.5702234 L13.1510712,13.1604437 L14.5210712,12.3605687 C14.8210712,12.1705983 15.0110712,11.8506483 15.0110712,11.4907046 L15.0110712,9.93094829 L15.8210712,8.51117013 C16.0510712,8.20121856 16.0510712,7.82127793 15.8610712,7.50132792 Z M11.7410712,6.68145602 L7.73107116,10.6908296 C7.55107116,10.8708014 7.30107116,10.9807843 7.02107116,10.9807843 C6.74107116,10.9807843 6.49107116,10.8708014 6.31107116,10.6908296 L4.31107116,8.69114201 C4.13107116,8.50117169 4.01107116,8.25121075 4.01107116,7.98125293 C4.01107116,7.43133885 4.46107116,6.98140915 5.01107116,6.98140915 C5.29107116,6.98140915 5.54107116,7.09139197 5.72107116,7.27136385 L7.02107116,8.57116076 L10.3210712,5.2716763 C10.5010712,5.09170442 10.7510712,4.98172161 11.0310712,4.98172161 C11.5810712,4.98172161 12.0310712,5.4316513 12.0310712,5.98156538 C12.0410712,6.2515232 11.9210712,6.50148414 11.7410712,6.68145602 Z" />
  </svg>
)
Endorsed.iconName = "Endorsed"
export const Envelope = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,3.06 L0,12.94 L4.94,8 L0,3.06 Z M14.94,2 L1.06,2 L8,8.94 L14.94,2 Z M8.53,10.53 C8.39,10.67 8.21,10.75 8,10.75 C7.79,10.75 7.61,10.67 7.47,10.53 L6,9.06 L1.06,14 L14.94,14 L10,9.06 L8.53,10.53 L8.53,10.53 Z M11.06,8 L16,12.94 L16,3.06 L11.06,8 Z" />
  </svg>
)
Envelope.iconName = "Envelope"
export const Eraser = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.06,13.8926342 L15.69,6.4619226 C16.1,6.06242197 16.1,5.41323346 15.69,5.01373283 L10.86,0.299625468 C10.45,-0.0998751561 9.78,-0.0998751561 9.37,0.299625468 L0.31,9.11860175 C-0.1,9.51810237 -0.1,10.1672909 0.31,10.5667915 L5.89,16 L14.01,16 L14.01,15.9900125 C14.56,15.9900125 15.01,15.5405743 15.01,14.9912609 C15.01,14.4419476 14.56,13.9925094 14.01,13.9925094 L7.96,13.9925094 L8.06,13.8926342 Z M5.89,13.9525593 L1.67,9.83770287 L5.89,5.73283396 L10.11,9.83770287 L5.89,13.9525593 L5.89,13.9525593 Z" />
  </svg>
)
Eraser.iconName = "Eraser"
export const Error = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0.00499687695 C3.58276077,0.00499687695 0.00499687695,3.58276077 0.00499687695,8 C0.00499687695,12.4172392 3.58276077,15.9950031 8,15.9950031 C12.4172392,15.9950031 15.9950031,12.4172392 15.9950031,8 C15.9950031,3.58276077 12.4172392,0.00499687695 8,0.00499687695 Z M8.99937539,12.996877 L7.00062461,12.996877 L7.00062461,10.9981262 L8.99937539,10.9981262 L8.99937539,12.996877 Z M8.99937539,9.99875078 L7.00062461,9.99875078 L7.00062461,3.00312305 L8.99937539,3.00312305 L8.99937539,9.99875078 Z" />
  </svg>
)
Error.iconName = "Error"
export const Euro = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.745,3.68 C8.255,3.41 8.865,3.28 9.575,3.28 C10.055,3.28 10.485,3.34 10.845,3.46 C11.215,3.58 11.525,3.75 11.805,3.97 C11.985,4.11 12.105,4.3 12.245,4.48 L13.775,2.95 C13.655,2.84 13.545,2.73 13.415,2.63 C12.915,2.27 12.335,1.99 11.675,1.8 C11.015,1.6 10.315,1.5 9.575,1.5 C8.585,1.5 7.695,1.68 6.915,2.03 C6.125,2.38 5.465,2.85 4.915,3.44 C4.365,4.02 3.955,4.71 3.655,5.5 L3.225,5.5 C2.675,5.5 2.225,5.95 2.225,6.5 C2.225,7.05 2.675,7.5 3.225,7.5 L3.265,7.5 C3.255,7.67 3.225,7.83 3.225,8 C3.225,8.17 3.255,8.33 3.265,8.5 L3.225,8.5 C2.675,8.5 2.225,8.95 2.225,9.5 C2.225,10.05 2.675,10.5 3.225,10.5 L3.655,10.5 C3.655,10.51 3.655,10.52 3.665,10.52 C3.955,11.31 4.375,12 4.915,12.59 C5.455,13.18 6.125,13.65 6.915,13.99 C7.695,14.33 8.585,14.5 9.575,14.5 C10.385,14.5 11.115,14.38 11.785,14.14 C12.455,13.9 13.035,13.55 13.535,13.11 L13.565,13.08 L12.015,11.75 C12.005,11.76 11.995,11.78 11.985,11.79 C11.695,12.09 11.355,12.32 10.965,12.48 C10.565,12.65 10.115,12.73 9.595,12.73 C8.885,12.73 8.275,12.6 7.765,12.33 C7.255,12.06 6.835,11.71 6.515,11.26 C6.325,11.02 6.175,10.77 6.055,10.5 L10.225,10.5 C10.775,10.5 11.225,10.05 11.225,9.5 C11.225,8.95 10.775,8.5 10.225,8.5 L5.575,8.5 C5.565,8.33 5.545,8.17 5.545,8 C5.545,7.83 5.565,7.66 5.575,7.5 L11.225,7.5 C11.775,7.5 12.225,7.05 12.225,6.5 C12.225,5.95 11.775,5.5 11.225,5.5 L6.055,5.5 C6.185,5.23 6.325,4.98 6.495,4.74 C6.815,4.3 7.235,3.94 7.745,3.68 Z" />
  </svg>
)
Euro.iconName = "Euro"
export const Exchange = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.00374766,6 C0.904434728,6 0.00499687695,6.9 0.00499687695,8 C0.00499687695,9.1 0.904434728,10 2.00374766,10 C3.10306059,10 4.00249844,9.1 4.00249844,8 C4.00249844,6.9 3.11305434,6 2.00374766,6 Z M6.15115553,7.86 C6.24109931,7.95 6.37101811,8.01 6.50093691,8.01 C6.78076202,8.01 7.00062461,7.79 7.00062461,7.51 C7.00062461,7.37 6.94066209,7.25 6.8507183,7.16 L5.71143036,6 L11.4978139,6 C11.777639,6 11.9975016,5.78 11.9975016,5.5 C11.9975016,5.22 11.777639,5 11.4978139,5 L5.71143036,5 L6.86071205,3.85 C6.95065584,3.76 7.01061836,3.63 7.01061836,3.5 C7.01061836,3.22 6.79075578,3 6.51093067,3 C6.37101811,3 6.25109307,3.06 6.16114928,3.15 L4.1623985,5.15 C4.06246096,5.24 4.00249844,5.36 4.00249844,5.5 C4.00249844,5.64 4.06246096,5.76 4.15240475,5.85 L6.15115553,7.86 L6.15115553,7.86 Z M13.9962523,6 C12.8969394,6 11.9975016,6.9 11.9975016,8 C11.9975016,9.1 12.8969394,10 13.9962523,10 C15.0955653,10 15.9950031,9.1 15.9950031,8 C15.9950031,6.9 15.105559,6 13.9962523,6 Z M9.85883823,8.15 C9.75890069,8.06 9.63897564,8 9.49906309,8 C9.21923798,8 8.99937539,8.22 8.99937539,8.5 C8.99937539,8.64 9.05933791,8.76 9.1492817,8.85 L10.2985634,10 L4.50218613,10 C4.22236102,10 4.00249844,10.22 4.00249844,10.5 C4.00249844,10.78 4.22236102,11 4.50218613,11 L10.2885696,11 L9.13928795,12.15 C9.04934416,12.24 8.98938164,12.37 8.98938164,12.5 C8.98938164,12.78 9.20924422,13 9.48906933,13 C9.62898189,13 9.74890693,12.94 9.83885072,12.85 L11.8376015,10.85 C11.9275453,10.76 11.9875078,10.63 11.9875078,10.5 C11.9875078,10.37 11.9275453,10.24 11.8376015,10.15 L9.85883823,8.15 Z" />
  </svg>
)
Exchange.iconName = "Exchange"
export const ExcludeRow = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,10 C0,10.55 0.45,11 1,11 C1.28,11 1.53,10.89 1.71,10.71 L3,9.41 L4.29,10.7 C4.47,10.89 4.72,11 5,11 C5.55,11 6,10.55 6,10 C6,9.72 5.89,9.47 5.71,9.29 L4.41,8 L5.7,6.71 C5.89,6.53 6,6.28 6,6 C6,5.45 5.55,5 5,5 C4.72,5 4.47,5.11 4.29,5.29 L3,6.59 L1.71,5.29 C1.53,5.11 1.28,5 1,5 C0.45,5 0,5.45 0,6 C0,6.28 0.11,6.53 0.29,6.71 L1.59,8 L0.29,9.29 C0.11,9.47 0,9.72 0,10 Z M1,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 Z M15,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M14,6 L9,6 C7.9,6 7,6.9 7,8 C7,9.1 7.9,10 9,10 L14,10 C15.1,10 16,9.1 16,8 C16,6.9 15.1,6 14,6 Z" />
  </svg>
)
ExcludeRow.iconName = "ExcludeRow"
export const ExpandAll = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,7 C4.28,7 4.53,6.89 4.71,6.71 L8,3.41 L11.29,6.7 C11.47,6.89 11.72,7 12,7 C12.55,7 13,6.55 13,6 C13,5.72 12.89,5.47 12.71,5.29 L8.71,1.29 C8.53,1.11 8.28,1 8,1 C7.72,1 7.47,1.11 7.29,1.29 L3.29,5.29 C3.11,5.47 3,5.72 3,6 C3,6.55 3.45,7 4,7 Z M12,9 C11.72,9 11.47,9.11 11.29,9.29 L8,12.59 L4.71,9.29 C4.53,9.11 4.28,9 4,9 C3.45,9 3,9.45 3,10 C3,10.28 3.11,10.53 3.29,10.71 L7.29,14.71 C7.47,14.89 7.72,15 8,15 C8.28,15 8.53,14.89 8.71,14.71 L12.71,10.71 C12.89,10.53 13,10.28 13,10 C13,9.45 12.55,9 12,9 Z" />
  </svg>
)
ExpandAll.iconName = "ExpandAll"
export const Export = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,6 C4.28,6 4.53,5.89 4.71,5.71 L7,3.41 L7,11 C7,11.55 7.45,12 8,12 C8.55,12 9,11.55 9,11 L9,3.41 L11.29,5.7 C11.47,5.89 11.72,6 12,6 C12.55,6 13,5.55 13,5 C13,4.72 12.89,4.47 12.71,4.29 L8.71,0.29 C8.53,0.11 8.28,0 8,0 C7.72,0 7.47,0.11 7.29,0.29 L3.29,4.29 C3.11,4.47 3,4.72 3,5 C3,5.55 3.45,6 4,6 Z M15,11 C14.45,11 14,11.45 14,12 L14,14 L2,14 L2,12 C2,11.45 1.55,11 1,11 C0.45,11 0,11.45 0,12 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,12 C16,11.45 15.55,11 15,11 Z" />
  </svg>
)
Export.iconName = "Export"
export const EyeOff = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16,7.97 L16,7.95 L16,7.94 L16,7.92 L16,7.9 C15.98,7.76 15.92,7.64 15.83,7.54 C15.34,6.91 14.76,6.34 14.18,5.82 L11.02,8.08 C10.98,9.69 9.66,10.98 8.04,10.98 C7.73,10.98 7.44,10.92 7.16,10.83 L5.09,12.3 C5.53,12.49 5.99,12.66 6.46,12.77 C7.43,13 8.4,13.01 9.38,12.82 C10.26,12.65 11.12,12.28 11.91,11.84 C13.16,11.14 14.3,10.17 15.29,9.09 C15.47,8.89 15.66,8.68 15.82,8.47 C15.91,8.37 15.97,8.25 15.99,8.11 L15.99,8.09 L15.99,8.07 L15.99,8.06 L15.99,8.04 L15.99,8.01 C16,7.99 16,7.98 16,7.97 L16,7.97 Z M15.57,3.8 C15.82,3.62 16,3.34 16,3 C16,2.45 15.55,2 15,2 C14.78,2 14.59,2.08 14.43,2.2 L14.42,2.19 L11.75,4.1 C11.06,3.72 10.34,3.41 9.58,3.23 C8.62,3 7.64,2.99 6.67,3.18 C5.79,3.36 4.93,3.72 4.14,4.17 C2.89,4.87 1.75,5.84 0.76,6.92 C0.58,7.12 0.39,7.33 0.23,7.54 C0,7.83 0,8.17 0.22,8.46 C0.73,9.12 1.33,9.71 1.95,10.25 C2.13,10.41 2.33,10.54 2.51,10.69 L0.42,12.19 L0.43,12.2 C0.18,12.38 0,12.66 0,13 C0,13.55 0.45,14 1,14 C1.22,14 1.41,13.92 1.57,13.8 L1.58,13.81 L15.58,3.81 L15.57,3.8 Z M5.16,8.8 C5.09,8.54 5.05,8.28 5.05,8 C5.05,6.36 6.39,5.02 8.04,5.02 C8.66,5.02 9.23,5.23 9.7,5.55 L5.16,8.8 Z" />
  </svg>
)
EyeOff.iconName = "EyeOff"
export const EyeOn = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.2875,7.70334776 C10.4675,7.88334776 10.7175,7.99334776 10.9975,7.99334776 C11.2775,7.99334776 11.5275,7.88334776 11.7075,7.70334776 L15.7075,3.70334776 C15.8775,3.52334776 15.9975,3.27334776 15.9975,3.00334776 C15.9975,2.45334776 15.5475,2.00334776 14.9975,2.00334776 C14.7175,2.00334776 14.4675,2.11334776 14.2875,2.29334776 L10.9975,5.58334776 L9.7075,4.29334776 C9.5275,4.11334776 9.2775,4.00334776 8.9975,4.00334776 C8.4475,4.00334776 7.9975,4.44334776 7.9975,5.00334776 C7.9975,5.27334776 8.1175,5.52334776 8.2975,5.70334776 L10.2875,7.70334776 L10.2875,7.70334776 Z M15.9975,8.96334776 L15.9975,8.94334776 L15.9975,8.93334776 L15.9975,8.91334776 L15.9975,8.89334776 C15.9775,8.75334776 15.9175,8.62334776 15.8275,8.53334776 C15.5275,8.13334776 15.1775,7.77334776 14.8275,7.41334776 L13.1275,9.11334776 C12.5775,9.66334776 11.8275,9.99334776 10.9975,9.99334776 C10.9375,9.99334776 10.8875,9.98334776 10.8275,9.97334776 C10.4175,11.1533478 9.3175,12.0033478 8.0075,12.0033478 C6.3475,12.0033478 5.0075,10.6533478 5.0075,8.99334776 C5.0075,7.92334776 5.5675,6.99334776 6.3975,6.46334776 C6.1575,6.03334776 6.0075,5.53334776 6.0075,5.00334776 C6.0075,4.74334776 6.0475,4.50334776 6.1075,4.26334776 C5.4075,4.46334776 4.7375,4.76334776 4.0975,5.12334776 C2.8375,5.82334776 1.6975,6.80334776 0.6975,7.89334776 C0.5175,8.10334776 0.3375,8.30334776 0.1675,8.52334776 C-0.0525,8.81334776 -0.0525,9.16334776 0.1675,9.45334776 C0.6775,10.1233478 1.2875,10.7233478 1.8975,11.2633478 C3.2275,12.4333478 4.7475,13.4133478 6.4275,13.8133478 C7.3975,14.0433478 8.3775,14.0533478 9.3475,13.8633478 C10.2375,13.6833478 11.0875,13.3233478 11.8875,12.8733478 C13.1375,12.1633478 14.2875,11.1833478 15.2775,10.0933478 C15.4575,9.89334776 15.6475,9.68334776 15.8175,9.46334776 C15.9075,9.36334776 15.9675,9.23334776 15.9875,9.09334776 L15.9875,9.07334776 L15.9875,9.05334776 L15.9875,9.04334776 L15.9875,9.02334776 L15.9875,8.99334776 C15.9975,8.98334776 15.9975,8.97334776 15.9975,8.96334776 L15.9975,8.96334776 Z M8.0075,10.0033478 C8.4875,10.0033478 8.8775,9.65334776 8.9675,9.19334776 C8.9375,9.16334776 8.9175,9.13334776 8.8975,9.10334776 L8.8775,9.11334776 L7.7975,8.03334776 C7.3475,8.13334776 7.0075,8.51334776 7.0075,8.99334776 C7.0075,9.55334776 7.4575,10.0033478 8.0075,10.0033478 Z" />
  </svg>
)
EyeOn.iconName = "EyeOn"
export const EyeOpen = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.00249688,6.99 C7.45318352,6.99 7.00374532,7.44 7.00374532,7.99 C7.00374532,8.54 7.45318352,8.99 8.00249688,8.99 C8.55181024,8.99 9.00124844,8.54 9.00124844,7.99 C9.00124844,7.44 8.54182272,6.99 8.00249688,6.99 Z M15.9725343,7.96 L15.9725343,7.89 C15.9525593,7.75 15.8926342,7.63 15.8027466,7.53 C15.2933833,6.86 14.6841448,6.27 14.0649189,5.73 C12.7365793,4.56 11.2184769,3.58 9.5505618,3.19 C8.58177278,2.96 7.60299625,2.95 6.64419476,3.15 C5.74531835,3.33 4.89637953,3.69 4.09737828,4.14 C2.84893883,4.85 1.70037453,5.82 0.701622971,6.91 C0.52184769,7.11 0.342072409,7.32 0.172284644,7.54 C-0.0474406991,7.83 -0.0474406991,8.18 0.172284644,8.47 C0.68164794,9.14 1.29088639,9.73 1.91011236,10.27 C3.23845194,11.44 4.75655431,12.42 6.42446941,12.81 C7.39325843,13.04 8.37203496,13.05 9.35081149,12.85 C10.2397004,12.67 11.0886392,12.31 11.897628,11.86 C13.1460674,11.15 14.2946317,10.18 15.2833958,9.09 C15.463171,8.89 15.6529338,8.68 15.8227216,8.46 C15.9126092,8.36 15.9725343,8.23 15.9925094,8.1 L15.9925094,8 C15.9725343,7.98 15.9725343,7.97 15.9725343,7.96 Z M8.00249688,10.99 C6.34456929,10.99 5.0062422,9.65 5.0062422,7.99 C5.0062422,6.33 6.34456929,4.99 8.00249688,4.99 C9.66042447,4.99 10.9987516,6.33 10.9987516,7.99 C10.9987516,9.65 9.66042447,10.99 8.00249688,10.99 Z" />
  </svg>
)
EyeOpen.iconName = "EyeOpen"
export const FastBackward = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.5,3 C13.26,3 13.06,3.09 12.88,3.23 L12.87,3.22 L8.5,6.72 L8.5,4 C8.5,3.45 8.05,3 7.5,3 C7.26,3 7.06,3.09 6.88,3.23 L6.88,3.22 L1.88,7.22 L1.89,7.23 C1.66,7.41 1.5,7.68 1.5,8 C1.5,8.32 1.66,8.59 1.88,8.77 L1.88,8.78 L6.88,12.78 L6.89,12.77 C7.06,12.91 7.26,13 7.5,13 C8.05,13 8.5,12.55 8.5,12 L8.5,9.28 L12.88,12.78 L12.89,12.77 C13.06,12.91 13.26,13 13.5,13 C14.05,13 14.5,12.55 14.5,12 L14.5,4 C14.5,3.45 14.05,3 13.5,3 L13.5,3 Z" />
  </svg>
)
FastBackward.iconName = "FastBackward"
export const FastForward = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,8 C14.5,7.68 14.34,7.41 14.12,7.23 L14.13,7.22 L9.13,3.22 L9.12,3.23 C8.94,3.09 8.74,3 8.5,3 C7.95,3 7.5,3.45 7.5,4 L7.5,6.72 L3.12,3.22 L3.12,3.23 C2.94,3.09 2.74,3 2.5,3 C1.95,3 1.5,3.45 1.5,4 L1.5,12 C1.5,12.55 1.95,13 2.5,13 C2.74,13 2.94,12.91 3.12,12.77 L3.13,12.78 L7.5,9.28 L7.5,12 C7.5,12.55 7.95,13 8.5,13 C8.74,13 8.94,12.91 9.12,12.77 L9.13,12.78 L14.13,8.78 L14.12,8.77 C14.34,8.59 14.5,8.32 14.5,8 Z" />
  </svg>
)
FastForward.iconName = "FastForward"
export const FeedSubscribed = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3,2 C4.06,2 5.08,2.16 6.06,2.45 C6.19,1.74 6.58,1.13 7.11,0.69 C5.82,0.25 4.44,0 3,0 C2.45,0 2,0.45 2,1 C2,1.55 2.45,2 3,2 Z M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 Z M10.32,5.67 C10.5,5.85 10.75,5.96 11.02,5.96 C11.29,5.96 11.54,5.85 11.72,5.67 L15.7,1.69 C15.89,1.51 16,1.27 16,0.99 C16,0.44 15.55,0 15,0 C14.72,0 14.48,0.11 14.3,0.29 L11.02,3.57 L9.73,2.28 C9.55,2.1 9.3,1.99 9.03,1.99 C8.48,1.99 8.03,2.44 8.03,2.98 C8.03,3.25 8.14,3.5 8.32,3.68 L10.32,5.67 Z M14.05,6.2 L13.12,7.13 L13.1,7.11 C12.93,7.28 12.75,7.44 12.54,7.56 C13.47,9.16 14,11.02 14,13 C14,13.55 14.45,14 15,14 C15.55,14 16,13.55 16,13 C16,10.5 15.27,8.18 14.05,6.2 Z M3,8 C2.45,8 2,8.45 2,9 C2,9.55 2.45,10 3,10 C4.66,10 6,11.34 6,13 C6,13.55 6.45,14 7,14 C7.55,14 8,13.55 8,13 C8,10.24 5.76,8 3,8 Z M8.91,7.09 L8.88,7.12 L6.88,5.12 L6.91,5.09 C6.8,4.98 6.68,4.89 6.58,4.76 C5.48,4.28 4.28,4 3,4 C2.45,4 2,4.45 2,5 C2,5.55 2.45,6 3,6 C6.87,6 10,9.13 10,13 C10,13.55 10.45,14 11,14 C11.55,14 12,13.55 12,13 C12,11.13 11.43,9.39 10.45,7.94 C9.84,7.83 9.32,7.52 8.91,7.09 Z" />
  </svg>
)
FeedSubscribed.iconName = "FeedSubscribed"
export const Feed = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.00374766,11.9975016 C0.904434728,11.9975016 0.00499687695,12.8969394 0.00499687695,13.9962523 C0.00499687695,15.0955653 0.904434728,15.9950031 2.00374766,15.9950031 C3.10306059,15.9950031 4.00249844,15.0955653 4.00249844,13.9962523 C4.00249844,12.8969394 3.11305434,11.9975016 2.00374766,11.9975016 Z M3.00312305,8 C2.45346658,8 2.00374766,8.44971893 2.00374766,8.99937539 C2.00374766,9.54903186 2.45346658,9.99875078 3.00312305,9.99875078 C4.6620862,9.99875078 6.00124922,11.3379138 6.00124922,12.996877 C6.00124922,13.5465334 6.45096814,13.9962523 7.00062461,13.9962523 C7.55028107,13.9962523 8,13.5465334 8,12.996877 C8,10.2386009 5.76139913,8 3.00312305,8 Z M3.00312305,4.00249844 C2.45346658,4.00249844 2.00374766,4.45221736 2.00374766,5.00187383 C2.00374766,5.55153029 2.45346658,6.00124922 3.00312305,6.00124922 C6.87070581,6.00124922 9.99875078,9.12929419 9.99875078,12.996877 C9.99875078,13.5465334 10.4484697,13.9962523 10.9981262,13.9962523 C11.5477826,13.9962523 11.9975016,13.5465334 11.9975016,12.996877 C11.9975016,8.02998126 7.97001874,4.00249844 3.00312305,4.00249844 Z M3.00312305,0.00499687695 C2.45346658,0.00499687695 2.00374766,0.454715803 2.00374766,1.00437227 C2.00374766,1.55402873 2.45346658,2.00374766 3.00312305,2.00374766 C9.07932542,2.00374766 13.9962523,6.92067458 13.9962523,12.996877 C13.9962523,13.5465334 14.4459713,13.9962523 14.9956277,13.9962523 C15.5452842,13.9962523 15.9950031,13.5465334 15.9950031,12.996877 C15.9950031,5.82136165 10.1786384,0.00499687695 3.00312305,0.00499687695 Z" />
  </svg>
)
Feed.iconName = "Feed"
export const Film = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1.5 L10,1.5 L10,3.5 L6,3.5 L6,1.5 L1,1.5 C0.45,1.5 0,1.95 0,2.5 L0,13.5 C0,14.05 0.45,14.5 1,14.5 L6,14.5 L6,12.5 L10,12.5 L10,14.5 L15,14.5 C15.55,14.5 16,14.05 16,13.5 L16,2.5 C16,1.95 15.55,1.5 15,1.5 Z M4,13.5 L2,13.5 L2,11.5 L4,11.5 L4,13.5 Z M4,10.5 L2,10.5 L2,8.5 L4,8.5 L4,10.5 Z M4,7.5 L2,7.5 L2,5.5 L4,5.5 L4,7.5 Z M4,4.5 L2,4.5 L2,2.5 L4,2.5 L4,4.5 Z M10,10.5 L6,10.5 L6,5.5 L10,5.5 L10,10.5 Z M14,13.5 L12,13.5 L12,11.5 L14,11.5 L14,13.5 Z M14,10.5 L12,10.5 L12,8.5 L14,8.5 L14,10.5 Z M14,7.5 L12,7.5 L12,5.5 L14,5.5 L14,7.5 Z M14,4.5 L12,4.5 L12,2.5 L14,2.5 L14,4.5 Z" />
  </svg>
)
Film.iconName = "Film"
export const FilterKeep = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,10 C14.72,10 14.47,10.11 14.29,10.29 L12,12.59 L10.71,11.3 C10.53,11.11 10.28,11 10,11 C9.45,11 9,11.45 9,12 C9,12.28 9.11,12.53 9.29,12.71 L11.29,14.71 C11.47,14.89 11.72,15 12,15 C12.28,15 12.53,14.89 12.71,14.71 L15.71,11.71 C15.89,11.53 16,11.28 16,11 C16,10.45 15.55,10 15,10 Z M12,2 C12,1.45 11.55,1 11,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.28 0.11,2.53 0.29,2.71 L4,6.41 L4,12 C4,12.55 4.45,13 5,13 C5.28,13 5.53,12.89 5.71,12.71 L7.71,10.71 C7.89,10.53 8,10.28 8,10 L8,6.41 L11.71,2.7 C11.89,2.53 12,2.28 12,2 Z" />
  </svg>
)
FilterKeep.iconName = "FilterKeep"
export const FilterList = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9,8 C9,8.55 9.45,9 10,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 L10,7 C9.45,7 9,7.45 9,8 Z M12,2 C12,1.45 11.55,1 11,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.28 0.11,2.53 0.29,2.71 L4,6.41 L4,12 C4,12.55 4.45,13 5,13 C5.28,13 5.53,12.89 5.71,12.71 L7.71,10.71 C7.89,10.53 8,10.28 8,10 L8,6.41 L11.71,2.7 C11.89,2.53 12,2.28 12,2 Z M15,10 L10,10 C9.45,10 9,10.45 9,11 C9,11.55 9.45,12 10,12 L15,12 C15.55,12 16,11.55 16,11 C16,10.45 15.55,10 15,10 Z M15,13 L10,13 C9.45,13 9,13.45 9,14 C9,14.55 9.45,15 10,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z" />
  </svg>
)
FilterList.iconName = "FilterList"
export const FilterRemove = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,2 C12,1.45 11.55,1 11,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.28 0.11,2.53 0.29,2.71 L4,6.41 L4,12 C4,12.55 4.45,13 5,13 C5.28,13 5.53,12.89 5.71,12.71 L7.71,10.71 C7.89,10.53 8,10.28 8,10 L8,6.41 L11.71,2.7 C11.89,2.53 12,2.28 12,2 Z M14.41,12 L15.7,10.71 C15.89,10.53 16,10.28 16,10 C16,9.45 15.55,9 15,9 C14.72,9 14.47,9.11 14.29,9.29 L13,10.59 L11.71,9.3 C11.53,9.11 11.28,9 11,9 C10.45,9 10,9.45 10,10 C10,10.28 10.11,10.53 10.29,10.71 L11.59,12 L10.3,13.29 C10.11,13.47 10,13.72 10,14 C10,14.55 10.45,15 11,15 C11.28,15 11.53,14.89 11.71,14.71 L13,13.41 L14.29,14.7 C14.47,14.89 14.72,15 15,15 C15.55,15 16,14.55 16,14 C16,13.72 15.89,13.47 15.71,13.29 L14.41,12 Z" />
  </svg>
)
FilterRemove.iconName = "FilterRemove"
export const Filter = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,0.995 L2,0.995 C1.45,0.995 1,1.445 1,1.995 C1,2.275 1.11,2.525 1.29,2.705 L6,7.415 L6,14.005 C6,14.555 6.45,15.005 7,15.005 C7.28,15.005 7.53,14.895 7.71,14.715 L9.71,12.715 C9.89,12.535 10,12.285 10,12.005 L10,7.415 L14.71,2.705 C14.89,2.525 15,2.275 15,1.995 C15,1.445 14.55,0.995 14,0.995 Z" />
  </svg>
)
Filter.iconName = "Filter"
export const Flag = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3,3.00312305 C2.45,3.00312305 2,3.45284197 2,4.00249844 L2,14.9956277 C2,15.5452842 2.45,15.9950031 3,15.9950031 C3.55,15.9950031 4,15.5452842 4,14.9956277 L4,4.00249844 C4,3.45284197 3.55,3.00312305 3,3.00312305 Z M3,0.00499687695 C2.45,0.00499687695 2,0.454715803 2,1.00437227 C2,1.55402873 2.45,2.00374766 3,2.00374766 C3.55,2.00374766 4,1.55402873 4,1.00437227 C4,0.454715803 3.55,0.00499687695 3,0.00499687695 Z M5,3.03310431 L5,10.2585884 C7.07,8.14990631 10.92,12.0074953 14,10.2585884 L14,3.03310431 C11,5.10181137 7.06,1.00437227 5,3.03310431 Z" />
  </svg>
)
Flag.iconName = "Flag"
export const Flash = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,8 C4,7.45 3.55,7 3,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L3,9 C3.55,9 4,8.55 4,8 Z M8,4 C8.55,4 9,3.55 9,3 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,3 C7,3.55 7.45,4 8,4 Z M3.79,5.21 C3.97,5.39 4.22,5.5 4.5,5.5 C5.05,5.5 5.5,5.05 5.5,4.5 C5.5,4.22 5.39,3.97 5.21,3.79 L3.71,2.29 C3.53,2.11 3.28,2 3,2 C2.45,2 2,2.45 2,3 C2,3.28 2.11,3.53 2.29,3.71 L3.79,5.21 Z M4.5,10.5 C4.22,10.5 3.97,10.61 3.79,10.79 L2.29,12.29 C2.11,12.47 2,12.72 2,13 C2,13.55 2.45,14 3,14 C3.28,14 3.53,13.89 3.71,13.71 L5.21,12.21 C5.39,12.03 5.5,11.78 5.5,11.5 C5.5,10.95 5.05,10.5 4.5,10.5 Z M11.5,5.5 C11.78,5.5 12.03,5.39 12.21,5.21 L13.71,3.71 C13.89,3.53 14,3.28 14,3 C14,2.45 13.55,2 13,2 C12.72,2 12.47,2.11 12.29,2.29 L10.79,3.79 C10.61,3.97 10.5,4.22 10.5,4.5 C10.5,5.05 10.95,5.5 11.5,5.5 Z M12.21,10.79 C12.03,10.61 11.78,10.5 11.5,10.5 C10.95,10.5 10.5,10.95 10.5,11.5 C10.5,11.78 10.61,12.03 10.79,12.21 L12.29,13.71 C12.47,13.89 12.72,14 13,14 C13.55,14 14,13.55 14,13 C14,12.72 13.89,12.47 13.71,12.29 L12.21,10.79 Z M15,7 L13,7 C12.45,7 12,7.45 12,8 C12,8.55 12.45,9 13,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z M8,5 C6.34,5 5,6.34 5,8 C5,9.66 6.34,11 8,11 C9.66,11 11,9.66 11,8 C11,6.34 9.66,5 8,5 Z M8,9 C7.45,9 7,8.55 7,8 C7,7.45 7.45,7 8,7 C8.55,7 9,7.45 9,8 C9,8.55 8.55,9 8,9 Z M8,12 C7.45,12 7,12.45 7,13 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,13 C9,12.45 8.55,12 8,12 Z" />
  </svg>
)
Flash.iconName = "Flash"
export const FloppyDisk = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.71,2.29 L13.71,0.29 C13.53,0.11 13.28,0 13,0 L12,0 L12,6 L4,6 L4,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,3 C16,2.72 15.89,2.47 15.71,2.29 Z M14,15 L2,15 L2,9 C2,8.45 2.45,8 3,8 L13,8 C13.55,8 14,8.45 14,9 L14,15 Z M11,1 L9,1 L9,5 L11,5 L11,1 Z" />
  </svg>
)
FloppyDisk.iconName = "FloppyDisk"
export const Flows = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.5,5.5 C12.29,5.5 11.28,6.36 11.05,7.5 L9.75,7.5 L5.74,3.5 L4.99,4.25 L8.25,7.5 L4.95,7.5 C4.72,6.36 3.71,5.5 2.5,5.5 C1.12,5.5 0,6.62 0,8 C0,9.38 1.12,10.5 2.5,10.5 C3.71,10.5 4.72,9.64 4.95,8.5 L8.25,8.5 L4.99,11.75 L5.74,12.5 L9.75,8.5 L11.05,8.5 C11.28,9.64 12.29,10.5 13.5,10.5 C14.88,10.5 16,9.38 16,8 C16,6.62 14.88,5.5 13.5,5.5 Z" />
  </svg>
)
Flows.iconName = "Flows"
export const FolderClose = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.00499687695,13.5 C0.00499687695,14.05 0.454715803,14.5 1.00437227,14.5 L14.9956277,14.5 C15.5452842,14.5 15.9950031,14.05 15.9950031,13.5 L15.9950031,6.5 L0.00499687695,6.5 L0.00499687695,13.5 Z M14.9956277,3.5 L7.42036227,3.5 L5.71143036,1.8 C5.53154279,1.61 5.28169894,1.5 5.00187383,1.5 L1.00437227,1.5 C0.454715803,1.5 0.00499687695,1.95 0.00499687695,2.5 L0.00499687695,5.5 L15.9950031,5.5 L15.9950031,4.5 C15.9950031,3.95 15.5452842,3.5 14.9956277,3.5 Z" />
  </svg>
)
FolderClose.iconName = "FolderClose"
export const FolderOpen = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.06,6.19 C2.2,5.79 2.56,5.5 3,5.5 L14,5.5 L14,4.5 C14,3.95 13.55,3.5 13,3.5 L6.41,3.5 L4.71,1.79 C4.53,1.61 4.28,1.5 4,1.5 L1,1.5 C0.45,1.5 0,1.95 0,2.5 L0,12.34 L2.05,6.19 L2.06,6.19 Z M16,7.5 C16,6.95 15.55,6.5 15,6.5 L4,6.5 C3.56,6.5 3.19,6.79 3.06,7.19 L1.06,13.19 C1.02,13.28 1,13.39 1,13.5 C1,14.05 1.45,14.5 2,14.5 L13,14.5 C13.44,14.5 13.81,14.21 13.94,13.81 L15.94,7.81 C15.98,7.72 16,7.61 16,7.5 Z" />
  </svg>
)
FolderOpen.iconName = "FolderOpen"
export const FolderSharedOpen = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.02,9.72 L12.12,10.62 L12.11,10.61 C11.57,11.16 10.83,11.5 10,11.5 C8.34,11.5 7,10.16 7,8.5 C7,7.73 7.3,7.03 7.78,6.5 L4,6.5 C3.56,6.5 3.19,6.79 3.06,7.19 L1.06,13.19 C1.02,13.28 1,13.39 1,13.5 C1,14.05 1.45,14.5 2,14.5 L13,14.5 C13.44,14.5 13.81,14.21 13.94,13.81 L15.05,10.49 C15.04,10.49 15.02,10.5 15,10.5 C14.23,10.5 13.55,10.2 13.02,9.72 L13.02,9.72 Z M2.06,6.19 C2.2,5.79 2.56,5.5 3,5.5 L8.76,5.5 L8.77,5.49 C8.3,4.96 8,4.27 8,3.5 L6.41,3.5 L4.71,1.79 C4.53,1.61 4.28,1.5 4,1.5 L1,1.5 C0.45,1.5 0,1.95 0,2.5 L0,12.34 L2.05,6.19 L2.06,6.19 Z M15,2.5 L11,2.5 C10.45,2.5 10,2.95 10,3.5 C10,4.05 10.45,4.5 11,4.5 L12.59,4.5 L9.29,7.79 C9.11,7.97 9,8.22 9,8.5 C9,9.05 9.45,9.5 10,9.5 C10.28,9.5 10.53,9.39 10.71,9.21 L14,5.91 L14,7.5 C14,8.05 14.45,8.5 15,8.5 C15.55,8.5 16,8.05 16,7.5 L16,3.5 C16,2.95 15.55,2.5 15,2.5 Z" />
  </svg>
)
FolderSharedOpen.iconName = "FolderSharedOpen"
export const FolderShared = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.76951905,5.485 C8.29981262,4.955 8,4.265 8,3.495 L7.42036227,3.495 L5.71143036,1.795 C5.53154279,1.605 5.28169894,1.495 5.00187383,1.495 L1.00437227,1.495 C0.454715803,1.495 0.00499687695,1.945 0.00499687695,2.495 L0.00499687695,5.495 L8.7595253,5.495 L8.76951905,5.485 Z M14.9956277,2.495 L10.9981262,2.495 C10.4484697,2.495 9.99875078,2.945 9.99875078,3.495 C9.99875078,4.045 10.4484697,4.495 10.9981262,4.495 L12.587133,4.495 L9.28919425,7.795 C9.10930668,7.975 8.99937539,8.225 8.99937539,8.495 C8.99937539,9.045 9.44909432,9.495 9.99875078,9.495 C10.2785759,9.495 10.5284197,9.385 10.7083073,9.205 L13.9962523,5.915 L13.9962523,7.505 C13.9962523,8.055 14.4459713,8.505 14.9956277,8.505 C15.5452842,8.505 15.9950031,8.055 15.9950031,7.505 L15.9950031,3.505 C15.9950031,2.945 15.5452842,2.495 14.9956277,2.495 L14.9956277,2.495 Z M13.0168645,9.725 L12.1174266,10.625 L12.1074329,10.615 C11.5677701,11.165 10.8282324,11.505 9.99875078,11.505 C8.33978763,11.505 7.00062461,10.165 7.00062461,8.505 C7.00062461,7.735 7.30043723,7.035 7.78013741,6.505 L0.00499687695,6.505 L0.00499687695,13.505 C0.00499687695,14.055 0.454715803,14.505 1.00437227,14.505 L14.9956277,14.505 C15.5452842,14.505 15.9950031,14.055 15.9950031,13.505 L15.9950031,10.325 C15.6851968,10.435 15.3454091,10.505 14.9956277,10.505 C14.2361024,10.495 13.5465334,10.195 13.0168645,9.725 L13.0168645,9.725 Z" />
  </svg>
)
FolderShared.iconName = "FolderShared"
export const Follower = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.37916844,12.69 C8.17992348,12.16 8.33982281,11.84 8.29984797,11.4 C8.28985427,11.34 8.28985427,11.28 8.28985427,11.21 C8.69959629,10.84 9.03938237,10.34 9.25924394,9.77 C9.25924394,9.77 9.26923765,9.74 9.26923765,9.73 C9.31920619,9.6 9.35918102,9.47 9.38916215,9.34 C9.66898597,9.28 9.8288853,8.98 9.88884755,8.71 C9.9488098,8.6 10.078728,8.32 10.0487469,8.01 C10.008772,7.61 9.84887272,7.42 9.66898597,7.34 L9.66898597,7.27 C9.66898597,6.75 9.61901743,6.01 9.52907406,5.53 C9.50908664,5.37 9.47910552,5.24 9.43913069,5.1 C9.25924394,4.5 8.88947675,3.97 8.39978505,3.59 C7.88011224,3.2 7.16056526,3 6.51097424,3 C5.87137693,3 5.15182995,3.2 4.64215084,3.59 C4.14246544,3.97 3.77269824,4.51 3.5928115,5.1 C3.55283667,5.23 3.52285554,5.37 3.50286813,5.5 C3.41292475,5.99 3.36295621,6.74 3.36295621,7.25 L3.36295621,7.31 C3.17307576,7.38 3.00318273,7.57 2.96320789,7.99 C2.93322677,8.3 3.06314497,8.58 3.12310722,8.69 C3.18306947,8.97 3.35296251,9.28 3.63278633,9.33 C3.67276116,9.47 3.71273599,9.6 3.76270453,9.72 C3.76270453,9.73 3.77269824,9.74 3.77269824,9.74 L3.77269824,9.75 C3.99255982,10.34 4.3423396,10.85 4.76207534,11.21 C4.76207534,11.27 4.75208163,11.33 4.75208163,11.38 C4.7121068,11.82 4.83203129,12.14 3.63278633,12.67 C2.43354137,13.2 0.624680218,13.77 0.254913021,14.62 C-0.114854175,15.5 0.0350514448,16 0.0350514448,16 L12.986897,16 C12.986897,16 13.1368027,15.5 12.7670355,14.64 C12.3872746,13.79 10.5784134,13.22 9.37916844,12.69 L9.37916844,12.69 Z M15.7051856,2.29 L13.706444,0.29 C13.5265573,0.11 13.2767146,0 12.9968907,0 C12.4472368,0 11.9975199,0.45 11.9975199,1 C11.9975199,1.28 12.1074507,1.53 12.2873375,1.71 L12.5871487,2 L9.99877834,2 C9.4491244,2 8.99940753,2.45 8.99940753,3 C8.99940753,3.55 9.4491244,4 9.99877834,4 L12.577155,4 L12.2873375,4.29 C12.1074507,4.47 11.9975199,4.72 11.9975199,5 C11.9975199,5.55 12.4472368,6 12.9968907,6 C13.2767146,6 13.5265573,5.89 13.706444,5.71 L15.7051856,3.71 C15.8850724,3.53 15.9950031,3.28 15.9950031,3 C15.9950031,2.72 15.8850724,2.47 15.7051856,2.29 L15.7051856,2.29 Z" />
  </svg>
)
Follower.iconName = "Follower"
export const Following = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.37916844,12.69 C8.17992348,12.16 8.33982281,11.84 8.29984797,11.4 C8.28985427,11.34 8.28985427,11.28 8.28985427,11.21 C8.69959629,10.84 9.03938237,10.34 9.25924394,9.77 C9.25924394,9.77 9.26923765,9.74 9.26923765,9.73 C9.31920619,9.6 9.35918102,9.47 9.38916215,9.34 C9.66898597,9.28 9.8288853,8.98 9.88884755,8.71 C9.9488098,8.6 10.078728,8.32 10.0487469,8.01 C10.008772,7.61 9.84887272,7.42 9.66898597,7.34 L9.66898597,7.27 C9.66898597,6.75 9.61901743,6.01 9.52907406,5.53 C9.50908664,5.37 9.47910552,5.24 9.43913069,5.1 C9.25924394,4.5 8.88947675,3.97 8.39978505,3.59 C7.88011224,3.2 7.16056526,3 6.51097424,3 C5.87137693,3 5.15182995,3.2 4.64215084,3.59 C4.14246544,3.97 3.77269824,4.51 3.5928115,5.1 C3.55283667,5.23 3.52285554,5.37 3.50286813,5.5 C3.41292475,5.99 3.36295621,6.74 3.36295621,7.25 L3.36295621,7.31 C3.17307576,7.38 3.00318273,7.57 2.96320789,7.99 C2.93322677,8.3 3.06314497,8.58 3.12310722,8.69 C3.18306947,8.97 3.35296251,9.28 3.63278633,9.33 C3.67276116,9.47 3.71273599,9.6 3.76270453,9.72 C3.76270453,9.73 3.77269824,9.74 3.77269824,9.74 L3.77269824,9.75 C3.99255982,10.34 4.3423396,10.85 4.76207534,11.21 C4.76207534,11.27 4.75208163,11.33 4.75208163,11.38 C4.7121068,11.82 4.83203129,12.14 3.63278633,12.67 C2.43354137,13.2 0.624680218,13.77 0.254913021,14.62 C-0.114854175,15.5 0.0350514448,16 0.0350514448,16 L12.986897,16 C12.986897,16 13.1368027,15.5 12.7670355,14.64 C12.3872746,13.79 10.5784134,13.22 9.37916844,12.69 L9.37916844,12.69 Z M14.9956323,2 L12.4172557,2 L12.7070732,1.71 C12.88696,1.53 12.9968907,1.28 12.9968907,1 C12.9968907,0.45 12.5471739,0 11.9975199,0 C11.7176961,0 11.4678534,0.11 11.2879667,0.29 L9.28922507,2.29 C9.11933203,2.47 8.99940753,2.72 8.99940753,3 C8.99940753,3.28 9.10933832,3.53 9.28922507,3.71 L11.2879667,5.71 C11.4778471,5.89 11.7276898,6 11.9975199,6 C12.5471739,6 12.9968907,5.55 12.9968907,5 C12.9968907,4.72 12.88696,4.47 12.7070732,4.29 L12.4172557,4 L14.9956323,4 C15.5452863,4 15.9950031,3.55 15.9950031,3 C15.9950031,2.45 15.5452863,2 14.9956323,2 Z" />
  </svg>
)
Following.iconName = "Following"
export const Font = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.93,14.67 L8.94,0.67 L8.93,0.67 C8.79,0.28 8.43,0 8,0 C7.57,0 7.21,0.28 7.07,0.67 L7.06,0.67 L2.06,14.67 L2.07,14.67 C2.03,14.77 2,14.88 2,15 C2,15.55 2.45,16 3,16 C3.43,16 3.79,15.72 3.93,15.33 L3.94,15.33 L5.49,11 L10.51,11 L12.06,15.34 L12.07,15.34 C12.21,15.72 12.57,16 13,16 C13.55,16 14,15.55 14,15 C14,14.88 13.97,14.77 13.93,14.67 Z M6.2,9 L8,3.97 L9.8,9 L6.2,9 Z" />
  </svg>
)
Font.iconName = "Font"
export const Fork = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.6928839,8.79 C13.5131086,8.61 13.2634207,8.5 12.9837703,8.5 C12.4344569,8.5 11.9850187,8.95 11.9850187,9.5 C11.9850187,9.78 12.0948814,10.03 12.2746567,10.21 L12.5642946,10.5 L11.3957553,10.5 L6.4019975,5.5 L12.5642946,5.5 L12.2746567,5.79 C12.0948814,5.97 11.9850187,6.22 11.9850187,6.5 C11.9850187,7.05 12.4344569,7.5 12.9837703,7.5 C13.2634207,7.5 13.5131086,7.39 13.6928839,7.21 L15.690387,5.21 C15.8701623,5.03 15.980025,4.78 15.980025,4.5 C15.980025,4.22 15.8701623,3.97 15.690387,3.79 L13.6928839,1.79 C13.5131086,1.61 13.2634207,1.5 12.9837703,1.5 C12.4344569,1.5 11.9850187,1.95 11.9850187,2.5 C11.9850187,2.78 12.0948814,3.03 12.2746567,3.21 L12.5642946,3.5 L0.998751561,3.5 C0.449438202,3.5 0,3.95 0,4.5 C0,5.05 0.449438202,5.5 0.998751561,5.5 L3.5855181,5.5 L10.2871411,12.21 C10.4669164,12.39 10.7166042,12.5 10.9962547,12.5 L12.5842697,12.5 L12.2946317,12.79 C12.1148564,12.97 12.0049938,13.22 12.0049938,13.5 C12.0049938,14.05 12.454432,14.5 13.0037453,14.5 C13.2833958,14.5 13.5330836,14.39 13.7128589,14.21 L15.710362,12.21 C15.8901373,12.03 16,11.78 16,11.5 C16,11.22 15.8901373,10.97 15.710362,10.79 L13.6928839,8.79 L13.6928839,8.79 Z" />
  </svg>
)
Fork.iconName = "Fork"
export const Form = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,11 L2,13 L4,13 L4,11 L2,11 Z M1,9 L5,9 C5.55,9 6,9.45 6,10 L6,14 C6,14.55 5.55,15 5,15 L1,15 C0.45,15 0,14.55 0,14 L0,10 C0,9.45 0.45,9 1,9 Z M10,3 L15,3 C15.55,3 16,3.45 16,4 C16,4.55 15.55,5 15,5 L10,5 C9.45,5 9,4.55 9,4 C9,3.45 9.45,3 10,3 Z M6,1 C6.55,1 7,1.45 7,2 C7,2.28 6.89,2.53 6.71,2.71 L3.71,6.71 C3.53,6.89 3.28,7 3,7 C2.72,7 2.47,6.89 2.29,6.71 L0.29,4.71 C0.11,4.53 0,4.28 0,4 C0,3.45 0.45,3 1,3 C1.28,3 1.53,3.11 1.71,3.29 L3,4.59 L5.29,1.29 C5.47,1.11 5.72,1 6,1 Z M10,11 L15,11 C15.55,11 16,11.45 16,12 C16,12.55 15.55,13 15,13 L10,13 C9.45,13 9,12.55 9,12 C9,11.45 9.45,11 10,11 Z" />
  </svg>
)
Form.iconName = "Form"
export const FullCircle = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8 C16,3.581722 12.418278,0 8,0 Z" />
  </svg>
)
FullCircle.iconName = "FullCircle"
export const FullStackedChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.5,12 L13.5,12 C14.05,12 14.5,11.55 14.5,11 L14.5,8 L11.5,8 L11.5,11 C11.5,11.55 11.95,12 12.5,12 Z M9.5,2 C9.5,1.45 9.05,1 8.5,1 L7.5,1 C6.95,1 6.5,1.45 6.5,2 L6.5,5 L9.5,5 L9.5,2 Z M9.5,6 L6.5,6 L6.5,9 L9.5,9 L9.5,6 Z M14.5,2 C14.5,1.45 14.05,1 13.5,1 L12.5,1 C11.95,1 11.5,1.45 11.5,2 L11.5,4 L14.5,4 L14.5,2 Z M14.5,5 L11.5,5 L11.5,7 L14.5,7 L14.5,5 Z M4.5,5 L1.5,5 L1.5,8 L4.5,8 L4.5,5 Z M2.5,12 L3.5,12 C4.05,12 4.5,11.55 4.5,11 L4.5,9 L1.5,9 L1.5,11 C1.5,11.55 1.95,12 2.5,12 Z M14.5,13 L1.5,13 C0.95,13 0.5,13.45 0.5,14 C0.5,14.55 0.95,15 1.5,15 L14.5,15 C15.05,15 15.5,14.55 15.5,14 C15.5,13.45 15.05,13 14.5,13 Z M4.5,2 C4.5,1.45 4.05,1 3.5,1 L2.5,1 C1.95,1 1.5,1.45 1.5,2 L1.5,4 L4.5,4 L4.5,2 Z M7.5,12 L8.5,12 C9.05,12 9.5,11.55 9.5,11 L9.5,10 L6.5,10 L6.5,11 C6.5,11.55 6.95,12 7.5,12 Z" />
  </svg>
)
FullStackedChart.iconName = "FullStackedChart"
export const Fullscreen = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.41,2 L5,2 C5.55,2 6,1.55 6,1 C6,0.45 5.55,0 5,0 L1,0 C0.45,0 0,0.45 0,1 L0,5 C0,5.55 0.45,6 1,6 C1.55,6 2,5.55 2,5 L2,3.41 L5.29,6.7 C5.47,6.89 5.72,7 6,7 C6.55,7 7,6.55 7,6 C7,5.72 6.89,5.47 6.71,5.29 L3.41,2 Z M6,9 C5.72,9 5.47,9.11 5.29,9.29 L2,12.59 L2,11 C2,10.45 1.55,10 1,10 C0.45,10 0,10.45 0,11 L0,15 C0,15.55 0.45,16 1,16 L5,16 C5.55,16 6,15.55 6,15 C6,14.45 5.55,14 5,14 L3.41,14 L6.7,10.71 C6.89,10.53 7,10.28 7,10 C7,9.45 6.55,9 6,9 Z M15,10 C14.45,10 14,10.45 14,11 L14,12.59 L10.71,9.3 C10.53,9.11 10.28,9 10,9 C9.45,9 9,9.45 9,10 C9,10.28 9.11,10.53 9.29,10.71 L12.59,14 L11,14 C10.45,14 10,14.45 10,15 C10,15.55 10.45,16 11,16 L15,16 C15.55,16 16,15.55 16,15 L16,11 C16,10.45 15.55,10 15,10 Z M15,0 L11,0 C10.45,0 10,0.45 10,1 C10,1.55 10.45,2 11,2 L12.59,2 L9.29,5.29 C9.11,5.47 9,5.72 9,6 C9,6.55 9.45,7 10,7 C10.28,7 10.53,6.89 10.71,6.71 L14,3.41 L14,5 C14,5.55 14.45,6 15,6 C15.55,6 16,5.55 16,5 L16,1 C16,0.45 15.55,0 15,0 Z" />
  </svg>
)
Fullscreen.iconName = "Fullscreen"
export const Function = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.12,4.735 L6.98,4.735 C7.31,3.445 7.73,2.495 8.26,1.895 C8.59,1.525 8.9,1.335 9.21,1.335 C9.27,1.335 9.32,1.355 9.36,1.385 C9.4,1.425 9.42,1.475 9.42,1.535 C9.42,1.585 9.38,1.685 9.29,1.825 C9.2,1.965 9.16,2.105 9.16,2.225 C9.16,2.405 9.23,2.555 9.36,2.685 C9.5,2.815 9.67,2.875 9.88,2.875 C10.1,2.875 10.29,2.795 10.44,2.645 C10.59,2.485 10.67,2.275 10.67,2.015 C10.67,1.715 10.56,1.465 10.33,1.275 C10.1,1.085 9.74,0.995 9.24,0.995 C8.46,0.995 7.75,1.215 7.12,1.665 C6.48,2.115 5.88,2.865 5.31,3.895 C5.11,4.255 4.93,4.485 4.75,4.585 C4.57,4.685 4.29,4.735 3.9,4.735 L3.64,5.635 L4.72,5.635 L3.13,11.755 C2.86,12.765 2.69,13.385 2.59,13.615 C2.45,13.955 2.25,14.245 1.97,14.485 C1.86,14.585 1.73,14.635 1.57,14.635 C1.53,14.635 1.49,14.625 1.46,14.595 L1.42,14.545 C1.42,14.515 1.46,14.465 1.54,14.385 C1.62,14.305 1.66,14.185 1.66,14.025 C1.66,13.845 1.6,13.695 1.47,13.585 C1.35,13.465 1.17,13.405 0.93,13.405 C0.65,13.405 0.42,13.485 0.25,13.635 C0.09,13.775 9e-16,13.955 9e-16,14.165 C9e-16,14.385 0.1,14.585 0.31,14.755 C0.52,14.925 0.84,15.005 1.28,15.005 C1.98,15.005 2.6,14.825 3.15,14.465 C3.69,14.105 4.17,13.545 4.57,12.795 C4.98,12.045 5.39,10.835 5.82,9.165 L6.73,5.625 L7.83,5.625 L8.12,4.735 Z M13.55,6.255 C13.75,6.105 13.96,6.025 14.17,6.025 C14.25,6.025 14.4,6.055 14.62,6.115 C14.84,6.175 15.03,6.205 15.19,6.205 C15.42,6.205 15.61,6.125 15.76,5.975 C15.92,5.815 16,5.615 16,5.365 C16,5.105 15.92,4.895 15.77,4.745 C15.62,4.595 15.4,4.515 15.11,4.515 C14.86,4.515 14.61,4.575 14.39,4.695 C14.16,4.815 13.88,5.075 13.53,5.475 C13.27,5.775 12.89,6.285 12.38,7.025 C12.18,6.115 11.83,5.275 11.33,4.515 L8.61,4.975 L8.55,5.265 C8.75,5.225 8.92,5.205 9.06,5.205 C9.33,5.205 9.55,5.315 9.73,5.545 C10.01,5.905 10.4,6.995 10.9,8.805 C10.51,9.325 10.24,9.655 10.1,9.815 C9.86,10.075 9.66,10.235 9.51,10.315 C9.39,10.375 9.26,10.405 9.1,10.405 C8.99,10.405 8.8,10.345 8.54,10.225 C8.36,10.145 8.2,10.105 8.06,10.105 C7.79,10.105 7.58,10.185 7.4,10.355 C7.23,10.525 7.14,10.735 7.14,10.995 C7.14,11.245 7.22,11.435 7.38,11.595 C7.54,11.745 7.75,11.825 8.02,11.825 C8.28,11.825 8.52,11.775 8.75,11.665 C8.98,11.555 9.27,11.325 9.61,10.975 C9.96,10.625 10.43,10.075 11.04,9.305 C11.27,10.035 11.48,10.555 11.65,10.885 C11.82,11.215 12.02,11.455 12.24,11.595 C12.46,11.745 12.74,11.815 13.07,11.815 C13.39,11.815 13.72,11.705 14.05,11.475 C14.49,11.175 14.93,10.665 15.39,9.945 L15.13,9.795 C14.82,10.225 14.59,10.495 14.44,10.595 C14.34,10.665 14.22,10.695 14.09,10.695 C13.93,10.695 13.77,10.595 13.61,10.395 C13.34,10.055 12.99,9.125 12.55,7.595 C12.95,6.915 13.28,6.465 13.55,6.255 L13.55,6.255 Z" />
  </svg>
)
Function.iconName = "Function"
export const GanttChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,10 C10,10.55 10.45,11 11,11 L15,11 C15.55,11 16,10.55 16,10 C16,9.45 15.55,9 15,9 L11,9 C10.45,9 10,9.45 10,10 Z M6,7 C6,7.55 6.45,8 7,8 L11,8 C11.55,8 12,7.55 12,7 C12,6.45 11.55,6 11,6 L7,6 C6.45,6 6,6.45 6,7 Z M15,12 L2,12 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z M4,5 L7,5 C7.55,5 8,4.55 8,4 C8,3.45 7.55,3 7,3 L4,3 C3.45,3 3,3.45 3,4 C3,4.55 3.45,5 4,5 Z" />
  </svg>
)
GanttChart.iconName = "GanttChart"
export const Geolocation = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon
      fillRule="evenodd"
      points=".005 6.671 7.34 8.67 9.339 15.995 15.995 .005"
    />
  </svg>
)
Geolocation.iconName = "Geolocation"
export const Geosearch = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.81449094,12.4022486 L9.4740787,12.4022486 C9.70393504,12.4022486 9.83385384,12.2323548 9.83385384,12.0024984 L9.83385384,10.5234229 L10.0237352,10.3435353 C9.75390381,10.3735166 9.4740787,10.4034978 9.19425359,10.4034978 C8.91442848,10.4034978 8.63460337,10.3735166 8.35477826,10.3335415 C8.37476577,10.3735166 8.40474703,10.4134916 8.42473454,10.4634603 L8.42473454,12.0024984 C8.42473454,12.2323548 8.57464085,12.4022486 8.81449094,12.4022486 Z M6.3960025,15.1005621 C3.36789507,15.1005621 0.899437851,12.6321049 0.899437851,9.6039975 C0.899437851,9.11430356 0.959400375,8.62460962 1.07932542,8.17489069 C1.10930668,8.17489069 1.12929419,8.16489694 1.15927545,8.16489694 L1.23922548,8.16489694 L1.23922548,8.60462211 C1.23922548,8.79450344 1.4091193,8.94440974 1.59900062,8.94440974 C1.62898189,8.94440974 1.6689569,8.93441599 1.69893816,8.93441599 L2.40849469,9.63397876 C2.47845097,9.70393504 2.59837601,9.70393504 2.66833229,9.63397876 C2.73828857,9.56402249 2.73828857,9.44409744 2.66833229,9.37414116 L1.96876952,8.65459088 C1.96876952,8.63460337 1.99875078,8.62460962 1.99875078,8.60462211 L1.99875078,8.49469082 C1.99875078,8.34478451 2.07870081,8.29481574 2.22860712,8.16489694 L2.64834478,8.16489694 C2.72829482,8.16489694 2.79825109,8.15490319 2.86820737,8.12492192 L2.88819488,8.12492192 C2.90818239,8.10493442 2.91817614,8.10493442 2.92816989,8.08494691 C2.93816365,8.07495315 2.93816365,8.07495315 2.9481574,8.07495315 L2.96814491,8.0649594 L3.86758276,7.16552155 C3.73766396,6.90568395 3.62773267,6.64584635 3.52779513,6.36602124 L3.02810743,6.36602124 L3.02810743,5.93628982 C3.02810743,5.92629606 3.0780762,5.98625859 3.06808245,5.85633979 L3.37788882,5.85633979 C3.34790756,5.72642099 3.3179263,5.59650219 3.29793879,5.46658339 L2.72829482,5.46658339 C2.88819488,5.34665834 3.06808245,5.22673329 3.23797626,5.10680824 C3.21798876,4.87695191 3.19800125,4.64709557 3.19800125,4.40724547 C3.19800125,4.28732042 3.207995,4.17738913 3.21798876,4.06745784 C1.29918801,5.16677077 0,7.23547783 0,9.6039975 C0,13.1317926 2.86820737,16 6.3960025,16 C9.49406621,16 12.062461,13.7813866 12.6520924,10.8532167 L11.8725796,9.9737664 C11.6627108,12.8219863 9.29419113,15.1005621 6.3960025,15.1005621 L6.3960025,15.1005621 Z M4.69706433,12.1723923 L4.69706433,11.8925671 L4.81698938,11.8925671 C5.04684572,11.8925671 5.20674578,11.7026858 5.20674578,11.4728295 L5.20674578,10.9331668 C5.20674578,10.9331668 5.21673954,10.923173 5.20674578,10.923173 L3.76764522,9.45409119 L3.14803248,9.45409119 C2.91817614,9.45409119 2.76826983,9.64397252 2.76826983,9.87382886 L2.76826983,11.4728295 C2.76826983,11.7026858 2.90818239,11.8925671 3.14803248,11.8925671 L3.40787008,11.8925671 L3.40787008,13.5015615 C3.40787008,13.7314179 3.62773267,13.9113054 3.85758901,13.9113054 C4.08744535,13.9113054 4.30730793,13.7314179 4.30730793,13.5015615 L4.30730793,12.5321674 L4.29731418,12.5321674 C4.53716427,12.5321674 4.69706433,12.4022486 4.69706433,12.1723923 L4.69706433,12.1723923 Z M15.7601499,9.83385384 L12.8219863,6.89569019 C12.9319176,6.72579638 13.0318551,6.55590256 13.1217989,6.37601499 C13.1317926,6.34603373 13.1517801,6.31605247 13.1617739,6.28607121 C13.2417239,6.10618364 13.321674,5.92629606 13.3816365,5.73641474 L13.3816365,5.72642099 C13.441599,5.53653966 13.481574,5.34665834 13.521549,5.14678326 C13.5315428,5.09681449 13.5315428,5.05683948 13.5415365,5.00687071 C13.5715178,4.80699563 13.5915053,4.60712055 13.5915053,4.39725172 C13.5915053,1.96876952 11.6227358,0 9.19425359,0 C6.76577139,0.0099937539 4.79700187,1.97876327 4.79700187,4.40724547 C4.79700187,6.83572767 6.76577139,8.80449719 9.19425359,8.80449719 C9.40412242,8.80449719 9.6039975,8.78450968 9.80387258,8.75452842 C9.8438476,8.75452842 9.89381636,8.74453467 9.94378513,8.73454091 C10.1436602,8.70455965 10.3335415,8.65459088 10.5234229,8.59462836 L10.5334166,8.59462836 C10.7232979,8.53466583 10.9031855,8.4547158 11.0830731,8.37476577 C11.1130543,8.36477202 11.1430356,8.34478451 11.1730169,8.33479076 C11.3529044,8.24484697 11.5227983,8.14490943 11.6926921,8.03497814 L14.6308557,10.9731418 C14.7707683,11.1130543 14.9706433,11.2029981 15.2004997,11.2029981 C15.6402249,11.2029981 16,10.843223 16,10.4034978 C15.9900062,10.1836352 15.9000625,9.98376015 15.7601499,9.83385384 L15.7601499,9.83385384 Z M9.19425359,7.60524672 C7.42535915,7.60524672 5.99625234,6.17613991 5.99625234,4.40724547 C5.99625234,2.63835103 7.42535915,1.20924422 9.19425359,1.20924422 C10.963148,1.20924422 12.3922548,2.63835103 12.3922548,4.40724547 C12.3922548,6.17613991 10.963148,7.60524672 9.19425359,7.60524672 Z M10.7332917,11.8625859 L10.7332917,11.3429107 C10.7332917,11.2529669 10.6333542,11.1730169 10.5434104,11.1730169 C10.4534666,11.1730169 10.353529,11.2429731 10.353529,11.3429107 L10.353529,11.8625859 C10.353529,11.9525297 10.4534666,12.0324797 10.5434104,12.0324797 C10.6333542,12.0324797 10.7332917,11.9625234 10.7332917,11.8625859 Z" />
  </svg>
)
Geosearch.iconName = "Geosearch"
export const GitBranch = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,1 C10.34,1 9,2.34 9,4 C9,5.25 9.76,6.32 10.85,6.77 C10.54,7.49 9.83,8 9,8 L7,8 C6.27,8 5.59,8.2 5,8.55 L5,5.82 C6.16,5.4 7,4.3 7,3 C7,1.34 5.66,0 4,0 C2.34,0 1,1.34 1,3 C1,4.3 1.84,5.4 3,5.82 L3,10.19 C1.84,10.59 1,11.7 1,13 C1,14.66 2.34,16 4,16 C5.66,16 7,14.66 7,13 C7,11.96 6.47,11.05 5.68,10.51 C6.03,10.2 6.49,10 7,10 L9,10 C10.92,10 12.52,8.65 12.91,6.85 C14.12,6.46 15,5.34 15,4 C15,2.34 13.66,1 12,1 Z M4,2 C4.55,2 5,2.45 5,3 C5,3.55 4.55,4 4,4 C3.45,4 3,3.55 3,3 C3,2.45 3.45,2 4,2 Z M4,14 C3.45,14 3,13.55 3,13 C3,12.45 3.45,12 4,12 C4.55,12 5,12.45 5,13 C5,13.55 4.55,14 4,14 Z M12,5 C11.45,5 11,4.55 11,4 C11,3.45 11.45,3 12,3 C12.55,3 13,3.45 13,4 C13,4.55 12.55,5 12,5 Z" />
  </svg>
)
GitBranch.iconName = "GitBranch"
export const GitCommit = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,7 L11.86,7 C11.41,5.28 9.86,4 8,4 C6.14,4 4.59,5.28 4.14,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L4.14,9 C4.59,10.72 6.14,12 8,12 C9.86,12 11.41,10.72 11.86,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z M8,10 C6.9,10 6,9.1 6,8 C6,6.9 6.9,6 8,6 C9.1,6 10,6.9 10,8 C10,9.1 9.1,10 8,10 Z" />
  </svg>
)
GitCommit.iconName = "GitCommit"
export const GitMerge = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,6 C10.7,6 9.6,6.84 9.18,8 L9,8 C7.38,8 6,7.04 5.37,5.66 C6.33,5.16 7,4.16 7,3 C7,1.34 5.66,0 4,0 C2.34,0 1,1.34 1,3 C1,4.3 1.84,5.4 3,5.81 L3,10.18 C1.84,10.6 1,11.7 1,13 C1,14.66 2.34,16 4,16 C5.66,16 7,14.66 7,13 C7,11.7 6.16,10.6 5,10.18 L5,8.43 C6.06,9.4 7.45,10 9,10 L9.18,10 C9.59,11.16 10.69,12 12,12 C13.66,12 15,10.66 15,9 C15,7.34 13.66,6 12,6 Z M4,14 C3.45,14 3,13.55 3,13 C3,12.45 3.45,12 4,12 C4.55,12 5,12.45 5,13 C5,13.55 4.55,14 4,14 Z M4,4 C3.45,4 3,3.55 3,3 C3,2.45 3.45,2 4,2 C4.55,2 5,2.45 5,3 C5,3.55 4.55,4 4,4 Z M12,10 C11.45,10 11,9.55 11,9 C11,8.45 11.45,8 12,8 C12.55,8 13,8.45 13,9 C13,9.55 12.55,10 12,10 Z" />
  </svg>
)
GitMerge.iconName = "GitMerge"
export const GitNewBranch = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,2 L13,2 L13,1 C13,0.45 12.55,0 12,0 C11.45,0 11,0.45 11,1 L11,2 L10,2 C9.45,2 9,2.45 9,3 C9,3.55 9.45,4 10,4 L11,4 L11,5 C11,5.55 11.45,6 12,6 C12.55,6 13,5.55 13,5 L13,4 L14,4 C14.55,4 15,3.55 15,3 C15,2.45 14.55,2 14,2 Z M10.82,6.8 C10.51,7.51 9.82,8 9,8 L7,8 C6.27,8 5.59,8.2 5,8.55 L5,5.82 C6.16,5.4 7,4.3 7,3 C7,1.34 5.66,0 4,0 C2.34,0 1,1.34 1,3 C1,4.3 1.84,5.4 3,5.82 L3,10.19 C1.84,10.59 1,11.7 1,13 C1,14.66 2.34,16 4,16 C5.66,16 7,14.66 7,13 C7,11.96 6.47,11.05 5.68,10.51 C6.03,10.2 6.49,10 7,10 L9,10 C10.9,10 12.49,8.67 12.89,6.89 C12.6,6.96 12.31,7 12,7 C11.59,7 11.2,6.92 10.82,6.8 Z M4,2 C4.55,2 5,2.45 5,3 C5,3.55 4.55,4 4,4 C3.45,4 3,3.55 3,3 C3,2.45 3.45,2 4,2 Z M4,14 C3.45,14 3,13.55 3,13 C3,12.45 3.45,12 4,12 C4.55,12 5,12.45 5,13 C5,13.55 4.55,14 4,14 Z" />
  </svg>
)
GitNewBranch.iconName = "GitNewBranch"
export const GitPull = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3,1 C1.34,1 0,2.34 0,4 C0,5.3 0.84,6.4 2,6.82 L2,10.19 C0.84,10.6 0,11.7 0,13 C0,14.66 1.34,16 3,16 C4.66,16 6,14.66 6,13 C6,11.7 5.16,10.6 4,10.18 L4,6.82 C5.16,6.4 6,5.3 6,4 C6,2.34 4.66,1 3,1 Z M3,14 C2.45,14 2,13.55 2,13 C2,12.45 2.45,12 3,12 C3.55,12 4,12.45 4,13 C4,13.55 3.55,14 3,14 Z M3,5 C2.45,5 2,4.55 2,4 C2,3.45 2.45,3 3,3 C3.55,3 4,3.45 4,4 C4,4.55 3.55,5 3,5 Z M14,10.18 L14,6 C14,4.34 12.66,3 11,3 L9.41,3 L10.7,1.71 C10.89,1.53 11,1.28 11,1 C11,0.45 10.55,0 10,0 C9.72,0 9.47,0.11 9.29,0.29 L6.29,3.29 C6.11,3.47 6,3.72 6,4 C6,4.28 6.11,4.53 6.29,4.71 L9.29,7.71 C9.47,7.89 9.72,8 10,8 C10.55,8 11,7.55 11,7 C11,6.72 10.89,6.47 10.71,6.29 L9.41,5 L11,5 C11.55,5 12,5.45 12,6 L12,10.18 C10.84,10.59 10,11.69 10,13 C10,14.66 11.34,16 13,16 C14.66,16 16,14.66 16,13 C16,11.7 15.16,10.6 14,10.18 Z M13,14 C12.45,14 12,13.55 12,13 C12,12.45 12.45,12 13,12 C13.55,12 14,12.45 14,13 C14,13.55 13.55,14 13,14 Z" />
  </svg>
)
GitPull.iconName = "GitPull"
export const GitPush = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,6 L5,6 L5,5 L4,5 L4,6 Z M13,9 C13,8.72 12.89,8.47 12.71,8.29 L9.71,5.29 C9.53,5.11 9.28,5 9,5 C8.72,5 8.47,5.11 8.29,5.29 L5.29,8.29 C5.11,8.47 5,8.72 5,9 C5,9.55 5.45,10 6,10 C6.28,10 6.53,9.89 6.71,9.71 L8,8.41 L8,15 C8,15.55 8.45,16 9,16 C9.55,16 10,15.55 10,15 L10,8.41 L11.29,9.7 C11.47,9.89 11.72,10 12,10 C12.55,10 13,9.55 13,9 Z M5,3 L4,3 L4,4 L5,4 L5,3 Z M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,14 C0,14.55 0.45,15 1,15 L6,15 L6,13 L2,13 L2,12 L6,12 L6,11 L3,11 L3,2 L14,2 L14,11 L12,11 L12,12 L14,12 L14,13 L12,13 L12,15 L15,15 C15.55,15 16,14.55 16,14 L16,1 C16,0.45 15.55,0 15,0 Z" />
  </svg>
)
GitPush.iconName = "GitPush"
export const GitRepo = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,9 L4,9 L4,10 L5,10 L5,9 Z M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,14 C0,14.55 0.45,15 1,15 L4,15 L4,16 L6,15 L8,16 L8,15 L15,15 C15.55,15 16,14.55 16,14 L16,1 C16,0.45 15.55,0 15,0 Z M4,13 L2,13 L2,12 L4,12 L4,13 Z M14,13 L8,13 L8,12 L14,12 L14,13 Z M14,11 L3,11 L3,2 L14,2 L14,11 Z M5,3 L4,3 L4,4 L5,4 L5,3 Z M5,7 L4,7 L4,8 L5,8 L5,7 Z M5,5 L4,5 L4,6 L5,6 L5,5 Z" />
  </svg>
)
GitRepo.iconName = "GitRepo"
export const Glass = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,0 L2,4 C2,6.97 4.16,9.43 7,9.91 L7,14 L5,14 C4.45,14 4,14.45 4,15 C4,15.55 4.45,16 5,16 L11,16 C11.55,16 12,15.55 12,15 C12,14.45 11.55,14 11,14 L9,14 L9,9.91 C11.84,9.43 14,6.97 14,4 L14,0 L2,0 Z" />
  </svg>
)
Glass.iconName = "Glass"
export const Globe = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.45,7.83 C4.19,7.83 4.04,8.04 4.04,8.29 L4.04,10.04 C4.04,10.3 4.2,10.5 4.45,10.5 L4.74,10.5 L4.74,12.27 C4.74,12.52 4.98,12.72 5.23,12.72 C5.48,12.72 5.72,12.52 5.72,12.27 L5.72,11.2 L5.71,11.2 C5.97,11.2 6.15,11.06 6.15,10.8 L6.15,10.5 L6.29,10.5 C6.55,10.5 6.72,10.3 6.72,10.04 L6.72,9.45 C6.72,9.45 6.73,9.44 6.72,9.44 L5.14,7.84 L4.45,7.84 L4.45,7.83 Z M8.51,3.9 L8.73,3.9 C8.79,3.9 8.85,3.89 8.85,3.83 C8.85,3.77 8.8,3.76 8.73,3.76 L8.51,3.76 C8.45,3.76 8.39,3.77 8.39,3.83 C8.4,3.89 8.45,3.9 8.51,3.9 Z M6.18,3.85 C6.25,3.78 6.25,3.66 6.18,3.59 L5.68,3.09 C5.61,3.02 5.49,3.02 5.42,3.09 C5.35,3.16 5.35,3.28 5.42,3.35 L5.92,3.85 C5.99,3.92 6.11,3.92 6.18,3.85 L6.18,3.85 Z M9.24,4.74 C9.31,4.74 9.38,4.68 9.38,4.62 L9.38,4.31 C9.38,4.24 9.31,4.19 9.24,4.19 C9.17,4.19 9.1,4.25 9.1,4.31 L9.1,4.62 C9.1,4.69 9.17,4.74 9.24,4.74 Z M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,7.45 2.1,6.93 2.23,6.43 L2.34,6.43 L2.34,6.9 C2.34,7.1 2.52,7.27 2.73,7.27 C2.76,7.27 2.81,7.26 2.84,7.25 L3.62,8.02 C3.7,8.1 3.82,8.1 3.9,8.02 C3.98,7.94 3.98,7.82 3.9,7.74 L3.15,6.96 C3.15,6.94 3.19,6.92 3.19,6.9 L3.19,6.78 C3.19,6.62 3.28,6.56 3.44,6.42 L3.9,6.42 C3.99,6.42 4.07,6.41 4.14,6.37 L4.16,6.37 C4.18,6.36 4.19,6.35 4.21,6.34 C4.22,6.33 4.22,6.33 4.23,6.33 L4.25,6.31 L5.84,4.73 C6.02,4.55 6.02,4.27 5.84,4.09 C5.66,3.91 5.37,3.94 5.19,4.12 L4.89,4.46 L4.32,4.46 L4.32,3.98 C4.32,3.97 4.37,4.03 4.37,3.89 L5.01,3.89 C5.13,3.89 5.23,3.8 5.23,3.68 C5.23,3.56 5.13,3.47 5.01,3.47 L4.1,3.47 C4.28,3.32 4.44,3.16 4.64,3.03 L4.65,3.02 C4.86,2.88 5.1,2.77 5.33,2.65 C5.48,2.58 5.62,2.5 5.77,2.44 C5.94,2.37 6.12,2.33 6.3,2.27 C6.48,2.22 6.65,2.15 6.83,2.11 C7.21,2.04 7.6,2 8,2 C8.82,2 9.59,2.17 10.3,2.46 C10.35,2.48 10.4,2.51 10.46,2.54 C10.71,2.65 10.94,2.78 11.17,2.93 C11.42,3.09 11.66,3.27 11.88,3.48 L10.6,3.48 C10.6,3.48 10.6,3.45 10.59,3.45 C10.55,3.45 10.5,3.45 10.46,3.48 L9.95,3.99 C9.89,4.05 9.89,4.16 9.95,4.22 C10.01,4.28 10.12,4.28 10.18,4.22 L10.6,3.78 L10.61,3.76 L10.86,3.76 C10.86,3.9 10.79,3.85 10.79,3.88 L10.79,3.95 C10.79,4.17 10.64,4.32 10.43,4.32 L10.05,4.32 C9.86,4.32 9.67,4.53 9.67,4.72 L9.67,4.89 L9.57,4.89 C9.45,4.89 9.37,4.95 9.37,5.07 L9.37,5.32 L9.14,5.32 C8.97,5.32 8.84,5.43 8.84,5.6 C8.84,5.77 8.97,5.86 9.14,5.86 C9.21,5.86 9.28,5.89 9.33,5.75 L9.37,5.76 L9.86,5.3 L10.03,5.3 L10.42,5.67 C10.45,5.7 10.5,5.69 10.54,5.66 C10.57,5.63 10.57,5.54 10.54,5.51 L10.22,5.16 L10.45,5.16 L10.54,5.28 C10.72,5.46 11.02,5.45 11.2,5.27 L11.29,5.17 L11.69,5.17 C11.71,5.17 11.77,5.22 11.77,5.22 L11.77,5.46 L11.72,5.45 L11.36,5.45 C11.25,5.45 11.15,5.55 11.15,5.66 C11.15,5.77 11.24,5.87 11.36,5.87 L11.77,5.87 L11.77,6.02 C11.63,6.23 11.53,6.44 11.32,6.44 L10.38,6.44 L10.38,6.43 L9.94,5.99 C9.76,5.81 9.46,5.81 9.28,5.99 L8.86,6.42 L8.86,6.43 L8.6,6.43 C8.34,6.43 8.11,6.64 8.11,6.89 L8.11,7.81 C8.11,8.07 8.34,8.26 8.6,8.26 L9.5,8.26 C9.84,8.4 10.07,8.61 10.22,8.95 L10.22,10.63 C10.22,10.89 10.39,11.07 10.64,11.07 L11.36,11.07 C11.62,11.07 11.76,10.89 11.76,10.63 L11.76,9 L12.65,8.14 L12.68,8.12 L12.7,8.11 L12.73,8.11 C12.8,8.03 12.88,7.92 12.88,7.8 L12.88,6.89 C12.88,6.71 12.72,6.57 12.57,6.43 L13,6.43 C13.01,6.71 13.21,6.85 13.46,6.85 L13.88,6.85 C13.96,7.22 14,7.61 14,8 C14,11.31 11.31,14 8,14 Z M12.54,9.73 C12.44,9.73 12.33,9.81 12.33,9.91 L12.33,10.48 C12.33,10.58 12.44,10.66 12.54,10.66 C12.64,10.66 12.75,10.58 12.75,10.48 L12.75,9.91 C12.75,9.81 12.64,9.73 12.54,9.73 Z M8.37,3.19 C8.37,2.94 8.17,2.77 7.91,2.77 L7.37,2.77 C7.12,2.77 6.95,2.95 6.95,3.2 C6.95,3.23 6.85,3.24 7,3.28 L7,3.75 C7,3.9 7.06,4.02 7.21,4.02 C7.36,4.02 7.42,3.9 7.42,3.75 L7.42,3.61 L7.92,3.61 C8.16,3.61 8.37,3.45 8.37,3.19 L8.37,3.19 Z" />
  </svg>
)
Globe.iconName = "Globe"
export const GraphRemove = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.89,8.11 L12.88,8.12 L12.5,7.74 L12.12,8.12 L12.1,8.1 C11.56,8.65 10.83,9 10,9 C8.34,9 7,7.66 7,6 C7,5.17 7.35,4.44 7.9,3.9 L7.88,3.88 L8.26,3.5 L7.88,3.12 L7.89,3.11 C7.35,2.57 7,1.83 7,1 C7,0.66 7.07,0.35 7.17,0.04 C3.14,0.46 0,3.86 0,8 C0,12.42 3.58,16 8,16 C12.14,16 15.54,12.86 15.96,8.83 C15.65,8.93 15.34,9 15,9 C14.17,9 13.43,8.65 12.89,8.11 Z M13.91,3.5 L15.7,1.71 C15.89,1.53 16,1.28 16,1 C16,0.45 15.55,0 15,0 C14.72,0 14.47,0.11 14.29,0.29 L12.5,2.09 L10.71,0.3 C10.53,0.11 10.28,0 10,0 C9.45,0 9,0.45 9,1 C9,1.28 9.11,1.53 9.29,1.71 L11.08,3.5 L9.29,5.29 C9.11,5.47 9,5.72 9,6 C9,6.55 9.45,7 10,7 C10.28,7 10.53,6.89 10.71,6.71 L12.5,4.92 L14.29,6.71 C14.47,6.89 14.72,7 15,7 C15.55,7 16,6.55 16,6 C16,5.72 15.89,5.47 15.71,5.29 L13.91,3.5 Z" />
  </svg>
)
GraphRemove.iconName = "GraphRemove"
export const Graph = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,2.5 C12.94,2.5 12.08,3.33 12.01,4.38 L10.08,5.35 C9.54,4.82 8.81,4.5 8,4.5 C7.44,4.5 6.92,4.66 6.48,4.93 L3.97,2.84 C3.98,2.73 4,2.62 4,2.5 C4,1.4 3.1,0.5 2,0.5 C0.9,0.5 0,1.4 0,2.5 C0,3.6 0.9,4.5 2,4.5 C2.24,4.5 2.47,4.45 2.68,4.37 L5.19,6.46 C5.08,6.79 5,7.13 5,7.5 C5,8.46 5.46,9.31 6.16,9.85 L5.6,11.54 C4.69,11.73 4,12.53 4,13.5 C4,14.6 4.9,15.5 6,15.5 C7.1,15.5 8,14.6 8,13.5 C8,12.99 7.8,12.53 7.49,12.18 L8.05,10.49 C9.69,10.46 11,9.14 11,7.5 C11,7.38 10.98,7.26 10.96,7.14 L12.9,6.17 C13.22,6.38 13.59,6.5 14,6.5 C15.1,6.5 16,5.6 16,4.5 C16,3.4 15.1,2.5 14,2.5 Z" />
  </svg>
)
Graph.iconName = "Graph"
export const GridView = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,1 L0,7 L7,7 L7,0 L1,0 C0.45,0 0,0.45 0,1 Z M0,15 C0,15.55 0.45,16 1,16 L7,16 L7,9 L0,9 L0,15 Z M15,0 L9,0 L9,7 L16,7 L16,1 C16,0.45 15.55,0 15,0 Z M9,16 L15,16 C15.55,16 16,15.55 16,15 L16,9 L9,9 L9,16 Z" />
  </svg>
)
GridView.iconName = "GridView"
export const Grid = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 L14,7 L14,4 L15,4 C15.55,4 16,3.55 16,3 C16,2.45 15.55,2 15,2 L14,2 L14,1 C14,0.45 13.55,0 13,0 C12.45,0 12,0.45 12,1 L12,2 L9,2 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,2 L4,2 L4,1 C4,0.45 3.55,0 3,0 C2.45,0 2,0.45 2,1 L2,2 L1,2 C0.45,2 0,2.45 0,3 C0,3.55 0.45,4 1,4 L2,4 L2,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L2,9 L2,12 L1,12 C0.45,12 0,12.45 0,13 C0,13.55 0.45,14 1,14 L2,14 L2,15 C2,15.55 2.45,16 3,16 C3.55,16 4,15.55 4,15 L4,14 L7,14 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,14 L12,14 L12,15 C12,15.55 12.45,16 13,16 C13.55,16 14,15.55 14,15 L14,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 L14,12 L14,9 L15,9 Z M7,12 L4,12 L4,9 L7,9 L7,12 Z M7,7 L4,7 L4,4 L7,4 L7,7 Z M12,12 L9,12 L9,9 L12,9 L12,12 Z M12,7 L9,7 L9,4 L12,4 L12,7 Z" />
  </svg>
)
Grid.iconName = "Grid"
export const GroupObjects = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,6 C3.9,6 3,6.9 3,8 C3,9.1 3.9,10 5,10 C6.1,10 7,9.1 7,8 C7,6.9 6.1,6 5,6 Z M11,3 L5,3 C2.24,3 0,5.24 0,8 C0,10.76 2.24,13 5,13 L11,13 C13.76,13 16,10.76 16,8 C16,5.24 13.76,3 11,3 Z M11,12 L5,12 C2.79,12 1,10.21 1,8 C1,5.79 2.79,4 5,4 L11,4 C13.21,4 15,5.79 15,8 C15,10.21 13.21,12 11,12 Z M11,6 C9.9,6 9,6.9 9,8 C9,9.1 9.9,10 11,10 C12.1,10 13,9.1 13,8 C13,6.9 12.1,6 11,6 Z" />
  </svg>
)
GroupObjects.iconName = "GroupObjects"
export const GroupedBarChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,12 C10.55,12 11,11.55 11,11 L11,3 C11,2.45 10.55,2 10,2 C9.45,2 9,2.45 9,3 L9,11 C9,11.55 9.45,12 10,12 Z M13,12 C13.55,12 14,11.55 14,11 L14,6 C14,5.45 13.55,5 13,5 C12.45,5 12,5.45 12,6 L12,11 C12,11.55 12.45,12 13,12 Z M15,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M6,12 C6.55,12 7,11.55 7,11 L7,8 C7,7.45 6.55,7 6,7 C5.45,7 5,7.45 5,8 L5,11 C5,11.55 5.45,12 6,12 Z M3,12 C3.55,12 4,11.55 4,11 L4,2 C4,1.45 3.55,1 3,1 C2.45,1 2,1.45 2,2 L2,11 C2,11.55 2.45,12 3,12 Z" />
  </svg>
)
GroupedBarChart.iconName = "GroupedBarChart"
export const HandDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.7205302,7.87 C13.1805302,7.2 11.7305302,5.19 11.0205302,3.92 C10.1105302,1.95 9.93053022,0 6.14053022,0 C4.05053022,0 2.71053022,0.61 1.92053022,2.12 C1.27053022,3.36 1.00053022,5.21 1.00053022,7.83 L1.00053022,8.62 C1.00053022,9.27 1.60053022,9.8 2.35053022,9.8 C2.69053022,9.8 2.99053022,9.69 3.23053022,9.51 C3.40053022,9.99 3.91053022,10.35 4.52053022,10.35 C4.93053022,10.35 5.30053022,10.19 5.55053022,9.93 C5.78053022,10.3 6.22053022,10.56 6.74053022,10.56 C7.31053022,10.56 7.79053022,10.25 7.99053022,9.82 L8.00053022,10.45 L8.00053022,14.5 C8.00053022,15.33 8.67053022,16 9.50053022,16 C10.3305302,16 11.0005302,15.33 11.0005302,14.5 L11.0005302,7.9 C11.5805302,8.31 12.5505302,9.11 13.4705302,9.19 C15.0405302,9.33 15.2905302,8.12 14.7205302,7.87 Z" />
  </svg>
)
HandDown.iconName = "HandDown"
export const HandLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.08,4.97344483 C10.82,4.26344483 8.81,2.82344483 8.13,1.27344483 C7.88,0.703444827 6.67,0.963444827 6.81,2.52344483 C6.9,3.45344483 7.7,4.42344483 8.11,5.00344483 L1.5,5.00344483 C0.67,5.00344483 0,5.67344483 0,6.50344483 C0,7.33344483 0.67,8.00344483 1.5,8.00344483 L5.55,8.00344483 L6.18,8.01344483 C5.74,8.21344483 5.43,8.70344483 5.43,9.26344483 C5.43,9.78344483 5.69,10.2234448 6.06,10.4534448 C5.8,10.7034448 5.64,11.0634448 5.64,11.4834448 C5.64,12.0934448 5.99,12.6034448 6.48,12.7734448 C6.3,13.0134448 6.19,13.3134448 6.19,13.6534448 C6.19,14.4034448 6.73,15.0034448 7.38,15.0034448 L8.17,15.0034448 C10.79,15.0034448 12.64,14.7234448 13.88,14.0834448 C15.39,13.2934448 16,11.9434448 16,9.86344483 C16,6.07344483 14.05,5.89344483 12.08,4.97344483 Z" />
  </svg>
)
HandLeft.iconName = "HandLeft"
export const HandRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,4.99844483 L7.89,4.99844483 C8.3,4.41844483 9.1,3.44844483 9.19,2.52844483 C9.34,0.968444827 8.12,0.708444827 7.87,1.27844483 C7.2,2.81844483 5.19,4.26844483 3.92,4.97844483 C1.95,5.88844483 0,6.06844483 0,9.85844483 C0,11.9484448 0.61,13.2884448 2.12,14.0784448 C3.36,14.7284448 5.21,14.9984448 7.83,14.9984448 L8.62,14.9984448 C9.27,14.9984448 9.8,14.3984448 9.8,13.6484448 C9.8,13.3084448 9.69,13.0084448 9.51,12.7684448 C9.99,12.5984448 10.35,12.0884448 10.35,11.4784448 C10.35,11.0684448 10.19,10.6984448 9.93,10.4484448 C10.3,10.2184448 10.56,9.77844483 10.56,9.25844483 C10.56,8.68844483 10.25,8.20844483 9.82,8.00844483 L10.45,7.99844483 L14.5,7.99844483 C15.33,7.99844483 16,7.32844483 16,6.49844483 C16,5.66844483 15.33,4.99844483 14.5,4.99844483 Z" />
  </svg>
)
HandRight.iconName = "HandRight"
export const HandUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.6518478,6.19 C13.3118478,6.19 13.0118478,6.3 12.7718478,6.48 C12.6018478,6 12.0918478,5.64 11.4818478,5.64 C11.0718478,5.64 10.7018478,5.8 10.4518478,6.06 C10.2218478,5.69 9.78184777,5.43 9.26184777,5.43 C8.69184777,5.43 8.21184777,5.74 8.01184777,6.17 L8.00184777,5.55 L8.00184777,1.5 C8.00184777,0.67 7.33184777,0 6.50184777,0 C5.67184777,0 5.00184777,0.67 5.00184777,1.5 L5.00184777,8.11 C4.42184777,7.7 3.45184777,6.9 2.52184777,6.81 C0.961847769,6.67 0.701847769,7.88 1.28184777,8.13 C2.82184777,8.8 4.27184777,10.81 4.98184777,12.08 C5.89184777,14.05 6.07184777,16 9.86184777,16 C11.9518478,16 13.2918478,15.39 14.0818478,13.88 C14.7218478,12.64 15.0018478,10.79 15.0018478,8.17 L15.0018478,7.38 C15.0018478,6.73 14.4018478,6.19 13.6518478,6.19 Z" />
  </svg>
)
HandUp.iconName = "HandUp"
export const Hand = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,5 C15,4.45 14.55,4 14,4 C13.59,4 13.24,4.24 13.09,4.59 L13.09,4.6 C13.09,4.6 13.09,4.61 13.08,4.61 L11.57,8 L11.21,8 L11.99,3.16 C12,3.11 12,3.05 12,3 C12,2.45 11.55,2 11,2 C10.5,2 10.09,2.36 10.01,2.84 L10.01,2.85 L9.18,8 L9,8 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,8 L6.91,8 L5.98,2.82 C5.9,2.36 5.49,2 5,2 C4.45,2 4,2.45 4,3 C4,3.05 4,3.11 4.01,3.16 L5.26,11 L5.22,11 L2.83,7.44 C2.65,7.18 2.35,7 2,7 C1.45,7 1,7.45 1,8 C1,8.17 1.04,8.33 1.12,8.47 L4.12,14.16 L4.13,14.16 L4.13,14.17 C5.05,15.29 6.44,16 8,16 C10.76,16 13,13.76 13,11 L13,10.41 L14.93,5.36 C14.98,5.25 15,5.13 15,5 Z" />
  </svg>
)
Hand.iconName = "Hand"
export const HeaderOne = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.56,8 C14.52,8.23 14.44,8.44 14.31,8.61 C14.18,8.78 14.02,8.91 13.83,9.02 C13.65,9.13 13.44,9.2 13.21,9.25 C12.98,9.29 12.75,9.32 12.5,9.32 L12.5,10.35 L14.24,10.35 L14.24,16 L15.5,16 L15.5,8 L14.56,8 Z M7.5,0 C6.94,0 6.5,0.45 6.5,1 L6.5,5 L2.5,5 L2.5,1 C2.5,0.45 2.05,0 1.5,0 C0.94,0 0.5,0.45 0.5,1 L0.5,11 C0.5,11.55 0.95,12 1.5,12 C2.06,12 2.5,11.55 2.5,11 L2.5,7 L6.5,7 L6.5,11 C6.5,11.55 6.95,12 7.5,12 C8.06,12 8.5,11.55 8.5,11 L8.5,1 C8.5,0.46 8.05,0 7.5,0 Z" />
  </svg>
)
HeaderOne.iconName = "HeaderOne"
export const HeaderTwo = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.17,13.93 C13,14.08 12.84,14.22 12.71,14.37 C12.58,14.53 12.49,14.69 12.44,14.86 L15.99,14.86 L15.99,16 L11,16 C11.01,15.35 11.16,14.78 11.44,14.29 C11.72,13.8 12.11,13.38 12.61,13.02 C12.85,12.84 13.1,12.66 13.36,12.48 C13.61,12.3 13.85,12.12 14.07,11.91 C14.28,11.71 14.46,11.49 14.6,11.26 C14.74,11.02 14.81,10.75 14.82,10.44 C14.82,10.3 14.8,10.15 14.77,9.99 C14.74,9.83 14.68,9.68 14.59,9.54 C14.5,9.4 14.37,9.28 14.22,9.19 C14.06,9.1 13.85,9.05 13.59,9.05 C13.35,9.05 13.16,9.1 13,9.2 C12.84,9.3 12.71,9.44 12.62,9.62 C12.52,9.79 12.45,10 12.41,10.24 C12.36,10.48 12.34,10.74 12.33,11.01 L11.14,11.01 C11.14,10.58 11.19,10.18 11.3,9.81 C11.41,9.44 11.57,9.12 11.79,8.85 C12,8.6 12.27,8.39 12.58,8.23 C12.89,8.08 13.25,8 13.65,8 C14.1,8 14.47,8.08 14.76,8.23 C15.06,8.39 15.31,8.59 15.49,8.83 C15.68,9.07 15.81,9.33 15.88,9.62 C15.96,9.9 16,10.16 16,10.41 C16,10.72 15.96,11.01 15.87,11.26 C15.78,11.51 15.65,11.75 15.5,11.96 C15.35,12.17 15.18,12.37 14.98,12.55 C14.78,12.73 14.58,12.9 14.37,13.06 L13.74,13.51 C13.53,13.65 13.35,13.79 13.17,13.93 L13.17,13.93 Z M9e-16,1 C9e-16,0.45 0.44,0 1,0 C1.55,0 2,0.46 2,1 L2,11 C2,11.55 1.56,12 1,12 C0.45,12 9e-16,11.54 9e-16,11 L9e-16,1 Z M6,1 C6,0.45 6.44,0 7,0 C7.55,0 8,0.46 8,1 L8,11 C8,11.55 7.56,12 7,12 C6.45,12 6,11.54 6,11 L6,1 Z M2,5 L6,5 L6,7 L2,7 L2,5 Z" />
  </svg>
)
HeaderTwo.iconName = "HeaderTwo"
export const Header = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,1 C12.45,1 12,1.45 12,2 L12,7 L4,7 L4,2 C4,1.45 3.55,1 3,1 C2.45,1 2,1.45 2,2 L2,14 C2,14.55 2.45,15 3,15 C3.55,15 4,14.55 4,14 L4,9 L12,9 L12,14 C12,14.55 12.45,15 13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 Z" />
  </svg>
)
Header.iconName = "Header"
export const Headset = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.85,6.34 C14.18,2.72 11.37,0 8,0 C4.63,0 1.82,2.72 1.15,6.34 C0.47,6.9 0,8.1 0,9.5 C0,11.43 0.9,13 2,13 C2,14.1 2.9,15 4,15 L6,15 C6,15.55 6.45,16 7,16 L9,16 C9.55,16 10,15.55 10,15 L10,14 C10,13.45 9.55,13 9,13 L7,13 C6.45,13 6,13.45 6,14 L4,14 C3.45,14 3,13.55 3,13 C3.55,13 4,12.55 4,12 L4,7 C4,6.55 3.7,6.19 3.29,6.06 C3.97,3.7 5.81,2 8,2 C10.19,2 12.03,3.7 12.71,6.06 C12.3,6.19 12,6.55 12,7 L12,12 C12,12.55 12.45,13 13,13 L14,13 C15.1,13 16,11.43 16,9.5 C16,8.1 15.53,6.9 14.85,6.34 Z" />
  </svg>
)
Headset.iconName = "Headset"
export const HeartBroken = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.71,9.21 L6.17,6.89 L6.19,6.88 C6.08,6.73 6,6.55 6,6.34 C6,6.27 6.03,6.21 6.04,6.15 L6.02,6.15 L6.8,2.23 C6.09,1.68 5.19,1.34 4.2,1.34 C1.88,1.34 0,3.17 0,5.43 C0,5.5 0.01,5.56 0.01,5.62 L0,5.62 C0,5.67 0.01,5.72 0.01,5.76 C0.01,5.81 0.02,5.86 0.02,5.9 C0.09,6.7 0.34,7.56 0.84,8.47 C1.91,10.41 3.72,11.94 6.7,14.31 L6.02,11.57 L6.04,11.57 C6.03,11.5 6,11.42 6,11.34 C6,11.06 6.11,10.81 6.29,10.63 L7.71,9.21 Z M16,5.43 C16,3.17 14.12,1.34 11.8,1.34 C10.6,1.34 9.53,1.84 8.76,2.62 L8.06,6.13 L9.83,8.79 L9.82,8.8 C9.92,8.95 10,9.13 10,9.34 C10,9.62 9.89,9.87 9.71,10.05 L8.11,11.65 L8.86,14.66 C12.09,12.1 14.02,10.51 15.14,8.48 C15.64,7.57 15.89,6.71 15.96,5.92 C15.97,5.87 15.97,5.81 15.98,5.76 C15.98,5.72 15.99,5.67 15.99,5.63 L15.98,5.63 C15.99,5.56 16,5.49 16,5.43 L16,5.43 Z" />
  </svg>
)
HeartBroken.iconName = "HeartBroken"
export const Heart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16,5.08915 C16,2.83405 14.1196,1.00585 11.8,1.00585 C10.1176,1.00585 8.6705,1.96985 8,3.35855 C7.3295,1.96975 5.8824,1.00585 4.2,1.00585 C1.8804,1.00585 0,2.83395 0,5.08915 C0,5.15485 0.007,5.21875 0.0101,5.28365 L0.0036,5.28365 C0.0051,5.32995 0.0147,5.37915 0.0175,5.42595 C0.0215,5.47365 0.0257,5.52115 0.0314,5.56845 C0.101,6.36795 0.3524,7.23135 0.8552,8.14065 C2.0732,10.34875 4.2325,12.01215 7.9998,14.99415 C11.767,12.01215 13.9263,10.34755 15.1443,8.14065 C15.6452,7.23485 15.8963,6.37455 15.9672,5.57775 C15.9736514,5.523265 15.9789858,5.46865354 15.9832,5.41395 C15.9856,5.37115 15.9946,5.32595 15.9959,5.28355 L15.99,5.28355 C15.993,5.21865 16,5.15475 16,5.08915 Z" />
  </svg>
)
Heart.iconName = "Heart"
export const HeatGrid = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,9.5 L5,9.5 L5,6.5 L0,6.5 L0,9.5 Z M1,7.5 L4,7.5 L4,8.5 L1,8.5 L1,7.5 Z M15,2.5 L11,2.5 L11,5.5 L16,5.5 L16,3.5 C16,2.95 15.55,2.5 15,2.5 Z M15,4.5 L12,4.5 L12,3.5 L15,3.5 L15,4.5 Z M0,3.5 L0,5.5 L5,5.5 L5,2.5 L1,2.5 C0.45,2.5 0,2.95 0,3.5 Z M0,12.5 C0,13.05 0.45,13.5 1,13.5 L5,13.5 L5,10.5 L0,10.5 L0,12.5 Z M6,5.5 L10,5.5 L10,2.5 L6,2.5 L6,5.5 Z M6,13.5 L10,13.5 L10,10.5 L6,10.5 L6,13.5 Z M7,11.5 L9,11.5 L9,12.5 L7,12.5 L7,11.5 Z M11,13.5 L15,13.5 C15.55,13.5 16,13.05 16,12.5 L16,10.5 L11,10.5 L11,13.5 Z M11,9.5 L16,9.5 L16,6.5 L11,6.5 L11,9.5 Z M6,9.5 L10,9.5 L10,6.5 L6,6.5 L6,9.5 Z" />
  </svg>
)
HeatGrid.iconName = "HeatGrid"
export const Heatmap = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,11 C0.9,11 0,11.9 0,13 C0,14.1 0.9,15 2,15 C3.1,15 4,14.1 4,13 C4,11.9 3.1,11 2,11 Z M13,4 C14.1,4 15,3.1 15,2 C15,0.9 14.1,0 13,0 C11.9,0 11,0.9 11,2 C11,3.1 11.9,4 13,4 Z M16,8.5 C16,7.12 14.88,6 13.5,6 C12.52,6 11.68,6.57 11.27,7.39 C10.67,6.61 9.76,6.09 8.71,6.03 C8.89,5.54 9,5.04 9,4.5 C9,2.01 6.99,0 4.5,0 C2.01,0 0,2.01 0,4.5 C0,6.99 2.01,9 4.5,9 C4.69,9 4.87,8.97 5.06,8.94 C5.03,9.13 5,9.31 5,9.5 C5,11.43 6.57,13 8.5,13 C10.13,13 11.48,11.89 11.87,10.38 C12.31,10.76 12.87,11 13.5,11 C14.88,11 16,9.88 16,8.5 Z M14.5,13 C13.67,13 13,13.67 13,14.5 C13,15.33 13.67,16 14.5,16 C15.33,16 16,15.33 16,14.5 C16,13.67 15.33,13 14.5,13 Z" />
  </svg>
)
Heatmap.iconName = "Heatmap"
export const Help = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M9,13 L7,13 L7,11 L9,11 L9,13 Z M10.93,6.48 C10.79,6.8 10.58,7.12 10.31,7.45 L9.25,8.83 C9.13,8.98 9.01,9.12 8.97,9.25 C8.93,9.38 8.88,9.55 8.88,9.77 L8.88,10 L7.12,10 L7.12,8.88 C7.12,8.88 7.17,8.37 7.33,8.17 L8.4,6.73 C8.62,6.47 8.75,6.24 8.84,6.05 C8.93,5.86 8.96,5.67 8.96,5.47 C8.96,5.17 8.86,4.92 8.68,4.72 C8.5,4.53 8.24,4.44 7.92,4.44 C7.59,4.44 7.33,4.54 7.14,4.73 C6.95,4.92 6.81,5.19 6.74,5.54 C6.71,5.65 6.64,5.69 6.54,5.68 L4.84,5.43 C4.72,5.42 4.68,5.35 4.7,5.24 C4.82,4.42 5.16,3.77 5.73,3.3 C6.3,2.82 7.05,2.58 7.98,2.58 C8.45,2.58 8.88,2.65 9.27,2.8 C9.66,2.95 9.99,3.14 10.27,3.39 C10.55,3.64 10.76,3.94 10.92,4.28 C11.07,4.63 11.14,5 11.14,5.4 C11.14,5.8 11.07,6.15 10.93,6.48 Z" />
  </svg>
)
Help.iconName = "Help"
export const HelperManagement = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,5 L11,5 L11,7 L13,7 L13,5 Z M13,11 L11,11 L11,13 L13,13 L13,11 Z M13,8 L11,8 L11,10 L13,10 L13,8 Z M15,0 L1,0 C0.4,0 0,0.4 0,1 L0,15 C0,15.6 0.4,16 1,16 L15,16 C15.6,16 16,15.6 16,15 L16,1 C16,0.4 15.6,0 15,0 Z M14,14 L2,14 L2,2 L14,2 L14,14 Z M7,11 L5,11 L5,13 L7,13 L7,11 Z M10,11 L8,11 L8,13 L10,13 L10,11 Z" />
  </svg>
)
HelperManagement.iconName = "HelperManagement"
export const Highlight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.12,11.07 L11.12,9.05 L11.83,9.76 L15.83,5.72 L10.17,0 L6.17,4.04 L6.88,4.75 L4.88,6.77 L9.12,11.07 Z M2,12.97 L6,12.97 C6.28,12.97 6.53,12.86 6.71,12.67 L7.71,11.66 L4.29,8.21 L1.29,11.24 C1.11,11.42 1,11.68 1,11.96 C1,12.51 1.45,12.97 2,12.97 Z M15,13.98 L1,13.98 C0.45,13.98 0,14.43 0,14.99 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,14.99 C16,14.43 15.55,13.98 15,13.98 Z" />
  </svg>
)
Highlight.iconName = "Highlight"
export const History = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,3 C7.45,3 7,3.45 7,4 L7,8 C7,8.28 7.11,8.53 7.29,8.71 L9.29,10.71 C9.47,10.89 9.72,11 10,11 C10.55,11 11,10.55 11,10 C11,9.72 10.89,9.47 10.71,9.29 L9,7.59 L9,4 C9,3.45 8.55,3 8,3 Z M8,0 C5.6,0 3.46,1.07 2,2.74 L2,1 C2,0.45 1.55,0 1,0 C0.45,0 0,0.45 0,1 L0,5 C0,5.55 0.45,6 1,6 L5,6 C5.55,6 6,5.55 6,5 C6,4.45 5.55,4 5,4 L3.54,4 C4.64,2.78 6.23,2 8,2 C11.31,2 14,4.69 14,8 C14,10.61 12.33,12.81 10,13.63 L10,13.62 C9.37,13.85 8.71,14 8,14 C4.69,14 2,11.31 2,8 C2,7.45 1.55,7 1,7 C0.45,7 0,7.45 0,8 C0,12.42 3.58,16 8,16 C8.34,16 8.67,15.97 9,15.93 C9.02,15.93 9.04,15.92 9.06,15.92 C12.98,15.4 16,12.06 16,8 C16,3.58 12.42,0 8,0 Z" />
  </svg>
)
History.iconName = "History"
export const Home = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,10 L2,15 C2,15.55 2.45,16 3,16 L6,16 L6,11 L10,11 L10,16 L13,16 C13.55,16 14,15.55 14,15 L14,10 L8,4 L2,10 Z M15.71,7.29 L14,5.59 L14,2 C14,1.45 13.55,1 13,1 C12.45,1 12,1.45 12,2 L12,3.59 L8.71,0.29 C8.53,0.11 8.28,0 8,0 C7.72,0 7.47,0.11 7.29,0.29 L0.29,7.29 C0.11,7.47 0,7.72 0,8 C0,8.55 0.45,9 1,9 C1.28,9 1.53,8.89 1.71,8.71 L8,2.41 L14.29,8.7 C14.47,8.89 14.72,9 15,9 C15.55,9 16,8.55 16,8 C16,7.72 15.89,7.47 15.71,7.29 Z" />
  </svg>
)
Home.iconName = "Home"
export const HorizontalBarChartAsc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1,3 L6,3 C6.55,3 7,2.55 7,2 C7,1.45 6.55,1 6,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 Z M1,7 L8,7 C8.55,7 9,6.55 9,6 C9,5.45 8.55,5 8,5 L1,5 C0.45,5 0,5.45 0,6 C0,6.55 0.45,7 1,7 Z M15,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M1,11 L11,11 C11.55,11 12,10.55 12,10 C12,9.45 11.55,9 11,9 L1,9 C0.45,9 0,9.45 0,10 C0,10.55 0.45,11 1,11 Z" />
  </svg>
)
HorizontalBarChartAsc.iconName = "HorizontalBarChartAsc"
export const HorizontalBarChartDesc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 Z M8,9 L1,9 C0.45,9 0,9.45 0,10 C0,10.55 0.45,11 1,11 L8,11 C8.55,11 9,10.55 9,10 C9,9.45 8.55,9 8,9 Z M6,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L6,15 C6.55,15 7,14.55 7,14 C7,13.45 6.55,13 6,13 Z M11,5 L1,5 C0.45,5 0,5.45 0,6 C0,6.55 0.45,7 1,7 L11,7 C11.55,7 12,6.55 12,6 C12,5.45 11.55,5 11,5 Z" />
  </svg>
)
HorizontalBarChartDesc.iconName = "HorizontalBarChartDesc"
export const HorizontalBarChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,4.5 L11,4.5 C11.55,4.5 12,4.05 12,3.5 L12,2.5 C12,1.95 11.55,1.5 11,1.5 L4,1.5 C3.45,1.5 3,1.95 3,2.5 L3,3.5 C3,4.05 3.45,4.5 4,4.5 Z M1,0.5 C0.45,0.5 0,0.95 0,1.5 L0,14.5 C0,15.05 0.45,15.5 1,15.5 C1.55,15.5 2,15.05 2,14.5 L2,1.5 C2,0.95 1.55,0.5 1,0.5 Z M15,6.5 L4,6.5 C3.45,6.5 3,6.95 3,7.5 L3,8.5 C3,9.05 3.45,9.5 4,9.5 L15,9.5 C15.55,9.5 16,9.05 16,8.5 L16,7.5 C16,6.95 15.55,6.5 15,6.5 Z M9,11.5 L4,11.5 C3.45,11.5 3,11.95 3,12.5 L3,13.5 C3,14.05 3.45,14.5 4,14.5 L9,14.5 C9.55,14.5 10,14.05 10,13.5 L10,12.5 C10,11.95 9.55,11.5 9,11.5 Z" />
  </svg>
)
HorizontalBarChart.iconName = "HorizontalBarChart"
export const HorizontalDistribution = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.5,0 C0.95,0 0.5,0.45 0.5,1 L0.5,15 C0.5,15.55 0.95,16 1.5,16 C2.05,16 2.5,15.55 2.5,15 L2.5,1 C2.5,0.45 2.05,0 1.5,0 Z M14.5,0 C13.95,0 13.5,0.45 13.5,1 L13.5,15 C13.5,15.55 13.95,16 14.5,16 C15.05,16 15.5,15.55 15.5,15 L15.5,1 C15.5,0.45 15.05,0 14.5,0 Z M9.5,2 L6.5,2 C5.95,2 5.5,2.45 5.5,3 L5.5,12 C5.5,12.55 5.95,13 6.5,13 L9.5,13 C10.05,13 10.5,12.55 10.5,12 L10.5,3 C10.5,2.45 10.05,2 9.5,2 Z" />
  </svg>
)
HorizontalDistribution.iconName = "HorizontalDistribution"
export const IconPlaceholder = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2,11 L2,14 L5,14 L5,16 L0,16 L0,11 L2,11 Z M16,11 L16,16 L11,16 L11,14 L14,14 L14,11 L16,11 Z M11,10 L11,12 L5,12 L5,10 L11,10 Z M6,5 L6,8 L4,8 L4,5 L6,5 Z M12,5 L12,8 L10,8 L10,5 L12,5 Z M16,0 L16,5 L14,5 L14,2 L11,2 L11,0 L16,0 Z M5,0 L5,2 L2,2 L2,5 L0,5 L0,0 L5,0 Z"
      fillRule="evenodd"
    />
  </svg>
)
IconPlaceholder.iconName = "IconPlaceholder"
export const IdNumber = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,4.5 L2,11.5 L14,11.5 L14,4.5 L2,4.5 Z M2,2.5 L14,2.5 C15.1,2.5 16,3.4 16,4.5 L16,11.5 C16,12.6 15.1,13.5 14,13.5 L2,13.5 C0.9,13.5 0,12.6 0,11.5 L0,4.5 C0,3.4 0.9,2.5 2,2.5 Z M7.9,9.98 C7.76,9.65 7.06,9.43 6.6,9.23 C6.14,9.03 6.2,8.9 6.18,8.73 L6.18,8.66 C6.34,8.52 6.47,8.33 6.55,8.1 C6.55,8.1 6.55,8.09 6.56,8.08 C6.58,8.03 6.59,7.98 6.61,7.93 C6.71,7.92 6.77,7.8 6.8,7.7 C6.83,7.66 6.87,7.55 6.86,7.43 C6.84,7.27 6.78,7.19 6.71,7.17 L6.71,7.14 C6.71,6.94 6.69,6.66 6.66,6.47 C6.65,6.42 6.64,6.37 6.63,6.31 C6.56,6.08 6.42,5.87 6.23,5.73 C6.03,5.58 5.75,5.5 5.5,5.5 C5.25,5.5 4.97,5.58 4.78,5.73 C4.59,5.87 4.45,6.08 4.38,6.31 C4.36,6.36 4.35,6.41 4.35,6.47 C4.3,6.65 4.29,6.94 4.29,7.14 L4.29,7.17 C4.22,7.2 4.15,7.27 4.14,7.43 C4.12,7.55 4.17,7.65 4.2,7.7 C4.22,7.8 4.29,7.92 4.4,7.94 C4.41,7.99 4.43,8.04 4.45,8.09 L4.45,8.1 C4.53,8.33 4.67,8.52 4.83,8.66 L4.83,8.73 C4.81,8.9 4.86,9.02 4.4,9.23 C3.94,9.43 3.24,9.65 3.1,9.98 C2.96,10.31 3.01,10.5 3.01,10.5 L8,10.5 C7.99,10.5 8.05,10.31 7.9,9.98 Z M10,5.5 L12,5.5 C12.55,5.5 13,5.95 13,6.5 C13,7.05 12.55,7.5 12,7.5 L10,7.5 C9.45,7.5 9,7.05 9,6.5 C9,5.95 9.45,5.5 10,5.5 Z M10,8.5 L12,8.5 C12.55,8.5 13,8.95 13,9.5 C13,10.05 12.55,10.5 12,10.5 L10,10.5 C9.45,10.5 9,10.05 9,9.5 C9,8.95 9.45,8.5 10,8.5 Z" />
  </svg>
)
IdNumber.iconName = "IdNumber"
export const ImageRotateLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,2 L11.41,2 L11.7,1.71 C11.89,1.53 12,1.28 12,1 C12,0.45 11.55,0 11,0 C10.72,0 10.47,0.11 10.29,0.29 L8.29,2.29 C8.11,2.47 8,2.72 8,3 C8,3.28 8.11,3.53 8.29,3.71 L10.29,5.71 C10.47,5.89 10.72,6 11,6 C11.55,6 12,5.55 12,5 C12,4.72 11.89,4.47 11.71,4.29 L11.41,4 L13,4 C13.55,4 14,4.45 14,5 L14,8 C14,8.55 14.45,9 15,9 C15.55,9 16,8.55 16,8 L16,5 C16,3.34 14.66,2 13,2 Z M7.5,11 C7.78,11 8,10.78 8,10.5 C8,10.22 7.78,10 7.5,10 C7.22,10 7,10.22 7,10.5 C7,10.78 7.22,11 7.5,11 Z M10,7 L1,7 C0.45,7 0,7.45 0,8 L0,15 C0,15.55 0.45,16 1,16 L10,16 C10.55,16 11,15.55 11,15 L11,8 C11,7.45 10.55,7 10,7 Z M9,13.33 L7,12 L6,13 L4,10 L2,12.67 L2,9 L9,9 L9,13.33 Z" />
  </svg>
)
ImageRotateLeft.iconName = "ImageRotateLeft"
export const ImageRotateRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.71,5.71 L7.71,3.71 C7.89,3.53 8,3.28 8,3 C8,2.72 7.89,2.47 7.71,2.29 L5.71,0.29 C5.53,0.11 5.28,0 5,0 C4.45,0 4,0.45 4,1 C4,1.28 4.11,1.53 4.29,1.71 L4.59,2 L3,2 C1.34,2 0,3.34 0,5 L0,8 C0,8.55 0.45,9 1,9 C1.55,9 2,8.55 2,8 L2,5 C2,4.45 2.45,4 3,4 L4.59,4 L4.29,4.29 C4.11,4.47 4,4.72 4,5 C4,5.55 4.45,6 5,6 C5.28,6 5.53,5.89 5.71,5.71 Z M12.5,11 C12.78,11 13,10.78 13,10.5 C13,10.22 12.78,10 12.5,10 C12.22,10 12,10.22 12,10.5 C12,10.78 12.22,11 12.5,11 Z M15,7 L6,7 C5.45,7 5,7.45 5,8 L5,15 C5,15.55 5.45,16 6,16 L15,16 C15.55,16 16,15.55 16,15 L16,8 C16,7.45 15.55,7 15,7 Z M14,13.33 L12,12 L11,13 L9,10 L7,12.67 L7,9 L14,9 L14,13.33 Z" />
  </svg>
)
ImageRotateRight.iconName = "ImageRotateRight"
export const Import = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.29,11.71 C7.47,11.89 7.72,12 8,12 C8.28,12 8.53,11.89 8.71,11.71 L12.71,7.71 C12.89,7.53 13,7.28 13,7 C13,6.45 12.55,6 12,6 C11.72,6 11.47,6.11 11.29,6.29 L9,8.59 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,8.59 L4.71,6.29 C4.53,6.11 4.28,6 4,6 C3.45,6 3,6.45 3,7 C3,7.28 3.11,7.53 3.29,7.71 L7.29,11.71 Z M15,11 C14.45,11 14,11.45 14,12 L14,14 L2,14 L2,12 C2,11.45 1.55,11 1,11 C0.45,11 0,11.45 0,12 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,12 C16,11.45 15.55,11 15,11 Z" />
  </svg>
)
Import.iconName = "Import"
export const Inbox = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.9163023,2.61 C13.7564022,2.25 13.4066209,2 12.996877,2 L3.00312305,2 C2.59337914,2 2.233604,2.25 2.08369769,2.61 L0.00499687695,7.46 L0.00499687695,13 C0.00499687695,13.55 0.454715803,14 1.00437227,14 L14.9956277,14 C15.5452842,14 15.9950031,13.55 15.9950031,13 L15.9950031,7.46 L13.9163023,2.61 Z M11.9975016,8 C11.4478451,8 10.9981262,8.45 10.9981262,9 L10.9981262,10 L5.00187383,10 L5.00187383,9 C5.00187383,8.45 4.5521549,8 4.00249844,8 L1.95377889,8 L3.66271081,4 L12.3372892,4 L14.0462211,8 L11.9975016,8 L11.9975016,8 Z" />
  </svg>
)
Inbox.iconName = "Inbox"
export const Info = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M7,3 L9,3 L9,5 L7,5 L7,3 Z M10,13 L6,13 L6,12 L7,12 L7,7 L6,7 L6,6 L9,6 L9,12 L10,12 L10,13 Z" />
  </svg>
)
Info.iconName = "Info"
export const InnerJoin = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.6,3.3 C5.3,4.4 4.5,6.1 4.5,8 C4.5,9.9 5.3,11.6 6.6,12.7 C6.1,12.9 5.6,13 5,13 C2.2,13 0,10.8 0,8 C0,5.2 2.2,3 5,3 C5.6,3 6.1,3.1 6.6,3.3 Z M4.64,11.98 C3.92,10.83 3.5,9.46 3.5,8 C3.5,6.54 3.92,5.17 4.64,4.02 C2.6,4.2 1,5.91 1,8 C1,10.09 2.6,11.8 4.64,11.98 L4.64,11.98 Z M8,4 C6.8,4.9 6,6.4 6,8 C6,9.6 6.8,11.1 8,12 C9.2,11.1 10,9.7 10,8 C10,6.3 9.2,4.9 8,4 Z M11,3 C13.8,3 16,5.2 16,8 C16,10.8 13.8,13 11,13 C10.4,13 9.9,12.9 9.4,12.7 C10.7,11.6 11.5,9.8 11.5,8 C11.5,6.2 10.7,4.5 9.4,3.3 C9.9,3.1 10.4,3 11,3 Z M11.35,4.02 C12.08,5.17 12.49,6.54 12.49,8 C12.49,9.46 12.07,10.83 11.35,11.98 C13.39,11.8 14.99,10.08 14.99,8 C14.99,5.92 13.39,4.2 11.35,4.02 Z" />
  </svg>
)
InnerJoin.iconName = "InnerJoin"
export const Insert = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,9 L7,9 L7,11 C7,11.6 7.4,12 8,12 C8.6,12 9,11.6 9,11 L9,9 L11,9 C11.6,9 12,8.6 12,8 C12,7.4 11.6,7 11,7 L9,7 L9,5 C9,4.4 8.6,4 8,4 C7.4,4 7,4.4 7,5 L7,7 L5,7 C4.4,7 4,7.4 4,8 C4,8.6 4.4,9 5,9 Z M15,0 L1,0 C0.4,0 0,0.4 0,1 L0,15 C0,15.6 0.4,16 1,16 L15,16 C15.6,16 16,15.6 16,15 L16,1 C16,0.4 15.6,0 15,0 Z M14,14 L2,14 L2,2 L14,2 L14,14 Z" />
  </svg>
)
Insert.iconName = "Insert"
export const Intersection = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5,3 C9.58,3 8.74,3.26 8,3.69 C7.26,3.26 6.42,3 5.5,3 C2.74,3 0.5,5.24 0.5,8 C0.5,10.76 2.74,13 5.5,13 C6.42,13 7.26,12.74 8,12.31 C8.74,12.74 9.58,13 10.5,13 C13.26,13 15.5,10.76 15.5,8 C15.5,5.24 13.26,3 10.5,3 Z M6.4,10.85 C6.11,10.94 5.81,11 5.5,11 C3.84,11 2.5,9.66 2.5,8 C2.5,6.34 3.84,5 5.5,5 C5.81,5 6.11,5.06 6.4,5.15 C5.83,5.96 5.5,6.94 5.5,8 C5.5,9.06 5.83,10.04 6.4,10.85 Z M10.5,11 C10.19,11 9.89,10.94 9.6,10.85 C10.17,10.04 10.5,9.06 10.5,8 C10.5,6.94 10.17,5.96 9.6,5.15 C9.89,5.06 10.19,5 10.5,5 C12.16,5 13.5,6.34 13.5,8 C13.5,9.66 12.16,11 10.5,11 Z" />
  </svg>
)
Intersection.iconName = "Intersection"
export const IpAddress = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,2.66 C5,4.14 8,8 8,8 C8,8 11,4.14 11,2.66 C10.99,1.2 9.66,0 8,0 C6.34,0 5,1.2 5,2.66 Z M7,3 C7,2.45 7.45,2 8,2 C8.55,2 9,2.45 9,3 C9,3.55 8.55,4 8,4 C7.45,4 7,3.55 7,3 Z M10.5,10 L8,10 L8,15 L9,15 L9,11 L10,11 L10,12 L9,12 L9,13 L11,13 L11,10 L10.5,10 Z M2,9 L14,9 C14.55,9 15,9.45 15,10 L15,15 C15,15.55 14.55,16 14,16 L2,16 C1.45,16 1,15.55 1,15 L1,10 C1,9.45 1.45,9 2,9 Z M6,10 L6,15 L7,15 L7,10 L6,10 Z" />
  </svg>
)
IpAddress.iconName = "IpAddress"
export const IssueClosed = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.296,0.1044 C8.9201932,0.255332534 8.57896102,0.481028875 8.293,0.7678 C7.94370967,1.11590141 7.68604303,1.54507096 7.543,2.017 C4.443,2.2506 2,4.8401 2,8 C2,11.3137 4.6863,14 8,14 C11.3137,14 14,11.3137 14,8 C14,7.4982 13.9384,7.0107 13.8223,6.5449 C13.865922,6.50604142 13.9084065,6.46592452 13.9497,6.4246 L15.4057,4.9686 C15.7888,5.9037 16,6.9272 16,8 C16,12.4183 12.4183,16 8,16 C3.5817,16 0,12.4183 0,8 C0,3.5817 3.5817,0 8,0 C8.4413,0 8.8742,0.0357 9.296,0.1044 Z M11.8284,5.30330081 C11.5631517,5.30361157 11.3087155,5.19820229 11.1214,5.0104 L9.707,3.5962 C9.3165,3.2057 9.3165,2.5725 9.707,2.182 C10.0975,1.7915 10.7307,1.7915 11.1212,2.182 L11.8283,2.889 L13.5961,1.1213 C13.9866,0.7308 14.6198,0.7308 15.0103,1.1213 C15.4008,1.5118 15.4008,2.145 15.0103,2.5355 L12.5354,5.0105 C12.3480681,5.19826561 12.0936339,5.30363806 11.8284,5.30330081 Z M9,12 L7,12 L7,10 L9,10 L9,12 Z M9,9 L7,9 L7,4 L9,4 L9,9 Z" />
  </svg>
)
IssueClosed.iconName = "IssueClosed"
export const IssueNew = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5677,0.421 C10.5581286,0.461113379 10.5495593,0.50145926 10.542,0.542 C9.7046,0.6977 9.0124,1.2724 8.6919,2.0395 C8.46220826,2.0131541 8.23119775,1.9999659 8,2 C4.6863,2 2,4.6863 2,8 C2,11.3137 4.6863,14 8,14 C11.3137,14 14,11.3137 14,8 C14,7.7676 13.9868,7.5382 13.961,7.3127 C14.7286,6.9917 15.303,6.298 15.4582,5.4579 C15.4986729,5.45037061 15.5389521,5.44183463 15.579,5.4323 C15.852,6.2383 16,7.1018 16,8 C16,12.4183 12.4183,16 8,16 C3.5817,16 0,12.4183 0,8 C0,3.5817 3.5817,0 8,0 C8.8982,0 9.7617,0.148 10.5677,0.421 Z M9,12 L7,12 L7,10 L9,10 L9,12 Z M9,9 L7,9 L7,4 L9,4 L9,9 Z M10,3 C10,2.45 10.45,2 11,2 L12,2 L12,1 C12,0.45 12.45,0 13,0 C13.55,0 14,0.45 14,1 L14,2 L15,2 C15.55,2 16,2.45 16,3 C16,3.55 15.55,4 15,4 L14,4 L14,5.0048 C14,5.5548 13.55,6.0048 13,6.0048 C12.45,6.0048 12,5.5548 12,5.0048 L12,4 L11,4 C10.45,4 10,3.55 10,3 Z" />
  </svg>
)
IssueNew.iconName = "IssueNew"
export const Issue = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,16 C3.5817,16 0,12.4183 0,8 C0,3.5817 3.5817,0 8,0 C12.4183,0 16,3.5817 16,8 C16,12.4183 12.4183,16 8,16 Z M8,14 C11.3137,14 14,11.3137 14,8 C14,4.6863 11.3137,2 8,2 C4.6863,2 2,4.6863 2,8 C2,11.3137 4.6863,14 8,14 Z M9,12 L7,12 L7,10 L9,10 L9,12 Z M9,9 L7,9 L7,4 L9,4 L9,9 Z" />
  </svg>
)
Issue.iconName = "Issue"
export const Italic = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.8,4 L11,4 C11.5,4 12,3.6 12,3 C12,2.4 11.6,2 11,2 L7,2 C6.5,2 6,2.4 6,3 C6,3.6 6.4,4 7,4 L7.8,4 L6.2,12 L5,12 C4.5,12 4,12.4 4,13 C4,13.6 4.4,14 5,14 L9,14 C9.5,14 10,13.6 10,13 C10,12.4 9.6,12 9,12 L8.2,12 L9.8,4 L9.8,4 Z" />
  </svg>
)
Italic.iconName = "Italic"
export const JoinTable = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,5 L12,5 L12,2 C12,1.45 11.55,1 11,1 L1,1 C0.45,1 0,1.45 0,2 L0,10 C0,10.55 0.45,11 1,11 L4,11 L4,14 C4,14.55 4.45,15 5,15 L15,15 C15.55,15 16,14.55 16,14 L16,6 C16,5.45 15.55,5 15,5 Z M10,4 L10,6 L6,6 L6,4 L10,4 Z M10,10 L6,10 L6,7 L10,7 L10,10 Z M2,4 L5,4 L5,6 L2,6 L2,4 Z M2,9 L2,7 L5,7 L5,9 L2,9 Z M6,13 L6,11 L10,11 L10,13 L6,13 Z M14,13 L11,13 L11,11 L14,11 L14,13 Z M14,10 L11,10 L11,8 L14,8 L14,10 Z" />
  </svg>
)
JoinTable.iconName = "JoinTable"
export const KeyBackspace = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,2 L6,2 C5.72,2 5.47,2.11 5.29,2.29 L0.29,7.29 C0.11,7.47 0,7.72 0,8 C0,8.28 0.11,8.53 0.29,8.71 L5.29,13.71 C5.47,13.89 5.72,14 6,14 L15,14 C15.55,14 16,13.55 16,13 L16,3 C16,2.45 15.55,2 15,2 Z M12.71,9.29 C12.89,9.47 13,9.72 13,10 C13,10.55 12.55,11 12,11 C11.72,11 11.47,10.89 11.29,10.71 L10,9.41 L8.71,10.7 C8.53,10.89 8.28,11 8,11 C7.45,11 7,10.55 7,10 C7,9.72 7.11,9.47 7.29,9.29 L8.59,8 L7.29,6.71 C7.11,6.53 7,6.28 7,6 C7,5.45 7.45,5 8,5 C8.28,5 8.53,5.11 8.71,5.29 L10,6.59 L11.29,5.3 C11.47,5.11 11.72,5 12,5 C12.55,5 13,5.45 13,6 C13,6.28 12.89,6.53 12.71,6.71 L11.41,8 L12.71,9.29 Z" />
  </svg>
)
KeyBackspace.iconName = "KeyBackspace"
export const KeyCommand = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,9 L11,9 L11,7 L12,7 C13.66,7 15,5.66 15,4 C15,2.34 13.66,1 12,1 C10.34,1 9,2.34 9,4 L9,5 L7,5 L7,4 C7,2.34 5.66,1 4,1 C2.34,1 1,2.34 1,4 C1,5.66 2.34,7 4,7 L5,7 L5,9 L4,9 C2.34,9 1,10.34 1,12 C1,13.66 2.34,15 4,15 C5.66,15 7,13.66 7,12 L7,11 L9,11 L9,12 C9,13.66 10.34,15 12,15 C13.66,15 15,13.66 15,12 C15,10.34 13.66,9 12,9 Z M12,3 C12.55,3 13,3.45 13,4 C13,4.55 12.55,5 12,5 C11.45,5 11,4.55 11,4 C11,3.45 11.45,3 12,3 Z M4,13 C3.45,13 3,12.55 3,12 C3,11.45 3.45,11 4,11 C4.55,11 5,11.45 5,12 C5,12.55 4.55,13 4,13 Z M4,5 C3.45,5 3,4.55 3,4 C3,3.45 3.45,3 4,3 C4.55,3 5,3.45 5,4 C5,4.55 4.55,5 4,5 Z M9,9 L7,9 L7,7 L9,7 L9,9 Z M12,13 C11.45,13 11,12.55 11,12 C11,11.45 11.45,11 12,11 C12.55,11 13,11.45 13,12 C13,12.55 12.55,13 12,13 Z" />
  </svg>
)
KeyCommand.iconName = "KeyCommand"
export const KeyDelete = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.71,7.29 L10.71,2.29 C10.53,2.11 10.28,2 10,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L10,14 C10.28,14 10.53,13.89 10.71,13.71 L15.71,8.71 C15.89,8.53 16,8.28 16,8 C16,7.72 15.89,7.47 15.71,7.29 Z M8.71,9.29 C8.89,9.47 9,9.72 9,10 C9,10.55 8.55,11 8,11 C7.72,11 7.47,10.89 7.29,10.71 L6,9.41 L4.71,10.7 C4.53,10.89 4.28,11 4,11 C3.45,11 3,10.55 3,10 C3,9.72 3.11,9.47 3.29,9.29 L4.59,8 L3.29,6.71 C3.11,6.53 3,6.28 3,6 C3,5.45 3.45,5 4,5 C4.28,5 4.53,5.11 4.71,5.29 L6,6.59 L7.29,5.3 C7.47,5.11 7.72,5 8,5 C8.55,5 9,5.45 9,6 C9,6.28 8.89,6.53 8.71,6.71 L7.41,8 L8.71,9.29 Z" />
  </svg>
)
KeyDelete.iconName = "KeyDelete"
export const KeyEnter = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,2 C13.45,2 13,2.45 13,3 L13,6 C13,7.66 11.66,9 10,9 L4.41,9 L5.7,7.71 C5.89,7.53 6,7.28 6,7 C6,6.45 5.55,6 5,6 C4.72,6 4.47,6.11 4.29,6.29 L1.29,9.29 C1.11,9.47 1,9.72 1,10 C1,10.28 1.11,10.53 1.29,10.71 L4.29,13.71 C4.47,13.89 4.72,14 5,14 C5.55,14 6,13.55 6,13 C6,12.72 5.89,12.47 5.71,12.29 L4.41,11 L10,11 C12.76,11 15,8.76 15,6 L15,3 C15,2.45 14.55,2 14,2 Z" />
  </svg>
)
KeyEnter.iconName = "KeyEnter"
export const KeyEscape = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,7 C2.55,7 3,6.55 3,6 L3,4.41 L7.29,8.7 C7.47,8.89 7.72,9 8,9 C8.55,9 9,8.55 9,8 C9,7.72 8.89,7.47 8.71,7.29 L4.41,3 L6,3 C6.55,3 7,2.55 7,2 C7,1.45 6.55,1 6,1 L2,1 C1.45,1 1,1.45 1,2 L1,6 C1,6.55 1.45,7 2,7 Z M9,1.1 L9,3.1 C11.28,3.56 13,5.58 13,8 C13,10.76 10.76,13 8,13 C5.58,13 3.56,11.28 3.1,9 L1.1,9 C1.59,12.39 4.48,15 8,15 C11.87,15 15,11.87 15,8 C15,4.48 12.39,1.59 9,1.1 Z" />
  </svg>
)
KeyEscape.iconName = "KeyEscape"
export const KeyOption = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,4 L15,4 C15.55,4 16,3.55 16,3 C16,2.45 15.55,2 15,2 L11,2 C10.45,2 10,2.45 10,3 C10,3.55 10.45,4 11,4 Z M15,12 L11.57,12 L5.86,2.49 L5.84,2.49 C5.67,2.2 5.36,2 5,2 L1,2 C0.45,2 0,2.45 0,3 C0,3.55 0.45,4 1,4 L4.43,4 L10.14,13.51 L10.15,13.5 C10.33,13.8 10.64,14 11,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z" />
  </svg>
)
KeyOption.iconName = "KeyOption"
export const KeyShift = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.71,7.29 L8.71,2.29 C8.53,2.11 8.28,2 8,2 C7.72,2 7.47,2.11 7.29,2.29 L2.29,7.29 C2.11,7.47 2,7.72 2,8 C2,8.55 2.45,9 3,9 L5,9 L5,13 C5,13.55 5.45,14 6,14 L10,14 C10.55,14 11,13.55 11,13 L11,9 L13,9 C13.55,9 14,8.55 14,8 C14,7.72 13.89,7.47 13.71,7.29 Z" />
  </svg>
)
KeyShift.iconName = "KeyShift"
export const KeyTab = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,10 L4.41,10 L5.7,8.71 C5.89,8.53 6,8.28 6,8 C6,7.45 5.55,7 5,7 C4.72,7 4.47,7.11 4.29,7.29 L2,9.59 L2,8 C2,7.45 1.55,7 1,7 C0.45,7 0,7.45 0,8 L0,14 C0,14.55 0.45,15 1,15 C1.55,15 2,14.55 2,14 L2,12.41 L4.29,14.7 C4.47,14.89 4.72,15 5,15 C5.55,15 6,14.55 6,14 C6,13.72 5.89,13.47 5.71,13.29 L4.41,12 L15,12 C15.55,12 16,11.55 16,11 C16,10.45 15.55,10 15,10 Z M15,1 C14.45,1 14,1.45 14,2 L14,3.59 L11.71,1.3 C11.53,1.11 11.28,1 11,1 C10.45,1 10,1.45 10,2 C10,2.28 10.11,2.53 10.29,2.71 L11.59,4 L1,4 C0.45,4 0,4.45 0,5 C0,5.55 0.45,6 1,6 L11.59,6 L10.3,7.29 C10.11,7.47 10,7.72 10,8 C10,8.55 10.45,9 11,9 C11.28,9 11.53,8.89 11.71,8.71 L14,6.41 L14,8 C14,8.55 14.45,9 15,9 C15.55,9 16,8.55 16,8 L16,2 C16,1.45 15.55,1 15,1 Z" />
  </svg>
)
KeyTab.iconName = "KeyTab"
export const Key = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,0 C8.24,0 6,2.24 6,5 C6,6.02 6.31,6.96 6.83,7.75 L0.29,14.29 C0.11,14.47 0,14.72 0,15 C0,15.55 0.45,16 1,16 C1.28,16 1.53,15.89 1.71,15.71 L3,14.41 L4.29,15.7 C4.47,15.89 4.72,16 5,16 C5.28,16 5.53,15.89 5.71,15.71 L7.71,13.71 C7.89,13.53 8,13.28 8,13 C8,12.72 7.89,12.47 7.71,12.29 L6.41,11 L8.24,9.17 C9.04,9.69 9.98,10 11,10 C13.76,10 16,7.76 16,5 C16,2.24 13.76,0 11,0 Z M11,8 C10.77,8 10.55,7.97 10.34,7.92 C10.33,7.92 10.32,7.91 10.31,7.91 C10.1,7.86 9.9,7.79 9.71,7.7 C9.09,7.4 8.6,6.91 8.3,6.29 C8.21,6.1 8.14,5.9 8.09,5.7 C8.09,5.69 8.08,5.68 8.08,5.67 C8.03,5.45 8,5.23 8,5 C8,3.34 9.34,2 11,2 C12.66,2 14,3.34 14,5 C14,6.66 12.66,8 11,8 Z" />
  </svg>
)
Key.iconName = "Key"
export const KnownVehicle = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.0000055,3 C14.7347732,2.99966194 14.4803406,3.10503439 14.2930099,3.2928 L12.0000244,5.5858 L10.7070325,4.2928 C10.5197018,4.10503439 10.2652693,3.99966194 10.0000433,4 C9.44774046,4 9.00004328,4.4477 9.00004328,5 C9.00004328,5.2762 9.11204258,5.5262 9.29304143,5.7072 L11.2930288,7.7072 C11.4739277,7.8881 11.7239261,8 12.0000244,8 C12.2761226,8 12.5261211,7.8881 12.7070199,7.7072 L15.707001,4.7072 C15.8948938,4.51981506 16.000342,4.26526229 16,3.9999 C16,3.4476 15.552302,2.9999 15.0000055,2.9999 L15.0000055,3 Z M14.121311,9.1213 L14.1137111,9.1136 C13.801413,9.4226 13.4231154,9.6659 12.9998181,9.8163 L12.9998181,9.9998 L12.0018244,9.9998 L12.0000244,9.9999 L11.9982244,9.9998 L10.9999307,9.9998 L10.9999307,9.8162 C10.5765333,9.6657 10.1996357,9.4213 9.88843768,9.1116 L9.87873774,9.1213 L7.87875035,7.1213 L7.88975028,7.1103 C7.57905224,6.8003 7.33445378,6.424 7.18365473,5.9996 L3.00008109,5.9996 C2.8240822,5.9996 2.93948148,5.1756 3.00008109,4.9996 L3.7291765,3.3691 C3.79017611,3.1929 3.8241759,2.9996 4.00007479,2.9996 L7.77885098,2.9996 C8.32804752,2.3902 9.11524256,1.9999 10.000037,1.9999 C10.7680321,1.9999 11.4610278,2.2932 11.9873245,2.77 L12.8313191,1.926 C12.5926206,1.6815 12.3068224,1.4838 12.0369241,1.4016 C12.0369241,1.4016 10.7199324,1 8.00014958,1 C5.28016672,1 3.96317502,1.4016 3.96317502,1.4016 C3.45537822,1.5566 2.88518182,2.1132 2.69548301,2.6392 L1.93248782,4.7561 L0.879894455,4.7561 C0.396097504,4.7561 0,5.1786 0,5.6949 C0,6.2114 0.395997504,6.6339 0.879994454,6.6339 L1.25539209,6.6339 L1.0001937,6.9997 C0.966193911,7.6847 1.0001937,8.4362 1.0001937,8.9997 L1.0001937,14 C1.0001937,14.6572 1.38419128,15 2.00018739,15 C2.61628351,15 3.00018109,14.6572 3.00018109,14 L3.00018109,13 L12.9997181,13 L12.9997181,14 C12.9997181,14.6572 13.3837157,15 13.9997118,15 C14.6157079,15 14.9997055,14.6572 14.9997055,14 L14.9997055,8.9998 C14.9997055,8.779 14.9981055,8.5165 14.9967055,8.2458 L14.121211,9.1213 L14.121311,9.1213 Z M5.00016849,9.9998 L3.00008109,9.9998 L3.00008109,7.9997 L5.00006849,7.9997 L5.00006849,9.9997 L5.00016849,9.9998 Z" />
  </svg>
)
KnownVehicle.iconName = "KnownVehicle"
export const Label = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 L16,7 L11,2 Z M14,12 L2,12 L2,4 L10,4 L10,6 L3,6 L3,7 L10,7 L10,8 L14,8 L14,12 Z M11,7 L11,4 L14,7 L11,7 Z M3,10 L13,10 L13,9 L3,9 L3,10 Z" />
  </svg>
)
Label.iconName = "Label"
export const Layer = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16,8 C16,7.63 15.79,7.32 15.49,7.15 L15.5,7.14 L8.5,3.14 L8.49,3.15 C8.34,3.06 8.18,3 8,3 C7.82,3 7.66,3.06 7.51,3.15 L7.5,3.13 L0.5,7.13 L0.51,7.14 C0.21,7.32 0,7.63 0,8 C0,8.37 0.21,8.68 0.51,8.85 L0.5,8.86 L7.5,12.86 L7.51,12.85 C7.66,12.94 7.82,13 8,13 C8.18,13 8.34,12.94 8.49,12.85 L8.5,12.86 L15.5,8.86 L15.49,8.85 C15.79,8.68 16,8.37 16,8 Z" />
  </svg>
)
Layer.iconName = "Layer"
export const Layers = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.55,5.14 L7.55,8.64 C7.69,8.71 7.84,8.75 8,8.75 C8.16,8.75 8.31,8.71 8.45,8.64 L15.45,5.14 C15.77,4.98 16,4.64 16,4.25 C16,3.84 15.75,3.48 15.39,3.33 L8.4,0.33 C8.27,0.28 8.14,0.25 8,0.25 C7.86,0.25 7.73,0.28 7.61,0.33 L0.62,3.33 C0.25,3.48 0,3.84 0,4.25 C0,4.64 0.23,4.98 0.55,5.14 Z M15,10.25 C14.84,10.25 14.69,10.29 14.55,10.36 L8,13.63 L1.45,10.35 C1.31,10.29 1.16,10.25 1,10.25 C0.45,10.25 0,10.7 0,11.25 C0,11.64 0.23,11.98 0.55,12.14 L7.55,15.64 C7.69,15.71 7.84,15.75 8,15.75 C8.16,15.75 8.31,15.71 8.45,15.64 L15.45,12.14 C15.77,11.98 16,11.64 16,11.25 C16,10.7 15.55,10.25 15,10.25 Z M15,6.75 C14.84,6.75 14.69,6.79 14.55,6.86 L8,10.13 L1.45,6.86 C1.31,6.79 1.16,6.75 1,6.75 C0.45,6.75 0,7.2 0,7.75 C0,8.14 0.23,8.48 0.55,8.64 L7.55,12.14 C7.69,12.21 7.84,12.25 8,12.25 C8.16,12.25 8.31,12.21 8.45,12.14 L15.45,8.64 C15.77,8.48 16,8.14 16,7.75 C16,7.2 15.55,6.75 15,6.75 Z" />
  </svg>
)
Layers.iconName = "Layers"
export const LayoutAuto = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,9.5 C13.44,9.5 12.94,9.73 12.58,10.09 L8.99,8 L12.58,5.91 C12.94,6.27 13.44,6.5 14,6.5 C15.1,6.5 16,5.6 16,4.5 C16,3.4 15.1,2.5 14,2.5 C12.9,2.5 12,3.4 12,4.5 C12,4.69 12.03,4.87 12.08,5.04 L8.5,7.13 L8.5,3.93 C9.36,3.71 10,2.93 10,2 C10,0.9 9.1,0 8,0 C6.9,0 6,0.9 6,2 C6,2.93 6.64,3.71 7.5,3.93 L7.5,7.13 L3.92,5.04 C3.97,4.87 4,4.69 4,4.5 C4,3.4 3.1,2.5 2,2.5 C0.9,2.5 0,3.4 0,4.5 C0,5.6 0.9,6.5 2,6.5 C2.56,6.5 3.06,6.27 3.42,5.91 L7.01,8 L3.42,10.09 C3.06,9.73 2.56,9.5 2,9.5 C0.9,9.5 0,10.4 0,11.5 C0,12.6 0.9,13.5 2,13.5 C3.1,13.5 4,12.6 4,11.5 C4,11.31 3.97,11.13 3.92,10.96 L7.5,8.87 L7.5,12.07 C6.64,12.29 6,13.07 6,14 C6,15.1 6.9,16 8,16 C9.1,16 10,15.1 10,14 C10,13.07 9.36,12.29 8.5,12.07 L8.5,8.87 L12.08,10.96 C12.03,11.13 12,11.31 12,11.5 C12,12.6 12.9,13.5 14,13.5 C15.1,13.5 16,12.6 16,11.5 C16,10.4 15.1,9.5 14,9.5 Z" />
  </svg>
)
LayoutAuto.iconName = "LayoutAuto"
export const LayoutBalloon = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,11 C13.8,11 13.62,11.04 13.44,11.09 L12.42,9.4 C12.78,9.04 13,8.55 13,8 C13,7.45 12.78,6.96 12.42,6.6 L13.43,4.91 C13.62,4.96 13.8,5 14,5 C15.1,5 16,4.1 16,3 C16,1.9 15.1,1 14,1 C12.9,1 12,1.9 12,3 C12,3.55 12.22,4.04 12.58,4.4 L11.57,6.09 C11.38,6.04 11.2,6 11,6 C10.07,6 9.29,6.64 9.07,7.5 L6.93,7.5 C6.71,6.64 5.93,6 5,6 C4.8,6 4.62,6.04 4.44,6.09 L3.42,4.4 C3.78,4.04 4,3.55 4,3 C4,1.9 3.1,1 2,1 C0.9,1 0,1.9 0,3 C0,4.1 0.9,5 2,5 C2.2,5 2.38,4.96 2.56,4.91 L3.58,6.6 C3.22,6.96 3,7.45 3,8 C3,8.55 3.22,9.04 3.58,9.4 L2.57,11.09 C2.38,11.04 2.2,11 2,11 C0.9,11 0,11.9 0,13 C0,14.1 0.9,15 2,15 C3.1,15 4,14.1 4,13 C4,12.45 3.78,11.96 3.42,11.6 L4.43,9.91 C4.62,9.96 4.8,10 5,10 C5.93,10 6.71,9.36 6.93,8.5 L9.07,8.5 C9.29,9.36 10.07,10 11,10 C11.2,10 11.38,9.96 11.56,9.91 L12.57,11.6 C12.22,11.96 12,12.45 12,13 C12,14.1 12.9,15 14,15 C15.1,15 16,14.1 16,13 C16,11.9 15.1,11 14,11 Z" />
  </svg>
)
LayoutBalloon.iconName = "LayoutBalloon"
export const LayoutCircle = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.16,6.02 C14.04,5.66 13.9,5.32 13.73,4.99 C13.9,4.7 14,4.36 14,4 C14,2.9 13.1,2 12,2 C11.64,2 11.3,2.1 11.01,2.27 C10.68,2.1 10.34,1.96 9.98,1.84 C9.9,0.81 9.05,0 8,0 C6.95,0 6.1,0.81 6.02,1.84 C5.66,1.96 5.32,2.1 4.99,2.27 C4.7,2.1 4.36,2 4,2 C2.9,2 2,2.9 2,4 C2,4.36 2.1,4.7 2.27,4.99 C2.1,5.32 1.96,5.66 1.84,6.02 C0.81,6.1 0,6.95 0,8 C0,9.05 0.81,9.9 1.84,9.98 C1.96,10.34 2.1,10.68 2.27,11.01 C2.1,11.3 2,11.64 2,12 C2,13.1 2.9,14 4,14 C4.36,14 4.7,13.9 4.99,13.73 C5.32,13.9 5.66,14.05 6.02,14.16 C6.1,15.19 6.95,16 8,16 C9.05,16 9.9,15.19 9.98,14.16 C10.34,14.04 10.68,13.9 11.01,13.73 C11.3,13.9 11.64,14 12,14 C13.1,14 14,13.1 14,12 C14,11.64 13.9,11.3 13.73,11.01 C13.9,10.68 14.04,10.34 14.16,9.98 C15.19,9.9 16,9.05 16,8 C16,6.95 15.19,6.1 14.16,6.02 Z M13.17,9.81 C13.12,9.97 13.06,10.12 13,10.27 C12.7,10.1 12.36,10 12,10 C10.9,10 10,10.9 10,12 C10,12.36 10.1,12.7 10.27,13 C10.12,13.07 9.97,13.12 9.81,13.17 C9.5,12.48 8.81,12 8,12 C7.19,12 6.5,12.48 6.19,13.17 C6.03,13.11 5.87,13.06 5.73,13 C5.9,12.7 6,12.36 6,12 C6,10.9 5.1,10 4,10 C3.64,10 3.3,10.1 3,10.27 C2.93,10.12 2.88,9.97 2.83,9.81 C3.52,9.5 4,8.81 4,8 C4,7.19 3.52,6.5 2.83,6.19 C2.89,6.03 2.94,5.87 3,5.73 C3.3,5.9 3.64,6 4,6 C5.1,6 6,5.1 6,4 C6,3.64 5.9,3.3 5.73,3 C5.88,2.93 6.03,2.88 6.19,2.83 C6.5,3.52 7.19,4 8,4 C8.81,4 9.5,3.52 9.81,2.83 C9.97,2.89 10.13,2.94 10.27,3 C10.1,3.3 10,3.64 10,4 C10,5.1 10.9,6 12,6 C12.36,6 12.7,5.9 13,5.73 C13.07,5.88 13.12,6.03 13.17,6.19 C12.48,6.5 12,7.19 12,8 C12,8.81 12.48,9.5 13.17,9.81 L13.17,9.81 Z" />
  </svg>
)
LayoutCircle.iconName = "LayoutCircle"
export const LayoutGrid = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 Z M2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C3.1,10 4,9.1 4,8 C4,6.9 3.1,6 2,6 Z M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z M14,4 C15.1,4 16,3.1 16,2 C16,0.9 15.1,0 14,0 C12.9,0 12,0.9 12,2 C12,3.1 12.9,4 14,4 Z M14,6 C12.9,6 12,6.9 12,8 C12,9.1 12.9,10 14,10 C15.1,10 16,9.1 16,8 C16,6.9 15.1,6 14,6 Z M8,0 C6.9,0 6,0.9 6,2 C6,3.1 6.9,4 8,4 C9.1,4 10,3.1 10,2 C10,0.9 9.1,0 8,0 Z M14,12 C12.9,12 12,12.9 12,14 C12,15.1 12.9,16 14,16 C15.1,16 16,15.1 16,14 C16,12.9 15.1,12 14,12 Z M8,6 C6.9,6 6,6.9 6,8 C6,9.1 6.9,10 8,10 C9.1,10 10,9.1 10,8 C10,6.9 9.1,6 8,6 Z M8,12 C6.9,12 6,12.9 6,14 C6,15.1 6.9,16 8,16 C9.1,16 10,15.1 10,14 C10,12.9 9.1,12 8,12 Z" />
  </svg>
)
LayoutGrid.iconName = "LayoutGrid"
export const LayoutGroupBy = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C3.1,10 4,9.1 4,8 C4,6.9 3.1,6 2,6 Z M2,11 C0.9,11 0,11.9 0,13 C0,14.1 0.9,15 2,15 C3.1,15 4,14.1 4,13 C4,11.9 3.1,11 2,11 Z M14,4 C15.1,4 16,3.1 16,2 C16,0.9 15.1,0 14,0 C12.9,0 12,0.9 12,2 C12,3.1 12.9,4 14,4 Z M2,1 C0.9,1 0,1.9 0,3 C0,4.1 0.9,5 2,5 C3.1,5 4,4.1 4,3 C4,1.9 3.1,1 2,1 Z M9,9 C7.9,9 7,9.9 7,11 C7,12.1 7.9,13 9,13 C10.1,13 11,12.1 11,11 C11,9.9 10.1,9 9,9 Z M9,3 C7.9,3 7,3.9 7,5 C7,6.1 7.9,7 9,7 C10.1,7 11,6.1 11,5 C11,3.9 10.1,3 9,3 Z M14,6 C12.9,6 12,6.9 12,8 C12,9.1 12.9,10 14,10 C15.1,10 16,9.1 16,8 C16,6.9 15.1,6 14,6 Z M14,12 C12.9,12 12,12.9 12,14 C12,15.1 12.9,16 14,16 C15.1,16 16,15.1 16,14 C16,12.9 15.1,12 14,12 Z" />
  </svg>
)
LayoutGroupBy.iconName = "LayoutGroupBy"
export const LayoutHierarchy = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,12.07 L14.5,9.93 C15.36,9.71 16,8.93 16,8 C16,6.9 15.1,6 14,6 C13.07,6 12.29,6.64 12.07,7.5 L9.93,7.5 C9.75,6.8 9.2,6.25 8.5,6.07 L8.5,3.93 C9.36,3.71 10,2.93 10,2 C10,0.9 9.1,0 8,0 C6.9,0 6,0.9 6,2 C6,2.93 6.64,3.71 7.5,3.93 L7.5,6.07 C6.8,6.25 6.25,6.8 6.07,7.5 L3.93,7.5 C3.71,6.64 2.93,6 2,6 C0.9,6 0,6.9 0,8 C0,8.93 0.64,9.71 1.5,9.93 L1.5,12.07 C0.64,12.29 0,13.07 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,13.07 3.36,12.29 2.5,12.07 L2.5,9.93 C3.2,9.75 3.75,9.2 3.93,8.5 L6.07,8.5 C6.25,9.2 6.8,9.75 7.5,9.93 L7.5,12.07 C6.64,12.29 6,13.07 6,14 C6,15.1 6.9,16 8,16 C9.1,16 10,15.1 10,14 C10,13.07 9.36,12.29 8.5,12.07 L8.5,9.93 C9.2,9.75 9.75,9.2 9.93,8.5 L12.07,8.5 C12.25,9.2 12.8,9.75 13.5,9.93 L13.5,12.07 C12.64,12.29 12,13.07 12,14 C12,15.1 12.9,16 14,16 C15.1,16 16,15.1 16,14 C16,13.07 15.36,12.29 14.5,12.07 Z" />
  </svg>
)
LayoutHierarchy.iconName = "LayoutHierarchy"
export const LayoutLinear = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.0049587,6 C13.0749587,6 12.2949587,6.64 12.0749587,7.5 L9.93495873,7.5 C9.71495873,6.64 8.93495873,6 8.00495873,6 C7.07495873,6 6.29495873,6.64 6.07495873,7.5 L3.93495873,7.5 C3.71495873,6.64 2.93495873,6 2.00495873,6 C0.904958732,6 0.00495873213,6.9 0.00495873213,8 C0.00495873213,9.1 0.904958732,10 2.00495873,10 C2.93495873,10 3.71495873,9.36 3.93495873,8.5 L6.06495873,8.5 C6.29495873,9.36 7.07495873,10 8.00495873,10 C8.93495873,10 9.71495873,9.36 9.93495873,8.5 L12.0649587,8.5 C12.2849587,9.36 13.0649587,10 13.9949587,10 C15.0949587,10 15.9950413,9.1 15.9950413,8 C16.0049587,6.9 15.1049587,6 14.0049587,6 Z" />
  </svg>
)
LayoutLinear.iconName = "LayoutLinear"
export const LayoutSkewGrid = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C3.1,10 4,9.1 4,8 C4,6.9 3.1,6 2,6 Z M14,4 C15.1,4 16,3.1 16,2 C16,0.9 15.1,0 14,0 C12.9,0 12,0.9 12,2 C12,3.1 12.9,4 14,4 Z M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 Z M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z M8,9 C6.9,9 6,9.9 6,11 C6,12.1 6.9,13 8,13 C9.1,13 10,12.1 10,11 C10,9.9 9.1,9 8,9 Z M14,6 C12.9,6 12,6.9 12,8 C12,9.1 12.9,10 14,10 C15.1,10 16,9.1 16,8 C16,6.9 15.1,6 14,6 Z M8,3 C6.9,3 6,3.9 6,5 C6,6.1 6.9,7 8,7 C9.1,7 10,6.1 10,5 C10,3.9 9.1,3 8,3 Z M14,12 C12.9,12 12,12.9 12,14 C12,15.1 12.9,16 14,16 C15.1,16 16,15.1 16,14 C16,12.9 15.1,12 14,12 Z" />
  </svg>
)
LayoutSkewGrid.iconName = "LayoutSkewGrid"
export const LayoutSortedClusters = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C3.1,10 4,9.1 4,8 C4,6.9 3.1,6 2,6 Z M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 Z M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z M14,6 C12.9,6 12,6.9 12,8 C12,9.1 12.9,10 14,10 C15.1,10 16,9.1 16,8 C16,6.9 15.1,6 14,6 Z M8,9 C6.9,9 6,9.9 6,11 C6,12.1 6.9,13 8,13 C9.1,13 10,12.1 10,11 C10,9.9 9.1,9 8,9 Z M8,3 C6.9,3 6,3.9 6,5 C6,6.1 6.9,7 8,7 C9.1,7 10,6.1 10,5 C10,3.9 9.1,3 8,3 Z" />
  </svg>
)
LayoutSortedClusters.iconName = "LayoutSortedClusters"
export const Layout = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,4 C12.9,4 12,4.9 12,6 C12,6.47 12.17,6.9 12.44,7.24 L11.76,8.15 C11.53,8.05 11.27,8 11,8 C10.07,8 9.29,8.64 9.07,9.5 L7.93,9.5 C7.71,8.64 6.93,8 6,8 C5.53,8 5.1,8.17 4.76,8.44 L3.85,7.76 C3.95,7.53 4,7.27 4,7 C4,6.63 3.89,6.29 3.72,5.99 L5.99,3.72 C6.29,3.89 6.63,4 7,4 C8.1,4 9,3.1 9,2 C9,0.9 8.1,0 7,0 C5.9,0 5,0.9 5,2 C5,2.37 5.11,2.71 5.28,3.01 L3.01,5.28 C2.71,5.11 2.37,5 2,5 C0.9,5 0,5.9 0,7 C0,8.1 0.9,9 2,9 C2.47,9 2.9,8.83 3.24,8.56 L4.15,9.24 C4.05,9.47 4,9.73 4,10 C4,10.37 4.11,10.71 4.28,11.01 L3.01,12.28 C2.71,12.11 2.37,12 2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,13.63 3.89,13.29 3.72,12.99 L4.99,11.72 C5.29,11.89 5.63,12 6,12 C6.93,12 7.71,11.36 7.93,10.5 L9.07,10.5 C9.29,11.36 10.07,12 11,12 C12.1,12 13,11.1 13,10 C13,9.53 12.83,9.1 12.56,8.76 L13.24,7.85 C13.47,7.95 13.73,8 14,8 C15.1,8 16,7.1 16,6 C16,4.9 15.1,4 14,4 Z" />
  </svg>
)
Layout.iconName = "Layout"
export const LeftJoin = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.6,3.3 C6.1,3.1 5.6,3 5,3 C2.2,3 0,5.2 0,8 C0,10.8 2.2,13 5,13 C5.6,13 6.1,12.9 6.6,12.7 C5.3,11.6 4.5,9.9 4.5,8 C4.5,6.1 5.3,4.4 6.6,3.3 Z M8,4 C6.8,4.9 6,6.4 6,8 C6,9.6 6.8,11.1 8,12 C9.2,11.1 10,9.7 10,8 C10,6.3 9.2,4.9 8,4 Z M11,3 C13.8,3 16,5.2 16,8 C16,10.8 13.8,13 11,13 C10.4,13 9.9,12.9 9.4,12.7 C10.7,11.6 11.5,9.8 11.5,8 C11.5,6.2 10.7,4.5 9.4,3.3 C9.9,3.1 10.4,3 11,3 Z M11.35,4.02 C12.08,5.17 12.49,6.54 12.49,8 C12.49,9.46 12.07,10.83 11.35,11.98 C13.39,11.8 14.99,10.08 14.99,8 C14.99,5.92 13.39,4.2 11.35,4.02 Z" />
  </svg>
)
LeftJoin.iconName = "LeftJoin"
export const Lightbulb = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.995,14 L6.995,14 C6.445,14 5.995,14.45 5.995,15 C5.995,15.55 6.445,16 6.995,16 L8.995,16 C9.545,16 9.995,15.55 9.995,15 C9.995,14.45 9.555,14 8.995,14 Z M9.995,11 L5.995,11 C5.445,11 4.995,11.45 4.995,12 C4.995,12.55 5.445,13 5.995,13 L9.995,13 C10.545,13 10.995,12.55 10.995,12 C10.995,11.45 10.555,11 9.995,11 Z M7.995,0 C5.245,0 3.015,1.95 3.015,4.35 C3.015,6.72 4.645,6.99 4.955,9.57 C4.955,9.81 5.175,10.01 5.455,10.01 L10.545,10.01 C10.825,10.01 11.045,9.82 11.045,9.57 C11.355,6.99 12.985,6.72 12.985,4.35 C12.985,1.95 10.755,0 7.995,0 Z" />
  </svg>
)
Lightbulb.iconName = "Lightbulb"
export const Link = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.00187383,11.9975016 C5.28169894,11.9975016 5.53154279,11.8875703 5.71143036,11.7076827 L11.7076827,5.71143036 C11.8875703,5.53154279 11.9975016,5.28169894 11.9975016,5.00187383 C11.9975016,4.45221736 11.5477826,4.00249844 10.9981262,4.00249844 C10.7183011,4.00249844 10.4684572,4.11242973 10.2885696,4.2923173 L4.2923173,10.2885696 C4.11242973,10.4684572 4.00249844,10.7183011 4.00249844,10.9981262 C4.00249844,11.5477826 4.45221736,11.9975016 5.00187383,11.9975016 L5.00187383,11.9975016 Z M8.84946908,9.97876327 L6.41099313,12.4172392 L5.41161774,13.4166146 L5.40162399,13.4066209 C5.04184884,13.766396 4.5521549,14.0062461 4.00249844,14.0062461 C2.90318551,14.0062461 2.00374766,13.1068082 2.00374766,12.0074953 C2.00374766,11.4578389 2.24359775,10.9681449 2.60337289,10.6083698 L2.59337914,10.598376 L3.59275453,9.59900062 L6.03123048,7.16052467 C5.7014366,7.06058713 5.36164897,7.00062461 5.00187383,7.00062461 C3.9025609,7.00062461 2.91317926,7.46033729 2.19362898,8.18988132 L2.17364147,8.16989382 L1.17426608,9.16926921 L1.19425359,9.18925671 C0.464709557,9.908807 0.00499687695,10.8981886 0.00499687695,11.9975016 C0.00499687695,14.2061212 1.79387883,15.9950031 4.00249844,15.9950031 C5.10181137,15.9950031 6.091193,15.5352904 6.81074329,14.8057464 L6.83073079,14.8257339 L7.83010618,13.8263585 L7.81011868,13.806371 C8.53966271,13.0868207 8.99937539,12.0974391 8.99937539,10.9981262 C8.99937539,10.6483448 8.93941287,10.3085572 8.84946908,9.97876327 Z M15.9950031,4.00249844 C15.9950031,1.79387883 14.2061212,0.00499687695 11.9975016,0.00499687695 C10.8981886,0.00499687695 9.908807,0.464709557 9.18925671,1.19425359 L9.16926921,1.17426608 L8.16989382,2.17364147 L8.18988132,2.19362898 C7.47033104,2.91317926 7.00062461,3.9025609 7.00062461,5.00187383 C7.00062461,5.36164897 7.06058713,5.69144285 7.15053092,6.02123673 L9.58900687,3.58276077 L10.5883823,2.58338538 L10.598376,2.59337914 C10.9581512,2.233604 11.4478451,1.9937539 11.9975016,1.9937539 C13.0968145,1.9937539 13.9962523,2.89319176 13.9962523,3.99250468 C13.9962523,4.54216115 13.7564022,5.03185509 13.3966271,5.39163023 L13.4066209,5.40162399 L12.4072455,6.40099938 L9.97876327,8.84946908 C10.3085572,8.93941287 10.6483448,8.99937539 10.9981262,8.99937539 C12.0974391,8.99937539 13.0868207,8.53966271 13.806371,7.81011868 L13.8263585,7.83010618 L14.8257339,6.83073079 L14.8057464,6.81074329 C15.5352904,6.091193 15.9950031,5.11180512 15.9950031,4.00249844 Z" />
  </svg>
)
Link.iconName = "Link"
export const ListDetailView = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,9 L1,9 C0.45,9 0,9.45 0,10 C0,10.55 0.45,11 1,11 L6,11 C6.55,11 7,10.55 7,10 C7,9.45 6.55,9 6,9 Z M6,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L6,15 C6.55,15 7,14.55 7,14 C7,13.45 6.55,13 6,13 Z M15,1 L10,1 C9.45,1 9,1.45 9,2 L9,14 C9,14.55 9.45,15 10,15 L15,15 C15.55,15 16,14.55 16,14 L16,2 C16,1.45 15.55,1 15,1 Z M6,5 L1,5 C0.45,5 0,5.45 0,6 C0,6.55 0.45,7 1,7 L6,7 C6.55,7 7,6.55 7,6 C7,5.45 6.55,5 6,5 Z M6,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 L6,3 C6.55,3 7,2.55 7,2 C7,1.45 6.55,1 6,1 Z" />
  </svg>
)
ListDetailView.iconName = "ListDetailView"
export const List = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 Z M15,13 L1,13 C0.45,13 0,13.45 0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M15,9 L1,9 C0.45,9 0,9.45 0,10 C0,10.55 0.45,11 1,11 L15,11 C15.55,11 16,10.55 16,10 C16,9.45 15.55,9 15,9 Z M15,5 L1,5 C0.45,5 0,5.45 0,6 C0,6.55 0.45,7 1,7 L15,7 C15.55,7 16,6.55 16,6 C16,5.45 15.55,5 15,5 Z" />
  </svg>
)
List.iconName = "List"
export const Locate = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,7 L14.91,7 C14.47,3.95 12.06,1.54 9,1.1 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,1.09 C3.95,1.53 1.54,3.94 1.1,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L1.1,9 C1.54,12.06 3.94,14.47 7,14.91 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,14.91 C12.05,14.47 14.46,12.06 14.9,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z M8.98,12.9 C8.93,12.4 8.52,12 8,12 C7.48,12 7.07,12.4 7.02,12.9 C5.05,12.5 3.49,10.95 3.1,8.98 C3.6,8.93 4,8.52 4,8 C4,7.48 3.6,7.07 3.1,7.02 C3.49,5.05 5.05,3.5 7.02,3.1 C7.07,3.6 7.48,4 8,4 C8.52,4 8.93,3.6 8.98,3.1 C10.95,3.49 12.5,5.05 12.9,7.02 C12.4,7.07 12,7.48 12,8 C12,8.52 12.4,8.93 12.9,8.98 C12.51,10.95 10.95,12.5 8.98,12.9 Z M8,6 C6.9,6 6,6.9 6,8 C6,9.1 6.9,10 8,10 C9.1,10 10,9.1 10,8 C10,6.9 9.1,6 8,6 Z" />
  </svg>
)
Locate.iconName = "Locate"
export const Lock = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.96,7 L12,7 L12,3.95 C12,1.77 10.21,0 8,0 C5.79,0 4,1.77 4,3.95 L4,7 L1.96,7 C1.41,7 1,7.35 1,7.9 L1,14.81 C1,15.35 1.41,16 1.96,16 L13.96,16 C14.51,16 15,15.35 15,14.81 L15,7.9 C15,7.35 14.51,7 13.96,7 Z M6,7 L6,3.95 C6,2.86 6.9,1.98 8,1.98 C9.1,1.98 10,2.86 10,3.95 L10,7 L6,7 Z" />
  </svg>
)
Lock.iconName = "Lock"
export const LogIn = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,8 C11,7.72 10.89,7.47 10.71,7.29 L7.71,4.29 C7.53,4.11 7.28,4 7,4 C6.45,4 6,4.45 6,5 C6,5.28 6.11,5.53 6.29,5.71 L7.59,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L7.59,9 L6.3,10.29 C6.11,10.47 6,10.72 6,11 C6,11.55 6.45,12 7,12 C7.28,12 7.53,11.89 7.71,11.71 L10.71,8.71 C10.89,8.53 11,8.28 11,8 Z M15,0 L9,0 C8.45,0 8,0.45 8,1 C8,1.55 8.45,2 9,2 L14,2 L14,14 L9,14 C8.45,14 8,14.45 8,15 C8,15.55 8.45,16 9,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z" />
  </svg>
)
LogIn.iconName = "LogIn"
export const LogOut = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7,14 L2,14 L2,2 L7,2 C7.55,2 8,1.55 8,1 C8,0.45 7.55,0 7,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L7,16 C7.55,16 8,15.55 8,15 C8,14.45 7.55,14 7,14 Z M15.71,7.29 L12.71,4.29 C12.53,4.11 12.28,4 12,4 C11.45,4 11,4.45 11,5 C11,5.28 11.11,5.53 11.29,5.71 L12.59,7 L6,7 C5.45,7 5,7.45 5,8 C5,8.55 5.45,9 6,9 L12.59,9 L11.3,10.29 C11.11,10.47 11,10.72 11,11 C11,11.55 11.45,12 12,12 C12.28,12 12.53,11.89 12.71,11.71 L15.71,8.71 C15.89,8.53 16,8.28 16,8 C16,7.72 15.89,7.47 15.71,7.29 Z" />
  </svg>
)
LogOut.iconName = "LogOut"
export const Manual = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.99,1.13035961 C15.97,0.720369524 15.66,0.36037823 15.21,0.260380648 C12.26,-0.359604358 9.84,0.130383792 8,1.70034582 C6.16,0.130383792 3.74,-0.359604358 0.78,0.260380648 C0.33,0.350378471 0.03,0.720369524 0.01,1.13035961 L0,1.13035961 L0,13.1300694 C0,13.2100675 0,13.3000653 0.02,13.3900631 C0.14,13.9000508 0.67,14.2100433 1.21,14.1000459 C3.84,13.5500592 5.8,14.0600469 7.22,15.670008 C7.24,15.7000073 7.28,15.710007 7.3,15.7300065 C7.32,15.750006 7.33,15.7700056 7.35,15.7900051 C7.39,15.8200044 7.44,15.8300041 7.48,15.8600034 C7.53,15.8900027 7.57,15.9100022 7.62,15.9300017 C7.73,15.9700007 7.85,16 7.97,16 L8.01,16 C8.13,16 8.25,15.9700007 8.36,15.9300017 C8.41,15.9100022 8.45,15.8800029 8.5,15.8600034 C8.54,15.8400039 8.59,15.8200044 8.63,15.7900051 C8.65,15.7700056 8.66,15.750006 8.68,15.7300065 C8.71,15.710007 8.74,15.7000073 8.76,15.670008 C10.18,14.0700467 12.15,13.5500592 14.77,14.1000459 C15.31,14.2100433 15.84,13.890051 15.96,13.3900631 C16,13.3000653 16,13.2100675 16,13.1300694 L15.99,1.13035961 Z M7,12.9900728 C5.6,12.1600929 3.93,11.8501004 2,12.0600953 L2,1.96033954 C4.11,1.68034631 5.75,2.1603347 7,3.42030423 L7,12.9900728 Z M14,12.070095 C12.07,11.8601001 10.4,12.1700926 9,13.0000726 L9,3.42030423 C10.25,2.1603347 11.89,1.68034631 14,1.96033954 L14,12.070095 Z" />
  </svg>
)
Manual.iconName = "Manual"
export const ManuallyEnteredData = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1,8 L4.76,8 L6.76,6 L1,6 C0.45,6 0,6.45 0,7 C0,7.55 0.45,8 1,8 Z M15.49,3.99 C15.8,3.67 16,3.23 16,2.75 C16,1.78 15.22,1 14.25,1 C13.77,1 13.33,1.2 13.01,1.51 L11.57,2.95 L14.04,5.42 L15.49,3.99 Z M1,4 L8.76,4 L10.76,2 L1,2 C0.45,2 0,2.45 0,3 C0,3.55 0.45,4 1,4 Z M1,10 C0.45,10 0,10.45 0,11 C0,11.48 0.35,11.86 0.8,11.96 L2.76,10 L1,10 Z M10.95,3.57 L4.26,10.26 L6.73,12.73 L13.42,6.04 L10.95,3.57 L10.95,3.57 Z M15.2,6.04 L13.24,8 L15,8 C15.55,8 16,7.55 16,7 C16,6.52 15.65,6.14 15.2,6.04 L15.2,6.04 Z M2,15 L5.86,13.61 L3.4,11.17 L2,15 Z M15,10 L11.24,10 L9.24,12 L15,12 C15.55,12 16,11.55 16,11 C16,10.45 15.55,10 15,10 Z" />
  </svg>
)
ManuallyEnteredData.iconName = "ManuallyEnteredData"
export const MapCreate = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,6.82 L14,13.14 L11.06,11.18 C11.04,11.17 11.02,11.16 11.01,11.15 L11.01,6.22 C10.93,6.15 10.86,6.06 10.79,5.98 C10.51,5.96 10.25,5.9 10,5.82 L10,11.14 C10,11.14 9.99,11.14 9.99,11.15 L6,13.53 L6,4.86 C6,4.86 6.01,4.86 6.01,4.85 L8.06,3.62 C8.02,3.42 8,3.21 8,3 C8,2.02 8.47,1.16 9.2,0.61 L5.53,2.81 L1.56,0.17 C1.4,0.06 1.21,0 1,0 C0.45,0 0,0.45 0,1 L0,12 C0,12.35 0.18,12.65 0.45,12.83 L4.94,15.83 C5.1,15.94 5.29,16 5.5,16 C5.69,16 5.86,15.94 6.01,15.85 L10.47,13.18 L14.44,15.83 C14.6,15.94 14.79,16 15,16 C15.55,16 16,15.55 16,15 L16,5.82 C15.75,5.91 15.48,5.96 15.2,5.98 C14.87,6.34 14.47,6.65 14,6.82 Z M5,13.46 L2,11.46 L2,2.86 L4.94,4.82 C4.96,4.84 4.98,4.85 5,4.86 L5,13.46 L5,13.46 Z M11,4 L12,4 L12,5 C12,5.55 12.45,6 13,6 C13.55,6 14,5.55 14,5 L14,4 L15,4 C15.55,4 16,3.55 16,3 C16,2.45 15.55,2 15,2 L14,2 L14,1 C14,0.45 13.55,0 13,0 C12.45,0 12,0.45 12,1 L12,2 L11,2 C10.45,2 10,2.45 10,3 C10,3.55 10.45,4 11,4 Z" />
  </svg>
)
MapCreate.iconName = "MapCreate"
export const MapMarker = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C4.96,0 2.49,2.39 2.49,5.33 C2.49,8.28 8,16 8,16 C8,16 13.51,8.28 13.51,5.33 C13.5,2.39 11.04,0 8,0 Z M8,8 C6.62,8 5.5,6.88 5.5,5.5 C5.5,4.12 6.62,3 8,3 C9.38,3 10.5,4.12 10.5,5.5 C10.5,6.88 9.38,8 8,8 Z" />
  </svg>
)
MapMarker.iconName = "MapMarker"
export const Map = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.55,3.17 L11.06,0.17 C10.9,0.06 10.71,0 10.5,0 C10.31,0 10.14,0.06 9.99,0.15 L5.53,2.82 L1.56,0.17 C1.4,0.06 1.21,0 1,0 C0.45,0 0,0.45 0,1 L0,12 C0,12.35 0.18,12.65 0.45,12.83 L4.94,15.83 C5.1,15.94 5.29,16 5.5,16 C5.69,16 5.86,15.94 6.01,15.85 L10.47,13.18 L14.44,15.83 C14.6,15.94 14.79,16 15,16 C15.55,16 16,15.55 16,15 L16,4 C16,3.65 15.82,3.35 15.55,3.17 Z M5,13.46 L2,11.46 L2,2.86 L4.94,4.82 C4.96,4.84 4.98,4.85 5,4.86 L5,13.46 L5,13.46 Z M10,11.14 C10,11.14 9.99,11.14 9.99,11.15 L6,13.53 L6,4.86 C6,4.86 6.01,4.86 6.01,4.85 L10,2.47 L10,11.14 Z M14,13.13 L11.06,11.17 C11.04,11.16 11.02,11.15 11.01,11.14 L11.01,2.54 L14.01,4.54 L14.01,13.13 L14,13.13 Z" />
  </svg>
)
Map.iconName = "Map"
export const Maximize = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.00124922,9.00437227 C5.72142411,9.00437227 5.47158026,9.11430356 5.29169269,9.29419113 L2.00374766,12.5821362 L2.00374766,10.9931293 C2.00374766,10.4434728 1.55402873,9.9937539 1.00437227,9.9937539 C0.454715803,9.9937539 0.00499687695,10.4434728 0.00499687695,10.9931293 L0.00499687695,14.9906309 C0.00499687695,15.5402873 0.454715803,15.9900062 1.00437227,15.9900062 L5.00187383,15.9900062 C5.55153029,15.9900062 6.00124922,15.5402873 6.00124922,14.9906309 C6.00124922,14.4409744 5.55153029,13.9912555 5.00187383,13.9912555 L3.42286071,13.9912555 L6.71080575,10.7133042 C6.89069332,10.5334166 7.00062461,10.2835728 7.00062461,10.0037477 C7.00062461,9.45409119 6.55090568,9.00437227 6.00124922,9.00437227 L6.00124922,9.00437227 Z M14.9956277,0.0099937539 L10.9981262,0.0099937539 C10.4484697,0.0099937539 9.99875078,0.45971268 9.99875078,1.00936914 C9.99875078,1.55902561 10.4484697,2.00874453 10.9981262,2.00874453 L12.587133,2.00874453 L9.28919425,5.30668332 C9.10930668,5.48657089 8.99937539,5.73641474 8.99937539,6.0062461 C8.99937539,6.55590256 9.44909432,7.00562149 9.99875078,7.00562149 C10.2785759,7.00562149 10.5284197,6.89569019 10.7083073,6.71580262 L13.9962523,3.42785759 L13.9962523,5.01686446 C13.9962523,5.56652092 14.4459713,6.01623985 14.9956277,6.01623985 C15.5452842,6.01623985 15.9950031,5.56652092 15.9950031,5.01686446 L15.9950031,1.0193629 C15.9950031,0.45971268 15.5452842,0.0099937539 14.9956277,0.0099937539 L14.9956277,0.0099937539 Z" />
  </svg>
)
Maximize.iconName = "Maximize"
export const Media = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.9975016,7 C12.547158,7 12.996877,6.55 12.996877,6 C12.996877,5.45 12.547158,5 11.9975016,5 C11.4478451,5 10.9981262,5.45 10.9981262,6 C10.9981262,6.55 11.4478451,7 11.9975016,7 Z M14.9956277,2 L1.00437227,2 C0.454715803,2 0.00499687695,2.45 0.00499687695,3 L0.00499687695,13 C0.00499687695,13.55 0.454715803,14 1.00437227,14 L14.9956277,14 C15.5452842,14 15.9950031,13.55 15.9950031,13 L15.9950031,3 C15.9950031,2.45 15.5452842,2 14.9956277,2 Z M13.9962523,11 L8.99937539,8 L8,10 L5.00187383,6 L2.00374766,11 L2.00374766,4 L13.9962523,4 L13.9962523,11 Z" />
  </svg>
)
Media.iconName = "Media"
export const MenuClose = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,12 C15.5522847,12 16,12.4477153 16,13 C16,13.5522847 15.5522847,14 15,14 L5,14 C4.44771525,14 4,13.5522847 4,13 C4,12.4477153 4.44771525,12 5,12 L15,12 Z M15,7 C15.5522847,7 16,7.44771525 16,8 C16,8.55228475 15.5522847,9 15,9 L1,9 C0.44771525,9 6.76353751e-17,8.55228475 0,8 C-6.76353751e-17,7.44771525 0.44771525,7 1,7 L15,7 Z M15,2 C15.5522847,2 16,2.44771525 16,3 C16,3.55228475 15.5522847,4 15,4 L8,4 C7.44771525,4 7,3.55228475 7,3 C7,2.44771525 7.44771525,2 8,2 L15,2 Z" />
  </svg>
)
MenuClose.iconName = "MenuClose"
export const MenuClosed = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.9956277,7 L6.00124922,7 C5.45159275,7 5.00187383,7.45 5.00187383,8 C5.00187383,8.55 5.45159275,9 6.00124922,9 L14.9956277,9 C15.5452842,9 15.9950031,8.55 15.9950031,8 C15.9950031,7.45 15.5452842,7 14.9956277,7 Z M3.00312305,5 C2.72329794,5 2.47345409,5.11 2.29356652,5.29 L0.29481574,7.29 C0.11492817,7.48 0.00499687695,7.73 0.00499687695,8 C0.00499687695,8.27 0.11492817,8.53 0.29481574,8.71 L2.29356652,10.71 C2.47345409,10.89 2.72329794,11 3.00312305,11 C3.55277951,11 4.00249844,10.55 4.00249844,10 L4.00249844,6 C4.00249844,5.45 3.55277951,5 3.00312305,5 L3.00312305,5 Z M6.00124922,4 L14.9956277,4 C15.5452842,4 15.9950031,3.55 15.9950031,3 C15.9950031,2.45 15.5452842,2 14.9956277,2 L6.00124922,2 C5.45159275,2 5.00187383,2.45 5.00187383,3 C5.00187383,3.55 5.45159275,4 6.00124922,4 Z M14.9956277,12 L6.00124922,12 C5.45159275,12 5.00187383,12.45 5.00187383,13 C5.00187383,13.55 5.45159275,14 6.00124922,14 L14.9956277,14 C15.5452842,14 15.9950031,13.55 15.9950031,13 C15.9950031,12.45 15.5452842,12 14.9956277,12 Z" />
  </svg>
)
MenuClosed.iconName = "MenuClosed"
export const MenuOpen = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99875078,12 L1.00437227,12 C0.454715803,12 0.00499687695,12.45 0.00499687695,13 C0.00499687695,13.55 0.454715803,14 1.00437227,14 L9.99875078,14 C10.5484072,14 10.9981262,13.55 10.9981262,13 C10.9981262,12.45 10.5484072,12 9.99875078,12 Z M9.99875078,7 L1.00437227,7 C0.454715803,7 0.00499687695,7.45 0.00499687695,8 C0.00499687695,8.55 0.454715803,9 1.00437227,9 L9.99875078,9 C10.5484072,9 10.9981262,8.55 10.9981262,8 C10.9981262,7.45 10.5484072,7 9.99875078,7 Z M9.99875078,2 L1.00437227,2 C0.454715803,2 0.00499687695,2.45 0.00499687695,3 C0.00499687695,3.55 0.454715803,4 1.00437227,4 L9.99875078,4 C10.5484072,4 10.9981262,3.55 10.9981262,3 C10.9981262,2.45 10.5484072,2 9.99875078,2 Z M15.7051843,7.3 L13.7064335,5.3 C13.5265459,5.12 13.2767021,5.01 12.996877,5.01 C12.4472205,5.01 11.9975016,5.46 11.9975016,6.01 L11.9975016,10.01 C11.9975016,10.56 12.4472205,11.01 12.996877,11.01 C13.2767021,11.01 13.5265459,10.9 13.7064335,10.72 L15.7051843,8.72 C15.8850718,8.54 15.9950031,8.29 15.9950031,8.01 C15.9950031,7.73 15.8850718,7.48 15.7051843,7.3 Z" />
  </svg>
)
MenuOpen.iconName = "MenuOpen"
export const Menu = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1,4 L15,4 C15.55,4 16,3.55 16,3 C16,2.45 15.55,2 15,2 L1,2 C0.45,2 0,2.45 0,3 C0,3.55 0.45,4 1,4 Z M15,12 L1,12 C0.45,12 0,12.45 0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z M15,7 L1,7 C0.45,7 0,7.45 0,8 C0,8.55 0.45,9 1,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z" />
  </svg>
)
Menu.iconName = "Menu"
export const MergeColumns = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.71,5.29 C5.53,5.11 5.28,5 5,5 C4.45,5 4,5.45 4,6 C4,6.28 4.11,6.53 4.29,6.71 L4.59,7 L2,7 L2,2 L5,2 L5,3.51 C5.52,3.57 5.99,3.8 6.34,4.16 L7,4.82 L7,1 C7,0.45 6.55,0 6,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L6,16 C6.55,16 7,15.55 7,15 L7,11.18 L6.34,11.84 C5.99,12.19 5.52,12.43 5,12.49 L5,14 L2,14 L2,9 L4.59,9 L4.29,9.29 C4.11,9.47 4,9.72 4,10 C4,10.55 4.45,11 5,11 C5.28,11 5.53,10.89 5.71,10.71 L7.71,8.71 C7.89,8.53 8,8.28 8,8 C8,7.72 7.89,7.47 7.71,7.29 L5.71,5.29 Z M15,0 L10,0 C9.45,0 9,0.45 9,1 L9,4.82 L9.66,4.16 C10.01,3.81 10.48,3.57 11,3.51 L11,2 L14,2 L14,7 L11.41,7 L11.7,6.71 C11.89,6.53 12,6.28 12,6 C12,5.45 11.55,5 11,5 C10.72,5 10.47,5.11 10.29,5.29 L8.29,7.29 C8.11,7.47 8,7.72 8,8 C8,8.28 8.11,8.53 8.29,8.71 L10.29,10.71 C10.47,10.89 10.72,11 11,11 C11.55,11 12,10.55 12,10 C12,9.72 11.89,9.47 11.71,9.29 L11.41,9 L14,9 L14,14 L11,14 L11,12.49 C10.48,12.43 10.01,12.2 9.66,11.84 L9,11.18 L9,15 C9,15.55 9.45,16 10,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z" />
  </svg>
)
MergeColumns.iconName = "MergeColumns"
export const MergeLinks = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,7 C7.45,7 7,7.45 7,8 C7,8.55 7.45,9 8,9 C8.55,9 9,8.55 9,8 C9,7.45 8.55,7 8,7 Z M8,11 C7.45,11 7,11.45 7,12 C7,12.55 7.45,13 8,13 C8.55,13 9,12.55 9,12 C9,11.45 8.55,11 8,11 Z M8,3 C7.45,3 7,3.45 7,4 C7,4.55 7.45,5 8,5 C8.55,5 9,4.55 9,4 C9,3.45 8.55,3 8,3 Z M14,6 C13.07,6 12.29,6.64 12.07,7.5 L11,7.5 L11,3 C11,1.34 9.66,0 8,0 C6.34,0 5,1.34 5,3 L5,7.5 L3.93,7.5 C3.71,6.64 2.93,6 2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C2.93,10 3.71,9.36 3.93,8.5 L5,8.5 L5,13 C5,14.66 6.34,16 8,16 C9.66,16 11,14.66 11,13 L11,8.5 L12.07,8.5 C12.29,9.36 13.07,10 14,10 C15.1,10 16,9.1 16,8 C16,6.9 15.1,6 14,6 Z M10,13 C10,14.1 9.1,15 8,15 C6.9,15 6,14.1 6,13 L6,3 C6,1.9 6.9,1 8,1 C9.1,1 10,1.9 10,3 L10,13 Z" />
  </svg>
)
MergeLinks.iconName = "MergeLinks"
export const Minimize = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.995,1.00437227 C15.995,0.454715803 15.545,0.00499687695 14.995,0.00499687695 C14.715,0.00499687695 14.465,0.11492817 14.285,0.29481574 L10.995,3.58276077 L10.995,2.00374766 C10.995,1.45409119 10.545,1.00437227 9.995,1.00437227 C9.445,1.00437227 8.995,1.45409119 8.995,2.00374766 L8.995,6.00124922 C8.995,6.55090568 9.445,7.00062461 9.995,7.00062461 L13.995,7.00062461 C14.545,7.00062461 14.995,6.55090568 14.995,6.00124922 C14.995,5.45159275 14.545,5.00187383 13.995,5.00187383 L12.405,5.00187383 L15.705,1.71392879 C15.885,1.53404122 15.995,1.28419738 15.995,1.00437227 L15.995,1.00437227 Z M5.995,8.99937539 L1.995,8.99937539 C1.445,8.99937539 0.995,9.44909432 0.995,9.99875078 C0.995,10.5484072 1.445,10.9981262 1.995,10.9981262 L3.585,10.9981262 L0.295,14.2860712 C0.115,14.4659588 0.005,14.7158026 0.005,14.9956277 C0.005,15.5452842 0.455,15.9950031 1.005,15.9950031 C1.285,15.9950031 1.535,15.8850718 1.715,15.7051843 L5.005,12.4172392 L5.005,14.0062461 C5.005,14.5559026 5.455,15.0056215 6.005,15.0056215 C6.555,15.0056215 7.005,14.5559026 7.005,14.0062461 L7.005,10.0087445 C6.995,9.44909432 6.545,8.99937539 5.995,8.99937539 Z" />
  </svg>
)
Minimize.iconName = "Minimize"
export const Minus = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,7 L3,7 C2.45,7 2,7.45 2,8 C2,8.55 2.45,9 3,9 L13,9 C13.55,9 14,8.55 14,8 C14,7.45 13.55,7 13,7 Z" />
  </svg>
)
Minus.iconName = "Minus"
export const MobilePhone = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,0 L4,0 C3.45,0 3,0.45 3,1 L3,15 C3,15.55 3.45,16 4,16 L12,16 C12.55,16 13,15.55 13,15 L13,1 C13,0.45 12.55,0 12,0 Z M8,15 C7.45,15 7,14.55 7,14 C7,13.45 7.45,13 8,13 C8.55,13 9,13.45 9,14 C9,14.55 8.55,15 8,15 Z M11,12 L5,12 L5,3 L11,3 L11,12 Z" />
  </svg>
)
MobilePhone.iconName = "MobilePhone"
export const MobileVideo = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,4 C14.72,4 14.47,4.11 14.29,4.29 L12,6.59 L12,4 C12,3.45 11.55,3 11,3 L1,3 C0.45,3 0,3.45 0,4 L0,12 C0,12.55 0.45,13 1,13 L11,13 C11.55,13 12,12.55 12,12 L12,9.41 L14.29,11.7 C14.47,11.89 14.72,12 15,12 C15.55,12 16,11.55 16,11 L16,5 C16,4.45 15.55,4 15,4 Z" />
  </svg>
)
MobileVideo.iconName = "MobileVideo"
export const Moon = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.5,10.88 C14.27,13.61 11.53,15.5 8.35,15.5 C4.01,15.5 0.5,11.99 0.5,7.65 C0.5,4.47 2.39,1.73 5.12,0.5 C4.67,1.49 4.42,2.58 4.42,3.73 C4.42,8.06 7.93,11.58 12.27,11.58 C13.42,11.58 14.51,11.33 15.5,10.88 Z" />
  </svg>
)
Moon.iconName = "Moon"
export const More = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,6 C0.8954305,6 0,6.8954305 0,8 C0,9.1045695 0.8954305,10 2,10 C3.1045695,10 4,9.1045695 4,8 C4,6.8954305 3.1045695,6 2,6 Z M14,6 C12.8954305,6 12,6.8954305 12,8 C12,9.1045695 12.8954305,10 14,10 C15.1045695,10 16,9.1045695 16,8 C16,6.8954305 15.1045695,6 14,6 Z M8,6 C6.8954305,6 6,6.8954305 6,8 C6,9.1045695 6.8954305,10 8,10 C9.1045695,10 10,9.1045695 10,8 C10,6.8954305 9.1045695,6 8,6 Z" />
  </svg>
)
More.iconName = "More"
export const Move = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.71,7.29 L13.71,5.29 C13.53,5.11 13.28,5 13,5 C12.45,5 12,5.45 12,6 C12,6.28 12.11,6.53 12.29,6.71 L12.59,7 L9,7 L9,3.41 L9.29,3.7 C9.47,3.89 9.72,4 10,4 C10.55,4 11,3.55 11,3 C11,2.72 10.89,2.47 10.71,2.29 L8.71,0.29 C8.53,0.11 8.28,0 8,0 C7.72,0 7.47,0.11 7.29,0.29 L5.29,2.29 C5.11,2.47 5,2.72 5,3 C5,3.55 5.45,4 6,4 C6.28,4 6.53,3.89 6.71,3.71 L7,3.41 L7,7 L3.41,7 L3.7,6.71 C3.89,6.53 4,6.28 4,6 C4,5.45 3.55,5 3,5 C2.72,5 2.47,5.11 2.29,5.29 L0.29,7.29 C0.11,7.47 0,7.72 0,8 C0,8.28 0.11,8.53 0.29,8.71 L2.29,10.71 C2.47,10.89 2.72,11 3,11 C3.55,11 4,10.55 4,10 C4,9.72 3.89,9.47 3.71,9.29 L3.41,9 L7,9 L7,12.59 L6.71,12.3 C6.53,12.11 6.28,12 6,12 C5.45,12 5,12.45 5,13 C5,13.28 5.11,13.53 5.29,13.71 L7.29,15.71 C7.47,15.89 7.72,16 8,16 C8.28,16 8.53,15.89 8.71,15.71 L10.71,13.71 C10.89,13.53 11,13.28 11,13 C11,12.45 10.55,12 10,12 C9.72,12 9.47,12.11 9.29,12.29 L9,12.59 L9,9 L12.59,9 L12.3,9.29 C12.11,9.47 12,9.72 12,10 C12,10.55 12.45,11 13,11 C13.28,11 13.53,10.89 13.71,10.71 L15.71,8.71 C15.89,8.53 16,8.28 16,8 C16,7.72 15.89,7.47 15.71,7.29 Z" />
  </svg>
)
Move.iconName = "Move"
export const Mugshot = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M14,14 L13.85,14 C13.82,13.91 13.81,13.84 13.77,13.75 C13.43,12.96 11.76,12.44 10.65,11.95 C9.54,11.46 9.69,11.16 9.65,10.75 C9.64,10.69 9.64,10.63 9.64,10.57 C10.02,10.23 10.33,9.77 10.53,9.24 C10.53,9.24 10.54,9.21 10.54,9.2 C10.58,9.08 10.62,8.96 10.65,8.84 C10.9,8.79 11.05,8.51 11.11,8.25 C11.17,8.15 11.29,7.89 11.26,7.6 C11.22,7.23 11.07,7.05 10.91,6.98 L10.91,6.92 C10.91,6.44 10.87,5.76 10.78,5.31 C10.76,5.19 10.73,5.06 10.7,4.94 C10.54,4.39 10.19,3.89 9.74,3.55 C9.26,3.19 8.6,3 8,3 C7.41,3 6.74,3.19 6.27,3.55 C5.82,3.9 5.47,4.39 5.31,4.94 C5.27,5.07 5.25,5.19 5.23,5.32 C5.14,5.77 5.1,6.45 5.1,6.93 L5.1,6.99 C4.92,7.05 4.77,7.23 4.73,7.61 C4.7,7.9 4.82,8.15 4.88,8.26 C4.94,8.52 5.09,8.8 5.35,8.85 C5.38,8.97 5.42,9.1 5.46,9.21 C5.46,9.22 5.47,9.23 5.47,9.23 L5.47,9.24 C5.68,9.78 6,10.25 6.39,10.59 C6.39,10.64 6.38,10.7 6.38,10.75 C6.34,11.16 6.46,11.45 5.35,11.95 C4.24,12.44 2.58,12.96 2.23,13.75 C2.19,13.84 2.18,13.91 2.15,14 L2,14 L2,2 L14,2 L14,14 Z" />
  </svg>
)
Mugshot.iconName = "Mugshot"
export const MultiSelect = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,4.5 L4,4.5 C3.45,4.5 3,4.95 3,5.5 L3,6.5 L11,6.5 L11,11.5 L12,11.5 C12.55,11.5 13,11.05 13,10.5 L13,5.5 C13,4.95 12.55,4.5 12,4.5 Z M15,1.5 L7,1.5 C6.45,1.5 6,1.95 6,2.5 L6,3.5 L14,3.5 L14,8.5 L15,8.5 C15.55,8.5 16,8.05 16,7.5 L16,2.5 C16,1.95 15.55,1.5 15,1.5 Z M9,7.5 L1,7.5 C0.45,7.5 0,7.95 0,8.5 L0,13.5 C0,14.05 0.45,14.5 1,14.5 L9,14.5 C9.55,14.5 10,14.05 10,13.5 L10,8.5 C10,7.95 9.55,7.5 9,7.5 Z M8,12.5 L2,12.5 L2,9.5 L8,9.5 L8,12.5 Z" />
  </svg>
)
MultiSelect.iconName = "MultiSelect"
export const Music = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 C14.93,0 14.87,0.03 14.81,0.04 L14.81,0.02 L4.81,2.02 L4.81,2.04 C4.35,2.13 4,2.52 4,3 L4,12.12 C3.69,12.05 3.35,12 3,12 C1.34,12 0,12.9 0,14 C0,15.1 1.34,16 3,16 C4.66,16 6,15.1 6,14 L6,6.32 L14,4.72 L14,10.12 C13.69,10.05 13.35,10 13,10 C11.34,10 10,10.9 10,12 C10,13.1 11.34,14 13,14 C14.66,14 16,13.1 16,12 L16,1 C16,0.45 15.55,0 15,0 Z" />
  </svg>
)
Music.iconName = "Music"
export const NewGridItem = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,0 L1,0 C0.45,0 0,0.45 0,1 L0,6 C0,6.55 0.45,7 1,7 L6,7 C6.55,7 7,6.55 7,6 L7,1 C7,0.45 6.55,0 6,0 Z M11,14 C11,13.45 10.55,13 10,13 C9.45,13 9,13.45 9,14 L9,15 C9,15.55 9.45,16 10,16 L11,16 C11.55,16 12,15.55 12,15 C12,14.45 11.55,14 11,14 Z M6,9 L1,9 C0.45,9 0,9.45 0,10 L0,15 C0,15.55 0.45,16 1,16 L6,16 C6.55,16 7,15.55 7,15 L7,10 C7,9.45 6.55,9 6,9 Z M15,13 C14.45,13 14,13.45 14,14 C13.45,14 13,14.45 13,15 C13,15.55 13.45,16 14,16 L15,16 C15.55,16 16,15.55 16,15 L16,14 C16,13.45 15.55,13 15,13 Z M11,9 L10,9 C9.45,9 9,9.45 9,10 L9,11 C9,11.55 9.45,12 10,12 C10.55,12 11,11.55 11,11 C11.55,11 12,10.55 12,10 C12,9.45 11.55,9 11,9 Z M15,0 L10,0 C9.45,0 9,0.45 9,1 L9,6 C9,6.55 9.45,7 10,7 L15,7 C15.55,7 16,6.55 16,6 L16,1 C16,0.45 15.55,0 15,0 Z M15,9 L14,9 C13.45,9 13,9.45 13,10 C13,10.55 13.45,11 14,11 C14,11.55 14.45,12 15,12 C15.55,12 16,11.55 16,11 L16,10 C16,9.45 15.55,9 15,9 Z" />
  </svg>
)
NewGridItem.iconName = "NewGridItem"
export const NewLink = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,3.5 L14,3.5 L14,2.5 C14,1.95 13.55,1.5 13,1.5 C12.45,1.5 12,1.95 12,2.5 L12,3.5 L11,3.5 C10.45,3.5 10,3.95 10,4.5 C10,5.05 10.45,5.5 11,5.5 L12,5.5 L12,6.5 C12,7.05 12.45,7.5 13,7.5 C13.55,7.5 14,7.05 14,6.5 L14,5.5 L15,5.5 C15.55,5.5 16,5.05 16,4.5 C16,3.95 15.55,3.5 15,3.5 Z M11.5,9.5 C10.29,9.5 9.28,10.36 9.05,11.5 L4.95,11.5 C4.72,10.36 3.71,9.5 2.5,9.5 C1.12,9.5 0,10.62 0,12 C0,13.38 1.12,14.5 2.5,14.5 C3.71,14.5 4.72,13.64 4.95,12.5 L9.05,12.5 C9.28,13.64 10.29,14.5 11.5,14.5 C12.88,14.5 14,13.38 14,12 C14,10.62 12.88,9.5 11.5,9.5 Z" />
  </svg>
)
NewLink.iconName = "NewLink"
export const NewObject = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,4 C8,4.6 8.4,5 9,5 L11,5 L11,7 C11,7.6 11.4,8 12,8 C12.6,8 13,7.6 13,7 L13,5 L15,5 C15.6,5 16,4.6 16,4 C16,3.4 15.6,3 15,3 L13,3 L13,1 C13,0.4 12.6,0 12,0 C11.4,0 11,0.4 11,1 L11,3 L9,3 C8.4,3 8,3.5 8,4 Z M14.5,6.5 L14.5,7 C14.5,8.4 13.4,9.5 12,9.5 C10.6,9.5 9.5,8.4 9.5,7 L9.5,6.5 L9,6.5 C7.6,6.5 6.5,5.4 6.5,4 C6.5,2.6 7.6,1.5 9,1.5 L9.5,1.5 L9.5,1 C9.5,0.7 9.6,0.4 9.6,0.2 C9.1,0.1 8.6,0 8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,7.4 15.9,6.7 15.8,6.1 C15.4,6.4 15,6.5 14.5,6.5 Z" />
  </svg>
)
NewObject.iconName = "NewObject"
export const NewPerson = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.17583283,12.69 C8.0059756,12.16 8.16595608,11.84 8.12596096,11.4 C8.11596218,11.34 8.11596218,11.28 8.11596218,11.21 C8.51591337,10.84 8.8458731,10.34 9.05584747,9.77 C9.05584747,9.77 9.06584625,9.74 9.06584625,9.73 C9.11584015,9.59 9.15583527,9.46 9.18583161,9.33 C9.45579866,9.27 9.61577914,8.97 9.67577182,8.7 C9.7357645,8.59 9.86574863,8.31 9.83575229,8 C9.79575717,7.59 9.6357767,7.4 9.45579866,7.32 L9.45579866,7.25 C9.45579866,6.74 9.40580476,6 9.31581575,5.51 C9.29581819,5.38 9.26582185,5.24 9.22582673,5.11 C9.05584747,4.51 8.6958914,3.97 8.21594998,3.59 C7.71601099,3.2 7.01609641,3 6.38617329,3 C5.76624894,3 5.05633558,3.2 4.56639537,3.59 C4.07645517,3.97 3.7164991,4.51 3.54651984,5.11 C3.50652472,5.24 3.47652838,5.37 3.45653082,5.51 C3.36654181,6 3.32654669,6.74 3.32654669,7.25 L3.32654669,7.31 C3.13656987,7.39 2.9765894,7.58 2.93659428,7.99 C2.90659794,8.3 3.03658207,8.58 3.09657475,8.69 C3.15656743,8.97 3.31654791,9.28 3.59651374,9.33 C3.62651008,9.47 3.6665052,9.6 3.70650032,9.73 C3.70650032,9.74 3.7164991,9.75 3.7164991,9.75 L3.7164991,9.76 C3.93647225,10.35 4.26643198,10.86 4.67638195,11.22 C4.67638195,11.28 4.66638317,11.34 4.66638317,11.39 C4.62638805,11.83 4.74637341,12.15 3.57651618,12.68 C2.40665895,13.21 0.646873717,13.78 0.286917647,14.63 C-0.0630396438,15.5 0.0869420522,16 0.0869420522,16 L12.6854045,16 C12.6854045,16 12.8353862,15.5 12.4654314,14.64 C12.1054753,13.79 10.3456901,13.22 9.17583283,12.69 L9.17583283,12.69 Z M14.9451287,2 L13.9452508,2 L13.9452508,1 C13.9452508,0.45 13.4953057,0 12.9453728,0 C12.3954399,0 11.9454948,0.45 11.9454948,1 L11.9454948,2 L10.9456168,2 C10.395684,2 9.94573887,2.45 9.94573887,3 C9.94573887,3.55 10.395684,4 10.9456168,4 L11.9454948,4 L11.9454948,5 C11.9454948,5.55 12.3954399,6 12.9453728,6 C13.4953057,6 13.9452508,5.55 13.9452508,5 L13.9452508,4 L14.9451287,4 C15.4950616,4 15.9450067,3.55 15.9450067,3 C15.9450067,2.45 15.4950616,2 14.9451287,2 Z" />
  </svg>
)
NewPerson.iconName = "NewPerson"
export const NewPrescription = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.82,11.66 L12.3,8.79 C12.42,8.59 12.43,8.42 12.34,8.26 C12.23,8.07 12.04,8 11.82,8 L10.53,8 C10.26,8 10.04,8.13 9.9,8.34 L8.44,9.9 L6.95,8 C6.94,7.98 6.91,7.94 6.87,7.9 L5.82,6.55 C6.39,6.31 6.86,5.98 7.24,5.54 C7.73,4.97 7.98,4.27 7.98,3.46 C7.98,2.95 7.88,2.47 7.66,2.04 C7.45,1.61 7.15,1.24 6.77,0.93 C6.39,0.63 5.94,0.4 5.42,0.24 C4.91,0.08 4.34,0 3.72,0 L0.61,0 C0.26,0 0,0.23 0,0.56 L0,10.45 C0,10.78 0.26,11 0.61,11 L1.41,11 C1.77,11 2.02,10.77 2.02,10.44 L2.02,6.99 L3.3,6.99 L7.03,11.73 L4.32,15.21 C4.2,15.41 4.19,15.58 4.28,15.74 C4.39,15.93 4.58,16 4.8,16 L6.07,16 C6.34,16 6.58,15.88 6.71,15.66 L8.4,13.51 L10.06,15.65 C10.18,15.86 10.4,16 10.68,16 L12.11,16 C12.31,16 12.5,15.92 12.61,15.75 C12.73,15.57 12.7,15.37 12.59,15.2 L9.82,11.66 Z M4.18,5 L1.99,5 L1.99,2.02 L4.18,2.02 C4.8,2.02 5.26,2.15 5.56,2.39 C5.85,2.61 6,3.01 6,3.47 C6,3.92 5.85,4.41 5.56,4.64 C5.25,4.87 4.8,5 4.18,5 L4.18,5 Z M15,2 L14,2 L14,1 C14,0.45 13.55,0 13,0 C12.45,0 12,0.45 12,1 L12,2 L11,2 C10.45,2 10,2.45 10,3 C10,3.55 10.45,4 11,4 L12,4 L12,5 C12,5.55 12.45,6 13,6 C13.55,6 14,5.55 14,5 L14,4 L15,4 C15.55,4 16,3.55 16,3 C16,2.45 15.55,2 15,2 Z M9.99,3.01 C9.99,3.03 10,3.05 10,3.07 L10,2.95 C10,2.97 9.99,2.99 9.99,3.01 L9.99,3.01 Z" />
  </svg>
)
NewPrescription.iconName = "NewPrescription"
export const NewTextBox = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.5,7 C4.5,7.28 4.72,7.5 5,7.5 L6.5,7.5 L6.5,11 C6.5,11.28 6.72,11.5 7,11.5 C7.28,11.5 7.5,11.28 7.5,11 L7.5,7.5 L9,7.5 C9.28,7.5 9.5,7.28 9.5,7 C9.5,6.72 9.28,6.5 9,6.5 L5,6.5 C4.72,6.5 4.5,6.72 4.5,7 Z M14.5,2.5 L13.5,2.5 L13.5,1.5 C13.5,0.95 13.05,0.5 12.5,0.5 C11.95,0.5 11.5,0.95 11.5,1.5 L11.5,2.5 L10.5,2.5 C9.95,2.5 9.5,2.95 9.5,3.5 C9.5,4.05 9.95,4.5 10.5,4.5 L11.5,4.5 L11.5,5.5 C11.5,6.05 11.95,6.5 12.5,6.5 C13.05,6.5 13.5,6.05 13.5,5.5 L13.5,4.5 L14.5,4.5 C15.05,4.5 15.5,4.05 15.5,3.5 C15.5,2.95 15.05,2.5 14.5,2.5 Z M12.5,7.5 C11.95,7.5 11.5,7.95 11.5,8.5 L11.5,13.5 L2.5,13.5 L2.5,4.5 L7.5,4.5 C8.05,4.5 8.5,4.05 8.5,3.5 C8.5,2.95 8.05,2.5 7.5,2.5 L1.5,2.5 C0.95,2.5 0.5,2.95 0.5,3.5 L0.5,14.5 C0.5,15.05 0.95,15.5 1.5,15.5 L12.5,15.5 C13.05,15.5 13.5,15.05 13.5,14.5 L13.5,8.5 C13.5,7.95 13.05,7.5 12.5,7.5 Z" />
  </svg>
)
NewTextBox.iconName = "NewTextBox"
export const Ninja = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16,5 C16,5 13.48,7.11 11.04,6.99 C11.03,4.89 10.39,0.23 5,0 C5,0 7.11,2.54 6.96,4.99 C4.86,5.01 0.23,5.65 0,11 C0,11 2.56,8.88 5.02,9.05 C5.04,11.16 5.69,15.77 11,16 C11,16 8.91,13.46 9.06,11.01 C11.17,10.99 15.77,10.33 16,5 Z M8,9.5 C7.17,9.5 6.5,8.83 6.5,8 C6.5,7.17 7.17,6.5 8,6.5 C8.83,6.5 9.5,7.17 9.5,8 C9.5,8.83 8.83,9.5 8,9.5 Z" />
  </svg>
)
Ninja.iconName = "Ninja"
export const Notifications = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,16 C9.1,16 10,15.1 10,14 L6,14 C6,15.1 6.9,16 8,16 Z M14,11 C13.45,11 13,10.55 13,10 L13,6 C13,3.57 11.27,1.55 8.98,1.1 C8.98,1.06 9,1.04 9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 C7,1.04 7.02,1.06 7.02,1.1 C4.73,1.55 3,3.57 3,6 L3,10 C3,10.55 2.55,11 2,11 C1.45,11 1,11.45 1,12 C1,12.55 1.45,13 2,13 L14,13 C14.55,13 15,12.55 15,12 C15,11.45 14.55,11 14,11 Z" />
  </svg>
)
Notifications.iconName = "Notifications"
export const NumberedList = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.75827608,7.01 L4.01748907,7.01 L4.01748907,0.01 L3.0780762,0.01 C3.03810119,0.22 2.95815116,0.4 2.82823235,0.55 C2.69831355,0.7 2.53841349,0.82 2.34853217,0.91 C2.1686446,1 1.95877577,1.07 1.72891943,1.11 C1.49906309,1.15 1.26920675,1.17 1.0193629,1.17 L1.0193629,2.07 L2.75827608,2.07 L2.75827608,7.01 Z M2.1686446,14.18 C2.34853217,14.06 2.53841349,13.93 2.74828232,13.81 C2.95815116,13.69 3.16801999,13.56 3.37788882,13.42 C3.58775765,13.28 3.78763273,13.14 3.98750781,12.98 C4.18738289,12.82 4.3572767,12.65 4.50718301,12.47 C4.65708932,12.28 4.78700812,12.08 4.87695191,11.86 C4.96689569,11.64 5.01686446,11.39 5.01686446,11.12 C5.01686446,10.9 4.97688944,10.67 4.89693941,10.42 C4.81698938,10.16 4.68707058,9.93 4.49718926,9.73 C4.31730169,9.52 4.06745784,9.34 3.77763898,9.21 C3.47782636,9.07 3.09806371,9 2.65833854,9 C2.24859463,9 1.88881949,9.07 1.57901312,9.2 C1.25921299,9.34 0.99937539,9.52 0.779512804,9.76 C0.559650219,9.99 0.399750156,10.27 0.289818863,10.6 C0.17988757,10.92 0.129918801,11.27 0.129918801,11.65 L1.31917552,11.65 C1.32916927,11.41 1.34915678,11.18 1.39912555,10.98 C1.44909432,10.77 1.50905684,10.59 1.60899438,10.44 C1.69893816,10.29 1.82885696,10.17 1.98875703,10.08 C2.14865709,9.99 2.33853841,9.95 2.57838851,9.95 C2.83822611,9.95 3.04809494,9.99 3.207995,10.07 C3.36789507,10.15 3.49781387,10.25 3.58775765,10.37 C3.67770144,10.49 3.73766396,10.62 3.76764522,10.76 C3.79762648,10.9 3.81761399,11.03 3.81761399,11.16 C3.80762024,11.43 3.73766396,11.66 3.59775141,11.87 C3.45783885,12.08 3.27795128,12.27 3.06808245,12.44 C2.84821986,12.62 2.61836352,12.78 2.35852592,12.93 C2.09868832,13.08 1.84884447,13.24 1.61898813,13.4 C1.11930044,13.71 0.729544035,14.08 0.449718926,14.51 C0.149906309,14.92 0.0099937539,15.42 0,15.99 L4.99687695,15.99 L4.99687695,14.99 L1.42910681,14.99 C1.47907558,14.84 1.56901936,14.7 1.69893816,14.56 C1.83885072,14.43 1.98875703,14.3 2.1686446,14.18 L2.1686446,14.18 Z M15.0006246,2 L8.00499688,2 C7.45534041,2 7.00562149,2.45 7.00562149,3 L7.00562149,4 C7.00562149,4.55 7.45534041,5 8.00499688,5 L15.0006246,5 C15.5502811,5 16,4.55 16,4 L16,3 C16,2.45 15.5602748,2 15.0006246,2 L15.0006246,2 Z M15.0006246,11 L8.00499688,11 C7.45534041,11 7.00562149,11.45 7.00562149,12 L7.00562149,13 C7.00562149,13.55 7.45534041,14 8.00499688,14 L15.0006246,14 C15.5502811,14 16,13.55 16,13 L16,12 C16,11.45 15.5602748,11 15.0006246,11 L15.0006246,11 Z" />
  </svg>
)
NumberedList.iconName = "NumberedList"
export const Numerical = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.3,4.62 C2.17,4.79 2.01,4.92 1.82,5.03 C1.64,5.14 1.43,5.21 1.2,5.26 C0.97,5.3 0.74,5.33 0.49,5.33 L0.49,6.36 L2.23,6.36 L2.23,12.01 L3.49,12.01 L3.49,4.01 L2.55,4.01 C2.51,4.24 2.43,4.45 2.3,4.62 Z M6.67,9.93 C6.85,9.79 7.04,9.65 7.25,9.51 L7.88,9.06 C8.09,8.9 8.29,8.73 8.49,8.55 C8.69,8.37 8.86,8.17 9.01,7.96 C9.16,7.75 9.29,7.51 9.38,7.26 C9.47,7.01 9.51,6.72 9.51,6.41 C9.51,6.16 9.47,5.89 9.39,5.61 C9.32,5.32 9.19,5.06 9,4.82 C8.82,4.58 8.57,4.38 8.27,4.22 C7.98,4.07 7.61,3.99 7.16,3.99 C6.75,3.99 6.39,4.07 6.08,4.22 C5.77,4.38 5.5,4.59 5.29,4.86 C5.07,5.13 4.91,5.45 4.8,5.82 C4.69,6.19 4.64,6.59 4.64,7.02 L5.83,7.02 C5.84,6.75 5.86,6.49 5.91,6.25 C5.95,6.01 6.02,5.8 6.12,5.63 C6.21,5.45 6.34,5.31 6.5,5.21 C6.66,5.11 6.85,5.06 7.09,5.06 C7.35,5.06 7.56,5.11 7.72,5.2 C7.87,5.29 8,5.41 8.09,5.55 C8.18,5.69 8.24,5.84 8.27,6 C8.3,6.16 8.32,6.31 8.32,6.45 C8.31,6.76 8.24,7.03 8.1,7.27 C7.96,7.5 7.78,7.72 7.57,7.92 C7.35,8.13 7.11,8.31 6.86,8.49 C6.6,8.67 6.35,8.85 6.11,9.03 C5.61,9.39 5.22,9.81 4.94,10.3 C4.66,10.79 4.51,11.36 4.5,12.01 L9.5,12.01 L9.5,10.86 L5.94,10.86 C5.99,10.69 6.08,10.53 6.21,10.37 C6.34,10.22 6.5,10.08 6.67,9.93 L6.67,9.93 Z M15.17,8.37 C14.94,8.02 14.63,7.8 14.22,7.72 L14.22,7.7 C14.56,7.57 14.82,7.36 14.98,7.07 C15.14,6.78 15.22,6.44 15.22,6.05 C15.22,5.71 15.16,5.41 15.03,5.15 C14.9,4.89 14.73,4.68 14.52,4.51 C14.31,4.34 14.07,4.21 13.8,4.13 C13.53,4.04 13.26,4 12.98,4 C12.62,4 12.3,4.07 12.02,4.2 C11.74,4.33 11.49,4.52 11.3,4.75 C11.1,4.98 10.94,5.26 10.83,5.58 C10.72,5.9 10.65,6.24 10.64,6.62 L11.79,6.62 C11.78,6.42 11.8,6.23 11.85,6.04 C11.9,5.85 11.97,5.68 12.07,5.53 C12.17,5.38 12.29,5.26 12.44,5.17 C12.59,5.08 12.76,5.04 12.97,5.04 C13.29,5.04 13.56,5.14 13.76,5.34 C13.97,5.54 14.07,5.8 14.07,6.13 C14.07,6.36 14.02,6.56 13.93,6.72 C13.84,6.88 13.72,7.01 13.58,7.1 C13.43,7.19 13.26,7.26 13.07,7.29 C12.88,7.33 12.69,7.34 12.5,7.33 L12.5,8.26 C12.73,8.25 12.95,8.26 13.17,8.28 C13.39,8.3 13.59,8.36 13.76,8.45 C13.94,8.54 14.08,8.68 14.19,8.85 C14.3,9.03 14.35,9.26 14.35,9.56 C14.35,10 14.22,10.34 13.96,10.58 C13.7,10.82 13.38,10.94 12.99,10.94 C12.54,10.94 12.2,10.78 11.97,10.47 C11.74,10.16 11.64,9.77 11.65,9.3 L10.51,9.3 C10.52,9.7 10.57,10.07 10.68,10.4 C10.79,10.73 10.94,11.01 11.15,11.25 C11.36,11.48 11.61,11.67 11.92,11.79 C12.23,11.92 12.59,11.98 13,11.98 C13.34,11.98 13.66,11.93 13.96,11.82 C14.26,11.71 14.53,11.55 14.76,11.35 C14.99,11.15 15.17,10.9 15.31,10.61 C15.44,10.34 15.51,10.01 15.51,9.64 C15.51,9.14 15.4,8.72 15.17,8.37 L15.17,8.37 Z" />
  </svg>
)
Numerical.iconName = "Numerical"
export const Office = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,5 L12,5 L12,1 C12,0.45 11.55,0 11,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L4,16 L4,12 L8,12 L8,16 L15,16 C15.55,16 16,15.55 16,15 L16,6 C16,5.45 15.55,5 15,5 Z M5,10 L2,10 L2,7 L5,7 L5,10 Z M5,5 L2,5 L2,2 L5,2 L5,5 Z M10,10 L7,10 L7,7 L10,7 L10,10 Z M10,5 L7,5 L7,2 L10,2 L10,5 Z M14,14 L12,14 L12,12 L14,12 L14,14 Z M14,10 L12,10 L12,7 L14,7 L14,10 Z" />
  </svg>
)
Office.iconName = "Office"
export const Offline = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M6,14 L7,9 L4,9 L10,2 L9,7 L12,7 L6,14 Z" />
  </svg>
)
Offline.iconName = "Offline"
export const OilField = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,13.995 L13.65,13.995 L10.31,6.485 L12.77,5.535 L14.22,8.745 C14.31,8.945 14.58,9.045 14.82,8.975 C14.92,8.945 15,8.895 15.06,8.825 C15.11,8.745 16.29,7.265 15.93,4.625 C15.82,3.835 15.41,0.005 12.67,0.005 C11.74,0.005 10.99,0.625 11,1.375 C11,1.515 11.03,1.655 11.09,1.795 L11.96,3.715 L0.64,8.065 L0.64,8.075 C0.27,8.215 0,8.565 0,8.995 C0,9.545 0.45,9.995 1,9.995 C1.13,9.995 1.25,9.965 1.36,9.925 L1.36,9.935 L2.4,9.535 L3.67,13.995 L2,13.995 C1.45,13.995 1,14.445 1,14.995 C1,15.545 1.45,15.995 2,15.995 L15,15.995 C15.55,15.995 16,15.545 16,14.995 C16,14.445 15.55,13.995 15,13.995 Z M4.27,8.805 L7.14,7.695 L5.2,12.075 L4.27,8.805 L4.27,8.805 Z M6.54,13.995 L9,8.455 L11.46,13.995 L6.54,13.995 Z" />
  </svg>
)
OilField.iconName = "OilField"
export const OneColumn = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,0.00499687695 L9,0.00499687695 C8.45,0.00499687695 8,0.454715803 8,1.00437227 L8,14.9956277 C8,15.5452842 8.45,15.9950031 9,15.9950031 L12,15.9950031 C12.55,15.9950031 13,15.5452842 13,14.9956277 L13,1.00437227 C13,0.454715803 12.55,0.00499687695 12,0.00499687695 Z M6,5.00187383 C5.72,5.00187383 5.47,5.11180512 5.29,5.29169269 L3.29,7.29044347 C3.11,7.4803248 3,7.73016864 3,8 C3,8.26983136 3.11,8.52966896 3.29,8.70955653 L5.29,10.7083073 C5.47,10.8881949 5.72,10.9981262 6,10.9981262 C6.55,10.9981262 7,10.5484072 7,9.99875078 L7,6.00124922 C7,5.45159275 6.55,5.00187383 6,5.00187383 L6,5.00187383 Z" />
  </svg>
)
OneColumn.iconName = "OneColumn"
export const PageLayout = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L15,15 C15.55,15 16,14.55 16,14 L16,2 C16,1.45 15.55,1 15,1 Z M6,13 L2,13 L2,7 L6,7 L6,13 Z M14,13 L7,13 L7,7 L14,7 L14,13 Z M14,6 L2,6 L2,3 L14,3 L14,6 Z" />
  </svg>
)
PageLayout.iconName = "PageLayout"
export const PanelStats = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,4.5 L13,4.5 L13,5.5 L10,5.5 L10,4.5 Z M10,6.5 L13,6.5 L13,7.5 L10,7.5 L10,6.5 Z M10,8.5 L13,8.5 L13,9.5 L10,9.5 L10,8.5 Z M10,10.5 L13,10.5 L13,11.5 L10,11.5 L10,10.5 Z M15,1.5 L1,1.5 C0.4,1.5 0,1.9 0,2.5 L0,13.5 C0,14.1 0.4,14.5 1,14.5 L15,14.5 C15.6,14.5 16,14.1 16,13.5 L16,2.5 C16,1.9 15.6,1.5 15,1.5 Z M8,12.5 L2,12.5 L2,3.5 L8,3.5 L8,12.5 Z M14,12.5 L9,12.5 L9,3.5 L14,3.5 L14,12.5 Z" />
  </svg>
)
PanelStats.iconName = "PanelStats"
export const PanelTable = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1.5 L1,1.5 C0.4,1.5 0,1.9 0,2.5 L0,13.5 C0,14.1 0.4,14.5 1,14.5 L15,14.5 C15.6,14.5 16,14.1 16,13.5 L16,2.5 C16,1.9 15.6,1.5 15,1.5 Z M8,9.5 L6,9.5 L6,7.5 L8,7.5 L8,9.5 Z M8,6.5 L6,6.5 L6,4.5 L8,4.5 L8,6.5 Z M2,12.5 L2,3.5 L5,3.5 L5,12.5 L2,12.5 Z M6,12.5 L6,10.5 L8,10.5 L8,12.5 L6,12.5 Z M14,12.5 L9,12.5 L9,10.5 L14,10.5 L14,12.5 Z M14,9.5 L9,9.5 L9,7.5 L14,7.5 L14,9.5 Z M14,6.5 L9,6.5 L9,4.5 L14,4.5 L14,6.5 Z" />
  </svg>
)
PanelTable.iconName = "PanelTable"
export const Paperclip = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.68,1.82936503 C13.8,0.949365026 12.63,0.509365026 11.46,0.509365026 C10.31,0.509365026 9.15,0.949365026 8.27,1.82936503 L0.95,9.14936503 C0.32,9.77936503 0,10.609365 0,11.429365 C0,12.249365 0.31,13.089365 0.95,13.719365 C1.57,14.339365 2.4,14.649365 3.23,14.649365 C4.06,14.649365 4.89,14.339365 5.53,13.699365 L12.84,6.37936503 C13.6,5.60936503 13.6,4.39936503 12.85,3.64936503 C12.1,2.89936503 10.86,2.88936503 10.1,3.64936503 L4.03,9.72936503 C3.79,9.97936503 3.79,10.379365 4.04,10.629365 C4.29,10.879365 4.69,10.879365 4.95,10.639365 L11.02,4.55936503 C11.27,4.30936503 11.69,4.30936503 11.93,4.54936503 C12.18,4.79936503 12.18,5.21936503 11.93,5.46936503 L4.62,12.789365 C3.87,13.539365 2.58,13.529365 1.86,12.799365 C1.11,12.049365 1.13,10.779365 1.87,10.039365 L9.2,2.72936503 C10.44,1.48936503 12.55,1.46936503 13.78,2.69936503 C15.02,3.93936503 15.02,6.05936503 13.78,7.29936503 L6.66,14.429365 C6.42,14.679365 6.42,15.069365 6.67,15.309365 C6.91,15.549365 7.3,15.549365 7.55,15.319365 L7.55,15.329365 L14.68,8.19936503 C15.56,7.33936503 16,6.18936503 16,5.02936503 C16,3.86936503 15.56,2.70936503 14.68,1.82936503 Z" />
  </svg>
)
Paperclip.iconName = "Paperclip"
export const Paragraph = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,1 L6,1 C3.8,1 2,2.8 2,5 C2,7.2 3.8,9 6,9 L6,14 C6,14.6 6.4,15 7,15 C7.6,15 8,14.5 8,14 L8,3 L10,3 L10,14 C10,14.6 10.4,15 11,15 C11.6,15 12,14.5 12,14 L12,3 L13,3 C13.5,3 14,2.6 14,2 C14,1.4 13.6,1 13,1 Z" />
  </svg>
)
Paragraph.iconName = "Paragraph"
export const PathSearch = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,14.62 L11,12.22 L11,9.77 C10.68,9.86 10.34,9.92 10,9.95 L10,12.22 L6,14.62 L6,8.71 C5.62,8.4 5.28,8.05 5,7.65 L5,14.62 L1,12.22 L1,8 C1.55,8 2,7.55 2,7 C2,6.45 1.55,6 1,6 L1,1.38 L4.15,3.27 C4.23,2.93 4.33,2.61 4.47,2.3 L0.76,0.07 L0.76,0.08 C0.68,0.03 0.59,0 0.5,0 C0.22,0 0,0.22 0,0.5 L0,12.5 C0,12.68 0.1,12.83 0.25,12.92 L0.25,12.93 L5.25,15.93 L5.25,15.92 C5.32,15.97 5.41,16 5.5,16 C5.59,16 5.68,15.97 5.75,15.92 L5.75,15.93 L10.49,13.08 L15.23,15.93 L15.23,15.92 C15.32,15.97 15.41,16 15.5,16 C15.78,16 16,15.78 16,15.5 L16,11.72 C15.7,11.89 15.37,12 15,12 L15,14.62 Z M2,5 C2,5.55 2.45,6 3,6 C3.55,6 4,5.55 4,5 C4,4.45 3.55,4 3,4 C2.45,4 2,4.45 2,5 Z M8,4 C7.45,4 7,4.45 7,5 C7,5.55 7.45,6 8,6 C8.55,6 9,5.55 9,5 C9,4.45 8.55,4 8,4 Z M15.75,3.08 L14.56,2.36 C14.74,2.79 14.85,3.26 14.92,3.74 L15,3.78 L15,7.17 L16,8.17 L16,3.5 C16,3.32 15.9,3.17 15.75,3.08 Z M10,2 C9.45,2 9,2.45 9,3 C9,3.55 9.45,4 10,4 C10.55,4 11,3.55 11,3 C11,2.45 10.55,2 10,2 Z M13.3,6.89 C13.74,6.19 14,5.38 14,4.5 C14,2.01 11.99,0 9.5,0 C7.01,0 5,2.01 5,4.5 C5,6.99 7.01,9 9.5,9 C10.38,9 11.19,8.74 11.89,8.3 L14.3,10.71 C14.47,10.89 14.72,11 15,11 C15.55,11 16,10.55 16,10 C16,9.72 15.89,9.47 15.71,9.29 L13.3,6.89 Z M9.5,8 C7.57,8 6,6.43 6,4.5 C6,2.57 7.57,1 9.5,1 C11.43,1 13,2.57 13,4.5 C13,6.43 11.43,8 9.5,8 Z" />
  </svg>
)
PathSearch.iconName = "PathSearch"
export const Path = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,0.5 L1.5,0.5 C0.67,0.5 0,1.17 0,2 C0,2.83 0.67,3.5 1.5,3.5 L7,3.5 L7,6.5 L3.5,6.5 C2.67,6.5 2,7.17 2,8 C2,8.83 2.67,9.5 3.5,9.5 L7,9.5 L7,12.5 L5.5,12.5 C4.67,12.5 4,13.17 4,14 C4,14.83 4.67,15.5 5.5,15.5 L10.5,15.5 C11.33,15.5 12,14.83 12,14 C12,13.17 11.33,12.5 10.5,12.5 L9,12.5 L9,9.5 L12.5,9.5 C13.33,9.5 14,8.83 14,8 C14,7.17 13.33,6.5 12.5,6.5 L9,6.5 L9,3.5 L14.5,3.5 C15.33,3.5 16,2.83 16,2 C16,1.17 15.33,0.5 14.5,0.5 Z" />
  </svg>
)
Path.iconName = "Path"
export const Pause = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,3 L4,3 C3.45,3 3,3.45 3,4 L3,12 C3,12.55 3.45,13 4,13 L6,13 C6.55,13 7,12.55 7,12 L7,4 C7,3.45 6.55,3 6,3 Z M12,3 L10,3 C9.45,3 9,3.45 9,4 L9,12 C9,12.55 9.45,13 10,13 L12,13 C12.55,13 13,12.55 13,12 L13,4 C13,3.45 12.55,3 12,3 Z" />
  </svg>
)
Pause.iconName = "Pause"
export const People = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.6609272,13.52 C13.6109728,13.28 13.5210549,13.02 13.4111552,12.76 C13.0514836,11.9 12.2921767,11.43 10.7236087,10.76 C10.5837364,10.7 10.1341468,10.51 10.124156,10.51 C9.91434749,10.42 9.7644843,10.36 9.624612,10.29 C9.64459375,10.19 9.64459375,10.09 9.65458463,9.98 C9.65458463,9.94 9.66457551,9.9 9.66457551,9.85 C9.59463936,9.79 9.53469408,9.73 9.47474881,9.66 C9.69454815,9.34 9.87438398,8.99 10.0142563,8.61 C10.034238,8.55 10.034238,8.55 10.0442289,8.51 C10.3339644,8.28 10.5237911,7.94 10.6336908,7.55 C10.7935449,7.22 10.8834628,6.82 10.8434993,6.39 C10.8135266,5.99 10.6836452,5.63 10.4738367,5.36 C10.453855,4.83 10.4039006,4.23 10.3239735,3.82 C10.3139827,3.76 10.3039918,3.7 10.2940009,3.63 C10.5237911,3.57 10.7735631,3.54 11.0133442,3.54 C11.5028973,3.54 12.0623865,3.7 12.4520308,4 C12.8316842,4.29 13.1214197,4.7 13.2513011,5.17 C13.2812738,5.27 13.3012555,5.38 13.3212373,5.48 C13.3911734,5.85 13.431137,6.42 13.431137,6.81 L13.431137,6.86 C13.5710093,6.92 13.7008907,7.07 13.7208725,7.37 C13.7408542,7.62 13.6509363,7.82 13.590991,7.91 C13.5410366,8.12 13.431137,8.35 13.2113376,8.39 C13.1913559,8.49 13.1613832,8.59 13.1214197,8.69 C13.1214197,8.7 13.1114288,8.72 13.1114288,8.72 C12.9415839,9.16 12.681821,9.55 12.3621129,9.83 L12.3621129,9.97 C12.3920855,10.32 12.272195,10.56 13.1913559,10.97 C14.1205076,11.38 15.5092398,11.81 15.7889845,12.47 C16.07872,13.13 15.9588294,13.51 15.9588294,13.51 L13.6609272,13.51 L13.6609272,13.52 Z M12.4919943,13.14 C12.8616569,14 12.7117937,14.5 12.7117937,14.5 L0.0433588546,14.5 C0.0433588546,14.5 -0.096513454,14 0.263158197,13.14 C0.622829848,12.28 2.39121546,11.71 3.57013921,11.18 C4.73907207,10.64 4.61918152,10.32 4.65914504,9.88 C4.65914504,9.83 4.66913592,9.77 4.66913592,9.71 C4.25950987,9.36 3.91981998,8.85 3.70002064,8.26 L3.70002064,8.25 C3.70002064,8.25 3.69002976,8.24 3.69002976,8.23 C3.65006624,8.11 3.60011185,7.97 3.57013921,7.84 C3.29039459,7.79 3.13054052,7.48 3.07059525,7.2 C3.01064997,7.08 2.88076854,6.81 2.91074118,6.49 C2.9507047,6.08 3.12054964,5.89 3.30038547,5.81 L3.30038547,5.75 C3.30038547,5.24 3.35033987,4.49 3.44025778,4.01 C3.46023954,3.88 3.49021217,3.74 3.53017569,3.61 C3.70002064,3.01 4.06968317,2.48 4.54924537,2.1 C5.04878933,1.71 5.75814175,1.5 6.38756714,1.5 C7.01699253,1.5 7.72634495,1.71 8.22588891,2.1 C8.70545111,2.48 9.07511364,3.01 9.24495859,3.62 C9.2849221,3.75 9.31489474,3.89 9.3348765,4.02 C9.42479441,4.5 9.47474881,5.24 9.47474881,5.75 L9.47474881,5.82 C9.65458463,5.9 9.8144387,6.09 9.84441134,6.49 C9.87438398,6.81 9.75449343,7.08 9.68455727,7.2 C9.624612,7.48 9.47474881,7.78 9.20499507,7.83 C9.17502243,7.96 9.13505892,8.09 9.08510452,8.22 C9.08510452,8.23 9.07511364,8.26 9.07511364,8.26 C8.8553143,8.84 8.52561529,9.34 8.12598012,9.71 L8.12598012,9.89 C8.16594363,10.34 8.00608957,10.66 9.18501331,11.19 C10.3639371,11.72 12.1323227,12.28 12.4919943,13.14 Z" />
  </svg>
)
People.iconName = "People"
export const Percentage = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,6 L6,4 C6,2.9 5.1,2 4,2 L3,2 C1.9,2 1,2.9 1,4 L1,6 C1,7.1 1.9,8 3,8 L4,8 C5.1,8 6,7.1 6,6 Z M3.5,6 C3.22,6 3,5.78 3,5.5 L3,4.5 C3,4.22 3.22,4 3.5,4 C3.78,4 4,4.22 4,4.5 L4,5.5 C4,5.78 3.78,6 3.5,6 Z M13,8 L12,8 C10.9,8 10,8.9 10,10 L10,12 C10,13.1 10.9,14 12,14 L13,14 C14.1,14 15,13.1 15,12 L15,10 C15,8.9 14.1,8 13,8 Z M13,11.5 C13,11.78 12.78,12 12.5,12 C12.22,12 12,11.78 12,11.5 L12,10.5 C12,10.22 12.22,10 12.5,10 C12.78,10 13,10.22 13,10.5 L13,11.5 Z M12,3 C12,2.45 11.55,2 11,2 C10.63,2 10.31,2.2 10.13,2.5 L4.14,12.48 C4.05,12.63 4,12.81 4,13 C4,13.55 4.45,14 5,14 C5.37,14 5.69,13.8 5.87,13.5 L11.86,3.52 C11.95,3.37 12,3.19 12,3 L12,3 Z" />
  </svg>
)
Percentage.iconName = "Percentage"
export const Person = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.6841604,14.3309836 C15.2241604,13.2816394 13.0041604,12.5820766 11.5241604,11.9324826 C10.0441604,11.2828886 10.2441604,10.8831385 10.1941604,10.3434758 C10.1841604,10.2735195 10.1841604,10.1935694 10.1841604,10.1136194 C10.6941604,9.66390049 11.1041604,9.04428775 11.3741604,8.33473122 C11.3741604,8.33473122 11.3841604,8.2947562 11.3941604,8.28476245 C11.4541604,8.13485614 11.5041604,7.96496232 11.5441604,7.80506226 C11.8841604,7.73510598 12.0841604,7.36533709 12.1541604,7.02554946 C12.2341604,6.8856369 12.3841604,6.54584927 12.3541604,6.15609287 C12.3041604,5.65640517 12.1041604,5.42654883 11.8841604,5.33660505 L11.8841604,5.24666126 C11.8841604,4.61705477 11.8241604,3.69762941 11.7141604,3.09800417 C11.6941604,2.92811036 11.6541604,2.76821029 11.6041604,2.59831648 C11.3841604,1.86877244 10.9341604,1.19919093 10.3241604,0.739478252 C9.68416037,0.269771819 8.79416037,0.00993421722 8.00416037,0.00993421722 C7.21416037,0.00993421722 6.32416037,0.259778065 5.69416037,0.739478252 C5.08416037,1.20918469 4.63416037,1.86877244 4.41416037,2.59831648 C4.36416037,2.76821029 4.32416037,2.92811036 4.30416037,3.09800417 C4.18416037,3.69762941 4.13416037,4.60706101 4.13416037,5.24666126 L4.13416037,5.32661129 C3.89416037,5.41655508 3.68416037,5.64641142 3.63416037,6.15609287 C3.60416037,6.53585552 3.76416037,6.87564315 3.83416037,7.0155557 C3.91416037,7.36533709 4.11416037,7.73510598 4.46416037,7.79506851 C4.50416037,7.96496232 4.55416037,8.12486239 4.61416037,8.28476245 C4.61416037,8.2947562 4.62416037,8.30474996 4.62416037,8.31474371 L4.63416037,8.32473747 C4.90416037,9.04428775 5.33416037,9.67389424 5.85416037,10.1236132 C5.85416037,10.1935694 5.84416037,10.2635257 5.84416037,10.333482 C5.79416037,10.8731447 5.94416037,11.2728949 4.47416037,11.9224889 C2.99416037,12.5720829 0.774160371,13.2716456 0.314160371,14.3209898 C-0.145839629,15.370334 0.0441603707,15.9900658 0.0441603707,15.9900658 L15.9641604,15.9900658 C15.9541604,15.9999405 16.1441604,15.3803277 15.6841604,14.3309836 Z" />
  </svg>
)
Person.iconName = "Person"
export const Phone = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.9080468,12.4099384 C15.8480566,12.3499524 12.5385994,10.4104059 12.4286174,10.3604176 C12.3186355,10.3104293 12.2086535,10.2804363 12.1086699,10.2804363 C11.9586945,10.2804363 11.7687257,10.3904106 11.5387634,10.6003615 C11.3088011,10.8203101 10.5989175,11.7900833 10.388952,12.0000342 C10.1789864,12.2199828 10.0090143,12.3199594 9.86903723,12.3199594 C9.79904871,12.3199594 9.71906183,12.2999641 9.61907823,12.2599734 C9.51909463,12.2199828 8.45926845,11.680109 6.25962921,9.74056257 C4.05998997,7.81101376 3.77003753,6.54131066 3.76003917,6.19139248 C3.76003917,6.05142521 3.87002113,5.88146495 4.07998669,5.67151405 C4.29995062,5.46156314 4.5299129,5.2616099 4.77987191,5.07165431 C5.02983091,4.88169873 5.26979155,4.67174783 5.47975712,4.45179926 C5.69972104,4.22185303 5.79970464,4.03189744 5.79970464,3.88193251 C5.79970464,3.77195823 5.76970956,3.6719816 5.71971776,3.56200732 C5.66972596,3.4620307 3.67005393,0.152804506 3.60006541,0.0828208704 C3.45009,-0.0671440628 2.86018675,0.0028395727 2.56023595,0.162802168 C0.170627869,1.46249826 -0.0193409747,3.20209148 0.0106541058,3.89193017 C0.0506475465,4.60176419 0.500573754,8.35088752 4.16997194,11.8400716 C8.72922417,16.1690594 11.8987043,15.9990991 12.1086699,15.9990991 C12.7985568,15.9990991 14.9282075,15.6191879 15.8280599,13.4496952 C15.9580386,13.1297701 16.0780189,12.5798986 15.9080468,12.4099384 Z" />
  </svg>
)
Phone.iconName = "Phone"
export const PieChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.485,1.58 C3.115,2.08 0.515,4.98 0.515,8.5 C0.515,12.37 3.645,15.5 7.495,15.5 C11.015,15.5 13.915,12.89 14.405,9.5 L6.485,9.5 L6.485,1.58 Z M7.485,0.5 L7.485,8.5 L15.485,8.5 C15.485,4.08 11.905,0.5 7.485,0.5 Z" />
  </svg>
)
PieChart.iconName = "PieChart"
export const Pin = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.42,0.925 C8.91,1.435 9.01,2.425 9.57,3.485 L4.35,7.545 C2.81,6.485 1.46,6.055 0.93,6.585 L4.47,10.125 L0.93,15.075 L5.88,11.535 L9.42,15.075 C9.95,14.545 9.52,13.195 8.46,11.655 L12.52,6.435 C13.58,6.995 14.56,7.095 15.07,6.585 L9.42,0.925 Z" />
  </svg>
)
Pin.iconName = "Pin"
export const PivotTable = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,4 L1,4 C0.45,4 0,4.45 0,5 L0,15 C0,15.55 0.45,16 1,16 L2,16 C2.55,16 3,15.55 3,15 L3,5 C3,4.45 2.55,4 2,4 Z M2,0 L1,0 C0.45,0 0,0.45 0,1 L0,2 C0,2.55 0.45,3 1,3 L2,3 C2.55,3 3,2.55 3,2 L3,1 C3,0.45 2.55,0 2,0 Z M13.71,4.29 C13.53,4.11 13.28,4 13,4 C12.72,4 12.47,4.11 12.29,4.29 L10.29,6.29 C10.11,6.47 10,6.72 10,7 C10,7.55 10.45,8 11,8 C11.28,8 11.53,7.89 11.71,7.71 L12,7.41 L12,9 C12,10.66 10.66,12 9,12 L7.41,12 L7.7,11.71 C7.89,11.53 8,11.28 8,11 C8,10.45 7.55,10 7,10 C6.72,10 6.47,10.11 6.29,10.29 L4.29,12.29 C4.11,12.47 4,12.72 4,13 C4,13.28 4.11,13.53 4.29,13.71 L6.29,15.71 C6.47,15.89 6.72,16 7,16 C7.55,16 8,15.55 8,15 C8,14.72 7.89,14.47 7.71,14.29 L7.41,14 L9,14 C11.76,14 14,11.76 14,9 L14,7.41 L14.29,7.7 C14.47,7.89 14.72,8 15,8 C15.55,8 16,7.55 16,7 C16,6.72 15.89,6.47 15.71,6.29 L13.71,4.29 Z M15,0 L5,0 C4.45,0 4,0.45 4,1 L4,2 C4,2.55 4.45,3 5,3 L15,3 C15.55,3 16,2.55 16,2 L16,1 C16,0.45 15.55,0 15,0 Z" />
  </svg>
)
PivotTable.iconName = "PivotTable"
export const Pivot = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.57,7.52 L0.3,11.79 C0.11,11.97 0,12.22 0,12.5 C0,13.05 0.45,13.5 1,13.5 C1.28,13.5 1.53,13.39 1.71,13.21 L5.98,8.94 C5.4,8.59 4.91,8.1 4.57,7.52 L4.57,7.52 Z M15,8.5 C14.45,8.5 14,8.95 14,9.5 L14,10.09 L11.43,7.52 C11.09,8.1 10.6,8.59 10.02,8.93 L12.59,11.5 L12,11.5 C11.45,11.5 11,11.95 11,12.5 C11,13.05 11.45,13.5 12,13.5 L15,13.5 C15.55,13.5 16,13.05 16,12.5 L16,9.5 C16,8.95 15.55,8.5 15,8.5 Z M11,5.5 C11,3.84 9.66,2.5 8,2.5 C6.34,2.5 5,3.84 5,5.5 C5,7.16 6.34,8.5 8,8.5 C9.66,8.5 11,7.16 11,5.5 Z M8,6.5 C7.45,6.5 7,6.05 7,5.5 C7,4.95 7.45,4.5 8,4.5 C8.55,4.5 9,4.95 9,5.5 C9,6.05 8.55,6.5 8,6.5 Z" />
  </svg>
)
Pivot.iconName = "Pivot"
export const Play = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,8 C12,7.65 11.81,7.36 11.54,7.18 L11.55,7.16 L5.55,3.16 L5.54,3.18 C5.39,3.08 5.21,3 5,3 C4.45,3 4,3.45 4,4 L4,12 C4,12.55 4.45,13 5,13 C5.21,13 5.39,12.92 5.54,12.82 L5.55,12.84 L11.55,8.84 L11.54,8.82 C11.81,8.64 12,8.35 12,8 L12,8 Z" />
  </svg>
)
Play.iconName = "Play"
export const Plus = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,7 L9,7 L9,3 C9,2.45 8.55,2 8,2 C7.45,2 7,2.45 7,3 L7,7 L3,7 C2.45,7 2,7.45 2,8 C2,8.55 2.45,9 3,9 L7,9 L7,13 C7,13.55 7.45,14 8,14 C8.55,14 9,13.55 9,13 L9,9 L13,9 C13.55,9 14,8.55 14,8 C14,7.45 13.55,7 13,7 Z" />
  </svg>
)
Plus.iconName = "Plus"
export const PolygonFilter = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,5 C13.76,5 13.53,5.05 13.32,5.13 L9.97,2.34 C9.98,2.23 10,2.12 10,2 C10,0.9 9.1,0 8,0 C6.9,0 6,0.9 6,2 C6,2.04 6.01,2.08 6.01,2.12 L2.88,4.21 C2.61,4.08 2.32,4 2,4 C0.9,4 0,4.9 0,6 C0,6.74 0.4,7.38 1,7.72 L1,12.27 C0.4,12.62 0,13.26 0,14 C0,15.1 0.9,16 2,16 C2.74,16 3.38,15.6 3.72,15 L8.27,15 C8.62,15.6 9.25,16 9.99,16 C11.09,16 11.99,15.1 11.99,14 C11.99,13.63 11.88,13.3 11.71,13 L14,9 C15.11,8.99 16,8.1 16,7 C16,5.9 15.1,5 14,5 Z M9.99,12 C9.26,12 8.62,12.41 8.28,13 L3.73,13 C3.55,12.7 3.3,12.45 3,12.28 L3,7.72 C3.6,7.38 4,6.74 4,6 C4,5.96 3.99,5.92 3.99,5.88 L7.12,3.79 C7.39,3.92 7.68,4 8,4 C8.24,4 8.47,3.95 8.68,3.87 L12.03,6.66 C12.02,6.77 12,6.88 12,7 C12,7.37 12.11,7.7 12.28,8 L9.99,12 L9.99,12 Z" />
  </svg>
)
PolygonFilter.iconName = "PolygonFilter"
export const Power = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,8 C8.55,8 9,7.55 9,7 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,7 C7,7.55 7.45,8 8,8 Z M11,2.68 L11,5.02 C12.21,5.93 13,7.37 13,9 C13,11.76 10.76,14 8,14 C5.24,14 3,11.76 3,9 C3,7.37 3.79,5.94 5,5.02 L5,2.68 C2.64,3.81 1,6.21 1,9 C1,12.87 4.13,16 8,16 C11.87,16 15,12.87 15,9 C15,6.21 13.36,3.81 11,2.68 Z" />
  </svg>
)
Power.iconName = "Power"
export const Prescription = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5646889,8.34 C11.7046889,8.13 11.9246889,8 12.1946889,8 L13.4846889,8 C13.7046889,8 13.8946889,8.07 14.0046889,8.26 C14.0946889,8.42 14.0846889,8.59 13.9646889,8.79 L11.4746889,11.66 L14.2446889,15.2 C14.3646889,15.37 14.3846889,15.57 14.2646889,15.75 C14.1546889,15.92 13.9646889,16 13.7646889,16 L12.3246889,16 C12.0546889,16 11.8346889,15.86 11.7146889,15.65 L10.0546889,13.51 L8.36468893,15.66 C8.23468893,15.87 8.00468893,16 7.73468893,16 L6.45468893,16 C6.23468893,16 6.04468893,15.93 5.93468893,15.74 C5.84468893,15.58 5.85468893,15.41 5.97468893,15.21 L8.68468893,11.73 L4.95468893,6.99 L3.68468893,6.99 L3.68468893,10.46 C3.68468893,10.79 3.42468893,11.02 3.06468893,11.02 L2.26468893,11.02 C1.91468893,11.01 1.65468893,10.79 1.65468893,10.46 L1.65468893,0.56 C1.65468893,0.23 1.91468893,0 2.27468893,0 L5.38468893,0 C6.00468893,0 6.57468893,0.08 7.08468893,0.24 C7.59468893,0.4 8.04468893,0.63 8.42468893,0.93 C8.80468893,1.23 9.10468893,1.61 9.31468893,2.04 C9.52468893,2.47 9.63468893,2.95 9.63468893,3.46 C9.63468893,4.27 9.38468893,4.96 8.89468893,5.54 C8.52468893,5.98 8.05468893,6.31 7.47468893,6.55 L8.53468893,7.9 C8.57468893,7.94 8.60468893,7.98 8.61468893,8 L10.1046889,9.9 L11.5646889,8.34 Z M5.83468893,5 C6.45468893,5 6.91468893,4.87 7.22468893,4.63 C7.51468893,4.4 7.66468893,3.92 7.66468893,3.47 C7.66468893,3.02 7.51468893,2.6 7.22468893,2.37 C6.91468893,2.12 6.45468893,2 5.83468893,2 L3.64468893,2 L3.64468893,5 L5.83468893,5 Z" />
  </svg>
)
Prescription.iconName = "Prescription"
export const Presentation = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1 L9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 L1,11 C1,11.55 1.45,12 2,12 L5.59,12 L3.3,14.29 C3.11,14.47 3,14.72 3,15 C3,15.55 3.45,16 4,16 C4.28,16 4.53,15.89 4.71,15.71 L7,13.41 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,13.41 L11.29,15.7 C11.47,15.89 11.72,16 12,16 C12.55,16 13,15.55 13,15 C13,14.72 12.89,14.47 12.71,14.29 L10.41,12 L14,12 C14.55,12 15,11.55 15,11 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 Z M13,10 L3,10 L3,3 L13,3 L13,10 Z" />
  </svg>
)
Presentation.iconName = "Presentation"
export const Print = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,2 C12,1.45 11.55,1 11,1 L5,1 C4.45,1 4,1.45 4,2 L4,3 L12,3 L12,2 Z M15,4 L1,4 C0.45,4 0,4.45 0,5 L0,11 C0,11.55 0.45,12 1,12 L2,12 L2,9 L14,9 L14,12 L15,12 C15.55,12 16,11.55 16,11 L16,5 C16,4.44 15.55,4 15,4 Z M14,7 L12,7 L12,6 L14,6 L14,7 Z M11,13 L5,13 L5,10 L3,10 L3,14 C3,14.55 3.45,15 4,15 L12,15 C12.55,15 13,14.55 13,14 L13,10 L11,10 L11,13 Z" />
  </svg>
)
Print.iconName = "Print"
export const Projects = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,3 C14,2.45 13.55,2 13,2 L3,2 C2.45,2 2,2.45 2,3 L2,4 L14,4 L14,3 Z M12,0 L4,0 C3.45,0 3,0.45 3,1 L13,1 C13,0.45 12.55,0 12,0 Z M15,5 L1,5 C0.45,5 0,5.45 0,6 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,6 C16,5.45 15.55,5 15,5 Z M12,11 C12,11.55 11.55,12 11,12 L5,12 C4.45,12 4,11.55 4,11 L4,9 L5,9 L5,11 L11,11 L11,9 L12,9 L12,11 Z" />
  </svg>
)
Projects.iconName = "Projects"
export const Properties = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C3.1,10 4,9.1 4,8 C4,6.9 3.1,6 2,6 Z M6,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L6,1 C5.45,1 5,1.45 5,2 C5,2.55 5.45,3 6,3 Z M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 Z M15,7 L6,7 C5.45,7 5,7.45 5,8 C5,8.55 5.45,9 6,9 L15,9 C15.55,9 16,8.55 16,8 C16,7.45 15.55,7 15,7 Z M15,13 L6,13 C5.45,13 5,13.45 5,14 C5,14.55 5.45,15 6,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z" />
  </svg>
)
Properties.iconName = "Properties"
export const Property = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3,12 C1.9,12 1,12.9 1,14 C1,15.1 1.9,16 3,16 C4.1,16 5,15.1 5,14 C5,12.9 4.1,12 3,12 Z M2.5,5.5 C1.12,5.5 0,6.62 0,8 C0,9.38 1.12,10.5 2.5,10.5 C3.88,10.5 5,9.38 5,8 C5,6.62 3.88,5.5 2.5,5.5 Z M7,3 L15,3 C15.55,3 16,2.55 16,2 C16,1.45 15.55,1 15,1 L7,1 C6.45,1 6,1.45 6,2 C6,2.55 6.45,3 7,3 Z M15,13 L7,13 C6.45,13 6,13.45 6,14 C6,14.55 6.45,15 7,15 L15,15 C15.55,15 16,14.55 16,14 C16,13.45 15.55,13 15,13 Z M3,0 C1.9,0 1,0.9 1,2 C1,3.1 1.9,4 3,4 C4.1,4 5,3.1 5,2 C5,0.9 4.1,0 3,0 Z M15,6 L7,6 C6.45,6 6,6.45 6,7 L6,9 C6,9.55 6.45,10 7,10 L15,10 C15.55,10 16,9.55 16,9 L16,7 C16,6.45 15.55,6 15,6 Z" />
  </svg>
)
Property.iconName = "Property"
export const PublishFunction = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.16,3.76 C12.31,3.65 12.46,3.6 12.63,3.6 C12.69,3.6 12.8,3.62 12.97,3.66 C13.13,3.7 13.28,3.72 13.4,3.72 C13.57,3.72 13.72,3.66 13.83,3.55 C13.94,3.44 14,3.3 14,3.12 C14,2.93 13.94,2.79 13.83,2.68 C13.72,2.57 13.55,2.52 13.34,2.52 C13.15,2.52 12.97,2.56 12.8,2.65 C12.63,2.74 12.41,2.92 12.15,3.2 C11.95,3.41 11.67,3.78 11.28,4.31 C11.13,3.66 10.87,3.06 10.5,2.52 L8.45,2.84 L8.41,3.05 C8.56,3.02 8.69,3.01 8.8,3.01 C9,3.01 9.17,3.09 9.3,3.26 C9.51,3.52 9.8,4.29 10.18,5.59 C9.89,5.95 9.69,6.19 9.58,6.3 C9.4,6.49 9.25,6.61 9.13,6.66 C9.04,6.7 8.94,6.73 8.83,6.73 C8.74,6.73 8.6,6.69 8.41,6.6 C8.27,6.54 8.16,6.51 8.05,6.51 C7.85,6.51 7.69,6.57 7.56,6.69 C7.43,6.81 7.37,6.96 7.37,7.15 C7.37,7.33 7.43,7.47 7.55,7.58 C7.67,7.69 7.83,7.74 8.03,7.74 C8.23,7.74 8.41,7.7 8.58,7.62 C8.75,7.54 8.97,7.38 9.23,7.13 C9.49,6.88 9.85,6.48 10.3,5.94 C10.48,6.46 10.63,6.83 10.76,7.07 C10.89,7.31 11.04,7.47 11.2,7.58 C11.37,7.68 11.57,7.74 11.82,7.74 C12.06,7.74 12.31,7.66 12.56,7.49 C12.89,7.28 13.22,6.91 13.57,6.4 L13.36,6.29 C13.13,6.6 12.95,6.79 12.84,6.86 C12.77,6.91 12.68,6.93 12.58,6.93 C12.46,6.93 12.34,6.86 12.22,6.72 C12.02,6.48 11.76,5.81 11.42,4.72 C11.71,4.23 11.96,3.91 12.16,3.76 L12.16,3.76 Z M6.37,5.83 L7.05,3.3 L7.88,3.3 L8.08,2.66 L7.24,2.66 C7.48,1.75 7.8,1.07 8.2,0.65 C8.44,0.38 8.68,0.25 8.91,0.25 C8.96,0.25 8.99,0.26 9.02,0.29 C9.05,0.32 9.06,0.35 9.06,0.39 C9.06,0.43 9.03,0.5 8.96,0.6 C8.9,0.7 8.86,0.8 8.86,0.89 C8.86,1.02 8.91,1.13 9.01,1.22 C9.11,1.31 9.24,1.36 9.4,1.36 C9.57,1.36 9.71,1.3 9.82,1.19 C9.94,1.07 10,0.92 10,0.73 C10,0.52 9.92,0.34 9.75,0.21 C9.57,0.07 9.3,0 8.93,0 C8.34,0 7.81,0.16 7.34,0.48 C6.86,0.8 6.41,1.33 5.98,2.07 C5.83,2.33 5.69,2.49 5.56,2.56 C5.43,2.63 5.21,2.67 4.92,2.66 L4.73,3.31 L5.54,3.31 L4.35,7.68 C4.15,8.4 4.02,8.84 3.95,9.01 C3.85,9.25 3.69,9.46 3.49,9.63 C3.4,9.7 3.3,9.73 3.18,9.73 C3.15,9.73 3.12,9.72 3.1,9.7 L3.07,9.67 C3.07,9.65 3.1,9.61 3.16,9.56 C3.22,9.5 3.25,9.41 3.25,9.3 C3.25,9.17 3.2,9.07 3.11,8.98 C3.01,8.89 2.88,8.85 2.7,8.85 C2.49,8.85 2.32,8.9 2.19,9.01 C2.06,9.13 2,9.26 2,9.4 C2,9.56 2.08,9.7 2.23,9.82 C2.39,9.94 2.63,10 2.97,10 C3.5,10 3.96,9.87 4.37,9.61 C4.78,9.35 5.13,8.96 5.44,8.42 C5.74,7.89 6.05,7.03 6.37,5.83 L6.37,5.83 Z M8.71,9.29 C8.53,9.11 8.28,9 8,9 C7.72,9 7.47,9.11 7.29,9.29 L5.29,11.29 C5.11,11.47 5,11.72 5,12 C5,12.55 5.45,13 6,13 C6.28,13 6.53,12.89 6.71,12.71 L7,12.41 L7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,12.41 L9.29,12.7 C9.47,12.89 9.72,13 10,13 C10.55,13 11,12.55 11,12 C11,11.72 10.89,11.47 10.71,11.29 L8.71,9.29 Z" />
  </svg>
)
PublishFunction.iconName = "PublishFunction"
export const Pulse = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,8 L13.54,8 L11.84,5.45 L11.82,5.46 C11.64,5.19 11.35,5 11,5 C10.57,5 10.21,5.27 10.07,5.65 L10.06,5.65 L8.37,10.16 L6.99,1.84 L6.97,1.84 C6.89,1.37 6.5,1 6,1 C5.59,1 5.23,1.25 5.08,1.61 L2.34,8 L1,8 C0.45,8 0,8.45 0,9 C0,9.55 0.45,10 1,10 L3,10 C3.41,10 3.77,9.75 3.92,9.39 L5.57,5.53 L7.01,14.16 L7.03,14.16 C7.11,14.63 7.5,15 8,15 C8.43,15 8.79,14.73 8.93,14.35 L8.94,14.35 L11.25,8.18 L12.17,9.56 L12.19,9.55 C12.36,9.81 12.65,10 13,10 L15,10 C15.55,10 16,9.55 16,9 C16,8.45 15.55,8 15,8 Z" />
  </svg>
)
Pulse.iconName = "Pulse"
export const Random = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.48,4 L12.59,4 L12.3,4.29 C12.11,4.47 12,4.72 12,5 C12,5.55 12.45,6 13,6 C13.28,6 13.53,5.89 13.71,5.71 L15.71,3.71 C15.89,3.53 16,3.28 16,3 C16,2.72 15.89,2.47 15.71,2.29 L13.71,0.29 C13.53,0.11 13.28,0 13,0 C12.45,0 12,0.45 12,1 C12,1.28 12.11,1.53 12.29,1.71 L12.59,2 L11,2 C10.68,2 10.41,2.16 10.23,2.38 L10.22,2.37 L8.28,4.8 L9.56,6.4 L11.48,4 Z M13.71,10.29 C13.53,10.11 13.28,10 13,10 C12.45,10 12,10.45 12,11 C12,11.28 12.11,11.53 12.29,11.71 L12.59,12 L11.48,12 L3.78,2.38 L3.77,2.38 C3.59,2.16 3.32,2 3,2 L1,2 C0.45,2 0,2.45 0,3 C0,3.55 0.45,4 1,4 L2.52,4 L10.22,13.62 L10.23,13.61 C10.41,13.84 10.68,14 11,14 L12.59,14 L12.3,14.29 C12.11,14.47 12,14.72 12,15 C12,15.55 12.45,16 13,16 C13.28,16 13.53,15.89 13.71,15.71 L15.71,13.71 C15.89,13.53 16,13.28 16,13 C16,12.72 15.89,12.47 15.71,12.29 L13.71,10.29 Z M2.52,12 L1,12 C0.45,12 0,12.45 0,13 C0,13.55 0.45,14 1,14 L3,14 C3.32,14 3.59,13.84 3.77,13.62 L3.78,13.63 L5.72,11.21 L4.44,9.6 L2.52,12 Z" />
  </svg>
)
Random.iconName = "Random"
export const Record = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,3 C5.23857625,3 3,5.23857625 3,8 C3,10.7614237 5.23857625,13 8,13 C10.7614237,13 13,10.7614237 13,8 C13,5.23857625 10.7614237,3 8,3 L8,3 Z" />
  </svg>
)
Record.iconName = "Record"
export const Redo = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,11 C10.9,11 10,11.9 10,13 C10,14.1 10.9,15 12,15 C13.1,15 14,14.1 14,13 C14,11.9 13.1,11 12,11 Z M15.71,4.29 L12.71,1.29 C12.53,1.11 12.28,1 12,1 C11.45,1 11,1.45 11,2 C11,2.28 11.11,2.53 11.29,2.71 L12.59,4 L5,4 C2.24,4 0,6.24 0,9 C0,11.76 2.24,14 5,14 L9,14 L9,12 L5,12 C3.34,12 2,10.66 2,9 C2,7.34 3.34,6 5,6 L12.59,6 L11.3,7.29 C11.11,7.47 11,7.72 11,8 C11,8.55 11.45,9 12,9 C12.28,9 12.53,8.89 12.71,8.71 L15.71,5.71 C15.89,5.53 16,5.28 16,5 C16,4.72 15.89,4.47 15.71,4.29 Z" />
  </svg>
)
Redo.iconName = "Redo"
export const Refresh = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.9956277,7.00062461 C14.4459713,7.00062461 13.9962523,7.45034354 13.9962523,8 C13.9962523,11.3079325 11.3079325,13.9962523 8,13.9962523 C6.23110556,13.9962523 4.64209869,13.2167395 3.54278576,11.9975016 L5.00187383,11.9975016 C5.55153029,11.9975016 6.00124922,11.5477826 6.00124922,10.9981262 C6.00124922,10.4484697 5.55153029,9.99875078 5.00187383,9.99875078 L1.00437227,9.99875078 C0.454715803,9.99875078 0.00499687695,10.4484697 0.00499687695,10.9981262 L0.00499687695,14.9956277 C0.00499687695,15.5452842 0.454715803,15.9950031 1.00437227,15.9950031 C1.55402873,15.9950031 2.00374766,15.5452842 2.00374766,14.9956277 L2.00374766,13.2567146 C3.46283573,14.9256715 5.60149906,15.9950031 8,15.9950031 C12.4172392,15.9950031 15.9950031,12.4172392 15.9950031,8 C15.9950031,7.45034354 15.5452842,7.00062461 14.9956277,7.00062461 Z M14.9956277,0.00499687695 C14.4459713,0.00499687695 13.9962523,0.454715803 13.9962523,1.00437227 L13.9962523,2.74328545 C12.5371643,1.07432854 10.3985009,0.00499687695 8,0.00499687695 C3.58276077,0.00499687695 0.00499687695,3.58276077 0.00499687695,8 C0.00499687695,8.54965646 0.454715803,8.99937539 1.00437227,8.99937539 C1.55402873,8.99937539 2.00374766,8.54965646 2.00374766,8 C2.00374766,4.69206746 4.69206746,2.00374766 8,2.00374766 C9.76889444,2.00374766 11.3579013,2.78326046 12.4572142,4.00249844 L10.9981262,4.00249844 C10.4484697,4.00249844 9.99875078,4.45221736 9.99875078,5.00187383 C9.99875078,5.55153029 10.4484697,6.00124922 10.9981262,6.00124922 L14.9956277,6.00124922 C15.5452842,6.00124922 15.9950031,5.55153029 15.9950031,5.00187383 L15.9950031,1.00437227 C15.9950031,0.454715803 15.5452842,0.00499687695 14.9956277,0.00499687695 Z" />
  </svg>
)
Refresh.iconName = "Refresh"
export const RegressionChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,6.5 C13,7.33 13.67,8 14.5,8 C15.33,8 16,7.33 16,6.5 C16,5.67 15.33,5 14.5,5 C13.67,5 13,5.67 13,6.5 Z M8.5,5 C9.33,5 10,4.33 10,3.5 C10,2.67 9.33,2 8.5,2 C7.67,2 7,2.67 7,3.5 C7,4.33 7.67,5 8.5,5 Z M9,9.5 C9,10.33 9.67,11 10.5,11 C11.33,11 12,10.33 12,9.5 C12,8.67 11.33,8 10.5,8 C9.67,8 9,8.67 9,9.5 Z M4.5,8 C5.33,8 6,7.33 6,6.5 C6,5.67 5.33,5 4.5,5 C3.67,5 3,5.67 3,6.5 C3,7.33 3.67,8 4.5,8 Z M15,12 L3.26,12 L15.29,3.41 L14.71,2.6 L2,11.67 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z" />
  </svg>
)
RegressionChart.iconName = "RegressionChart"
export const RemoveColumnLeft = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,9 L8,9 C8.55,9 9,8.55 9,8 C9,7.45 8.55,7 8,7 L4,7 C3.45,7 3,7.45 3,8 C3,8.55 3.45,9 4,9 Z M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M10,14 L2,14 L2,2 L10,2 L10,14 Z M14,14 L11,14 L11,2 L14,2 L14,14 Z" />
  </svg>
)
RemoveColumnLeft.iconName = "RemoveColumnLeft"
export const RemoveColumnRight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M5,14 L2,14 L2,2 L5,2 L5,14 Z M14,14 L6,14 L6,2 L14,2 L14,14 Z M8,9 L12,9 C12.55,9 13,8.55 13,8 C13,7.45 12.55,7 12,7 L8,7 C7.45,7 7,7.45 7,8 C7,8.55 7.45,9 8,9 Z" />
  </svg>
)
RemoveColumnRight.iconName = "RemoveColumnRight"
export const RemoveColumn = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,0 L4.5,0 C3.95,0 3.5,0.45 3.5,1 L3.5,4 L5.5,4 L5.5,2 L8.5,2 L8.5,14 L5.5,14 L5.5,12 L3.5,12 L3.5,15 C3.5,15.55 3.95,16 4.5,16 L14.5,16 C15.05,16 15.5,15.55 15.5,15 L15.5,1 C15.5,0.45 15.05,0 14.5,0 Z M13.5,14 L10.5,14 L10.5,2 L13.5,2 L13.5,14 Z M4.79,10.71 C4.97,10.89 5.22,11 5.5,11 C6.05,11 6.5,10.55 6.5,10 C6.5,9.72 6.39,9.47 6.21,9.29 L4.91,8 L6.2,6.71 C6.39,6.53 6.5,6.28 6.5,6 C6.5,5.45 6.05,5 5.5,5 C5.22,5 4.97,5.11 4.79,5.29 L3.5,6.59 L2.21,5.29 C2.03,5.11 1.78,5 1.5,5 C0.95,5 0.5,5.45 0.5,6 C0.5,6.28 0.61,6.53 0.79,6.71 L2.09,8 L0.79,9.29 C0.61,9.47 0.5,9.72 0.5,10 C0.5,10.55 0.95,11 1.5,11 C1.78,11 2.03,10.89 2.21,10.71 L3.5,9.41 L4.79,10.71 Z" />
  </svg>
)
RemoveColumn.iconName = "RemoveColumn"
export const RemoveRowBottom = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M14,14 L2,14 L2,6 L14,6 L14,14 Z M14,5 L2,5 L2,2 L14,2 L14,5 Z M6,11 L10,11 C10.55,11 11,10.55 11,10 C11,9.45 10.55,9 10,9 L6,9 C5.45,9 5,9.45 5,10 C5,10.55 5.45,11 6,11 Z" />
  </svg>
)
RemoveRowBottom.iconName = "RemoveRowBottom"
export const RemoveRowTop = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,1 C16,0.45 15.55,0 15,0 Z M14,14 L2,14 L2,11 L14,11 L14,14 Z M14,10 L2,10 L2,2 L14,2 L14,10 Z M6,7 L10,7 C10.55,7 11,6.55 11,6 C11,5.45 10.55,5 10,5 L6,5 C5.45,5 5,5.45 5,6 C5,6.55 5.45,7 6,7 Z" />
  </svg>
)
RemoveRowTop.iconName = "RemoveRowTop"
export const Remove = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.9981262,7.00062461 L5.00187383,7.00062461 C4.45221736,7.00062461 4.00249844,7.45034354 4.00249844,8 C4.00249844,8.54965646 4.45221736,8.99937539 5.00187383,8.99937539 L10.9981262,8.99937539 C11.5477826,8.99937539 11.9975016,8.54965646 11.9975016,8 C11.9975016,7.45034354 11.5477826,7.00062461 10.9981262,7.00062461 Z M8,0.00499687695 C3.58276077,0.00499687695 0.00499687695,3.58276077 0.00499687695,8 C0.00499687695,12.4172392 3.58276077,15.9950031 8,15.9950031 C12.4172392,15.9950031 15.9950031,12.4172392 15.9950031,8 C15.9950031,3.58276077 12.4172392,0.00499687695 8,0.00499687695 Z M8,13.9962523 C4.69206746,13.9962523 2.00374766,11.3079325 2.00374766,8 C2.00374766,4.69206746 4.69206746,2.00374766 8,2.00374766 C11.3079325,2.00374766 13.9962523,4.69206746 13.9962523,8 C13.9962523,11.3079325 11.3179263,13.9962523 8,13.9962523 Z" />
  </svg>
)
Remove.iconName = "Remove"
export const Repeat = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,5 C10,5.55 10.45,6 11,6 L15,6 C15.55,6 16,5.55 16,5 L16,1 C16,0.45 15.55,0 15,0 C14.45,0 14,0.45 14,1 L14,2.74 C12.54,1.07 10.4,0 8,0 C3.58,0 0,3.58 0,8 C0,12.06 3.02,15.4 6.94,15.92 C6.96,15.92 6.98,15.93 7,15.93 C7.33,15.97 7.66,16 8,16 C12.42,16 16,12.42 16,8 C16,7.45 15.55,7 15,7 C14.45,7 14,7.45 14,8 C14,11.31 11.31,14 8,14 C7.29,14 6.63,13.85 6,13.62 L6,13.63 C3.67,12.81 2,10.61 2,8 C2,4.69 4.69,2 8,2 C9.77,2 11.36,2.78 12.46,4 L11,4 C10.45,4 10,4.45 10,5 Z" />
  </svg>
)
Repeat.iconName = "Repeat"
export const Resolve = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.6,3.3 C6.1,3.1 5.6,3 5,3 C2.2,3 0,5.2 0,8 C0,10.8 2.2,13 5,13 C5.6,13 6.1,12.9 6.6,12.7 C5.3,11.6 4.5,9.9 4.5,8 C4.5,6.1 5.3,4.4 6.6,3.3 Z M8,4 C6.8,4.9 6,6.4 6,8 C6,9.6 6.8,11.1 8,12 C9.2,11.1 10,9.7 10,8 C10,6.3 9.2,4.9 8,4 Z M11,3 C10.4,3 9.9,3.1 9.4,3.3 C10.7,4.5 11.5,6.2 11.5,8 C11.5,9.8 10.7,11.6 9.4,12.7 C9.9,12.9 10.4,13 11,13 C13.8,13 16,10.8 16,8 C16,5.2 13.8,3 11,3 Z" />
  </svg>
)
Resolve.iconName = "Resolve"
export const Rig = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.71,3 C5.71,4.1 6.67,5 7.85,5 C9.04,5 10,3.96 10,3 C10,1.04 8.53,0 7.86,0 L5,0 C5,1.96 7.68,1.4 5.71,3 Z M8.21,6 L8.22,6.01 C8.22,6.01 8.22,6 8.21,6 Z M14.71,14.29 L10,9.59 L10,7 C10,6.45 9.55,6 9,6 L7,6 C6.45,6 6,6.45 6,7 L6,9.58 L1.29,14.28 C1.11,14.47 1,14.72 1,15 C1,15.55 1.45,16 2,16 C2.28,16 2.53,15.89 2.71,15.71 L6,12.42 L6,15 C6,15.55 6.45,16 7,16 L9,16 C9.55,16 10,15.55 10,15 L10,12.42 L13.29,15.71 C13.47,15.89 13.72,16 14,16 C14.55,16 15,15.55 15,15 C15,14.72 14.89,14.47 14.71,14.29 Z" />
  </svg>
)
Rig.iconName = "Rig"
export const RightJoin = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.6,3.3 C5.3,4.4 4.5,6.1 4.5,8 C4.5,9.9 5.3,11.6 6.6,12.7 C6.1,12.9 5.6,13 5,13 C2.2,13 0,10.8 0,8 C0,5.2 2.2,3 5,3 C5.6,3 6.1,3.1 6.6,3.3 Z M4.64,11.98 C3.92,10.83 3.5,9.46 3.5,8 C3.5,6.54 3.92,5.17 4.64,4.02 C2.6,4.2 1,5.91 1,8 C1,10.09 2.6,11.8 4.64,11.98 L4.64,11.98 Z M8,4 C6.8,4.9 6,6.4 6,8 C6,9.6 6.8,11.1 8,12 C9.2,11.1 10,9.7 10,8 C10,6.3 9.2,4.9 8,4 Z M11,3 C13.8,3 16,5.2 16,8 C16,10.8 13.8,13 11,13 C10.4,13 9.9,12.9 9.4,12.7 C10.7,11.6 11.5,9.8 11.5,8 C11.5,6.2 10.7,4.5 9.4,3.3 C9.9,3.1 10.4,3 11,3 Z" />
  </svg>
)
RightJoin.iconName = "RightJoin"
export const Ring = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,12 C5.79,12 4,10.21 4,8 C4,5.79 5.79,4 8,4 C10.21,4 12,5.79 12,8 C12,10.21 10.21,12 8,12 Z" />
  </svg>
)
Ring.iconName = "Ring"
export const RotateDocument = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.5,2 L10.91,2 L11.2,1.71 C11.39,1.53 11.5,1.28 11.5,1 C11.5,0.45 11.05,0 10.5,0 C10.22,0 9.97,0.11 9.79,0.29 L7.79,2.29 C7.61,2.47 7.5,2.72 7.5,3 C7.5,3.28 7.61,3.53 7.79,3.71 L9.79,5.71 C9.97,5.89 10.22,6 10.5,6 C11.05,6 11.5,5.55 11.5,5 C11.5,4.72 11.39,4.47 11.21,4.29 L10.91,4 L12.5,4 C13.05,4 13.5,4.45 13.5,5 L13.5,8 C13.5,8.55 13.95,9 14.5,9 C15.05,9 15.5,8.55 15.5,8 L15.5,5 C15.5,3.34 14.16,2 12.5,2 Z M6.21,5.29 C6.03,5.11 5.78,5 5.5,5 L1.5,5 C0.95,5 0.5,5.45 0.5,6 L0.5,15 C0.5,15.55 0.95,16 1.5,16 L8.5,16 C9.05,16 9.5,15.55 9.5,15 L9.5,9 C9.5,8.72 9.39,8.47 9.21,8.29 L6.21,5.29 Z M7.5,14 L2.5,14 L2.5,7 L4.5,7 L4.5,9 C4.5,9.55 4.95,10 5.5,10 L7.5,10 L7.5,14 Z" />
  </svg>
)
RotateDocument.iconName = "RotateDocument"
export const RotatePage = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,6 L2,6 C1.45,6 1,6.45 1,7 L1,15 C1,15.55 1.45,16 2,16 L8,16 C8.55,16 9,15.55 9,15 L9,7 C9,6.45 8.55,6 8,6 Z M7,14 L3,14 L3,8 L7,8 L7,14 Z M12,2 L10.41,2 L10.7,1.71 C10.89,1.53 11,1.28 11,1 C11,0.45 10.55,0 10,0 C9.72,0 9.47,0.11 9.29,0.29 L7.29,2.29 C7.11,2.47 7,2.72 7,3 C7,3.28 7.11,3.53 7.29,3.71 L9.29,5.71 C9.47,5.89 9.72,6 10,6 C10.55,6 11,5.55 11,5 C11,4.72 10.89,4.47 10.71,4.29 L10.41,4 L12,4 C12.55,4 13,4.45 13,5 L13,8 C13,8.55 13.45,9 14,9 C14.55,9 15,8.55 15,8 L15,5 C15,3.34 13.66,2 12,2 Z" />
  </svg>
)
RotatePage.iconName = "RotatePage"
export const Satellite = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3,9 C3,8.4 3.4,8 4,8 C4.6,8 5,8.4 5,9 C5,10.1 5.9,11 7,11 C7.6,11 8,11.4 8,12 C8,12.6 7.6,13 7,13 C4.8,13 3,11.2 3,9 Z M9e-16,9 C9e-16,8.4 0.4,8 1,8 C1.6,8 2,8.4 2,9 C2,11.8 4.2,14 7,14 C7.6,14 8,14.4 8,15 C8,15.6 7.6,16 7,16 C3.1,16 9e-16,12.9 9e-16,9 Z M7,10 C6.4,10 6,9.6 6,9 C6,8.4 6.4,8 7,8 C7.6,8 8,8.4 8,9 C8,9.6 7.6,10 7,10 Z M8.3,7.2 C7.9,6.8 7.9,6.2 8.3,5.8 L12.8,1.3 C13.2,0.9 13.8,0.9 14.2,1.3 L14.7,1.8 C15.1,2.2 15.1,2.8 14.7,3.2 L10.2,7.7 C9.8,8.1 9.2,8.1 8.8,7.7 L8.3,7.2 L8.3,7.2 Z M5.2,0.3 C5.6,-0.1 6.2,-0.1 6.6,0.3 L8.7,2.4 C9.1,2.8 9.1,3.4 8.7,3.8 L7.8,4.7 C7.4,5.1 6.8,5.1 6.4,4.7 L4.3,2.6 C3.9,2.2 3.9,1.6 4.3,1.2 L5.2,0.3 Z M12.2,7.3 C12.6,6.9 13.2,6.9 13.6,7.3 L15.7,9.4 C16.1,9.8 16.1,10.4 15.7,10.8 L14.8,11.7 C14.4,12.1 13.8,12.1 13.4,11.7 L11.3,9.6 C10.9,9.2 10.9,8.6 11.3,8.2 L12.2,7.3 Z" />
  </svg>
)
Satellite.iconName = "Satellite"
export const Saved = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.71,9.29 C6.53,9.11 6.28,9 6,9 C5.45,9 5,9.45 5,10 C5,10.28 5.11,10.53 5.29,10.71 L7.29,12.71 C7.47,12.89 7.72,13 8,13 C8.39,13 8.72,12.77 8.89,12.44 L8.9,12.44 L10.9,8.44 L10.89,8.44 C10.95,8.31 11,8.16 11,8 C11,7.45 10.55,7 10,7 C9.61,7 9.28,7.23 9.11,7.56 L9.1,7.56 L7.72,10.32 L6.71,9.29 Z M9,0 L3,0 C2.45,0 2,0.45 2,1 L2,15 C2,15.55 2.45,16 3,16 L13,16 C13.55,16 14,15.55 14,15 L14,5 L9,0 Z M12,14 L4,14 L4,2 L8,2 L8,6 L12,6 L12,14 Z" />
  </svg>
)
Saved.iconName = "Saved"
export const ScatterPlot = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,12 L2,12 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z M14.5,5 C15.33,5 16,4.33 16,3.5 C16,2.67 15.33,2 14.5,2 C13.67,2 13,2.67 13,3.5 C13,4.33 13.67,5 14.5,5 Z M11.5,9 C12.33,9 13,8.33 13,7.5 C13,6.67 12.33,6 11.5,6 C10.67,6 10,6.67 10,7.5 C10,8.33 10.67,9 11.5,9 Z M7.5,7 C8.33,7 9,6.33 9,5.5 C9,4.67 8.33,4 7.5,4 C6.67,4 6,4.67 6,5.5 C6,6.33 6.67,7 7.5,7 Z M4.5,11 C5.33,11 6,10.33 6,9.5 C6,8.67 5.33,8 4.5,8 C3.67,8 3,8.67 3,9.5 C3,10.33 3.67,11 4.5,11 Z" />
  </svg>
)
ScatterPlot.iconName = "ScatterPlot"
export const SearchAround = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.5,11 C12.99,11 12.52,11.15 12.12,11.42 L9.72,9.01 C9.89,8.71 10,8.37 10,8 C10,7.63 9.89,7.29 9.72,6.99 L12.13,4.58 C12.52,4.85 12.99,5 13.5,5 C14.88,5 16,3.88 16,2.5 C16,1.12 14.88,0 13.5,0 C12.12,0 11,1.12 11,2.5 C11,3.01 11.15,3.48 11.42,3.88 L9.01,6.28 C8.71,6.11 8.37,6 8,6 C7.63,6 7.29,6.11 6.99,6.28 L4.58,3.88 C4.85,3.48 5,3.01 5,2.5 C5,1.12 3.88,0 2.5,0 C1.12,0 0,1.12 0,2.5 C0,3.88 1.12,5 2.5,5 C3.01,5 3.48,4.85 3.88,4.58 L6.29,6.99 C6.11,7.29 6,7.63 6,8 C6,8.37 6.11,8.71 6.28,9.01 L3.87,11.42 C3.48,11.15 3.01,11 2.5,11 C1.12,11 0,12.12 0,13.5 C0,14.88 1.12,16 2.5,16 C3.88,16 5,14.88 5,13.5 C5,12.99 4.85,12.52 4.58,12.12 L6.99,9.71 C7.29,9.89 7.63,10 8,10 C8.37,10 8.71,9.89 9.01,9.72 L11.42,12.13 C11.15,12.52 11,12.99 11,13.5 C11,14.88 12.12,16 13.5,16 C14.88,16 16,14.88 16,13.5 C16,12.12 14.88,11 13.5,11 Z M13.5,1 C14.33,1 15,1.67 15,2.5 C15,3.33 14.33,4 13.5,4 C12.67,4 12,3.33 12,2.5 C12,1.67 12.67,1 13.5,1 Z M2.5,4 C1.67,4 1,3.33 1,2.5 C1,1.67 1.67,1 2.5,1 C3.33,1 4,1.67 4,2.5 C4,3.33 3.33,4 2.5,4 Z M2.5,15 C1.67,15 1,14.33 1,13.5 C1,12.67 1.67,12 2.5,12 C3.33,12 4,12.67 4,13.5 C4,14.33 3.33,15 2.5,15 Z M13.5,15 C12.67,15 12,14.33 12,13.5 C12,12.67 12.67,12 13.5,12 C14.33,12 15,12.67 15,13.5 C15,14.33 14.33,15 13.5,15 Z" />
  </svg>
)
SearchAround.iconName = "SearchAround"
export const SearchTemplate = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.555278,13.4366021 L12.8869457,10.7682698 C13.5865084,9.67895066 13.9962523,8.3897564 13.9962523,7.00062461 C13.9962523,3.13304185 10.8682074,0.00499687695 7.00062461,0.00499687695 C3.13304185,0.00499687695 0.00499687695,3.13304185 0.00499687695,7.00062461 C0.00499687695,10.8682074 3.13304185,13.9962523 7.00062461,13.9962523 C8.3897564,13.9962523 9.67895066,13.5865084 10.7682698,12.8869457 L13.4366021,15.555278 C13.7064335,15.8251093 14.0861961,15.9950031 14.49594,15.9950031 C15.3254216,15.9950031 15.9950031,15.3254216 15.9950031,14.49594 C15.9950031,14.0861961 15.8251093,13.7064335 15.555278,13.4366021 Z M7.00062461,11.9975016 C4.24234853,11.9975016 2.00374766,9.75890069 2.00374766,7.00062461 C2.00374766,4.24234853 4.24234853,2.00374766 7.00062461,2.00374766 C9.75890069,2.00374766 11.9975016,4.24234853 11.9975016,7.00062461 C11.9975016,9.75890069 9.75890069,11.9975016 7.00062461,11.9975016 Z M9.49906309,6.00124922 L4.50218613,6.00124922 C4.22236102,6.00124922 4.00249844,6.22111181 4.00249844,6.50093691 C4.00249844,6.78076202 4.22236102,7.00062461 4.50218613,7.00062461 L9.49906309,7.00062461 C9.77888819,7.00062461 9.99875078,6.78076202 9.99875078,6.50093691 C9.99875078,6.22111181 9.77888819,6.00124922 9.49906309,6.00124922 Z M9.49906309,4.00249844 L4.50218613,4.00249844 C4.22236102,4.00249844 4.00249844,4.22236102 4.00249844,4.50218613 C4.00249844,4.78201124 4.22236102,5.00187383 4.50218613,5.00187383 L9.49906309,5.00187383 C9.77888819,5.00187383 9.99875078,4.78201124 9.99875078,4.50218613 C9.99875078,4.22236102 9.77888819,4.00249844 9.49906309,4.00249844 Z M9.49906309,8 L4.50218613,8 C4.22236102,8 4.00249844,8.21986259 4.00249844,8.4996877 C4.00249844,8.7795128 4.22236102,8.99937539 4.50218613,8.99937539 L9.49906309,8.99937539 C9.77888819,8.99937539 9.99875078,8.7795128 9.99875078,8.4996877 C9.99875078,8.21986259 9.77888819,8 9.49906309,8 Z" />
  </svg>
)
SearchTemplate.iconName = "SearchTemplate"
export const SearchText = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9,4 L5,4 C4.45,4 4,4.45 4,5 C4,5.55 4.45,6 5,6 L6,6 L6,9 C6,9.55 6.45,10 7,10 C7.55,10 8,9.55 8,9 L8,6 L9,6 C9.55,6 10,5.55 10,5 C10,4.45 9.55,4 9,4 Z M15.56,13.44 L12.89,10.77 C13.59,9.68 14,8.39 14,7 C14,3.13 10.87,0 7,0 C3.13,0 0,3.13 0,7 C0,10.87 3.13,14 7,14 C8.39,14 9.68,13.59 10.77,12.89 L13.44,15.56 C13.71,15.83 14.09,16 14.5,16 C15.33,16 16,15.33 16,14.5 C16,14.09 15.83,13.71 15.56,13.44 Z M7,12 C4.24,12 2,9.76 2,7 C2,4.24 4.24,2 7,2 C9.76,2 12,4.24 12,7 C12,9.76 9.76,12 7,12 Z" />
  </svg>
)
SearchText.iconName = "SearchText"
export const Search = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.5502811,13.4316052 L12.8819488,10.7532792 C13.5815116,9.66396002 13.9912555,8.37476577 13.9912555,6.99562773 C13.9912555,3.12804497 10.8632105,-1.77635684e-15 6.99562773,-1.77635684e-15 C3.12804497,-1.77635684e-15 5.5067062e-14,3.12804497 5.5067062e-14,6.99562773 C5.5067062e-14,10.8632105 3.12804497,13.9912555 6.99562773,13.9912555 C8.38475953,13.9912555 9.67395378,13.5715178 10.7532792,12.8819488 L13.4316052,15.5502811 C13.7014366,15.8201124 14.0811993,15.9900062 14.4909432,15.9900062 C15.3204247,15.9900062 15.9900062,15.3204247 15.9900062,14.4909432 C15.9900062,14.0811993 15.8201124,13.7014366 15.5502811,13.4316052 Z M6.99562773,11.9925047 C4.23735166,11.9925047 1.99875078,9.75390381 1.99875078,6.99562773 C1.99875078,4.23735166 4.23735166,1.99875078 6.99562773,1.99875078 C9.75390381,1.99875078 11.9925047,4.23735166 11.9925047,6.99562773 C11.9925047,9.75390381 9.75390381,11.9925047 6.99562773,11.9925047 Z" />
  </svg>
)
Search.iconName = "Search"
export const SegmentedControl = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,4 L1,4 C0.45,4 0,4.45 0,5 L0,11 C0,11.55 0.45,12 1,12 L15,12 C15.55,12 16,11.55 16,11 L16,5 C16,4.45 15.55,4 15,4 Z M14,10 L8,10 L8,6 L14,6 L14,10 Z" />
  </svg>
)
SegmentedControl.iconName = "SegmentedControl"
export const Select = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16,15 C16,14.72 15.88,14.48 15.69,14.31 L15.71,14.29 L12.59,11.17 L16,10.33 L7.95,7.47 C7.98,7.38 8,7.3 8,7.2 L8,2 C8,1.45 7.55,1 7,1 L3,1 C3,0.45 2.55,0 2,0 C1.45,0 1,0.45 1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 L1,7 C1,7.55 1.45,8 2,8 L7.2,8 C7.3,8 7.38,7.98 7.47,7.95 L10.33,16 L11.18,12.59 L14.3,15.71 L14.32,15.69 C14.48,15.88 14.72,16 15,16 C15.04,16 15.07,15.98 15.1,15.98 C15.13,15.98 15.16,16 15.2,16 C15.64,16 16,15.64 16,15.2 C16,15.16 15.98,15.13 15.98,15.1 C15.98,15.07 16,15.04 16,15 Z M6,6 L3,6 L3,3 L6,3 L6,6 Z" />
  </svg>
)
Select.iconName = "Select"
export const Selection = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,4.69 4.69,2 8,2 C11.31,2 14,4.69 14,8 C14,11.31 11.31,14 8,14 Z M8,5 C6.34,5 5,6.34 5,8 C5,9.66 6.34,11 8,11 C9.66,11 11,9.66 11,8 C11,6.34 9.66,5 8,5 Z" />
  </svg>
)
Selection.iconName = "Selection"
export const SendToGraph = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,9 L2,9 C1.45,9 1,9.45 1,10 C1,10.55 1.45,11 2,11 L3.59,11 L0.3,14.29 C0.11,14.47 0,14.72 0,15 C0,15.55 0.45,16 1,16 C1.28,16 1.53,15.89 1.71,15.71 L5,12.41 L5,14 C5,14.55 5.45,15 6,15 C6.55,15 7,14.55 7,14 L7,10 C7,9.45 6.55,9 6,9 Z M14,9.5 C13.44,9.5 12.94,9.73 12.58,10.09 L10.45,8.85 L8.99,8 L12.58,5.91 C12.94,6.27 13.44,6.5 14,6.5 C15.1,6.5 16,5.6 16,4.5 C16,3.4 15.1,2.5 14,2.5 C12.9,2.5 12,3.4 12,4.5 C12,4.69 12.03,4.87 12.08,5.04 L8.5,7.13 L8.5,3.93 C9.36,3.71 10,2.93 10,2 C10,0.9 9.1,0 8,0 C6.9,0 6,0.9 6,2 C6,2.93 6.64,3.71 7.5,3.93 L7.5,7.13 L6.62,6.61 L3.92,5.04 C3.97,4.87 4,4.69 4,4.5 C4,3.4 3.1,2.5 2,2.5 C0.9,2.5 0,3.4 0,4.5 C0,5.6 0.9,6.5 2,6.5 C2.56,6.5 3.06,6.27 3.42,5.91 L5.55,7.15 L9.39,9.39 L12.09,10.96 C12.03,11.13 12,11.31 12,11.5 C12,12.6 12.9,13.5 14,13.5 C15.1,13.5 16,12.6 16,11.5 C16,10.4 15.1,9.5 14,9.5 Z" />
  </svg>
)
SendToGraph.iconName = "SendToGraph"
export const SendToMap = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,9 L2,9 C1.45,9 1,9.45 1,10 C1,10.55 1.45,11 2,11 L3.59,11 L0.3,14.29 C0.11,14.47 0,14.72 0,15 C0,15.55 0.45,16 1,16 C1.28,16 1.53,15.89 1.71,15.71 L5,12.41 L5,14 C5,14.55 5.45,15 6,15 C6.55,15 7,14.55 7,14 L7,10 C7,9.45 6.55,9 6,9 Z M15.55,3.17 L11.06,0.17 C10.9,0.06 10.71,0 10.5,0 C10.31,0 10.14,0.06 9.99,0.15 L5.53,2.82 L1.56,0.17 C1.4,0.06 1.21,0 1,0 C0.45,0 0,0.45 0,1 L0,7 L2,7 L2,2.87 L4.94,4.83 L5,4.86 L5,7 L6,7 L6,4.86 C6,4.86 6.01,4.86 6.01,4.85 L10,2.47 L10,11.14 C10,11.14 9.99,11.14 9.99,11.15 L9,11.73 L9,14.06 L10.47,13.18 L14.44,15.83 C14.6,15.94 14.79,16 15,16 C15.55,16 16,15.55 16,15 L16,4 C16,3.65 15.82,3.35 15.55,3.17 Z M14,13.13 L11.06,11.17 C11.04,11.16 11.02,11.15 11.01,11.14 L11.01,2.54 L14.01,4.54 L14.01,13.13 L14,13.13 Z" />
  </svg>
)
SendToMap.iconName = "SendToMap"
export const SendTo = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,7.5 C14.2,7.5 13.5,7.1 13,6.5 L11.8,7.7 C11.4,8.2 10.7,8.4 10,8.4 C8.6,8.5 7.5,7.4 7.5,6 C7.5,5.3 7.8,4.7 8.2,4.2 L9.5,3 C8.9,2.5 8.5,1.8 8.5,1 C8.5,0.7 8.6,0.3 8.7,0 L8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 L16,7.3 C15.7,7.4 15.4,7.5 15,7.5 Z M15,0 L11,0 C10.4,0 10,0.5 10,1 C10,1.5 10.4,2 11,2 L12.6,2 L9.3,5.3 C9.1,5.5 9,5.7 9,6 C9,6.5 9.4,7 10,7 C10.3,7 10.5,6.9 10.7,6.7 L14,3.4 L14,5 C14,5.6 14.4,6 15,6 C15.5,6 16,5.6 16,5 L16,1 C16,0.5 15.6,0 15,0 Z" />
  </svg>
)
SendTo.iconName = "SendTo"
export const SeriesAdd = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.68,7.9 C11.12,8.44 11.75,8.82 12.47,8.95 L9.71,11.71 C9.53,11.89 9.28,12 9,12 C8.72,12 8.47,11.89 8.29,11.7 L5,8.41 L2,11.41 L2,13 L15,13 C15.55,13 16,13.45 16,14 C16,14.55 15.55,15 15,15 L1,15 C0.45,15 0,14.55 0,14 L0,4 C0,3.45 0.45,3 1,3 C1.55,3 2,3.45 2,4 L2,8.59 L4.29,6.29 C4.47,6.11 4.72,6 5,6 C5.28,6 5.53,6.11 5.71,6.29 L9,9.59 L10.68,7.9 Z M15,3 C15.55,3 16,3.45 16,4 C16,4.55 15.55,5 15,5 L14,5 L14,6 C14,6.55 13.55,7 13,7 C12.45,7 12,6.55 12,6 L12,5 L11,5 C10.45,5 10,4.55 10,4 C10,3.45 10.45,3 11,3 L12,3 L12,2 C12,1.45 12.45,1 13,1 C13.55,1 14,1.45 14,2 L14,3 L15,3 Z" />
  </svg>
)
SeriesAdd.iconName = "SeriesAdd"
export const SeriesConfiguration = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.945,9.64 C10.595,9.87 11.285,10 12.005,10 C12.145,10 12.295,9.99 12.435,9.99 L9.705,12.71 C9.525,12.89 9.275,13 8.995,13 C8.715,13 8.465,12.89 8.285,12.7 L5.005,9.41 L2.005,12.41 L2.005,14 L14.995,14 C15.545,14 15.995,14.45 15.995,15 C15.995,15.55 15.545,16 14.995,16 L1.005,16 C0.455,16 0.005,15.55 0.005,15 L0.005,5 C0.005,4.45 0.455,4 1.005,4 C1.555,4 2.005,4.45 2.005,5 L2.005,9.59 L4.295,7.29 C4.475,7.11 4.725,7 5.005,7 C5.285,7 5.535,7.11 5.715,7.29 L9.005,10.59 L9.945,9.64 Z M14.675,3.2 L15.595,3.2 C15.815,3.2 15.995,3.38 15.995,3.6 L15.995,4.4 C15.995,4.62 15.815,4.8 15.595,4.8 L14.665,4.8 C14.605,5 14.525,5.18 14.425,5.35 L15.085,6 C15.235,6.15 15.235,6.4 15.085,6.55 L14.545,7.1 C14.395,7.25 14.145,7.25 13.995,7.1 L13.345,6.45 C13.175,6.55 12.985,6.63 12.795,6.69 L12.795,7.6 C12.795,7.82 12.615,8 12.395,8 L11.595,8 C11.375,8 11.195,7.82 11.195,7.6 L11.195,6.67 C11.015,6.61 10.835,6.54 10.675,6.45 L9.995,7.13 C9.845,7.29 9.585,7.29 9.425,7.13 L8.865,6.57 C8.715,6.41 8.715,6.16 8.865,6 L9.545,5.32 C9.465,5.16 9.385,4.99 9.325,4.8 L8.395,4.8 C8.175,4.8 7.995,4.62 7.995,4.4 L7.995,3.6 C7.995,3.38 8.175,3.2 8.395,3.2 L9.325,3.2 C9.385,3 9.465,2.82 9.565,2.65 L8.915,2.01 C8.765,1.86 8.765,1.61 8.915,1.46 L9.455,0.91 C9.605,0.76 9.845,0.76 9.995,0.91 L10.645,1.56 C10.825,1.46 11.005,1.38 11.195,1.32 L11.195,0.4 C11.195,0.18 11.375,0 11.595,0 L12.395,0 C12.615,0 12.795,0.18 12.795,0.4 L12.795,1.33 C12.975,1.39 13.145,1.47 13.315,1.55 L13.995,0.87 C14.145,0.71 14.405,0.71 14.565,0.87 L15.135,1.44 C15.285,1.6 15.285,1.85 15.135,2.01 L14.455,2.69 C14.545,2.85 14.615,3.02 14.675,3.2 L14.675,3.2 Z M10.495,4 C10.495,4.83 11.165,5.5 11.995,5.5 C12.825,5.5 13.495,4.83 13.495,4 C13.495,3.17 12.825,2.5 11.995,2.5 C11.175,2.5 10.495,3.17 10.495,4 Z" />
  </svg>
)
SeriesConfiguration.iconName = "SeriesConfiguration"
export const SeriesDerived = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.66,7.92 C11.1,8.46 11.73,8.83 12.46,8.95 L9.71,11.7 C9.53,11.89 9.28,12 9,12 C8.72,12 8.47,11.89 8.29,11.7 L5,8.41 L2,11.41 L2,13 L15,13 C15.55,13 16,13.45 16,14 C16,14.55 15.55,15 15,15 L1,15 C0.45,15 0,14.55 0,14 L0,4 C0,3.45 0.45,3 1,3 C1.55,3 2,3.45 2,4 L2,8.59 L4.29,6.29 C4.47,6.11 4.72,6 5,6 C5.28,6 5.53,6.11 5.71,6.29 L9,9.59 L10.66,7.92 Z M12.3,5.3 L12.6,5 L8,5 C7.4,5 7,4.6 7,4 C7,3.4 7.4,3 8,3 L12.6,3 L12.3,2.7 C12.1,2.5 12,2.3 12,2 C12,1.4 12.5,1 13,1 C13.3,1 13.5,1.1 13.7,1.3 L15.7,3.3 C15.9,3.5 16,3.7 16,4 C16,4.3 15.9,4.5 15.7,4.7 L13.7,6.7 C13.5,6.9 13.3,7 13,7 C12.4,7 12,6.6 12,6 C12,5.7 12.1,5.5 12.3,5.3 L12.3,5.3 Z" />
  </svg>
)
SeriesDerived.iconName = "SeriesDerived"
export const SeriesFiltered = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.29,9.3 C9.59,9.92 10.09,10.42 10.71,10.71 L9.71,11.71 C9.53,11.89 9.28,12 9,12 C8.72,12 8.47,11.89 8.29,11.7 L5,8.41 L2,11.41 L2,13 L15,13 C15.55,13 16,13.45 16,14 C16,14.55 15.55,15 15,15 L1,15 C0.45,15 0,14.55 0,14 L0,4 C0,3.45 0.45,3 1,3 C1.55,3 2,3.45 2,4 L2,8.59 L4.29,6.29 C4.47,6.11 4.72,6 5,6 C5.28,6 5.53,6.11 5.71,6.29 L9,9.59 L9.29,9.3 Z M15.48,1 C15.79,1 16,1.26 16,1.57 C16,1.73 15.94,1.87 15.83,1.98 L12.97,4.71 L12.97,7.34 C12.97,7.5 12.91,7.64 12.8,7.75 L11.98,8.85 C11.88,8.95 11.73,9.02 11.57,9.02 C11.26,9.02 11,8.76 11,8.45 L11,4.71 L8.17,1.98 C8.06,1.87 8,1.73 8,1.57 C8,1.26 8.26,1 8.57,1 L15.48,1 Z" />
  </svg>
)
SeriesFiltered.iconName = "SeriesFiltered"
export const SeriesSearch = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.6,8.94 C9.91,9 10.22,9.03 10.55,9.03 C10.75,9.03 10.95,9.02 11.15,8.99 C11.24,8.98 11.31,8.97 11.42,8.95 C11.52,8.94 11.64,8.91 11.81,8.87 L12.04,8.8 C12.08,8.79 12.12,8.78 12.15,8.76 L12.37,8.98 L9.67,11.7 C9.49,11.89 9.24,12 8.96,12 C8.68,12 8.43,11.89 8.25,11.7 L4.98,8.41 L1.99,11.41 L1.99,13 L14.93,13 C15.48,13 15.93,13.45 15.93,14 C15.93,14.55 15.48,15 14.93,15 L1,15 C0.45,15 0,14.55 0,14 L0,3.99 C0,3.44 0.45,2.99 1,2.99 C1.55,2.99 2,3.44 2,3.99 L2,8.58 L4.28,6.28 C4.45,6.1 4.7,5.99 4.98,5.99 C5.26,5.99 5.51,6.1 5.68,6.28 L8.96,9.58 L9.6,8.94 Z M15.82,8.53 C15.92,8.65 15.99,8.8 16,8.97 C16,9.31 15.73,9.58 15.39,9.58 C15.21,9.58 15.06,9.51 14.96,9.4 L12.72,7.15 C12.59,7.23 12.46,7.31 12.32,7.38 C12.3,7.39 12.27,7.4 12.25,7.41 C12.11,7.47 11.98,7.53 11.83,7.58 L11.82,7.58 C11.68,7.63 11.53,7.66 11.38,7.69 C11.34,7.7 11.3,7.71 11.27,7.71 C11.12,7.73 10.97,7.75 10.81,7.75 C8.96,7.75 7.46,6.24 7.46,4.38 C7.46,2.52 8.96,1.01 10.81,1 C12.66,1 14.16,2.51 14.16,4.37 C14.16,4.53 14.14,4.68 14.12,4.84 C14.11,4.88 14.11,4.91 14.1,4.95 C14.08,5.1 14.05,5.24 14,5.39 L14,5.4 C13.95,5.55 13.89,5.68 13.83,5.82 C13.82,5.84 13.81,5.87 13.8,5.89 C13.73,6.03 13.66,6.16 13.57,6.29 L15.82,8.53 L15.82,8.53 Z M10.81,6.59 C12.03,6.59 13.02,5.6 13.02,4.37 C13.02,3.14 12.03,2.15 10.81,2.15 C9.59,2.15 8.6,3.14 8.6,4.37 C8.6,5.59 9.59,6.59 10.81,6.59 L10.81,6.59 Z" />
  </svg>
)
SeriesSearch.iconName = "SeriesSearch"
export const Settings = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3,1 C3,0.45 2.55,0 2,0 C1.45,0 1,0.45 1,1 L1,4 L3,4 L3,1 Z M3,5 L1,5 C0.45,5 0,5.45 0,6 L0,8 C0,8.55 0.45,9 1,9 L3,9 C3.55,9 4,8.55 4,8 L4,6 C4,5.45 3.55,5 3,5 Z M15,1 C15,0.45 14.55,0 14,0 C13.45,0 13,0.45 13,1 L13,3 L15,3 L15,1 Z M9,1 C9,0.45 8.55,0 8,0 C7.45,0 7,0.45 7,1 L7,7 L9,7 L9,1 Z M1,15 C1,15.55 1.45,16 2,16 C2.55,16 3,15.55 3,15 L3,10 L1,10 L1,15 Z M15,4 L13,4 C12.45,4 12,4.45 12,5 L12,7 C12,7.55 12.45,8 13,8 L15,8 C15.55,8 16,7.55 16,7 L16,5 C16,4.45 15.55,4 15,4 Z M13,15 C13,15.55 13.45,16 14,16 C14.55,16 15,15.55 15,15 L15,9 L13,9 L13,15 Z M9,8 L7,8 C6.45,8 6,8.45 6,9 L6,11 C6,11.55 6.45,12 7,12 L9,12 C9.55,12 10,11.55 10,11 L10,9 C10,8.45 9.55,8 9,8 Z M7,15 C7,15.55 7.45,16 8,16 C8.55,16 9,15.55 9,15 L9,13 L7,13 L7,15 Z" />
  </svg>
)
Settings.iconName = "Settings"
export const SettingsGear = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2 6.4H13.35C13.24 6.03 13.08 5.69 12.9 5.36L14.26 4C14.57 3.69 14.57 3.18 14.26 2.87L13.13 1.74C12.82 1.43 12.31 1.43 12 1.74L10.64 3.1C10.31 2.93 9.97 2.77 9.6 2.66V0.8C9.6 0.36 9.24 0 8.8 0H7.2C6.76 0 6.4 0.36 6.4 0.8V2.66C6.01 2.78 5.65 2.94 5.3 3.13L4 1.83C3.7 1.53 3.21 1.53 2.91 1.83L1.83 2.92C1.53 3.22 1.53 3.71 1.83 4.01L3.13 5.31C2.93 5.65 2.77 6.01 2.65 6.4H0.8C0.36 6.4 0 6.76 0 7.2V8.8C0 9.24 0.36 9.6 0.8 9.6H2.65C2.76 9.97 2.92 10.31 3.1 10.64L1.74 12C1.43 12.31 1.43 12.82 1.74 13.13L2.87 14.26C3.18 14.57 3.69 14.57 4 14.26L5.36 12.9C5.69 13.08 6.03 13.23 6.4 13.34V15.2C6.4 15.64 6.76 16 7.2 16H8.8C9.24 16 9.6 15.64 9.6 15.2V13.34C9.99 13.22 10.35 13.06 10.7 12.87L12 14.17C12.3 14.47 12.79 14.47 13.09 14.17L14.18 13.08C14.48 12.78 14.48 12.29 14.18 11.99L12.88 10.69C13.07 10.34 13.24 9.98 13.36 9.59H15.21C15.65 9.59 16.01 9.23 16.01 8.79V7.19C16 6.76 15.64 6.4 15.2 6.4ZM8 11C6.34 11 5 9.66 5 8C5 6.34 6.34 5 8 5C9.66 5 11 6.34 11 8C11 9.66 9.66 11 8 11Z"
      fillRule="evenodd"
    />
  </svg>
)
SettingsGear.iconName = "SettingsGear"
export const Share = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.9981262,13.9962523 L2.00374766,13.9962523 L2.00374766,5.00187383 L6.76077452,5.00187383 L8.7595253,3.00312305 L1.00437227,3.00312305 C0.454715803,3.00312305 0.00499687695,3.45284197 0.00499687695,4.00249844 L0.00499687695,14.9956277 C0.00499687695,15.5452842 0.454715803,15.9950031 1.00437227,15.9950031 L11.9975016,15.9950031 C12.547158,15.9950031 12.996877,15.5452842 12.996877,14.9956277 L12.996877,7.25046846 L10.9981262,9.24921924 L10.9981262,13.9962523 Z M14.9956277,0.00499687695 L9.99875078,0.00499687695 C9.44909432,0.00499687695 8.99937539,0.454715803 8.99937539,1.00437227 C8.99937539,1.55402873 9.44909432,2.00374766 9.99875078,2.00374766 L12.587133,2.00374766 L7.30043723,7.29044347 C7.1105559,7.4803248 7.00062461,7.73016864 7.00062461,8 C7.00062461,8.54965646 7.45034354,8.99937539 8,8.99937539 C8.27982511,8.99937539 8.52966896,8.8894441 8.70955653,8.70955653 L13.9962523,3.42286071 L13.9962523,6.01124297 C13.9962523,6.56089944 14.4459713,7.01061836 14.9956277,7.01061836 C15.5452842,7.01061836 15.9950031,6.56089944 15.9950031,6.01124297 L15.9950031,1.01436602 C15.9950031,0.454715803 15.5452842,0.00499687695 14.9956277,0.00499687695 L14.9956277,0.00499687695 Z" />
  </svg>
)
Share.iconName = "Share"
export const Shop = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3,2 L13,2 C13.55,2 14,1.55 14,1 C14,0.45 13.55,0 13,0 L3,0 C2.45,0 2,0.45 2,1 C2,1.55 2.45,2 3,2 Z M12,13 L4,13 L4,10 L2,10 L2,15 C2,15.55 2.45,16 3,16 L13,16 C13.55,16 14,15.55 14,15 L14,10 L12,10 L12,13 Z M16,7 L14.99,3.83 C14.9,3.36 14.49,3 14,3 L2,3 C1.51,3 1.1,3.36 1.02,3.83 L0.01,7 L0,7 C0,8.1 0.9,9 2,9 C3.1,9 4,8.1 4,7 C4,8.1 4.9,9 6,9 C7.1,9 8,8.1 8,7 C8,8.1 8.9,9 10,9 C11.1,9 12,8.1 12,7 C12,8.1 12.9,9 14,9 C15.1,9 16,8.1 16,7 Z" />
  </svg>
)
Shop.iconName = "Shop"
export const ShoppingCart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,10.5 L7.72,10.5 L7.39,9.5 L13,9.5 C13.39,9.5 13.72,9.27 13.89,8.94 L13.9,8.94 L15.9,4.94 L15.89,4.94 C15.95,4.81 16,4.66 16,4.5 C16,3.95 15.55,3.5 15,3.5 L5.39,3.5 L4.95,2.18 L4.94,2.18 C4.8,1.79 4.44,1.5 4,1.5 L1,1.5 C0.45,1.5 0,1.95 0,2.5 C0,3.05 0.45,3.5 1,3.5 L3.28,3.5 L5.61,10.5 L4,10.5 C2.9,10.5 2,11.4 2,12.5 C2,13.6 2.9,14.5 4,14.5 C5.1,14.5 6,13.6 6,12.5 L12,12.5 C12,13.6 12.9,14.5 14,14.5 C15.1,14.5 16,13.6 16,12.5 C16,11.4 15.1,10.5 14,10.5 Z M6.05,5.5 L13.38,5.5 L12.38,7.5 L6.72,7.5 L6.05,5.5 Z" />
  </svg>
)
ShoppingCart.iconName = "ShoppingCart"
export const SimCard = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.71,4.29 L9.71,0.29 C9.53,0.11 9.28,0 9,0 L3,0 C2.45,0 2,0.45 2,1 L2,15 C2,15.55 2.45,16 3,16 L13,16 C13.55,16 14,15.55 14,15 L14,5 C14,4.72 13.89,4.47 13.71,4.29 Z M7,6 L9,6 L9,8 L7,8 L7,6 Z M4,6 L6,6 L6,8 L4,8 L4,6 Z M6,14 L4,14 L4,12 L6,12 L6,14 Z M9,14 L7,14 L7,12 L9,12 L9,14 Z M12,14 L10,14 L10,12 L12,12 L12,14 Z M12,11 L4,11 L4,9 L12,9 L12,11 Z M12,8 L10,8 L10,6 L12,6 L12,8 Z" />
  </svg>
)
SimCard.iconName = "SimCard"
export const Slash = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.5,2 C9.04,2 8.65,2.31 8.54,2.73 L5.55,12.69 C5.52,12.79 5.5,12.89 5.5,13 C5.5,13.55 5.95,14 6.5,14 C6.96,14 7.35,13.69 7.46,13.27 L10.45,3.31 C10.48,3.21 10.5,3.11 10.5,3 C10.5,2.45 10.05,2 9.5,2 Z" />
  </svg>
)
Slash.iconName = "Slash"
export const SocialMedia = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,4.5 C10.4,4.5 10.8,4.4 11.1,4.2 C12.5,5 13.4,6.5 13.5,8.1 C13.5,8.6 14,9 14.5,9 C15.1,9 15.5,8.6 15.5,8 L15.5,7.8 C15.3,5.4 14,3.4 12,2.3 C11.9,1.3 11.1,0.5 10,0.5 C8.9,0.5 8,1.4 8,2.5 C8,3.6 8.9,4.5 10,4.5 Z M4.5,9 C4.5,8.3 4.1,7.7 3.6,7.3 C3.9,5.9 4.8,4.7 6.1,4 C6.4,3.9 6.7,3.6 6.7,3.1 C6.7,2.6 6.3,2.1 5.7,2.1 C5.5,2.1 5.4,2.1 5.2,2.2 C3.3,3.2 2,5 1.6,7.2 C0.9,7.6 0.5,8.3 0.5,9 C0.5,10.1 1.4,11 2.5,11 C3.6,11 4.5,10.1 4.5,9 Z M13.3,10.2 C12.2,10.2 11.3,11.1 11.3,12.2 L11.3,12.5 C10.5,13.1 9.5,13.4 8.5,13.4 C7.3,13.4 6.2,13 5.3,12.3 C5.1,12.1 4.9,12 4.6,12 C4,12 3.6,12.4 3.6,13 C3.6,13.3 3.7,13.6 3.9,13.8 C5.1,14.9 6.7,15.5 8.5,15.5 C10,15.5 11.5,15 12.6,14.2 C12.8,14.3 13.1,14.3 13.3,14.3 C14.4,14.3 15.3,13.4 15.3,12.3 C15.3,11.2 14.4,10.2 13.3,10.2 L13.3,10.2 Z" />
  </svg>
)
SocialMedia.iconName = "SocialMedia"
export const SortAlphabeticalDesc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.995,11.99 C5.715,11.99 5.465,12.1 5.285,12.28 L4.995,12.57 L4.995,8.99 C4.995,8.44 4.545,7.99 3.995,7.99 C3.445,7.99 2.995,8.44 2.995,8.99 L2.995,12.58 L2.705,12.29 C2.525,12.11 2.275,12 1.995,12 C1.445,12 0.995,12.45 0.995,13 C0.995,13.28 1.105,13.53 1.285,13.71 L3.285,15.71 C3.465,15.89 3.715,16 3.995,16 C4.275,16 4.525,15.89 4.705,15.71 L6.705,13.71 C6.885,13.53 6.995,13.28 6.995,13 C6.995,12.44 6.545,11.99 5.995,11.99 Z M12.705,10 L11.325,10 L9.005,15.99 L10.365,15.99 L10.845,14.66 L13.145,14.66 L13.605,15.99 L15.005,15.99 L12.705,10 Z M11.195,13.67 L11.995,11.47 L12.015,11.47 L12.785,13.67 L11.195,13.67 L11.195,13.67 Z M14.995,6.5 L10.425,6.5 L14.875,1.38 L14.875,0 L8.345,0 L8.345,1.48 L12.445,1.48 L7.995,6.59 L7.995,7.98 L14.995,7.98 L14.995,6.5 L14.995,6.5 Z" />
  </svg>
)
SortAlphabeticalDesc.iconName = "SortAlphabeticalDesc"
export const SortAlphabetical = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,11.995 C5.72,11.995 5.47,12.105 5.29,12.285 L5,12.585 L5,8.995 C5,8.445 4.55,7.995 4,7.995 C3.45,7.995 3,8.445 3,8.995 L3,12.585 L2.71,12.295 C2.53,12.105 2.28,11.995 2,11.995 C1.45,11.995 1,12.445 1,12.995 C1,13.275 1.11,13.525 1.29,13.705 L3.29,15.705 C3.48,15.885 3.73,15.995 4,15.995 C4.28,15.995 4.53,15.885 4.71,15.705 L6.71,13.705 C6.89,13.525 7,13.275 7,12.995 C7.01,12.445 6.56,11.995 6,11.995 Z M13.93,11.045 L13.93,10.005 L9.25,10.005 L9.25,11.115 L12.19,11.115 L9,14.955 L9,15.995 L14.02,15.995 L14.02,14.885 L10.75,14.885 L13.93,11.045 Z M12.51,6.205 L13.13,7.985 L15,7.985 L11.94,0.005 L10.1,0.005 L7,7.985 L8.81,7.985 L9.45,6.205 L12.51,6.205 L12.51,6.205 Z M10.99,1.965 L11.01,1.965 L12.04,4.895 L9.92,4.895 L10.99,1.965 Z" />
  </svg>
)
SortAlphabetical.iconName = "SortAlphabetical"
export const SortAsc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,6.5 L11,6.5 C11.55,6.5 12,6.05 12,5.5 C12,4.95 11.55,4.5 11,4.5 L8,4.5 C7.45,4.5 7,4.95 7,5.5 C7,6.05 7.45,6.5 8,6.5 Z M8,2.5 L9,2.5 C9.55,2.5 10,2.05 10,1.5 C10,0.95 9.55,0.5 9,0.5 L8,0.5 C7.45,0.5 7,0.95 7,1.5 C7,2.05 7.45,2.5 8,2.5 Z M8,10.5 L13,10.5 C13.55,10.5 14,10.05 14,9.5 C14,8.95 13.55,8.5 13,8.5 L8,8.5 C7.45,8.5 7,8.95 7,9.5 C7,10.05 7.45,10.5 8,10.5 Z M5,11.5 C4.72,11.5 4.47,11.61 4.29,11.79 L4,12.09 L4,8.5 C4,7.95 3.55,7.5 3,7.5 C2.45,7.5 2,7.95 2,8.5 L2,12.09 L1.71,11.8 C1.53,11.61 1.28,11.5 1,11.5 C0.45,11.5 0,11.95 0,12.5 C0,12.78 0.11,13.03 0.29,13.21 L2.29,15.21 C2.47,15.39 2.72,15.5 3,15.5 C3.28,15.5 3.53,15.39 3.71,15.21 L5.71,13.21 C5.89,13.03 6,12.78 6,12.5 C6,11.95 5.55,11.5 5,11.5 Z M15,12.5 L8,12.5 C7.45,12.5 7,12.95 7,13.5 C7,14.05 7.45,14.5 8,14.5 L15,14.5 C15.55,14.5 16,14.05 16,13.5 C16,12.95 15.55,12.5 15,12.5 Z" />
  </svg>
)
SortAsc.iconName = "SortAsc"
export const SortDesc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,11.5 C4.72,11.5 4.47,11.61 4.29,11.79 L4,12.09 L4,8.5 C4,7.95 3.55,7.5 3,7.5 C2.45,7.5 2,7.95 2,8.5 L2,12.09 L1.71,11.8 C1.53,11.61 1.28,11.5 1,11.5 C0.45,11.5 0,11.95 0,12.5 C0,12.78 0.11,13.03 0.29,13.21 L2.29,15.21 C2.47,15.39 2.72,15.5 3,15.5 C3.28,15.5 3.53,15.39 3.71,15.21 L5.71,13.21 C5.89,13.03 6,12.78 6,12.5 C6,11.95 5.55,11.5 5,11.5 Z M9,12.5 L8,12.5 C7.45,12.5 7,12.95 7,13.5 C7,14.05 7.45,14.5 8,14.5 L9,14.5 C9.55,14.5 10,14.05 10,13.5 C10,12.95 9.55,12.5 9,12.5 Z M13,4.5 L8,4.5 C7.45,4.5 7,4.95 7,5.5 C7,6.05 7.45,6.5 8,6.5 L13,6.5 C13.55,6.5 14,6.05 14,5.5 C14,4.95 13.55,4.5 13,4.5 Z M11,8.5 L8,8.5 C7.45,8.5 7,8.95 7,9.5 C7,10.05 7.45,10.5 8,10.5 L11,10.5 C11.55,10.5 12,10.05 12,9.5 C12,8.95 11.55,8.5 11,8.5 Z M15,0.5 L8,0.5 C7.45,0.5 7,0.95 7,1.5 C7,2.05 7.45,2.5 8,2.5 L15,2.5 C15.55,2.5 16,2.05 16,1.5 C16,0.95 15.55,0.5 15,0.5 Z" />
  </svg>
)
SortDesc.iconName = "SortDesc"
export const SortNumericalDesc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.5,11.995 C6.22,11.995 5.97,12.105 5.79,12.285 L5.5,12.585 L5.5,8.995 C5.5,8.445 5.05,7.995 4.5,7.995 C3.95,7.995 3.5,8.445 3.5,8.995 L3.5,12.585 L3.21,12.295 C3.02,12.105 2.78,11.995 2.5,11.995 C1.95,11.995 1.5,12.445 1.5,12.995 C1.5,13.275 1.61,13.525 1.79,13.705 L3.79,15.705 C3.97,15.885 4.22,15.995 4.5,15.995 C4.78,15.995 5.03,15.885 5.21,15.705 L7.21,13.705 C7.38,13.525 7.5,13.275 7.5,12.995 C7.5,12.445 7.05,11.995 6.5,11.995 L6.5,11.995 Z M14.36,2.545 C14.27,2.065 14.1,1.645 13.86,1.265 C13.62,0.885 13.3,0.585 12.9,0.355 C12.5,0.125 11.99,0.005 11.36,0.005 C10.93,0.005 10.54,0.075 10.19,0.225 C9.84,0.375 9.54,0.575 9.29,0.825 C9.04,1.075 8.85,1.375 8.71,1.715 C8.57,2.055 8.51,2.425 8.51,2.825 C8.51,3.135 8.56,3.435 8.66,3.735 C8.76,4.035 8.92,4.305 9.14,4.535 C9.37,4.775 9.66,4.965 9.99,5.115 C10.32,5.255 10.67,5.325 11.02,5.325 C11.42,5.325 11.77,5.255 12.07,5.125 C12.37,4.995 12.64,4.775 12.86,4.465 L12.88,4.485 C12.86,4.695 12.83,4.935 12.78,5.215 C12.73,5.485 12.65,5.745 12.53,5.975 C12.41,6.215 12.26,6.415 12.06,6.575 C11.87,6.735 11.62,6.825 11.31,6.825 C11.02,6.825 10.78,6.725 10.59,6.535 C10.4,6.355 10.28,6.135 10.22,5.875 L8.65,5.875 C8.7,6.215 8.79,6.515 8.94,6.775 C9.09,7.035 9.28,7.265 9.51,7.445 C9.74,7.625 10.01,7.765 10.31,7.855 C10.62,7.955 10.94,8.005 11.29,8.005 C11.87,8.005 12.37,7.885 12.77,7.645 C13.17,7.405 13.5,7.095 13.76,6.715 C14.02,6.325 14.2,5.895 14.32,5.425 C14.44,4.945 14.5,4.465 14.5,3.985 C14.5,3.505 14.45,3.025 14.36,2.545 L14.36,2.545 Z M12.65,3.265 C12.6,3.435 12.51,3.585 12.41,3.725 C12.3,3.855 12.17,3.965 12,4.035 C11.84,4.115 11.64,4.155 11.42,4.155 C11.21,4.155 11.03,4.115 10.87,4.025 C10.71,3.945 10.58,3.835 10.48,3.695 C10.36,3.555 10.29,3.405 10.24,3.235 C10.19,3.065 10.16,2.885 10.16,2.695 C10.16,2.515 10.19,2.345 10.24,2.175 C10.3,2.015 10.38,1.865 10.49,1.735 C10.6,1.605 10.73,1.495 10.89,1.415 C11.05,1.335 11.22,1.295 11.41,1.295 C11.62,1.295 11.81,1.335 11.97,1.415 C12.13,1.495 12.27,1.605 12.38,1.735 C12.49,1.875 12.58,2.025 12.64,2.195 C12.7,2.365 12.73,2.545 12.73,2.715 C12.73,2.915 12.7,3.095 12.65,3.265 L12.65,3.265 Z M12.19,10.575 C12.07,10.725 11.93,10.855 11.75,10.945 C11.58,11.035 11.38,11.105 11.17,11.145 C10.95,11.185 10.73,11.195 10.5,11.195 L10.5,12.115 L12.15,12.115 L12.15,15.995 L13.48,15.995 L13.48,10.005 L12.42,10.005 C12.39,10.235 12.31,10.425 12.19,10.575 Z" />
  </svg>
)
SortNumericalDesc.iconName = "SortNumericalDesc"
export const SortNumerical = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.5,11.99 C6.22,11.99 5.97,12.1 5.79,12.28 L5.5,12.58 L5.5,8.99 C5.5,8.44 5.05,7.99 4.5,7.99 C3.95,7.99 3.5,8.44 3.5,8.99 L3.5,12.58 L3.21,12.29 C3.03,12.11 2.78,11.99 2.5,11.99 C1.95,11.99 1.5,12.44 1.5,12.99 C1.5,13.27 1.61,13.52 1.79,13.7 L3.79,15.7 C3.97,15.88 4.22,15.99 4.5,15.99 C4.78,15.99 5.03,15.88 5.21,15.7 L7.21,13.7 C7.39,13.52 7.5,13.27 7.5,12.99 C7.5,12.44 7.05,11.99 6.5,11.99 L6.5,11.99 Z M14.41,11.91 C14.35,11.55 14.24,11.23 14.08,10.95 C13.92,10.67 13.71,10.44 13.44,10.26 C13.17,10.09 12.83,10 12.41,10 C12.13,10 11.87,10.06 11.63,10.17 C11.4,10.28 11.2,10.43 11.03,10.62 C10.86,10.81 10.73,11.03 10.64,11.29 C10.55,11.55 10.5,11.82 10.5,12.12 C10.5,12.35 10.53,12.58 10.6,12.81 C10.67,13.04 10.77,13.24 10.92,13.41 C11.08,13.59 11.26,13.74 11.49,13.84 C11.71,13.95 11.94,14 12.17,14 C12.43,14 12.67,13.95 12.87,13.85 C13.07,13.75 13.25,13.59 13.4,13.35 L13.42,13.37 C13.41,13.53 13.39,13.71 13.35,13.91 C13.32,14.11 13.26,14.31 13.18,14.48 C13.1,14.66 13,14.81 12.87,14.93 C12.74,15.05 12.58,15.12 12.37,15.12 C12.18,15.12 12.02,15.05 11.89,14.91 C11.76,14.77 11.68,14.6 11.64,14.41 L10.6,14.41 C10.63,14.66 10.7,14.89 10.79,15.09 C10.89,15.29 11.01,15.46 11.17,15.59 C11.33,15.73 11.5,15.83 11.71,15.9 C11.92,15.97 12.13,16 12.36,16 C12.75,16 13.08,15.91 13.35,15.73 C13.62,15.55 13.84,15.32 14.01,15.03 C14.18,14.74 14.3,14.42 14.38,14.06 C14.46,13.7 14.5,13.34 14.5,12.99 C14.5,12.63 14.47,12.27 14.41,11.91 L14.41,11.91 Z M13.27,12.45 C13.23,12.58 13.18,12.69 13.11,12.79 C13.04,12.89 12.95,12.97 12.84,13.03 C12.73,13.09 12.6,13.12 12.45,13.12 C12.31,13.12 12.19,13.09 12.08,13.03 C11.97,12.97 11.89,12.88 11.82,12.78 C11.75,12.68 11.7,12.56 11.67,12.43 C11.64,12.3 11.62,12.17 11.62,12.03 C11.62,11.9 11.64,11.77 11.67,11.64 C11.71,11.51 11.76,11.4 11.83,11.3 C11.9,11.2 11.99,11.12 12.09,11.06 C12.19,11 12.31,10.97 12.44,10.97 C12.58,10.97 12.7,11 12.81,11.06 C12.92,11.12 13.01,11.2 13.09,11.3 C13.16,11.4 13.22,11.52 13.26,11.65 C13.3,11.78 13.32,11.91 13.32,12.04 C13.32,12.19 13.3,12.32 13.27,12.45 L13.27,12.45 Z M11.71,7.98 L13.5,7.98 L13.5,2.7e-15 L12.08,2.7e-15 C12.03,0.3 11.92,0.56 11.77,0.76 C11.61,0.97 11.42,1.13 11.19,1.26 C10.96,1.39 10.7,1.47 10.41,1.52 C10.11,1.57 9.81,1.59 9.5,1.58 L9.5,2.8 L11.71,2.8 L11.71,7.98 L11.71,7.98 Z" />
  </svg>
)
SortNumerical.iconName = "SortNumerical"
export const Sort = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,11.5 C4.72,11.5 4.47,11.61 4.29,11.79 L4,12.09 L4,8.5 C4,7.95 3.55,7.5 3,7.5 C2.45,7.5 2,7.95 2,8.5 L2,12.09 L1.71,11.8 C1.53,11.61 1.28,11.5 1,11.5 C0.45,11.5 0,11.95 0,12.5 C0,12.78 0.11,13.03 0.29,13.21 L2.29,15.21 C2.47,15.39 2.72,15.5 3,15.5 C3.28,15.5 3.53,15.39 3.71,15.21 L5.71,13.21 C5.89,13.03 6,12.78 6,12.5 C6,11.95 5.55,11.5 5,11.5 Z M8,2.5 L15,2.5 C15.55,2.5 16,2.05 16,1.5 C16,0.95 15.55,0.5 15,0.5 L8,0.5 C7.45,0.5 7,0.95 7,1.5 C7,2.05 7.45,2.5 8,2.5 Z M15,4.5 L8,4.5 C7.45,4.5 7,4.95 7,5.5 C7,6.05 7.45,6.5 8,6.5 L15,6.5 C15.55,6.5 16,6.05 16,5.5 C16,4.95 15.55,4.5 15,4.5 Z M15,12.5 L8,12.5 C7.45,12.5 7,12.95 7,13.5 C7,14.05 7.45,14.5 8,14.5 L15,14.5 C15.55,14.5 16,14.05 16,13.5 C16,12.95 15.55,12.5 15,12.5 Z M15,8.5 L8,8.5 C7.45,8.5 7,8.95 7,9.5 C7,10.05 7.45,10.5 8,10.5 L15,10.5 C15.55,10.5 16,10.05 16,9.5 C16,8.95 15.55,8.5 15,8.5 Z" />
  </svg>
)
Sort.iconName = "Sort"
export const SplitColumns = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,10 C12,10.55 12.45,11 13,11 C13.28,11 13.53,10.89 13.71,10.71 L15.71,8.71 C15.89,8.53 16,8.28 16,8 C16,7.72 15.89,7.47 15.71,7.29 L13.71,5.29 C13.53,5.11 13.28,5 13,5 C12.45,5 12,5.45 12,6 C12,6.28 12.11,6.53 12.29,6.71 L12.59,7 L9,7 L9,2 L12,2 L12,3.71 C12.31,3.58 12.64,3.5 13,3.5 C13.36,3.5 13.69,3.58 14,3.71 L14,1 C14,0.45 13.55,0 13,0 L3,0 C2.45,0 2,0.45 2,1 L2,3.71 C2.31,3.58 2.64,3.5 3,3.5 C3.36,3.5 3.69,3.58 4,3.71 L4,2 L7,2 L7,7 L3.41,7 L3.7,6.71 C3.89,6.53 4,6.28 4,6 C4,5.45 3.55,5 3,5 C2.72,5 2.47,5.11 2.29,5.29 L0.29,7.29 C0.11,7.47 0,7.72 0,8 C0,8.28 0.11,8.53 0.29,8.71 L2.29,10.71 C2.47,10.89 2.72,11 3,11 C3.55,11 4,10.55 4,10 C4,9.72 3.89,9.47 3.71,9.29 L3.41,9 L7,9 L7,14 L4,14 L4,12.29 C3.69,12.42 3.36,12.5 3,12.5 C2.64,12.5 2.31,12.42 2,12.29 L2,15 C2,15.55 2.45,16 3,16 L13,16 C13.55,16 14,15.55 14,15 L14,12.29 C13.69,12.42 13.36,12.5 13,12.5 C12.64,12.5 12.31,12.42 12,12.29 L12,14 L9,14 L9,9 L12.59,9 L12.3,9.29 C12.11,9.47 12,9.72 12,10 Z" />
  </svg>
)
SplitColumns.iconName = "SplitColumns"
export const StackedChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.5,2 C9.5,1.45 9.05,1 8.5,1 L7.5,1 C6.95,1 6.5,1.45 6.5,2 L6.5,5 L9.5,5 L9.5,2 Z M12.5,12 L13.5,12 C14.05,12 14.5,11.55 14.5,11 L14.5,8 L11.5,8 L11.5,11 C11.5,11.55 11.95,12 12.5,12 Z M14.5,5 C14.5,4.45 14.05,4 13.5,4 L12.5,4 C11.95,4 11.5,4.45 11.5,5 L11.5,7 L14.5,7 L14.5,5 Z M9.5,6 L6.5,6 L6.5,9 L9.5,9 L9.5,6 Z M4.5,7 C4.5,6.45 4.05,6 3.5,6 L2.5,6 C1.95,6 1.5,6.45 1.5,7 L1.5,8 L4.5,8 L4.5,7 Z M7.5,12 L8.5,12 C9.05,12 9.5,11.55 9.5,11 L9.5,10 L6.5,10 L6.5,11 C6.5,11.55 6.95,12 7.5,12 Z M14.5,13 L1.5,13 C0.95,13 0.5,13.45 0.5,14 C0.5,14.55 0.95,15 1.5,15 L14.5,15 C15.05,15 15.5,14.55 15.5,14 C15.5,13.45 15.05,13 14.5,13 Z M2.5,12 L3.5,12 C4.05,12 4.5,11.55 4.5,11 L4.5,9 L1.5,9 L1.5,11 C1.5,11.55 1.95,12 2.5,12 Z" />
  </svg>
)
StackedChart.iconName = "StackedChart"
export const StarEmpty = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16,6.11 L10.47,5.27 L8,0 L5.53,5.27 L0,6.11 L4,10.21 L3.06,16 L8,13.27 L12.94,16 L12,10.21 L16,6.11 Z M4.91,13.2 L5.5,9.58 L3,7.02 L6.45,6.49 L8,3.2 L9.55,6.49 L13,7.02 L10.5,9.58 L11.09,13.2 L8,11.49 L4.91,13.2 Z" />
  </svg>
)
StarEmpty.iconName = "StarEmpty"
export const Star = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon
      fillRule="evenodd"
      points="8 0 10.5 5.3 16 6.1 12 10.2 12.9 16 8 13.3 3.1 16 4 10.2 0 6.1 5.5 5.3"
    />
  </svg>
)
Star.iconName = "Star"
export const StepBackward = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5,3 C11.26,3 11.06,3.09 10.88,3.23 L10.87,3.22 L6.5,6.72 L6.5,4 C6.5,3.45 6.05,3 5.5,3 L4.5,3 C3.95,3 3.5,3.45 3.5,4 L3.5,12 C3.5,12.55 3.95,13 4.5,13 L5.5,13 C6.05,13 6.5,12.55 6.5,12 L6.5,9.28 L10.88,12.78 L10.89,12.77 C11.06,12.91 11.26,13 11.5,13 C12.05,13 12.5,12.55 12.5,12 L12.5,4 C12.5,3.45 12.05,3 11.5,3 L11.5,3 Z" />
  </svg>
)
StepBackward.iconName = "StepBackward"
export const StepChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,12 L2,12 L2,10 L5,10 C5.55,10 6,9.55 6,9 L6,7 L8,7 L8,8 C8,8.55 8.45,9 9,9 L13,9 C13.55,9 14,8.55 14,8 L14,5 L15,5 C15.55,5 16,4.55 16,4 C16,3.45 15.55,3 15,3 L13,3 C12.45,3 12,3.45 12,4 L12,7 L10,7 L10,6 C10,5.45 9.55,5 9,5 L5,5 C4.45,5 4,5.45 4,6 L4,8 L2,8 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z" />
  </svg>
)
StepChart.iconName = "StepChart"
export const StepForward = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5,3 L10.5,3 C9.95,3 9.5,3.45 9.5,4 L9.5,6.72 L5.12,3.22 L5.12,3.23 C4.94,3.09 4.74,3 4.5,3 C3.95,3 3.5,3.45 3.5,4 L3.5,12 C3.5,12.55 3.95,13 4.5,13 C4.74,13 4.94,12.91 5.12,12.77 L5.13,12.78 L9.5,9.28 L9.5,12 C9.5,12.55 9.95,13 10.5,13 L11.5,13 C12.05,13 12.5,12.55 12.5,12 L12.5,4 C12.5,3.45 12.05,3 11.5,3 Z" />
  </svg>
)
StepForward.iconName = "StepForward"
export const Stop = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,3 L4,3 C3.45,3 3,3.45 3,4 L3,12 C3,12.55 3.45,13 4,13 L12,13 C12.55,13 13,12.55 13,12 L13,4 C13,3.45 12.55,3 12,3 Z" />
  </svg>
)
Stop.iconName = "Stop"
export const Style = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,14 L2,14 L2,2 L10.76,2 L12.76,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L15,16 C15.55,16 16,15.55 16,15 L16,6.24 L14,8.24 L14,14 Z M15.4,0 L9.7,5.7 L11.8,7.8 L16,3.6 L16,0 L15.4,0 Z M4,11.92 C6.33,12.07 8.42,12.07 10.15,10.42 C10.97,9.59 10.97,8.17 10.15,7.34 C9.7,6.96 9.17,6.74 8.65,6.74 C8.12,6.74 7.6,6.96 7.22,7.34 C6.4,8.25 5.95,10.72 4,11.92 Z" />
  </svg>
)
Style.iconName = "Style"
export const SwapHorizontal = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,7.02 L0.05,7 L0,7 L0,7.02 Z M2,4.99 L11.57,4.99 L10.28,6.28 C10.1,6.47 9.99,6.72 9.99,6.99 C9.99,7.54 10.44,7.99 10.99,7.99 C11.27,7.99 11.52,7.88 11.7,7.7 L14.69,4.7 C14.87,4.52 14.98,4.27 14.98,3.99 C14.98,3.71 14.87,3.46 14.69,3.28 L11.7,0.28 C11.51,0.11 11.26,1.8e-15 10.99,1.8e-15 C10.44,1.8e-15 9.99,0.45 9.99,1 C9.99,1.28 10.1,1.53 10.28,1.71 L11.57,3 L2,3 C1.45,3 1,3.45 1,4 C1.01,4.55 1.45,4.99 2,4.99 Z M15.96,9 L16,9 L16,8.98 L15.96,9 Z M14,11.01 L4.43,11.01 L5.72,9.72 C5.9,9.53 6.01,9.28 6.01,9.01 C6.01,8.46 5.56,8.01 5.01,8.01 C4.73,8.01 4.48,8.12 4.3,8.3 L1.31,11.3 C1.13,11.48 1.02,11.73 1.02,12 C1.02,12.28 1.13,12.53 1.31,12.71 L4.3,15.71 C4.49,15.89 4.74,16 5.01,16 C5.56,16 6.01,15.55 6.01,15 C6.01,14.72 5.9,14.47 5.72,14.29 L4.43,13 L14,13 C14.55,13 15,12.55 15,12 C15,11.45 14.55,11.01 14,11.01 Z" />
  </svg>
)
SwapHorizontal.iconName = "SwapHorizontal"
export const SwapVertical = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.99437851,0 L8.97439101,0 L8.99437851,0.04 L8.99437851,0 Z M6.99562773,16 L7.01561524,16 L6.99562773,15.95 L6.99562773,16 Z M4.69706433,1.31 C4.51717676,1.13 4.26733292,1.02 3.99750156,1.02 C3.72767021,1.02 3.4678326,1.13 3.28794503,1.31 L0.289818863,4.3 C0.109931293,4.49 0,4.74 0,5.01 C0,5.56 0.449718926,6.01 0.99937539,6.01 C1.2792005,6.01 1.52904435,5.9 1.70893192,5.72 L2.99812617,4.43 L2.99812617,14 C2.99812617,14.55 3.4478451,15 3.99750156,15 C4.54715803,15 4.99687695,14.55 4.99687695,14 L4.99687695,4.43 L6.28607121,5.72 C6.46595878,5.9 6.71580262,6.01 6.98563398,6.01 C7.53529044,6.01 7.98500937,5.56 7.98500937,5.01 C7.98500937,4.73 7.87507808,4.48 7.69519051,4.3 L4.69706433,1.31 Z M14.9906309,9.99 C14.7108057,9.99 14.4609619,10.1 14.2810743,10.28 L12.9918801,11.57 L12.9918801,2 C12.9918801,1.45 12.5421611,1 11.9925047,1 C11.4428482,1 10.9931293,1.45 10.9931293,2 L10.9931293,11.57 L9.70393504,10.28 C9.52404747,10.1 9.27420362,9.99 9.00437227,9.99 C8.4547158,9.99 8.00499688,10.44 8.00499688,10.99 C8.00499688,11.27 8.11492817,11.52 8.29481574,11.7 L11.2929419,14.69 C11.4728295,14.87 11.7226733,14.98 12.0024984,14.98 C12.2823235,14.98 12.5321674,14.87 12.712055,14.69 L15.7101811,11.7 C15.8900687,11.52 16,11.27 16,10.99 C15.9900062,10.44 15.5402873,9.99 14.9906309,9.99 L14.9906309,9.99 Z" />
  </svg>
)
SwapVertical.iconName = "SwapVertical"
export const TableFiltered = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.33333333,2 L9,5.3 L9,6 L7,6 L7,8 L9,8 L9,9 L7,9 L7,11 L13,11 L14.7808703,8.77391208 C14.9227198,8.5966002 15,8.37629139 15,8.14922138 L15.0000139,5.29998746 L16,4.4 L16,15 C16,15.6 15.6,16 15,16 L1,16 C0.4,16 0,15.6 0,15 L0,3 C0,2.5 0.4,2 1,2 L5.33333333,2 Z M6,12 L2,12 L2,14 L6,14 L6,12 Z M14,12 L7,12 L7,14 L14,14 L14,12 Z M6,9 L2,9 L2,11 L6,11 L6,9 Z M15.48,1 C15.79,1 16,1.26 16,1.57 C16,1.73 15.94,1.87 15.83,1.98 L12.97,4.71 L12.97,7.34 C12.97,7.5 12.91,7.64 12.8,7.75 L11.98,8.85 C11.88,8.95 11.73,9.02 11.57,9.02 C11.26,9.02 11,8.76 11,8.45 L11,4.71 L8.17,1.98 C8.06,1.87 8,1.73 8,1.57 C8,1.26 8.26,1 8.57,1 L15.48,1 Z M6,6 L2,6 L2,8 L6,8 L6,6 Z" />
  </svg>
)
TableFiltered.iconName = "TableFiltered"
export const Tag = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.71,8.29 L7.71,0.29 C7.53,0.11 7.28,0 7,0 L1,0 C0.45,0 1.8e-15,0.45 1.8e-15,1 L1.8e-15,7 C1.8e-15,7.28 0.11,7.53 0.29,7.71 L8.29,15.71 L8.3,15.7 C8.49,15.88 8.72,16 9,16 C9.28,16 9.53,15.89 9.71,15.71 L15.71,9.71 C15.89,9.53 16,9.28 16,9 C16,8.72 15.89,8.47 15.71,8.29 L15.71,8.29 Z M4,6 C2.9,6 2,5.1 2,4 C2,2.9 2.9,2 4,2 C5.1,2 6,2.9 6,4 C6,5.1 5.1,6 4,6 Z" />
  </svg>
)
Tag.iconName = "Tag"
export const TakeAction = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9,11 C9,11.55 9.45,12 10,12 C10.28,12 10.53,11.89 10.71,11.71 L14.71,7.71 C14.89,7.53 15,7.28 15,7 C15,6.45 14.55,6 14,6 C13.72,6 13.47,6.11 13.29,6.29 L9.29,10.29 C9.11,10.47 9,10.72 9,11 Z M4,6 C4.28,6 4.53,5.89 4.71,5.71 L8.71,1.71 C8.89,1.53 9,1.28 9,1 C9,0.45 8.55,0 8,0 C7.72,0 7.47,0.11 7.29,0.29 L3.29,4.29 C3.11,4.47 3,4.72 3,5 C3,5.55 3.45,6 4,6 Z M8,10 L13,5 L12.21,4.21 L12.71,3.71 C12.89,3.53 13,3.28 13,3 C13,2.45 12.55,2 12,2 C11.72,2 11.47,2.11 11.29,2.29 L10.79,2.79 L10,2 L5,7 L5.79,7.79 L0.29,13.29 C0.11,13.47 0,13.72 0,14 C0,14.55 0.45,15 1,15 C1.28,15 1.53,14.89 1.71,14.71 L7.21,9.21 L8,10 Z M15,14 L7,14 C6.45,14 6,14.45 6,15 C6,15.55 6.45,16 7,16 L15,16 C15.55,16 16,15.55 16,15 C16,14.45 15.55,14 15,14 Z" />
  </svg>
)
TakeAction.iconName = "TakeAction"
export const TextHighlight = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9,10 L2,10 L2,6 L9,6 L9,4 L1,4 C0.45,4 0,4.45 0,5 L0,11 C0,11.55 0.45,12 1,12 L9,12 L9,10 Z M13,13 L12,13 L12,3 L13,3 C13.55,3 14,2.55 14,2 C14,1.45 13.55,1 13,1 L12,1 C11.63,1 11.3,1.11 11,1.28 C10.7,1.11 10.37,1 10,1 L9,1 C8.45,1 8,1.45 8,2 C8,2.55 8.45,3 9,3 L10,3 L10,13 L9,13 C8.45,13 8,13.45 8,14 C8,14.55 8.45,15 9,15 L10,15 C10.37,15 10.7,14.89 11,14.72 C11.3,14.89 11.63,15 12,15 L13,15 C13.55,15 14,14.55 14,14 C14,13.45 13.55,13 13,13 Z M15,4 L13,4 L13,6 L14,6 L14,10 L13,10 L13,12 L15,12 C15.55,12 16,11.55 16,11 L16,5 C16,4.45 15.55,4 15,4 Z" />
  </svg>
)
TextHighlight.iconName = "TextHighlight"
export const TextLarge = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.96925859,12.7902098 L6.95840868,12.7902098 L6.37974684,11.1818182 L2.51717902,11.1818182 L1.93851718,12.7902098 L0,12.7902098 L3.66003617,3 L5.32368897,3 L8.96925859,12.7902098 Z M4.47016275,5.7972028 L4.44122966,5.7972028 L3.06690778,9.61538462 L5.83001808,9.61538462 L4.47016275,5.7972028 Z M16,12.7902098 L14.4231465,12.7902098 L14.4231465,12.0769231 L14.3942134,12.0769231 C14.3942134,12.0909091 13.8589512,13 12.3110307,13 C10.4593128,13 9.54792043,12.034965 9.54792043,10.8041958 C9.54792043,9.51748252 10.2567812,8.94405594 12.1518987,8.4965035 C13.034358,8.28671329 13.5840868,8.13286713 13.801085,8.00699301 C14.0180832,7.88111888 14.1338156,7.71328671 14.1338156,7.48951049 C14.1338156,7.04195804 13.6998192,6.70629371 12.8318264,6.70629371 C11.8047016,6.70629371 11.4575045,7.18181818 11.2115732,7.92307692 L9.64918626,7.29370629 C10.0108499,6.04895105 11.0813743,5.16783217 12.8028933,5.16783217 C13.7432188,5.16783217 14.5099458,5.40559441 15.1030741,5.88111888 C15.6962025,6.35664336 16,7.0979021 16,8.09090909 L16,12.7902098 Z M12.5280289,9.75524476 C11.5587703,9.97902098 11.3562387,10.2867133 11.3562387,10.6783217 C11.3562387,11.1818182 11.7323689,11.4335664 12.4846293,11.4335664 C13.6274864,11.4335664 14.1916817,10.958042 14.1916817,10.3426573 L14.1916817,9.05594406 L14.1627486,9.05594406 C14.119349,9.12587413 14.0759494,9.1958042 14.0325497,9.23776224 C13.960217,9.30769231 13.4538879,9.53146853 12.5280289,9.75524476 Z"
      fillRule="evenodd"
    />
  </svg>
)
TextLarge.iconName = "TextLarge"
export const TextSmall = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.7875226,11.8321678 L7.15370705,11.8321678 L6.6835443,10.5454545 L3.54520796,10.5454545 L3.07504521,11.8321678 L1.5,11.8321678 L4.47377939,4 L5.82549729,4 L8.7875226,11.8321678 Z M5.13200723,6.23776224 L5.1084991,6.23776224 L3.99186257,9.29230769 L6.23688969,9.29230769 L5.13200723,6.23776224 Z M14.5,11.8321678 L13.2188065,11.8321678 L13.2188065,11.2615385 L13.1952984,11.2615385 C13.1952984,11.2727273 12.7603978,12 11.5027125,12 C9.99819168,12 9.25768535,11.227972 9.25768535,10.2433566 C9.25768535,9.21398601 9.83363472,8.75524476 11.3734177,8.3972028 C12.0904159,8.22937063 12.5370705,8.10629371 12.7133816,8.00559441 C12.8896926,7.9048951 12.9837251,7.77062937 12.9837251,7.59160839 C12.9837251,7.23356643 12.6311031,6.96503497 11.925859,6.96503497 C11.0913201,6.96503497 10.8092224,7.34545455 10.6094033,7.93846154 L9.33996383,7.43496503 C9.63381555,6.43916084 10.5036166,5.73426573 11.9023508,5.73426573 C12.6663653,5.73426573 13.2893309,5.92447552 13.7712477,6.3048951 C14.2531646,6.68531469 14.5,7.27832168 14.5,8.07272727 L14.5,11.8321678 Z M11.6790235,9.4041958 C10.8915009,9.58321678 10.7269439,9.82937063 10.7269439,10.1426573 C10.7269439,10.5454545 11.0325497,10.7468531 11.6437613,10.7468531 C12.5723327,10.7468531 13.0307414,10.3664336 13.0307414,9.87412587 L13.0307414,8.84475524 L13.0072333,8.84475524 C12.9719711,8.9006993 12.9367089,8.95664336 12.9014467,8.99020979 C12.8426763,9.04615385 12.4312839,9.22517483 11.6790235,9.4041958 Z"
      fillRule="evenodd"
    />
  </svg>
)
TextSmall.iconName = "TextSmall"
export const ThDerived = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.6,10 L5.3,10.3 C5.1,10.5 5,10.7 5,11 C5,11.6 5.4,12 6,12 C6.3,12 6.5,11.9 6.7,11.7 L8.7,9.7 C8.9,9.5 9,9.3 9,9 C9,8.7 8.9,8.5 8.7,8.3 L6.7,6.3 C6.5,6.1 6.3,6 6,6 C5.5,6 5,6.4 5,7 C5,7.3 5.1,7.5 5.3,7.7 L5.6,8 L1,8 C0.4,8 0,8.4 0,9 C0,9.6 0.4,10 1,10 L5.6,10 Z M15,1 L2,1 C1.5,1 1,1.5 1,2 L1,7 L3,7 L3,5 L14,5 L14,7 L8.8,7 L9.4,7.6 C9.5,7.7 9.6,7.9 9.7,8 L14,8 L14,10 L9.7,10 C9.6,10.1 9.5,10.3 9.4,10.4 L8.8,11 L14,11 L14,13 L3,13 L3,11 L1,11 L1,14 C1,14.5 1.5,15 2,15 L15,15 C15.6,15 16,14.5 16,14 L16,2 C16,1.5 15.6,1 15,1 Z" />
  </svg>
)
ThDerived.iconName = "ThDerived"
export const ThList = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1 L1,1 C0.4,1 0,1.5 0,2 L0,14 C0,14.6 0.4,15 1,15 L15,15 C15.6,15 16,14.6 16,14 L16,2 C16,1.5 15.6,1 15,1 Z M14,13 L2,13 L2,11 L14,11 L14,13 Z M14,10 L2,10 L2,8 L14,8 L14,10 Z M14,7 L2,7 L2,5 L14,5 L14,7 Z" />
  </svg>
)
ThList.iconName = "ThList"
export const Th = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,1 L1,1 C0.4,1 0,1.5 0,2 L0,14 C0,14.6 0.4,15 1,15 L15,15 C15.6,15 16,14.6 16,14 L16,2 C16,1.5 15.6,1 15,1 Z M6,13 L2,13 L2,11 L6,11 L6,13 Z M6,10 L2,10 L2,8 L6,8 L6,10 Z M6,7 L2,7 L2,5 L6,5 L6,7 Z M14,13 L7,13 L7,11 L14,11 L14,13 Z M14,10 L7,10 L7,8 L14,8 L14,10 Z M14,7 L7,7 L7,5 L14,5 L14,7 Z" />
  </svg>
)
Th.iconName = "Th"
export const ThumbsDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.00093708,1.99812001 L0.00093708407,1.99812001 L0.00093708407,8.99812001 L2.00093708,8.99812001 C2.55093708,8.99812001 3.00093708,8.54812001 3.00093708,7.99812001 L3.00093708,2.99812001 C3.00093708,2.44812001 2.55093708,1.99812001 2.00093708,1.99812001 Z M15.9909371,6.37812001 C16.0709371,5.79812001 15.5509371,5.35812001 14.8409371,5.32812001 C14.5909371,5.31812001 14.3209371,5.29812001 14.0309371,5.27812001 C14.0509371,5.27812001 14.0809371,5.26812001 14.1009371,5.26812001 C14.8009371,5.16812001 15.4409371,4.77812001 15.5109371,4.19812001 C15.5709371,3.61812001 15.0509371,3.22812001 14.3409371,3.15812001 C14.0909371,3.13812001 13.8209371,3.11812001 13.5509371,3.09812001 C14.0209371,2.94812001 14.3909371,2.67812001 14.4209371,2.16812001 C14.4609371,1.58812001 13.6309371,1.13812001 12.9209371,1.07812001 C12.6509371,1.05812001 12.4109371,1.03812001 12.1909371,1.02812001 L12.1009371,1.02812001 C11.8709371,1.00812001 11.6709371,1.00812001 11.4809371,0.998120006 C8.35093708,0.948120006 5.66093708,1.46812001 4.00093708,2.50812001 L4.00093708,8.50812001 C6.14093708,9.79812001 8.76093708,12.09812 8.21093708,14.01812 C8.03093708,14.60812 8.52093708,15.06812 9.19093708,14.99812 C10.0009371,14.90812 10.5609371,14.08812 10.5909371,13.21812 C10.6309371,12.21812 10.4409371,11.20812 10.0909371,10.30812 C10.0509371,10.05812 10.1009371,9.80812001 10.4609371,9.77812001 C10.9509371,9.74812001 11.5709371,9.71812001 12.0509371,9.69812001 C12.3109371,9.69812001 12.5609371,9.68812001 12.8009371,9.67812001 L12.8109371,9.67812001 C13.2209371,9.65812001 13.6109371,9.62812001 13.9409371,9.58812001 C14.6409371,9.49812001 15.2909371,9.11812001 15.3709371,8.53812001 C15.4509371,7.95812001 14.9309371,7.56812001 14.2209371,7.48812001 C14.1709371,7.47812001 14.1109371,7.47812001 14.0609371,7.46812001 C14.2309371,7.45812001 14.3909371,7.43812001 14.5509371,7.41812001 C15.2709371,7.33812001 15.9209371,6.95812001 15.9909371,6.37812001 Z" />
  </svg>
)
ThumbsDown.iconName = "ThumbsDown"
export const ThumbsUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.9909371,9.62623276 C15.9109371,9.04623276 15.2609371,8.66623276 14.5609371,8.57623276 C14.4109371,8.55623276 14.2409371,8.53623276 14.0709371,8.52623276 C14.1309371,8.51623276 14.1809371,8.51623276 14.2309371,8.50623276 C14.9409371,8.42623276 15.4609371,8.03623276 15.3809371,7.45623276 C15.3009371,6.87623276 14.6509371,6.49623276 13.9509371,6.40623276 C13.6109371,6.36623276 13.2309371,6.33623276 12.8209371,6.31623276 L12.8109371,6.31623276 C12.5709371,6.30623276 12.3209371,6.29623276 12.0609371,6.29623276 C11.5809371,6.27623276 10.9509371,6.25623276 10.4709371,6.21623276 C10.1109371,6.18623276 10.0609371,5.93623276 10.1009371,5.68623276 C10.4509371,4.78623276 10.6409371,3.77623276 10.6009371,2.77623276 C10.5609371,1.92623276 10.0009371,1.09623276 9.19093708,1.00623276 C8.52093708,0.93623276 8.03093708,1.39623276 8.20093708,1.98623276 C8.76093708,3.91623276 6.13093708,6.20623276 4.00093708,7.49623276 L4.00093708,13.4962328 C5.66093708,14.5262328 8.35093708,15.0562328 11.4809371,14.9962328 C11.6709371,14.9962328 11.8709371,14.9862328 12.1009371,14.9762328 L12.1909371,14.9762328 C12.4109371,14.9662328 12.6509371,14.9462328 12.9209371,14.9262328 C13.6309371,14.8662328 14.4609371,14.4162328 14.4209371,13.8362328 C14.3909371,13.3262328 14.0209371,13.0462328 13.5509371,12.9062328 C13.8209371,12.8862328 14.0909371,12.8662328 14.3409371,12.8462328 C15.0509371,12.7862328 15.5809371,12.3962328 15.5109371,11.8062328 C15.4509371,11.2262328 14.8109371,10.8362328 14.1009371,10.7362328 C14.0809371,10.7362328 14.0509371,10.7262328 14.0309371,10.7262328 C14.3209371,10.7062328 14.6009371,10.6962328 14.8409371,10.6762328 C15.5509371,10.6462328 16.0709371,10.2062328 15.9909371,9.62623276 Z M2.00093708,7.00623276 L0.00093708407,7.00623276 L0.00093708407,14.0062328 L2.00093708,14.0062328 C2.55093708,14.0062328 3.00093708,13.5562328 3.00093708,13.0062328 L3.00093708,8.00623276 C3.00093708,7.44623276 2.55093708,7.00623276 2.00093708,7.00623276 Z" />
  </svg>
)
ThumbsUp.iconName = "ThumbsUp"
export const TickCircle = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,16 C3.58,16 0,12.42 0,8 C0,3.58 3.58,0 8,0 C12.42,0 16,3.58 16,8 C16,12.42 12.42,16 8,16 Z M12,5 C11.72,5 11.47,5.11 11.29,5.29 L7,9.59 L4.71,7.29 C4.53,7.11 4.28,7 4,7 C3.45,7 3,7.45 3,8 C3,8.28 3.11,8.53 3.29,8.71 L6.29,11.71 C6.47,11.89 6.72,12 7,12 C7.28,12 7.53,11.89 7.71,11.71 L12.71,6.71 C12.89,6.53 13,6.28 13,6 C13,5.45 12.55,5 12,5 Z" />
  </svg>
)
TickCircle.iconName = "TickCircle"
export const Tick = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,3 C13.72,3 13.47,3.11 13.29,3.29 L6,10.59 L2.71,7.29 C2.53,7.11 2.28,7 2,7 C1.45,7 1,7.45 1,8 C1,8.28 1.11,8.53 1.29,8.71 L5.29,12.71 C5.47,12.89 5.72,13 6,13 C6.28,13 6.53,12.89 6.71,12.71 L14.71,4.71 C14.89,4.53 15,4.28 15,4 C15,3.45 14.55,3 14,3 Z" />
  </svg>
)
Tick.iconName = "Tick"
export const Time = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M8,14 C4.69,14 2,11.31 2,8 C2,4.69 4.69,2 8,2 C11.31,2 14,4.69 14,8 C14,11.31 11.31,14 8,14 Z M9,7.59 L9,4 C9,3.45 8.55,3 8,3 C7.45,3 7,3.45 7,4 L7,8 C7,8.28 7.11,8.53 7.29,8.71 L9.29,10.71 C9.47,10.89 9.72,11 10,11 C10.55,11 11,10.55 11,10 C11,9.72 10.89,9.47 10.71,9.29 L9,7.59 Z" />
  </svg>
)
Time.iconName = "Time"
export const TimelineAreaChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,2.59 L9.91,7.68 L6.6,5.2 L6.59,5.21 C6.42,5.09 6.23,5 6,5 C5.76,5 5.56,5.09 5.38,5.23 L5.38,5.22 L3,7.12 L3,11 L15,11 L15,2.59 Z M15,12 L2,12 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z" />
  </svg>
)
TimelineAreaChart.iconName = "TimelineAreaChart"
export const TimelineBarChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.5,12 L8.5,12 C9.05,12 9.5,11.55 9.5,11 L9.5,2 C9.5,1.45 9.05,1 8.5,1 L7.5,1 C6.95,1 6.5,1.45 6.5,2 L6.5,11 C6.5,11.55 6.95,12 7.5,12 Z M12.5,12 L13.5,12 C14.05,12 14.5,11.55 14.5,11 L14.5,5 C14.5,4.45 14.05,4 13.5,4 L12.5,4 C11.95,4 11.5,4.45 11.5,5 L11.5,11 C11.5,11.55 11.95,12 12.5,12 Z M14.5,13 L1.5,13 C0.95,13 0.5,13.45 0.5,14 C0.5,14.55 0.95,15 1.5,15 L14.5,15 C15.05,15 15.5,14.55 15.5,14 C15.5,13.45 15.05,13 14.5,13 Z M2.5,12 L3.5,12 C4.05,12 4.5,11.55 4.5,11 L4.5,7 C4.5,6.45 4.05,6 3.5,6 L2.5,6 C1.95,6 1.5,6.45 1.5,7 L1.5,11 C1.5,11.55 1.95,12 2.5,12 Z" />
  </svg>
)
TimelineBarChart.iconName = "TimelineBarChart"
export const TimelineEvents = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.5,11.5 L7.5,11.5 L7.5,12.5 L8.5,12.5 L8.5,11.5 Z M4.5,11.5 L3.5,11.5 L3.5,12.5 L4.5,12.5 L4.5,11.5 Z M11.5,3.5 C12.1,3.5 12.5,3 12.5,2.5 L12.5,1.5 C12.5,1 12.1,0.5 11.5,0.5 C10.9,0.5 10.5,1 10.5,1.5 L10.5,2.5 C10.5,3 11,3.5 11.5,3.5 Z M4.5,3.5 C5,3.5 5.5,3 5.5,2.5 L5.5,1.5 C5.5,1 5,0.5 4.5,0.5 C4,0.5 3.5,1 3.5,1.5 L3.5,2.5 C3.5,3 4,3.5 4.5,3.5 Z M14.5,1.5 L13.5,1.5 L13.5,2.5 C13.5,3.6 12.6,4.5 11.5,4.5 C10.4,4.5 9.5,3.6 9.5,2.5 L9.5,1.5 L6.5,1.5 L6.5,2.5 C6.5,3.6 5.6,4.5 4.5,4.5 C3.4,4.5 2.5,3.6 2.5,2.5 L2.5,1.5 L1.5,1.5 C1,1.5 0.5,2 0.5,2.5 L0.5,14.5 C0.5,15 1,15.5 1.5,15.5 L14.5,15.5 C15.1,15.5 15.5,15 15.5,14.5 L15.5,2.5 C15.5,2 15.1,1.5 14.5,1.5 Z M5.5,13.5 L2.5,13.5 L2.5,10.5 L5.5,10.5 L5.5,13.5 Z M5.5,9.5 L2.5,9.5 L2.5,6.5 L5.5,6.5 L5.5,9.5 Z M9.5,13.5 L6.5,13.5 L6.5,10.5 L9.5,10.5 L9.5,13.5 Z M9.5,9.5 L6.5,9.5 L6.5,6.5 L9.5,6.5 L9.5,9.5 Z M13.5,13.5 L10.5,13.5 L10.5,10.5 L13.5,10.5 L13.5,13.5 Z M13.5,9.5 L10.5,9.5 L10.5,6.5 L13.5,6.5 L13.5,9.5 Z M12.5,7.5 L11.5,7.5 L11.5,8.5 L12.5,8.5 L12.5,7.5 Z" />
  </svg>
)
TimelineEvents.iconName = "TimelineEvents"
export const TimelineLineChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,12 L2,12 L2,9.41 L5,6.41 L8.29,9.7 C8.47,9.89 8.72,10 9,10 C9.28,10 9.53,9.89 9.71,9.71 L15.71,3.71 C15.89,3.53 16,3.28 16,3 C16,2.45 15.55,2 15,2 C14.72,2 14.47,2.11 14.29,2.29 L9,7.59 L5.71,4.29 C5.53,4.11 5.28,4 5,4 C4.72,4 4.47,4.11 4.29,4.29 L2,6.59 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z" />
  </svg>
)
TimelineLineChart.iconName = "TimelineLineChart"
export const Tint = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.89,1 C7.89,1 2.99,7.28 2.99,9.9 C3,12.72 5.33,15 7.98,15 C10.63,14.99 13.01,12.7 13.01,9.87 C13,7.17 7.89,1 7.89,1 Z" />
  </svg>
)
Tint.iconName = "Tint"
export const Torch = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5,15 C5,15.55 5.45,16 6,16 L10,16 C10.55,16 11,15.55 11,15 L11,14 L5,14 L5,15 Z M12,0 L4,0 C3.45,0 3,0.45 3,1 L3,2 L13,2 L13,1 C13,0.45 12.55,0 12,0 Z M5,7 L5,13 L11,13 L11,7 L13,3 L3,3 L5,7 Z M7,7 C7,6.45 7.45,6 8,6 C8.55,6 9,6.45 9,7 L9,9 C9,9.55 8.55,10 8,10 C7.45,10 7,9.55 7,9 L7,7 Z" />
  </svg>
)
Torch.iconName = "Torch"
export const Translate = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.89,14.56 L11.9,6.56 L11.89,6.56 C11.72,6.23 11.39,6 11,6 C10.61,6 10.28,6.23 10.11,6.56 L10.1,6.56 L9,8.76 L7.17,7.38 L7.4,7.2 C8.37,6.47 9,5.31 9,4 L9,3 L10,3 C10.55,3 11,2.55 11,2 C11,1.45 10.55,1 10,1 L7,1 C7,0.45 6.55,0 6,0 L5,0 C4.45,0 4,0.45 4,1 L1,1 C0.45,1 0,1.45 0,2 C0,2.55 0.45,3 1,3 L7,3 L7,4 C7,4.66 6.68,5.25 6.18,5.61 L5.5,6.12 L4.82,5.62 C4.32,5.25 4,4.66 4,4 L2,4 C2,5.31 2.63,6.47 3.6,7.2 L3.83,7.37 L1.4,9.2 L1.41,9.21 C1.17,9.4 1,9.67 1,10 C1,10.55 1.45,11 2,11 C2.23,11 2.42,10.91 2.59,10.79 L2.6,10.8 L5.5,8.63 L8.1,10.58 L6.11,14.56 L6.12,14.56 C6.05,14.69 6,14.84 6,15 C6,15.55 6.45,16 7,16 C7.39,16 7.72,15.77 7.89,15.44 L7.9,15.44 L8.62,14 L13.38,14 L14.1,15.45 L14.11,15.45 C14.28,15.77 14.61,16 15,16 C15.55,16 16,15.55 16,15 C16,14.84 15.95,14.69 15.89,14.56 Z M9.62,12 L11,9.24 L12.38,12 L9.62,12 Z" />
  </svg>
)
Translate.iconName = "Translate"
export const Trash = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5,4.00249844 L1.5,4.00249844 C1.22,4.00249844 1,4.22236102 1,4.50218613 C1,4.78201124 1.22,5.00187383 1.5,5.00187383 L2,5.00187383 L2,14.9956277 C2,15.5452842 2.45,15.9950031 3,15.9950031 L13,15.9950031 C13.55,15.9950031 14,15.5452842 14,14.9956277 L14,5.00187383 L14.5,5.00187383 C14.78,5.00187383 15,4.78201124 15,4.50218613 C15,4.22236102 14.78,4.00249844 14.5,4.00249844 Z M6,12.996877 C6,13.5465334 5.55,13.9962523 5,13.9962523 C4.45,13.9962523 4,13.5465334 4,12.996877 L4,7.00062461 C4,6.45096814 4.45,6.00124922 5,6.00124922 C5.55,6.00124922 6,6.45096814 6,7.00062461 L6,12.996877 Z M9,12.996877 C9,13.5465334 8.55,13.9962523 8,13.9962523 C7.45,13.9962523 7,13.5465334 7,12.996877 L7,7.00062461 C7,6.45096814 7.45,6.00124922 8,6.00124922 C8.55,6.00124922 9,6.45096814 9,7.00062461 L9,12.996877 Z M12,12.996877 C12,13.5465334 11.55,13.9962523 11,13.9962523 C10.45,13.9962523 10,13.5465334 10,12.996877 L10,7.00062461 C10,6.45096814 10.45,6.00124922 11,6.00124922 C11.55,6.00124922 12,6.45096814 12,7.00062461 L12,12.996877 Z M14,1.00437227 L10,1.00437227 C10,0.454715803 9.55,0.00499687695 9,0.00499687695 L7,0.00499687695 C6.45,0.00499687695 6,0.454715803 6,1.00437227 L2,1.00437227 C1.45,1.00437227 1,1.45409119 1,2.00374766 L1,3.00312305 L15,3.00312305 L15,2.00374766 C15,1.45409119 14.55,1.00437227 14,1.00437227 Z" />
  </svg>
)
Trash.iconName = "Trash"
export const TrendingDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,7 C14.45,7 14,7.45 14,8 L14,8.59 L9.71,4.29 C9.53,4.11 9.28,4 9,4 C8.84,4 8.69,4.05 8.56,4.11 L8.56,4.1 L5,5.88 L1.45,4.11 L1.45,4.12 C1.31,4.05 1.16,4 1,4 C0.45,4 0,4.45 0,5 C0,5.39 0.23,5.72 0.56,5.89 L0.56,5.9 L4.56,7.9 L4.56,7.89 C4.69,7.95 4.84,8 5,8 C5.16,8 5.31,7.95 5.44,7.89 L5.44,7.9 L8.8,6.22 L12.59,10 L12,10 C11.45,10 11,10.45 11,11 C11,11.55 11.45,12 12,12 L15,12 C15.55,12 16,11.55 16,11 L16,8 C16,7.45 15.55,7 15,7 Z" />
  </svg>
)
TrendingDown.iconName = "TrendingDown"
export const TrendingUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,4 L12,4 C11.45,4 11,4.45 11,5 C11,5.55 11.45,6 12,6 L12.59,6 L8.8,9.78 L5.45,8.11 L5.45,8.12 C5.31,8.05 5.16,8 5,8 C4.84,8 4.69,8.05 4.56,8.11 L4.56,8.1 L0.56,10.1 L0.56,10.11 C0.23,10.28 0,10.61 0,11 C0,11.55 0.45,12 1,12 C1.16,12 1.31,11.95 1.44,11.89 L1.44,11.9 L5,10.12 L8.55,11.9 L8.55,11.89 C8.69,11.95 8.84,12 9,12 C9.28,12 9.53,11.89 9.71,11.71 L14,7.41 L14,8 C14,8.55 14.45,9 15,9 C15.55,9 16,8.55 16,8 L16,5 C16,4.45 15.55,4 15,4 Z" />
  </svg>
)
TrendingUp.iconName = "TrendingUp"
export const TwoColumns = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.00249844,0.00499687695 L1.00437227,0.00499687695 C0.454715803,0.00499687695 0.00499687695,0.454715803 0.00499687695,1.00437227 L0.00499687695,14.9956277 C0.00499687695,15.5452842 0.454715803,15.9950031 1.00437227,15.9950031 L4.00249844,15.9950031 C4.5521549,15.9950031 5.00187383,15.5452842 5.00187383,14.9956277 L5.00187383,1.00437227 C5.00187383,0.454715803 4.5521549,0.00499687695 4.00249844,0.00499687695 Z M15.7051843,7.30043723 L13.7064335,5.30168645 C13.5265459,5.12179888 13.2767021,5.01186758 12.996877,5.01186758 C12.4472205,5.01186758 11.9975016,5.46158651 11.9975016,6.01124297 L11.9975016,10.0087445 C11.9975016,10.558401 12.4472205,11.0081199 12.996877,11.0081199 C13.2767021,11.0081199 13.5265459,10.8981886 13.7064335,10.7183011 L15.7051843,8.71955028 C15.8850718,8.53966271 15.9950031,8.28981886 15.9950031,8.00999375 C15.9950031,7.73016864 15.8850718,7.4803248 15.7051843,7.30043723 L15.7051843,7.30043723 Z M9.99875078,0.00499687695 L7.00062461,0.00499687695 C6.45096814,0.00499687695 6.00124922,0.454715803 6.00124922,1.00437227 L6.00124922,14.9956277 C6.00124922,15.5452842 6.45096814,15.9950031 7.00062461,15.9950031 L9.99875078,15.9950031 C10.5484072,15.9950031 10.9981262,15.5452842 10.9981262,14.9956277 L10.9981262,1.00437227 C10.9981262,0.454715803 10.5484072,0.00499687695 9.99875078,0.00499687695 Z" />
  </svg>
)
TwoColumns.iconName = "TwoColumns"
export const Underline = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,13 C10.8,13 13,10.8 13,8 L13,2 C13,1.4 12.6,1 12,1 C11.4,1 11,1.4 11,2 L11,8 C11,9.7 9.7,11 8,11 C6.3,11 5,9.7 5,8 L5,2 C5,1.4 4.6,1 4,1 C3.4,1 3,1.4 3,2 L3,8 C3,10.8 5.2,13 8,13 Z M13.5,14 L2.5,14 C2.2,14 2,14.2 2,14.5 C2,14.8 2.2,15 2.5,15 L13.5,15 C13.8,15 14,14.8 14,14.5 C14,14.2 13.8,14 13.5,14 Z" />
  </svg>
)
Underline.iconName = "Underline"
export const Undo = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4,11 C2.9,11 2,11.9 2,13 C2,14.1 2.9,15 4,15 C5.1,15 6,14.1 6,13 C6,11.9 5.1,11 4,11 Z M11,4 L3.41,4 L4.7,2.71 C4.89,2.53 5,2.28 5,2 C5,1.45 4.55,1 4,1 C3.72,1 3.47,1.11 3.29,1.29 L0.29,4.29 C0.11,4.47 0,4.72 0,5 C0,5.28 0.11,5.53 0.29,5.71 L3.29,8.71 C3.47,8.89 3.72,9 4,9 C4.55,9 5,8.55 5,8 C5,7.72 4.89,7.47 4.71,7.29 L3.41,6 L11,6 C12.66,6 14,7.34 14,9 C14,10.66 12.66,12 11,12 L7,12 L7,14 L11,14 C13.76,14 16,11.76 16,9 C16,6.24 13.76,4 11,4 Z" />
  </svg>
)
Undo.iconName = "Undo"
export const Unlock = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.9975016,0.00499687695 C9.78888195,0.00499687695 8,1.79387883 8,4.00249844 L8,7.00062461 L1.00437227,7.00062461 C0.454715803,7.00062461 0.00499687695,7.45034354 0.00499687695,8 L0.00499687695,14.9956277 C0.00499687695,15.5452842 0.454715803,15.9950031 1.00437227,15.9950031 L12.996877,15.9950031 C13.5465334,15.9950031 13.9962523,15.5452842 13.9962523,14.9956277 L13.9962523,8 C13.9962523,7.45034354 13.5465334,7.00062461 12.996877,7.00062461 L9.99875078,7.00062461 L9.99875078,4.00249844 C9.99875078,2.90318551 10.8981886,2.00374766 11.9975016,2.00374766 C13.0968145,2.00374766 13.9962523,2.90318551 13.9962523,4.00249844 L13.9962523,5.00187383 C13.9962523,5.55153029 14.4459713,6.00124922 14.9956277,6.00124922 C15.5452842,6.00124922 15.9950031,5.55153029 15.9950031,5.00187383 L15.9950031,4.00249844 C15.9950031,1.79387883 14.2061212,0.00499687695 11.9975016,0.00499687695 Z" />
  </svg>
)
Unlock.iconName = "Unlock"
export const Unpin = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.4,1.005 C8.9,1.505 9,2.485 9.55,3.535 L4.39,7.545 C2.86,6.505 1.53,6.075 1.01,6.595 L4.51,10.095 C4.49,10.115 3.11,12.895 3.11,12.895 L5.91,11.495 L9.41,14.995 C9.94,14.465 9.51,13.135 8.46,11.615 L12.48,6.455 C13.52,7.005 14.49,7.105 14.99,6.595 L9.4,1.005 Z" />
  </svg>
)
Unpin.iconName = "Unpin"
export const Unresolve = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,3 C10.45,3 9.93,3.09 9.43,3.26 C10.7,4.44 11.5,6.13 11.5,8 C11.5,9.87 10.7,11.56 9.43,12.74 C9.93,12.91 10.45,13 11,13 C13.76,13 16,10.76 16,8 C16,5.24 13.76,3 11,3 Z M9.78,9.38 L9.87,9.11 C9.95,8.75 10,8.38 10,8 C10,7.62 9.95,7.25 9.87,6.89 L9.78,6.62 C9.7,6.35 9.61,6.08 9.49,5.83 L9.37,5.62 C9.23,5.35 9.06,5.1 8.86,4.86 C8.84,4.83 8.81,4.79 8.78,4.76 C8.54,4.49 8.29,4.24 8,4.02 C7.57,3.7 7.08,3.44 6.55,3.27 L6.56,3.26 C6.46,3.23 6.36,3.21 6.26,3.18 C6.14,3.15 6.03,3.11 5.9,3.09 C5.61,3.04 5.31,3 5,3 C2.24,3 0,5.24 0,8 C0,10.76 2.24,13 5,13 C5.31,13 5.61,12.96 5.9,12.91 C6.02,12.89 6.14,12.85 6.26,12.82 C6.36,12.79 6.47,12.78 6.56,12.74 L6.55,12.73 C7.43,12.44 8.19,11.93 8.77,11.24 C8.8,11.21 8.83,11.17 8.86,11.14 C9.05,10.9 9.22,10.65 9.37,10.38 C9.41,10.31 9.45,10.24 9.48,10.17 C9.61,9.92 9.71,9.65 9.78,9.38 L9.78,9.38 Z" />
  </svg>
)
Unresolve.iconName = "Unresolve"
export const Upload = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 Z M11,8 C10.72,8 10.47,7.89 10.29,7.71 L9,6.41 L9,12 C9,12.55 8.55,13 8,13 C7.45,13 7,12.55 7,12 L7,6.41 L5.71,7.71 C5.53,7.89 5.28,8 5,8 C4.45,8 4,7.55 4,7 C4,6.72 4.11,6.47 4.29,6.29 L7.29,3.29 C7.47,3.11 7.72,3 8,3 C8.28,3 8.53,3.11 8.71,3.29 L11.71,6.29 C11.89,6.47 12,6.72 12,7 C12,7.55 11.55,8 11,8 Z" />
  </svg>
)
Upload.iconName = "Upload"
export const User = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.98502807,0 C3.57330006,0 0,3.5777639 0,7.99500312 C0,8.25484072 0.00998128509,8.51467833 0.0399251404,8.77451593 C0.0499064255,8.86445971 0.0698689956,8.9544035 0.0798502807,9.05434104 C0.0998128509,9.20424735 0.119775421,9.36414741 0.149719276,9.52404747 C0.169681847,9.63397876 0.199625702,9.74391006 0.229569557,9.8638351 C0.259513412,9.9937539 0.289457268,10.1236727 0.329382408,10.2435978 C0.369307548,10.3635228 0.409232689,10.4934416 0.449157829,10.6133666 C0.489082969,10.7232979 0.52900811,10.8232355 0.56893325,10.9331668 C0.618839676,11.0630856 0.678727386,11.1930044 0.738615097,11.3229232 C0.778540237,11.412867 0.818465377,11.492817 0.868371803,11.5827608 C0.938240799,11.7226733 1.00810979,11.8525921 1.08796007,11.9825109 C1.12788522,12.0524672 1.16781036,12.1124297 1.2077355,12.182386 L1.47723019,12.6021237 C1.50717405,12.6420987 1.54709919,12.6920675 1.57704304,12.7320425 C2.52526513,14.0212367 3.85277604,15.0206121 5.39987523,15.5502811 C5.42981909,15.5602748 5.44978166,15.5702686 5.46974423,15.5802623 C5.83905178,15.7001874 6.21834061,15.8001249 6.60761073,15.8700812 C6.67747973,15.880075 6.73736744,15.8900687 6.80723643,15.9000625 C7.19650655,15.960025 7.59575795,16 8.00499064,16 C8.41422333,16 8.81347473,15.960025 9.20274485,15.9000625 C9.27261385,15.8900687 9.33250156,15.880075 9.40237056,15.8700812 C9.79164067,15.8001249 10.1709295,15.7101811 10.5402371,15.5802623 C10.5701809,15.5702686 10.5901435,15.5602748 10.6101061,15.5502811 C12.1572052,15.0106184 13.4847162,14.0212367 14.4329382,12.7320425 C14.4628821,12.6920675 14.492826,12.6520924 14.5227698,12.6021237 C14.6225827,12.4622111 14.7124142,12.3222986 14.8022458,12.182386 C14.8421709,12.1124297 14.8820961,12.0524672 14.9220212,11.9825109 C15.0018715,11.8525921 15.0717405,11.7126796 15.1416095,11.572767 C15.1815346,11.492817 15.2214598,11.4028732 15.2613849,11.3129294 C15.3212726,11.1830106 15.371179,11.0530918 15.4310667,10.923173 C15.4709919,10.8232355 15.510917,10.7133042 15.5508422,10.6033729 C15.5907673,10.4834478 15.6306925,10.3635228 15.6706176,10.233604 C15.7105427,10.1036852 15.7404866,9.98376015 15.7704304,9.85384135 C15.8003743,9.74391006 15.8303182,9.63397876 15.8502807,9.51405372 C15.8802246,9.35415365 15.9001871,9.20424735 15.9201497,9.04434728 C15.930131,8.9544035 15.9500936,8.86445971 15.9600749,8.76452217 C15.9800374,8.50468457 16,8.25484072 16,7.98500937 C15.9700561,3.5777639 12.3967561,0 7.98502807,0 L7.98502807,0 Z M7.98502807,14.3910056 C6.00873362,14.3910056 4.24204616,13.4915678 3.07423581,12.0824485 C3.74298191,11.7226733 4.56144729,11.4228607 5.21023082,11.1330418 C6.36805989,10.6133666 6.24828447,10.2935665 6.28820961,9.8638351 C6.29819089,9.80387258 6.29819089,9.75390381 6.29819089,9.69394129 C5.8889582,9.33416615 5.5595758,8.83447845 5.33998752,8.25484072 L5.33998752,8.24484697 C5.33998752,8.23485322 5.33000624,8.22485946 5.33000624,8.22485946 C5.28009981,8.09494066 5.24017467,7.96502186 5.21023082,7.83510306 C4.93075483,7.78513429 4.77105427,7.48532167 4.71116656,7.20549656 C4.65127885,7.09556527 4.53150343,6.82573392 4.56144729,6.51592755 C4.60137243,6.10618364 4.76107299,5.92629606 4.94073612,5.84634603 L4.94073612,5.78638351 C4.94073612,5.27670206 4.99064255,4.54715803 5.08047411,4.06745784 C5.10043668,3.93753904 5.13038054,3.80762024 5.17030568,3.67770144 C5.33998752,3.08806996 5.69931379,2.558401 6.17841547,2.1886321 C6.66749844,1.80886946 7.3661884,1.59900062 7.99500936,1.59900062 C8.61384903,1.59900062 9.31253899,1.7988757 9.81160324,2.1886321 C10.2907049,2.558401 10.6500312,3.08806996 10.819713,3.67770144 C10.8596382,3.80762024 10.889582,3.93753904 10.9095446,4.07745159 C10.9993762,4.55715178 11.0492826,5.28669582 11.0492826,5.79637726 L11.0492826,5.86633354 C11.2289457,5.94628357 11.378665,6.12617114 11.4185901,6.5259213 C11.448534,6.83572767 11.3187773,7.10555903 11.2588896,7.21549032 C11.1990019,7.48532167 11.0492826,7.78513429 10.7797879,7.83510306 C10.749844,7.96502186 10.7099189,8.09494066 10.6600125,8.21486571 C10.6600125,8.22485946 10.6500312,8.25484072 10.6500312,8.25484072 C10.4404242,8.8244847 10.1110418,9.31417864 9.71179039,9.67395378 C9.71179039,9.7339163 9.72177168,9.80387258 9.72177168,9.8638351 C9.76169682,10.2935665 9.60199626,10.6133666 10.7698066,11.1330418 C11.4185901,11.4228607 12.2370555,11.7326671 12.9058016,12.0824485 C11.72801,13.4915678 9.96132252,14.3910056 7.98502807,14.3910056 Z" />
  </svg>
)
User.iconName = "User"
export const Variable = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.94,3.64 C4.41,2.98 4.99,2.4 5.7,1.91 L5.83,1.51 C4.72,1.96 3.78,2.52 2.99,3.21 C1.97,4.09 1.19,5.11 0.67,6.26 C0.22,7.25 0,8.24 0,9.24 C0,10.99 0.66,12.74 1.99,14.49 L2.12,14.07 C1.73,13.13 1.53,12.25 1.53,11.44 C1.53,10.16 1.75,8.8 2.2,7.34 C2.65,5.89 3.23,4.65 3.94,3.64 Z M11.45,10.05 L11.18,9.9 C10.88,10.31 10.66,10.56 10.52,10.67 C10.43,10.73 10.31,10.77 10.19,10.77 C10.04,10.77 9.89,10.67 9.74,10.49 C9.49,10.16 9.15,9.27 8.73,7.8 C9.11,7.15 9.42,6.72 9.68,6.52 C9.87,6.37 10.07,6.3 10.27,6.3 C10.35,6.3 10.49,6.33 10.7,6.38 C10.9,6.44 11.09,6.46 11.24,6.46 C11.46,6.46 11.64,6.39 11.78,6.24 C11.93,6.09 12,5.9 12,5.67 C12,5.42 11.93,5.22 11.78,5.08 C11.63,4.93 11.43,4.86 11.15,4.86 C10.91,4.86 10.68,4.92 10.46,5.03 C10.25,5.14 9.97,5.39 9.64,5.77 C9.39,6.05 9.03,6.55 8.54,7.25 C8.37,6.39 8.04,5.59 7.57,4.87 L4.98,5.31 L4.93,5.58 C5.12,5.54 5.29,5.52 5.42,5.52 C5.68,5.52 5.89,5.63 6.06,5.85 C6.32,6.19 6.69,7.23 7.17,8.97 C6.8,9.46 6.54,9.78 6.4,9.93 C6.17,10.17 5.99,10.33 5.84,10.4 C5.73,10.46 5.6,10.49 5.45,10.49 C5.34,10.49 5.16,10.43 4.92,10.31 C4.75,10.24 4.6,10.2 4.47,10.2 C4.22,10.2 4.01,10.28 3.85,10.44 C3.69,10.6 3.61,10.81 3.61,11.05 C3.61,11.28 3.69,11.47 3.84,11.62 C3.99,11.77 4.19,11.84 4.45,11.84 C4.7,11.84 4.93,11.79 5.15,11.69 C5.37,11.59 5.64,11.37 5.97,11.04 C6.3,10.71 6.75,10.18 7.33,9.45 C7.55,10.14 7.75,10.64 7.91,10.96 C8.07,11.27 8.26,11.5 8.47,11.64 C8.68,11.78 8.94,11.85 9.26,11.85 C9.57,11.85 9.88,11.74 10.19,11.52 C10.59,11.23 11.01,10.75 11.45,10.05 L11.45,10.05 Z M14.01,1.51 L13.89,1.93 C14.28,2.88 14.48,3.75 14.48,4.57 C14.48,5.66 14.31,6.83 13.98,8.08 C13.72,9.04 13.38,9.95 12.96,10.79 C12.54,11.64 12.14,12.3 11.75,12.77 C11.36,13.25 10.88,13.69 10.31,14.09 L10.17,14.49 C11.28,14.04 12.22,13.47 13.01,12.79 C14.04,11.9 14.82,10.88 15.34,9.74 C15.78,8.75 16,7.75 16,6.74 C16,5.01 15.34,3.26 14.01,1.51 Z" />
  </svg>
)
Variable.iconName = "Variable"
export const VerticalBarChartAsc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,7 C5.45,7 5,7.45 5,8 L5,15 C5,15.55 5.45,16 6,16 C6.55,16 7,15.55 7,15 L7,8 C7,7.45 6.55,7 6,7 Z M2,9 C1.45,9 1,9.45 1,10 L1,15 C1,15.55 1.45,16 2,16 C2.55,16 3,15.55 3,15 L3,10 C3,9.45 2.55,9 2,9 Z M10,4 C9.45,4 9,4.45 9,5 L9,15 C9,15.55 9.45,16 10,16 C10.55,16 11,15.55 11,15 L11,5 C11,4.45 10.55,4 10,4 Z M14,0 C13.45,0 13,0.45 13,1 L13,15 C13,15.55 13.45,16 14,16 C14.55,16 15,15.55 15,15 L15,1 C15,0.45 14.55,0 14,0 Z" />
  </svg>
)
VerticalBarChartAsc.iconName = "VerticalBarChartAsc"
export const VerticalBarChartDesc = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6,4 C5.45,4 5,4.45 5,5 L5,15 C5,15.55 5.45,16 6,16 C6.55,16 7,15.55 7,15 L7,5 C7,4.45 6.55,4 6,4 Z M2,0 C1.45,0 1,0.45 1,1 L1,15 C1,15.55 1.45,16 2,16 C2.55,16 3,15.55 3,15 L3,1 C3,0.45 2.55,0 2,0 Z M10,7 C9.45,7 9,7.45 9,8 L9,15 C9,15.55 9.45,16 10,16 C10.55,16 11,15.55 11,15 L11,8 C11,7.45 10.55,7 10,7 Z M14,9 C13.45,9 13,9.45 13,10 L13,15 C13,15.55 13.45,16 14,16 C14.55,16 15,15.55 15,15 L15,10 C15,9.45 14.55,9 14,9 Z" />
  </svg>
)
VerticalBarChartDesc.iconName = "VerticalBarChartDesc"
export const VerticalDistribution = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1,2.5 L15,2.5 C15.55,2.5 16,2.05 16,1.5 C16,0.95 15.55,0.5 15,0.5 L1,0.5 C0.45,0.5 0,0.95 0,1.5 C0,2.05 0.45,2.5 1,2.5 Z M15,13.5 L1,13.5 C0.45,13.5 0,13.95 0,14.5 C0,15.05 0.45,15.5 1,15.5 L15,15.5 C15.55,15.5 16,15.05 16,14.5 C16,13.95 15.55,13.5 15,13.5 Z M3,5.5 C2.45,5.5 2,5.95 2,6.5 L2,9.5 C2,10.05 2.45,10.5 3,10.5 L12,10.5 C12.55,10.5 13,10.05 13,9.5 L13,6.5 C13,5.95 12.55,5.5 12,5.5 L3,5.5 Z" />
  </svg>
)
VerticalDistribution.iconName = "VerticalDistribution"
export const Video = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 L16,3 C16,2.45 15.55,2 15,2 Z M5,11 L5,5 L11,8 L5,11 Z" />
  </svg>
)
Video.iconName = "Video"
export const VolumeDown = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9,2 C8.72,2 8.47,2.11 8.29,2.29 L5.59,5 L3,5 C2.45,5 2,5.45 2,6 L2,10 C2,10.55 2.45,11 3,11 L5.59,11 L8.3,13.71 C8.47,13.89 8.72,14 9,14 C9.55,14 10,13.55 10,13 L10,3 C10,2.45 9.55,2 9,2 Z M12.57,3.44 L10.98,4.66 C11.62,5.61 12,6.76 12,8 C12,9.24 11.62,10.39 10.98,11.34 L12.57,12.56 C13.47,11.27 14,9.7 14,8 C14,6.3 13.47,4.73 12.57,3.44 Z" />
  </svg>
)
VolumeDown.iconName = "VolumeDown"
export const VolumeOff = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,2 C10.72,2 10.47,2.11 10.29,2.29 L7.59,5 L5,5 C4.45,5 4,5.45 4,6 L4,10 C4,10.55 4.45,11 5,11 L7.59,11 L10.3,13.71 C10.47,13.89 10.72,14 11,14 C11.55,14 12,13.55 12,13 L12,3 C12,2.45 11.55,2 11,2 Z" />
  </svg>
)
VolumeOff.iconName = "VolumeOff"
export const VolumeUp = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.00495637,1.995 C6.72495637,1.995 6.47495637,2.105 6.29495637,2.285 L3.59495637,4.995 L1.00495637,4.995 C0.454956366,4.995 0.00495636583,5.445 0.00495636583,5.995 L0.00495636583,9.995 C0.00495636583,10.545 0.454956366,10.995 1.00495637,10.995 L3.59495637,10.995 L6.30495637,13.705 C6.48495637,13.885 6.73495637,13.995 7.01495637,13.995 C7.56495637,13.995 8.01495637,13.545 8.01495637,12.995 L8.01495637,2.995 C8.00495637,2.445 7.55495637,1.995 7.00495637,1.995 Z M13.7449564,1.005 L12.1649564,2.225 C13.3149564,3.855 14.0049564,5.845 14.0049564,7.995 C14.0049564,10.155 13.3149564,12.145 12.1549564,13.775 L13.7349564,14.995 C15.1549564,13.025 15.9949564,10.615 15.9949564,7.995 C16.0049564,5.385 15.1549564,2.975 13.7449564,1.005 Z M8.98495637,4.655 C9.62495637,5.615 10.0049564,6.765 10.0049564,7.995 C10.0049564,9.225 9.62495637,10.385 8.98495637,11.335 L10.5749564,12.555 C11.4749564,11.265 12.0049564,9.695 12.0049564,7.995 C12.0049564,6.295 11.4749564,4.725 10.5749564,3.435 L8.98495637,4.655 Z" />
  </svg>
)
VolumeUp.iconName = "VolumeUp"
export const Warning = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.8450968,13.5 L15.8550906,13.49 L8.85946284,1.49 L8.84946908,1.5 C8.67957527,1.2 8.36976889,1 8,1 C7.63023111,1 7.33041849,1.2 7.15053092,1.5 L7.14053716,1.49 L0.144909432,13.49 L0.154903186,13.5 C0.0649594004,13.65 0.00499687695,13.81 0.00499687695,14 C0.00499687695,14.55 0.454715803,15 1.00437227,15 L14.9956277,15 C15.5452842,15 15.9950031,14.55 15.9950031,14 C15.9950031,13.81 15.9350406,13.65 15.8450968,13.5 Z M8.99937539,12.99 L7.00062461,12.99 L7.00062461,10.99 L8.99937539,10.99 L8.99937539,12.99 Z M8.99937539,9.99 L7.00062461,9.99 L7.00062461,4.99 L8.99937539,4.99 L8.99937539,9.99 Z" />
  </svg>
)
Warning.iconName = "Warning"
export const WaterfallChart = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,7 C8.55,7 9,6.55 9,6 C9,5.45 8.55,5 8,5 C7.45,5 7,5.45 7,6 C7,6.55 7.45,7 8,7 Z M4,11 L5,11 C5.55,11 6,10.55 6,10 L6,8 C6,7.45 5.55,7 5,7 L4,7 C3.45,7 3,7.45 3,8 L3,10 C3,10.55 3.45,11 4,11 Z M11,5 C11.55,5 12,4.55 12,4 L12,3 C12,2.45 11.55,2 11,2 C10.45,2 10,2.45 10,3 L10,4 C10,4.55 10.45,5 11,5 Z M15,2 L14,2 C13.45,2 13,2.45 13,3 L13,10 C13,10.55 13.45,11 14,11 L15,11 C15.55,11 16,10.55 16,10 L16,3 C16,2.45 15.55,2 15,2 Z M15,12 L2,12 L2,3 C2,2.45 1.55,2 1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 C16,12.45 15.55,12 15,12 Z" />
  </svg>
)
WaterfallChart.iconName = "WaterfallChart"
export const WidgetButton = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1,3 L15,3 C15.55,3 16,3.45 16,4 L16,12 C16,12.55 15.55,13 15,13 L1,13 C0.45,13 0,12.55 0,12 L0,4 C0,3.45 0.45,3 1,3 Z M2,5 L2,11 L14,11 L14,5 L2,5 Z M5,9 C4.45,9 4,8.55 4,8 C4,7.45 4.45,7 5,7 C5.55,7 6,7.45 6,8 C6,8.55 5.55,9 5,9 Z M8,9 C7.45,9 7,8.55 7,8 C7,7.45 7.45,7 8,7 C8.55,7 9,7.45 9,8 C9,8.55 8.55,9 8,9 Z M11,9 C10.45,9 10,8.55 10,8 C10,7.45 10.45,7 11,7 C11.55,7 12,7.45 12,8 C12,8.55 11.55,9 11,9 Z" />
  </svg>
)
WidgetButton.iconName = "WidgetButton"
export const WidgetFooter = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,0 L2,0 C1.45,0 1,0.45 1,1 L1,15 C1,15.55 1.45,16 2,16 L14,16 C14.55,16 15,15.55 15,15 L15,1 C15,0.45 14.55,0 14,0 Z M13,14 L3,14 L3,11 L13,11 L13,14 Z M13,10 L3,10 L3,2 L13,2 L13,10 Z" />
  </svg>
)
WidgetFooter.iconName = "WidgetFooter"
export const WidgetHeader = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14,0 L2,0 C1.45,0 1,0.45 1,1 L1,15 C1,15.55 1.45,16 2,16 L14,16 C14.55,16 15,15.55 15,15 L15,1 C15,0.45 14.55,0 14,0 Z M13,14 L3,14 L3,6 L13,6 L13,14 Z M13,5 L3,5 L3,2 L13,2 L13,5 Z" />
  </svg>
)
WidgetHeader.iconName = "WidgetHeader"
export const Widget = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13,11 L15,11 L15,5 L13,5 L13,11 Z M3,5 L1,5 L1,11 L3,11 L3,5 Z M14,4 C15.1,4 16,3.1 16,2 C16,0.9 15.1,0 14,0 C12.9,0 12,0.9 12,2 C12,3.1 12.9,4 14,4 Z M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 Z M14,12 C12.9,12 12,12.9 12,14 C12,15.1 12.9,16 14,16 C15.1,16 16,15.1 16,14 C16,12.9 15.1,12 14,12 Z M5,3 L11,3 L11,1 L5,1 L5,3 Z M2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 Z M5,15 L11,15 L11,13 L5,13 L5,15 Z" />
  </svg>
)
Widget.iconName = "Widget"
export const Wrench = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.8309133,3.70416916 L12.7709133,6.75416916 L9.93091326,6.05416916 L9.23091326,3.22416916 L12.2909133,0.17416916 C10.6209133,-0.26583084 8.77091326,0.15416916 7.46091326,1.46416916 C6.00091326,2.91416916 5.63091326,5.03416916 6.34091326,6.82416916 L0.580913256,12.5841692 C0.220913256,12.9441692 0.000913255912,13.4441692 0.000913255912,13.9941692 C0.000913255912,15.0941692 0.900913256,15.9941692 2.00091326,15.9941692 C2.55091326,15.9941692 3.05091326,15.7741692 3.41091326,15.4041692 L9.18091326,9.63416916 C10.9709133,10.3241692 13.0909133,9.96416916 14.5309133,8.51416916 C15.8509133,7.21416916 16.2709133,5.36416916 15.8309133,3.70416916 Z" />
  </svg>
)
Wrench.iconName = "Wrench"
export const ZoomIn = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8,6.00124922 L8,4.00249844 C8,3.45284197 7.55028107,3.00312305 7.00062461,3.00312305 C6.45096814,3.00312305 6.00124922,3.45284197 6.00124922,4.00249844 L6.00124922,6.00124922 L4.00249844,6.00124922 C3.45284197,6.00124922 3.00312305,6.45096814 3.00312305,7.00062461 C3.00312305,7.55028107 3.45284197,8 4.00249844,8 L6.00124922,8 L6.00124922,9.99875078 C6.00124922,10.5484072 6.45096814,10.9981262 7.00062461,10.9981262 C7.55028107,10.9981262 8,10.5484072 8,9.99875078 L8,8 L9.99875078,8 C10.5484072,8 10.9981262,7.55028107 10.9981262,7.00062461 C10.9981262,6.45096814 10.5484072,6.00124922 9.99875078,6.00124922 L8,6.00124922 Z M15.555278,13.4366021 L12.8869457,10.7582761 C13.5865084,9.6689569 13.9962523,8.37976265 13.9962523,7.00062461 C13.9962523,3.13304185 10.8682074,0.00499687695 7.00062461,0.00499687695 C3.13304185,0.00499687695 0.00499687695,3.13304185 0.00499687695,7.00062461 C0.00499687695,10.8682074 3.13304185,13.9962523 7.00062461,13.9962523 C8.3897564,13.9962523 9.67895066,13.5765147 10.7582761,12.8869457 L13.4366021,15.555278 C13.7064335,15.8251093 14.0861961,15.9950031 14.49594,15.9950031 C15.3254216,15.9950031 15.9950031,15.3254216 15.9950031,14.49594 C15.9950031,14.0861961 15.8251093,13.7064335 15.555278,13.4366021 Z M7.00062461,11.9975016 C4.24234853,11.9975016 2.00374766,9.75890069 2.00374766,7.00062461 C2.00374766,4.24234853 4.24234853,2.00374766 7.00062461,2.00374766 C9.75890069,2.00374766 11.9975016,4.24234853 11.9975016,7.00062461 C11.9975016,9.75890069 9.75890069,11.9975016 7.00062461,11.9975016 Z" />
  </svg>
)
ZoomIn.iconName = "ZoomIn"
export const ZoomOut = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.00249844,6.00124922 C3.45284197,6.00124922 3.00312305,6.45096814 3.00312305,7.00062461 C3.00312305,7.55028107 3.45284197,8 4.00249844,8 L9.99875078,8 C10.5484072,8 10.9981262,7.55028107 10.9981262,7.00062461 C10.9981262,6.45096814 10.5484072,6.00124922 9.99875078,6.00124922 L4.00249844,6.00124922 Z M15.555278,13.4366021 L12.8869457,10.7582761 C13.5865084,9.6689569 13.9962523,8.37976265 13.9962523,7.00062461 C13.9962523,3.13304185 10.8682074,0.00499687695 7.00062461,0.00499687695 C3.13304185,0.00499687695 0.00499687695,3.13304185 0.00499687695,7.00062461 C0.00499687695,10.8682074 3.13304185,13.9962523 7.00062461,13.9962523 C8.3897564,13.9962523 9.67895066,13.5765147 10.7582761,12.8869457 L13.4366021,15.555278 C13.7064335,15.8251093 14.0861961,15.9950031 14.49594,15.9950031 C15.3254216,15.9950031 15.9950031,15.3254216 15.9950031,14.49594 C15.9950031,14.0861961 15.8251093,13.7064335 15.555278,13.4366021 Z M7.00062461,11.9975016 C4.24234853,11.9975016 2.00374766,9.75890069 2.00374766,7.00062461 C2.00374766,4.24234853 4.24234853,2.00374766 7.00062461,2.00374766 C9.75890069,2.00374766 11.9975016,4.24234853 11.9975016,7.00062461 C11.9975016,9.75890069 9.75890069,11.9975016 7.00062461,11.9975016 Z" />
  </svg>
)
ZoomOut.iconName = "ZoomOut"
export const ZoomToFit = () => (
  <svg
    height="16"
    width="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11,10 C11,10.55 11.45,11 12,11 C12.28,11 12.53,10.89 12.71,10.71 L14.71,8.71 C14.89,8.53 15,8.28 15,8 C15,7.72 14.89,7.47 14.71,7.29 L12.71,5.29 C12.53,5.11 12.28,5 12,5 C11.45,5 11,5.45 11,6 C11,6.28 11.11,6.53 11.29,6.71 L12.59,8 L11.3,9.29 C11.11,9.47 11,9.72 11,10 Z M1,5 C1.55,5 2,4.55 2,4 L2,2 L4,2 C4.55,2 5,1.55 5,1 C5,0.45 4.55,0 4,0 L1,0 C0.45,0 0,0.45 0,1 L0,4 C0,4.55 0.45,5 1,5 Z M5,6 C5,5.45 4.55,5 4,5 C3.72,5 3.47,5.11 3.29,5.29 L1.29,7.29 C1.11,7.47 1,7.72 1,8 C1,8.28 1.11,8.53 1.29,8.71 L3.29,10.71 C3.47,10.89 3.72,11 4,11 C4.55,11 5,10.55 5,10 C5,9.72 4.89,9.47 4.71,9.29 L3.41,8 L4.7,6.71 C4.89,6.53 5,6.28 5,6 Z M6,5 C6.28,5 6.53,4.89 6.71,4.71 L8,3.41 L9.29,4.7 C9.47,4.89 9.72,5 10,5 C10.55,5 11,4.55 11,4 C11,3.72 10.89,3.47 10.71,3.29 L8.71,1.29 C8.53,1.11 8.28,1 8,1 C7.72,1 7.47,1.11 7.29,1.29 L5.29,3.29 C5.11,3.47 5,3.72 5,4 C5,4.55 5.45,5 6,5 Z M15,11 C14.45,11 14,11.45 14,12 L14,14 L12,14 C11.45,14 11,14.45 11,15 C11,15.55 11.45,16 12,16 L15,16 C15.55,16 16,15.55 16,15 L16,12 C16,11.45 15.55,11 15,11 Z M15,0 L12,0 C11.45,0 11,0.45 11,1 C11,1.55 11.45,2 12,2 L14,2 L14,4 C14,4.55 14.45,5 15,5 C15.55,5 16,4.55 16,4 L16,1 C16,0.45 15.55,0 15,0 Z M4,14 L2,14 L2,12 C2,11.45 1.55,11 1,11 C0.45,11 0,11.45 0,12 L0,15 C0,15.55 0.45,16 1,16 L4,16 C4.55,16 5,15.55 5,15 C5,14.45 4.55,14 4,14 Z M10,11 C9.72,11 9.47,11.11 9.29,11.29 L8,12.59 L6.71,11.3 C6.53,11.11 6.28,11 6,11 C5.45,11 5,11.45 5,12 C5,12.28 5.11,12.53 5.29,12.71 L7.29,14.71 C7.47,14.89 7.72,15 8,15 C8.28,15 8.53,14.89 8.71,14.71 L10.71,12.71 C10.89,12.53 11,12.28 11,12 C11,11.45 10.55,11 10,11 Z" />
  </svg>
)
ZoomToFit.iconName = "ZoomToFit"
